import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Byte: { input: any; output: any };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  Decimal: { input: any; output: any };
  LocalDate: { input: string; output: string };
  LocalDateTime: { input: any; output: any };
  Short: { input: any; output: any };
  TimeSpan: { input: any; output: any };
  UUID: { input: any; output: any };
};

export type AccountTypeDto = {
  __typename?: 'AccountTypeDto';
  accountType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type AccountTypeDtoFilterInput = {
  accountType?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AccountTypeDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<AccountTypeDtoFilterInput>>;
};

export type AccountTypeDtoInput = {
  accountType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};

export type AccountTypeDtoSortInput = {
  accountType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

export type AccountTypeInput = {
  accountType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** A segment of a collection. */
export type AccountTypesCollectionSegment = {
  __typename?: 'AccountTypesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<AccountTypeDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Address = {
  __typename?: 'Address';
  addressId: Scalars['Int']['output'];
  addressLabel?: Maybe<Scalars['String']['output']>;
  addressLine?: Maybe<Scalars['String']['output']>;
  addressTypeId: Scalars['Int']['output'];
  city: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  createdOn: Scalars['LocalDateTime']['output'];
  customId1?: Maybe<Scalars['String']['output']>;
  customId2?: Maybe<Scalars['String']['output']>;
  customerWithContactsAndMailAddress: Array<RaptorCustomerWithContacts>;
  customersWithMailAddress: Array<Customer>;
  differentParentName?: Maybe<Scalars['String']['output']>;
  isInactive: Scalars['Boolean']['output'];
  jobSitesWithBillingAddress: Array<JobSite>;
  latitude?: Maybe<Scalars['Decimal']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
  parentCustomer: Customer;
  parentCustomerWithContacts: RaptorCustomerWithContacts;
  parentId: Scalars['Int']['output'];
  parentTypeId: Scalars['Int']['output'];
  primaryContactId?: Maybe<Scalars['Int']['output']>;
  primaryPhoneId?: Maybe<Scalars['Int']['output']>;
  rowId: Scalars['UUID']['output'];
  state: Scalars['String']['output'];
  updatedBy: Scalars['Int']['output'];
  updatedOn: Scalars['LocalDateTime']['output'];
  useDifferentParentName: Scalars['Boolean']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type AddressDto = {
  __typename?: 'AddressDto';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type AddressDtoFilterInput = {
  address?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AddressDtoFilterInput>>;
  city?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<AddressDtoFilterInput>>;
  state?: InputMaybe<StringOperationFilterInput>;
  zipCode?: InputMaybe<StringOperationFilterInput>;
};

export type AddressDtoInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressDtoSortInput = {
  address?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  zipCode?: InputMaybe<SortEnumType>;
};

export type AddressFilterInput = {
  addressId?: InputMaybe<IntOperationFilterInput>;
  addressLabel?: InputMaybe<StringOperationFilterInput>;
  addressLine?: InputMaybe<StringOperationFilterInput>;
  addressTypeId?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<AddressFilterInput>>;
  city?: InputMaybe<StringOperationFilterInput>;
  comment?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<IntOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  customId1?: InputMaybe<StringOperationFilterInput>;
  customId2?: InputMaybe<StringOperationFilterInput>;
  customerWithContactsAndMailAddress?: InputMaybe<ListFilterInputTypeOfRaptorCustomerWithContactsFilterInput>;
  customersWithMailAddress?: InputMaybe<ListFilterInputTypeOfCustomerFilterInput>;
  differentParentName?: InputMaybe<StringOperationFilterInput>;
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  jobSitesWithBillingAddress?: InputMaybe<ListFilterInputTypeOfJobSiteFilterInput>;
  latitude?: InputMaybe<DecimalOperationFilterInput>;
  longitude?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<AddressFilterInput>>;
  parentCustomer?: InputMaybe<CustomerFilterInput>;
  parentCustomerWithContacts?: InputMaybe<RaptorCustomerWithContactsFilterInput>;
  parentId?: InputMaybe<IntOperationFilterInput>;
  parentTypeId?: InputMaybe<IntOperationFilterInput>;
  primaryContactId?: InputMaybe<IntOperationFilterInput>;
  primaryPhoneId?: InputMaybe<IntOperationFilterInput>;
  rowId?: InputMaybe<UuidOperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
  useDifferentParentName?: InputMaybe<BooleanOperationFilterInput>;
  zipCode?: InputMaybe<StringOperationFilterInput>;
};

export type AddressSortInput = {
  addressId?: InputMaybe<SortEnumType>;
  addressLabel?: InputMaybe<SortEnumType>;
  addressLine?: InputMaybe<SortEnumType>;
  addressTypeId?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  comment?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  customId1?: InputMaybe<SortEnumType>;
  customId2?: InputMaybe<SortEnumType>;
  differentParentName?: InputMaybe<SortEnumType>;
  isInactive?: InputMaybe<SortEnumType>;
  latitude?: InputMaybe<SortEnumType>;
  longitude?: InputMaybe<SortEnumType>;
  parentCustomer?: InputMaybe<CustomerSortInput>;
  parentCustomerWithContacts?: InputMaybe<RaptorCustomerWithContactsSortInput>;
  parentId?: InputMaybe<SortEnumType>;
  parentTypeId?: InputMaybe<SortEnumType>;
  primaryContactId?: InputMaybe<SortEnumType>;
  primaryPhoneId?: InputMaybe<SortEnumType>;
  rowId?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  updatedOn?: InputMaybe<SortEnumType>;
  useDifferentParentName?: InputMaybe<SortEnumType>;
  zipCode?: InputMaybe<SortEnumType>;
};

export type AppBlobRemote = {
  __typename?: 'AppBlobRemote';
  accesses: Array<AppBlobRemoteAccess>;
  bizObject: BizObject;
  certificateAssignments: RaptorCertificateAssignmentVw;
  createdBy: Scalars['Int']['output'];
  createdOn: Scalars['LocalDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  employee: Employee;
  ext?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  metaData?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parentID: Scalars['Int']['output'];
  parentTypID: Scalars['Int']['output'];
  permitAssignments: RaptorPermitAssignmentVw;
  provider: Scalars['String']['output'];
  providerKey: Scalars['String']['output'];
  rowID: Scalars['UUID']['output'];
  sasExpiration?: Maybe<Scalars['LocalDateTime']['output']>;
  sasurl?: Maybe<Scalars['String']['output']>;
  thm?: Maybe<Array<Scalars['Byte']['output']>>;
  thumbnail?: Maybe<Array<Scalars['Byte']['output']>>;
  thumbnailSASExpiration?: Maybe<Scalars['LocalDateTime']['output']>;
  thumbnailSASURL?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uploadedOn: Scalars['LocalDateTime']['output'];
  utcCreatedOn: Scalars['LocalDateTime']['output'];
  utcUpdatedOn?: Maybe<Scalars['LocalDateTime']['output']>;
  utcUploadedOn?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type AppBlobRemoteAccess = {
  __typename?: 'AppBlobRemoteAccess';
  allowDelete: Scalars['Boolean']['output'];
  allowRead: Scalars['Boolean']['output'];
  allowWrite: Scalars['Boolean']['output'];
  appBlobRemote: AppBlobRemote;
  blobID: Scalars['Int']['output'];
  contType?: Maybe<ContentType>;
  contTypeID?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  typeID: Scalars['Int']['output'];
};

export type AppBlobRemoteAccessFilterInput = {
  allowDelete?: InputMaybe<BooleanOperationFilterInput>;
  allowRead?: InputMaybe<BooleanOperationFilterInput>;
  allowWrite?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<AppBlobRemoteAccessFilterInput>>;
  appBlobRemote?: InputMaybe<AppBlobRemoteFilterInput>;
  blobID?: InputMaybe<IntOperationFilterInput>;
  contType?: InputMaybe<ContentTypeFilterInput>;
  contTypeID?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<AppBlobRemoteAccessFilterInput>>;
  typeID?: InputMaybe<IntOperationFilterInput>;
};

export type AppBlobRemoteFilterInput = {
  accesses?: InputMaybe<ListFilterInputTypeOfAppBlobRemoteAccessFilterInput>;
  and?: InputMaybe<Array<AppBlobRemoteFilterInput>>;
  bizObject?: InputMaybe<BizObjectFilterInput>;
  certificateAssignments?: InputMaybe<RaptorCertificateAssignmentVwFilterInput>;
  createdBy?: InputMaybe<IntOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  employee?: InputMaybe<EmployeeFilterInput>;
  ext?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  metaData?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AppBlobRemoteFilterInput>>;
  parentID?: InputMaybe<IntOperationFilterInput>;
  parentTypID?: InputMaybe<IntOperationFilterInput>;
  permitAssignments?: InputMaybe<RaptorPermitAssignmentVwFilterInput>;
  provider?: InputMaybe<StringOperationFilterInput>;
  providerKey?: InputMaybe<StringOperationFilterInput>;
  rowID?: InputMaybe<UuidOperationFilterInput>;
  sasExpiration?: InputMaybe<DateTimeOperationFilterInput>;
  sasurl?: InputMaybe<StringOperationFilterInput>;
  thm?: InputMaybe<ListByteOperationFilterInput>;
  thumbnail?: InputMaybe<ListByteOperationFilterInput>;
  thumbnailSASExpiration?: InputMaybe<DateTimeOperationFilterInput>;
  thumbnailSASURL?: InputMaybe<StringOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  uploadedOn?: InputMaybe<DateTimeOperationFilterInput>;
  utcCreatedOn?: InputMaybe<DateTimeOperationFilterInput>;
  utcUpdatedOn?: InputMaybe<DateTimeOperationFilterInput>;
  utcUploadedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type AppUser = {
  __typename?: 'AppUser';
  allowERPLogin: Scalars['Boolean']['output'];
  allowROTGLogin: Scalars['Boolean']['output'];
  createdOn: Scalars['LocalDateTime']['output'];
  empId: Scalars['Int']['output'];
  employee?: Maybe<Employee>;
  forceNewPassword: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  isSuspended: Scalars['Boolean']['output'];
  lastLoginOn: Scalars['LocalDateTime']['output'];
  passwordHash: Array<Scalars['Byte']['output']>;
  update: ResultOfAppUser;
  updatedBy: Scalars['Int']['output'];
  updatedByEmployee?: Maybe<AppUser>;
  updatedUsers: Array<AppUser>;
  userId: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
  utcLicenseAcceptedOn?: Maybe<Scalars['LocalDateTime']['output']>;
  utcUpdatedOn: Scalars['LocalDateTime']['output'];
};

export type AppUserUpdateArgs = {
  allowERPLogin: Scalars['Boolean']['input'];
  lastLoginOn: Scalars['LocalDateTime']['input'];
};

export type AppUserAccess = {
  __typename?: 'AppUserAccess';
  accessId: Scalars['Int']['output'];
  allowCentralAccess: Scalars['Boolean']['output'];
  allowDelete: Scalars['Boolean']['output'];
  allowExcelExport: Scalars['Boolean']['output'];
  allowRead: Scalars['Boolean']['output'];
  allowWrite: Scalars['Boolean']['output'];
  featureId: Scalars['Int']['output'];
  modules?: Maybe<BizObject>;
  updatedBy: Scalars['Int']['output'];
  updatedByUser?: Maybe<Employee>;
  userId: Scalars['Int']['output'];
  utcUpdatedOn?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type AppUserAccessFilterInput = {
  accessId?: InputMaybe<IntOperationFilterInput>;
  allowCentralAccess?: InputMaybe<BooleanOperationFilterInput>;
  allowDelete?: InputMaybe<BooleanOperationFilterInput>;
  allowExcelExport?: InputMaybe<BooleanOperationFilterInput>;
  allowRead?: InputMaybe<BooleanOperationFilterInput>;
  allowWrite?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<AppUserAccessFilterInput>>;
  featureId?: InputMaybe<IntOperationFilterInput>;
  modules?: InputMaybe<BizObjectFilterInput>;
  or?: InputMaybe<Array<AppUserAccessFilterInput>>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedByUser?: InputMaybe<EmployeeFilterInput>;
  userId?: InputMaybe<IntOperationFilterInput>;
  utcUpdatedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type AppUserDto = {
  __typename?: 'AppUserDto';
  empId: Scalars['Int']['output'];
  lastLoginOn: Scalars['LocalDateTime']['output'];
  passwordHash: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
  userName: Scalars['String']['output'];
};

export type AppUserDtoSortInput = {
  empId?: InputMaybe<SortEnumType>;
  lastLoginOn?: InputMaybe<SortEnumType>;
  passwordHash?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
};

export type AppUserFilterInput = {
  allowERPLogin?: InputMaybe<BooleanOperationFilterInput>;
  allowROTGLogin?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<AppUserFilterInput>>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  empId?: InputMaybe<IntOperationFilterInput>;
  employee?: InputMaybe<EmployeeFilterInput>;
  forceNewPassword?: InputMaybe<BooleanOperationFilterInput>;
  isLocked?: InputMaybe<BooleanOperationFilterInput>;
  isSuspended?: InputMaybe<BooleanOperationFilterInput>;
  lastLoginOn?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AppUserFilterInput>>;
  passwordHash?: InputMaybe<ListByteOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedByEmployee?: InputMaybe<AppUserFilterInput>;
  updatedUsers?: InputMaybe<ListFilterInputTypeOfAppUserFilterInput>;
  userId?: InputMaybe<IntOperationFilterInput>;
  userName?: InputMaybe<StringOperationFilterInput>;
  utcLicenseAcceptedOn?: InputMaybe<DateTimeOperationFilterInput>;
  utcUpdatedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type AppUserSortInput = {
  allowERPLogin?: InputMaybe<SortEnumType>;
  allowROTGLogin?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  empId?: InputMaybe<SortEnumType>;
  employee?: InputMaybe<EmployeeSortInput>;
  forceNewPassword?: InputMaybe<SortEnumType>;
  isLocked?: InputMaybe<SortEnumType>;
  isSuspended?: InputMaybe<SortEnumType>;
  lastLoginOn?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  updatedByEmployee?: InputMaybe<AppUserSortInput>;
  userId?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
  utcLicenseAcceptedOn?: InputMaybe<SortEnumType>;
  utcUpdatedOn?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type AppUsersCollectionSegment = {
  __typename?: 'AppUsersCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<AppUserDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
};

export type AppUsersMutation = {
  __typename?: 'AppUsersMutation';
  updateAppUserAllowERPLogin: Scalars['Boolean']['output'];
};

export type AppUsersMutationUpdateAppUserAllowErpLoginArgs = {
  allowERPLogin: Scalars['Boolean']['input'];
  lastLogin: Scalars['LocalDateTime']['input'];
  userId: Scalars['Int']['input'];
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION'
}

/** A segment of a collection. */
export type AvailableCrewMembersCollectionSegment = {
  __typename?: 'AvailableCrewMembersCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V2_CrewDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type AvailableEmployeesCollectionSegment = {
  __typename?: 'AvailableEmployeesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<EmployeeDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
};

/** A segment of a collection. */
export type AvailableEquipmentsCollectionSegment = {
  __typename?: 'AvailableEquipmentsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V2_Equipment_EquipmentDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum BannedFrom {
  Customer = 'CUSTOMER',
  JobSite = 'JOB_SITE'
}

export type BannedFromOperationFilterInput = {
  eq?: InputMaybe<BannedFrom>;
  in?: InputMaybe<Array<BannedFrom>>;
  neq?: InputMaybe<BannedFrom>;
  nin?: InputMaybe<Array<BannedFrom>>;
};

export type BizObject = {
  __typename?: 'BizObject';
  allJobsWithDispatchLocation?: Maybe<Array<RaptorAllJobsVw>>;
  appBlobRemotes: Array<AppBlobRemote>;
  checklistMappings: Array<ChecklistMapping>;
  contactSource?: Maybe<ContactSource>;
  createdOn?: Maybe<Scalars['LocalDateTime']['output']>;
  customer: Customer;
  customerWithContacts: RaptorCustomerWithContacts;
  description?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<Employee>;
  employeeOutOfOfficeDayReasons: Array<Entities_V1_EmployeeOutOfOfficeDay>;
  employeeWithDispatchLocation?: Maybe<Employee>;
  equipment?: Maybe<Equipment>;
  id: Scalars['Int']['output'];
  isInactive: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  isUsable: Scalars['Boolean']['output'];
  items?: Maybe<Array<Entities_V1_Item>>;
  jobExtraSystem: Entities_V1_JobExtraSystem;
  jobSites: JobSite;
  jobs?: Maybe<Array<PourForAdding>>;
  jobs2?: Maybe<Array<PourForAdding>>;
  jobs3?: Maybe<Array<PourForAdding>>;
  miscValues?: Maybe<Scalars['String']['output']>;
  objectName: Scalars['String']['output'];
  parentObjectId?: Maybe<Scalars['Int']['output']>;
  permissions: Array<AppUserAccess>;
  reasons: Array<Entities_V1_EquipmentServiceStatusDay>;
  rowId: Scalars['UUID']['output'];
  sortOrder: Scalars['Int']['output'];
  updatedBy: Scalars['Int']['output'];
  updatedOn: Scalars['LocalDateTime']['output'];
};

export type BizObjectDto = {
  __typename?: 'BizObjectDto';
  id: Scalars['Int']['output'];
  objectName: Scalars['String']['output'];
  parentObjectId: Scalars['Int']['output'];
};

export type BizObjectDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  objectName?: InputMaybe<SortEnumType>;
  parentObjectId?: InputMaybe<SortEnumType>;
};

export type BizObjectFilterInput = {
  allJobsWithDispatchLocation?: InputMaybe<ListFilterInputTypeOfRaptorAllJobsVwFilterInput>;
  and?: InputMaybe<Array<BizObjectFilterInput>>;
  appBlobRemotes?: InputMaybe<ListFilterInputTypeOfAppBlobRemoteFilterInput>;
  checklistMappings?: InputMaybe<ListFilterInputTypeOfChecklistMappingFilterInput>;
  contactSource?: InputMaybe<ContactSourceFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerWithContacts?: InputMaybe<RaptorCustomerWithContactsFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  employee?: InputMaybe<EmployeeFilterInput>;
  employeeOutOfOfficeDayReasons?: InputMaybe<ListFilterInputTypeOfEntities_V1_EmployeeOutOfOfficeDayFilterInput>;
  employeeWithDispatchLocation?: InputMaybe<EmployeeFilterInput>;
  equipment?: InputMaybe<EquipmentFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  isSystem?: InputMaybe<BooleanOperationFilterInput>;
  isUsable?: InputMaybe<BooleanOperationFilterInput>;
  items?: InputMaybe<ListFilterInputTypeOfEntities_V1_ItemFilterInput>;
  jobExtraSystem?: InputMaybe<Entities_V1_JobExtraSystemFilterInput>;
  jobSites?: InputMaybe<JobSiteFilterInput>;
  jobs?: InputMaybe<ListFilterInputTypeOfPourForAddingFilterInput>;
  jobs2?: InputMaybe<ListFilterInputTypeOfPourForAddingFilterInput>;
  jobs3?: InputMaybe<ListFilterInputTypeOfPourForAddingFilterInput>;
  miscValues?: InputMaybe<StringOperationFilterInput>;
  objectName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BizObjectFilterInput>>;
  parentObjectId?: InputMaybe<IntOperationFilterInput>;
  permissions?: InputMaybe<ListFilterInputTypeOfAppUserAccessFilterInput>;
  reasons?: InputMaybe<ListFilterInputTypeOfEntities_V1_EquipmentServiceStatusDayFilterInput>;
  rowId?: InputMaybe<UuidOperationFilterInput>;
  sortOrder?: InputMaybe<IntOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type BizObjectSortInput = {
  contactSource?: InputMaybe<ContactSourceSortInput>;
  createdOn?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerWithContacts?: InputMaybe<RaptorCustomerWithContactsSortInput>;
  description?: InputMaybe<SortEnumType>;
  employee?: InputMaybe<EmployeeSortInput>;
  employeeWithDispatchLocation?: InputMaybe<EmployeeSortInput>;
  equipment?: InputMaybe<EquipmentSortInput>;
  id?: InputMaybe<SortEnumType>;
  isInactive?: InputMaybe<SortEnumType>;
  isSystem?: InputMaybe<SortEnumType>;
  isUsable?: InputMaybe<SortEnumType>;
  jobExtraSystem?: InputMaybe<Entities_V1_JobExtraSystemSortInput>;
  jobSites?: InputMaybe<JobSiteSortInput>;
  miscValues?: InputMaybe<SortEnumType>;
  objectName?: InputMaybe<SortEnumType>;
  parentObjectId?: InputMaybe<SortEnumType>;
  rowId?: InputMaybe<SortEnumType>;
  sortOrder?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  updatedOn?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type BizObjectsCollectionSegment = {
  __typename?: 'BizObjectsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<BizObjectDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ByteOperationFilterInput = {
  eq?: InputMaybe<Scalars['Byte']['input']>;
  gt?: InputMaybe<Scalars['Byte']['input']>;
  gte?: InputMaybe<Scalars['Byte']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Byte']['input']>>>;
  lt?: InputMaybe<Scalars['Byte']['input']>;
  lte?: InputMaybe<Scalars['Byte']['input']>;
  neq?: InputMaybe<Scalars['Byte']['input']>;
  ngt?: InputMaybe<Scalars['Byte']['input']>;
  ngte?: InputMaybe<Scalars['Byte']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Byte']['input']>>>;
  nlt?: InputMaybe<Scalars['Byte']['input']>;
  nlte?: InputMaybe<Scalars['Byte']['input']>;
};

export type CheckList = {
  __typename?: 'CheckList';
  checklistMappings: Array<ChecklistMapping>;
  employeeCheckLists: Array<EmployeeCheckList>;
  id: Scalars['Int']['output'];
  includeJobTicket: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  jobSites?: Maybe<JobSite>;
  name?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['UUID']['output'];
};

export type CheckListDto = {
  __typename?: 'CheckListDto';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CheckListDtoFilterInput = {
  and?: InputMaybe<Array<CheckListDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CheckListDtoFilterInput>>;
};

export type CheckListDtoInput = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type CheckListDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type CheckListFilterInput = {
  and?: InputMaybe<Array<CheckListFilterInput>>;
  checklistMappings?: InputMaybe<ListFilterInputTypeOfChecklistMappingFilterInput>;
  employeeCheckLists?: InputMaybe<ListFilterInputTypeOfEmployeeCheckListFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  includeJobTicket?: InputMaybe<BooleanOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isRequired?: InputMaybe<BooleanOperationFilterInput>;
  jobSites?: InputMaybe<JobSiteFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CheckListFilterInput>>;
  rowId?: InputMaybe<UuidOperationFilterInput>;
};

export type CheckListSortInput = {
  id?: InputMaybe<SortEnumType>;
  includeJobTicket?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isRequired?: InputMaybe<SortEnumType>;
  jobSites?: InputMaybe<JobSiteSortInput>;
  name?: InputMaybe<SortEnumType>;
  rowId?: InputMaybe<SortEnumType>;
};

export type ChecklistMapping = {
  __typename?: 'ChecklistMapping';
  checkList?: Maybe<CheckList>;
  checkListId: Scalars['Int']['output'];
  createdBy: Scalars['Int']['output'];
  createdOn: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isRequired: Scalars['Boolean']['output'];
  parentId: Scalars['Int']['output'];
  parentType?: Maybe<BizObject>;
  parentTypeId: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
  updatedOn?: Maybe<Scalars['DateTime']['output']>;
};

export type ChecklistMappingFilterInput = {
  and?: InputMaybe<Array<ChecklistMappingFilterInput>>;
  checkList?: InputMaybe<CheckListFilterInput>;
  checkListId?: InputMaybe<IntOperationFilterInput>;
  createdBy?: InputMaybe<IntOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isRequired?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ChecklistMappingFilterInput>>;
  parentId?: InputMaybe<IntOperationFilterInput>;
  parentType?: InputMaybe<BizObjectFilterInput>;
  parentTypeId?: InputMaybe<IntOperationFilterInput>;
  sortOrder?: InputMaybe<IntOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

/** A segment of a collection. */
export type CitiesCollectionSegment = {
  __typename?: 'CitiesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CityDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type CityDto = {
  __typename?: 'CityDto';
  abbreviation?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CityDtoFilterInput = {
  abbreviation?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CityDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CityDtoFilterInput>>;
};

export type CityDtoSortInput = {
  abbreviation?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename?: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type ContactDto = {
  __typename?: 'ContactDto';
  contactInformation: Array<ContactInformationDto>;
  customerId?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ContactDtoFilterInput = {
  and?: InputMaybe<Array<ContactDtoFilterInput>>;
  contactInformation?: InputMaybe<ListFilterInputTypeOfContactInformationDtoFilterInput>;
  /** Will always reference a ContactPersonId in the context of this query. */
  contactOrCustomerId?: InputMaybe<IntOperationFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ContactDtoFilterInput>>;
  title?: InputMaybe<StringOperationFilterInput>;
};

export type ContactDtoInput = {
  contactInformation: Array<ContactInformationDtoInput>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContactDtoSortInput = {
  customerId?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
};

export type ContactInformationDto = {
  __typename?: 'ContactInformationDto';
  contact?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ContactInformationDtoFilterInput = {
  and?: InputMaybe<Array<ContactInformationDtoFilterInput>>;
  contact?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ContactInformationDtoFilterInput>>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type ContactInformationDtoInput = {
  contact?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ContactInformationDtoSortInput = {
  contact?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export type ContactPerson = {
  __typename?: 'ContactPerson';
  allowMobilAppAccess: Scalars['Boolean']['output'];
  allowWebPortalAccess: Scalars['Boolean']['output'];
  createdBy: Scalars['Int']['output'];
  createdOn: Scalars['LocalDateTime']['output'];
  firstName: Scalars['String']['output'];
  forceNewPassword: Scalars['Boolean']['output'];
  fullName: Scalars['String']['output'];
  isInactive: Scalars['Boolean']['output'];
  isLoginSuspended: Scalars['Boolean']['output'];
  jobContacts: Array<RaptorJobContact>;
  lastName: Scalars['String']['output'];
  parentId: Scalars['Int']['output'];
  parentTypeId: Scalars['Int']['output'];
  personId: Scalars['Int']['output'];
  rowId: Scalars['UUID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  updatedOn: Scalars['LocalDateTime']['output'];
};

export type ContactPersonFilterInput = {
  allowMobilAppAccess?: InputMaybe<BooleanOperationFilterInput>;
  allowWebPortalAccess?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ContactPersonFilterInput>>;
  createdBy?: InputMaybe<IntOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  forceNewPassword?: InputMaybe<BooleanOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  isLoginSuspended?: InputMaybe<BooleanOperationFilterInput>;
  jobContacts?: InputMaybe<ListFilterInputTypeOfRaptorJobContactFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ContactPersonFilterInput>>;
  parentId?: InputMaybe<IntOperationFilterInput>;
  parentTypeId?: InputMaybe<IntOperationFilterInput>;
  personId?: InputMaybe<IntOperationFilterInput>;
  rowId?: InputMaybe<UuidOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type ContactSource = {
  __typename?: 'ContactSource';
  comment?: Maybe<Scalars['String']['output']>;
  contactOrCustomerId: Scalars['Int']['output'];
  contactSourceType: BizObject;
  createdBy: Scalars['Int']['output'];
  createdOn: Scalars['LocalDateTime']['output'];
  employeeWithEmail: Employee;
  employeeWithPhone: Employee;
  isInactive: Scalars['Boolean']['output'];
  parentTypeId?: Maybe<ParentContactTypeId>;
  rowId: Scalars['UUID']['output'];
  sourceId?: Maybe<Scalars['Int']['output']>;
  sourceInfo: Scalars['String']['output'];
  sourceTypeId?: Maybe<Scalars['Int']['output']>;
  updatedBy: Scalars['Int']['output'];
  updatedOn: Scalars['LocalDateTime']['output'];
};

export type ContactSourceFilterInput = {
  and?: InputMaybe<Array<ContactSourceFilterInput>>;
  comment?: InputMaybe<StringOperationFilterInput>;
  contactOrCustomerId?: InputMaybe<IntOperationFilterInput>;
  contactSourceType?: InputMaybe<BizObjectFilterInput>;
  createdBy?: InputMaybe<IntOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  employeeWithEmail?: InputMaybe<EmployeeFilterInput>;
  employeeWithPhone?: InputMaybe<EmployeeFilterInput>;
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<ContactSourceFilterInput>>;
  parentTypeId?: InputMaybe<NullableOfParentContactTypeIdOperationFilterInput>;
  rowId?: InputMaybe<UuidOperationFilterInput>;
  sourceId?: InputMaybe<IntOperationFilterInput>;
  sourceInfo?: InputMaybe<StringOperationFilterInput>;
  sourceTypeId?: InputMaybe<IntOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type ContactSourceSortInput = {
  comment?: InputMaybe<SortEnumType>;
  contactOrCustomerId?: InputMaybe<SortEnumType>;
  contactSourceType?: InputMaybe<BizObjectSortInput>;
  createdBy?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  employeeWithEmail?: InputMaybe<EmployeeSortInput>;
  employeeWithPhone?: InputMaybe<EmployeeSortInput>;
  isInactive?: InputMaybe<SortEnumType>;
  parentTypeId?: InputMaybe<SortEnumType>;
  rowId?: InputMaybe<SortEnumType>;
  sourceId?: InputMaybe<SortEnumType>;
  sourceInfo?: InputMaybe<SortEnumType>;
  sourceTypeId?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  updatedOn?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type ContactsCollectionSegment = {
  __typename?: 'ContactsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ContactDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ContentType = {
  __typename?: 'ContentType';
  category?: Maybe<Scalars['Short']['output']>;
  cboGuid?: Maybe<Scalars['String']['output']>;
  customer: Customer;
  customerWithContacts: RaptorCustomerWithContacts;
  description?: Maybe<Scalars['String']['output']>;
  employeeContentTypes: Array<EmployeeContentType>;
  employees: Array<Employee>;
  id: Scalars['Int']['output'];
  isSalesman: Scalars['Int']['output'];
  status?: Maybe<Scalars['Int']['output']>;
  system?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ContentTypeFilterInput = {
  and?: InputMaybe<Array<ContentTypeFilterInput>>;
  category?: InputMaybe<ShortOperationFilterInput>;
  cboGuid?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerWithContacts?: InputMaybe<RaptorCustomerWithContactsFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  employeeContentTypes?: InputMaybe<ListFilterInputTypeOfEmployeeContentTypeFilterInput>;
  employees?: InputMaybe<ListFilterInputTypeOfEmployeeFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isSalesman?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ContentTypeFilterInput>>;
  status?: InputMaybe<IntOperationFilterInput>;
  system?: InputMaybe<BooleanOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
};

export type ContentTypeSortInput = {
  category?: InputMaybe<SortEnumType>;
  cboGuid?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerWithContacts?: InputMaybe<RaptorCustomerWithContactsSortInput>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isSalesman?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  system?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
};

export type CreateCustomerContactsMutationInput = {
  contactsToCreate: Array<ContactDtoInput>;
  customerId: Scalars['Int']['input'];
};

export type CreateCustomerDto = {
  __typename?: 'CreateCustomerDto';
  accountType?: Maybe<AccountTypeDto>;
  address?: Maybe<AddressDto>;
  companyName?: Maybe<Scalars['String']['output']>;
  contactsToCreate?: Maybe<Array<ContactDto>>;
  customerDiscount?: Maybe<Scalars['Float']['output']>;
  customerType?: Maybe<CustomerTypeDto>;
  id?: Maybe<Scalars['Int']['output']>;
  maxCredit?: Maybe<Scalars['Decimal']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  pricingScheme?: Maybe<PricingSchemeDto>;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryPhone?: Maybe<Scalars['String']['output']>;
  salesAgent: EmployeeDto;
  salesRegion?: Maybe<SalesRegionDto>;
  taxNumber?: Maybe<Scalars['String']['output']>;
  term?: Maybe<TermDto>;
};

export type CreateCustomerMutationInput = {
  accountType?: InputMaybe<AccountTypeInput>;
  address?: InputMaybe<AddressDtoInput>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactsToCreate?: InputMaybe<Array<ContactDtoInput>>;
  customerDiscount?: InputMaybe<Scalars['Float']['input']>;
  customerType?: InputMaybe<CustomerTypeInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  maxCredit?: InputMaybe<Scalars['Decimal']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pricingScheme?: InputMaybe<PricingSchemeInput>;
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
  salesAgent?: InputMaybe<SalesAgentInput>;
  salesRegion?: InputMaybe<SalesRegionInput>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<TermInput>;
};

export type CreateJobsiteDto = {
  __typename?: 'CreateJobsiteDto';
  address: Scalars['String']['output'];
  checkListId: Scalars['Int']['output'];
  city: Scalars['String']['output'];
  customerId: Scalars['Int']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  jobSiteName?: Maybe<Scalars['String']['output']>;
  jobType?: Maybe<JobSiteTypeDto>;
  latitude: Scalars['Decimal']['output'];
  longitude: Scalars['Decimal']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  powerlinePresent: Scalars['Boolean']['output'];
  pricingScheme?: Maybe<PricingSchemeDto>;
  released: Scalars['Int']['output'];
  rmxId: Scalars['Int']['output'];
  salesAgent?: Maybe<EmployeeDto>;
  salesRegion?: Maybe<SalesRegionDto>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  term?: Maybe<TermDto>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type CreateJobsiteMutationInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  customerId: Scalars['Int']['input'];
  jobSiteName?: InputMaybe<Scalars['String']['input']>;
  jobSiteType?: InputMaybe<JobSiteTypeInput>;
  latitude: Scalars['Decimal']['input'];
  longitude: Scalars['Decimal']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  powerlinePresent?: InputMaybe<Scalars['Boolean']['input']>;
  pricingScheme?: InputMaybe<PricingSchemeInput>;
  salesAgent?: InputMaybe<SalesAgentInput>;
  salesRegion?: InputMaybe<SalesRegionInput>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  term?: InputMaybe<TermInput>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type Crew = {
  __typename?: 'Crew';
  acceptedByCrewTime?: Maybe<Scalars['LocalDateTime']['output']>;
  allowNotification: Scalars['Boolean']['output'];
  arriveTime?: Maybe<Scalars['LocalDateTime']['output']>;
  arriveTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  booked?: Maybe<Scalars['Int']['output']>;
  cboGuid?: Maybe<Scalars['String']['output']>;
  crewId: Scalars['Int']['output'];
  earliestTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  empId: Scalars['Int']['output'];
  employee: Employee;
  finishTime?: Maybe<Scalars['LocalDateTime']['output']>;
  finishTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  isAcceptedByCrew: Scalars['Boolean']['output'];
  isBillable: Scalars['Boolean']['output'];
  isCrewNotified: Scalars['Boolean']['output'];
  isJobPay: Scalars['Boolean']['output'];
  isOverlappingTicketTime: Scalars['Boolean']['output'];
  isPayroll: Scalars['Boolean']['output'];
  latestTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  lvJobTime?: Maybe<Scalars['LocalDateTime']['output']>;
  lvJobTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  lvYdTime?: Maybe<Scalars['LocalDateTime']['output']>;
  lvYdTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  pour?: Maybe<PourForAdding>;
  pourId?: Maybe<Scalars['Int']['output']>;
  rdyTime?: Maybe<Scalars['LocalDateTime']['output']>;
  rdyTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  returnTime?: Maybe<Scalars['LocalDateTime']['output']>;
  returnTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  startTime?: Maybe<Scalars['LocalDateTime']['output']>;
  startTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  system?: Maybe<Scalars['Boolean']['output']>;
  ticketResourceGroupsCrew: Array<RaptorTicketResourceGroupCrew>;
  title?: Maybe<Entities_V1_CrewTitle>;
  titleId?: Maybe<Scalars['Int']['output']>;
  updatedBy: Scalars['Int']['output'];
  updatedOnUtc?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export enum CrewAssignmentStatus {
  Available = 'AVAILABLE',
  Banned = 'BANNED',
  Booked = 'BOOKED',
  None = 'NONE',
  OutOfOffice = 'OUT_OF_OFFICE'
}

export type CrewAssignmentStatusOperationFilterInput = {
  eq?: InputMaybe<CrewAssignmentStatus>;
  in?: InputMaybe<Array<CrewAssignmentStatus>>;
  neq?: InputMaybe<CrewAssignmentStatus>;
  nin?: InputMaybe<Array<CrewAssignmentStatus>>;
};

export type CrewFilterInput = {
  acceptedByCrewTime?: InputMaybe<DateTimeOperationFilterInput>;
  allowNotification?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CrewFilterInput>>;
  arriveTime?: InputMaybe<DateTimeOperationFilterInput>;
  arriveTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
  booked?: InputMaybe<IntOperationFilterInput>;
  cboGuid?: InputMaybe<StringOperationFilterInput>;
  crewId?: InputMaybe<IntOperationFilterInput>;
  earliestTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
  empId?: InputMaybe<IntOperationFilterInput>;
  employee?: InputMaybe<EmployeeFilterInput>;
  finishTime?: InputMaybe<DateTimeOperationFilterInput>;
  finishTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
  isAcceptedByCrew?: InputMaybe<BooleanOperationFilterInput>;
  isBillable?: InputMaybe<BooleanOperationFilterInput>;
  isCrewNotified?: InputMaybe<BooleanOperationFilterInput>;
  isJobPay?: InputMaybe<BooleanOperationFilterInput>;
  isOverlappingTicketTime?: InputMaybe<BooleanOperationFilterInput>;
  isPayroll?: InputMaybe<BooleanOperationFilterInput>;
  latestTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
  lvJobTime?: InputMaybe<DateTimeOperationFilterInput>;
  lvJobTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
  lvYdTime?: InputMaybe<DateTimeOperationFilterInput>;
  lvYdTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CrewFilterInput>>;
  pour?: InputMaybe<PourForAddingFilterInput>;
  pourId?: InputMaybe<IntOperationFilterInput>;
  rdyTime?: InputMaybe<DateTimeOperationFilterInput>;
  rdyTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
  returnTime?: InputMaybe<DateTimeOperationFilterInput>;
  returnTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
  startTime?: InputMaybe<DateTimeOperationFilterInput>;
  startTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<IntOperationFilterInput>;
  system?: InputMaybe<BooleanOperationFilterInput>;
  ticketResourceGroupsCrew?: InputMaybe<ListFilterInputTypeOfRaptorTicketResourceGroupCrewFilterInput>;
  title?: InputMaybe<Entities_V1_CrewTitleFilterInput>;
  titleId?: InputMaybe<IntOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedOnUtc?: InputMaybe<DateTimeOperationFilterInput>;
  userId?: InputMaybe<IntOperationFilterInput>;
};

export enum CustomFieldDataType {
  Bit = 'BIT',
  Date = 'DATE',
  DateTime = 'DATE_TIME',
  Email = 'EMAIL',
  Number = 'NUMBER',
  Phone = 'PHONE',
  Text = 'TEXT',
  TextArea = 'TEXT_AREA',
  Time = 'TIME'
}

export type CustomFieldDataTypeOperationFilterInput = {
  eq?: InputMaybe<CustomFieldDataType>;
  in?: InputMaybe<Array<CustomFieldDataType>>;
  neq?: InputMaybe<CustomFieldDataType>;
  nin?: InputMaybe<Array<CustomFieldDataType>>;
};

export type Customer = {
  __typename?: 'Customer';
  accountType?: Maybe<BizObject>;
  accountTypeId?: Maybe<Scalars['Int']['output']>;
  address?: Maybe<Address>;
  allowMobileAppAccess: Scalars['Boolean']['output'];
  allowWebPortalAccess: Scalars['Boolean']['output'];
  billAddressId?: Maybe<Scalars['Int']['output']>;
  cboGuid?: Maybe<Scalars['String']['output']>;
  checkListId?: Maybe<Scalars['Int']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  contactPeople: Array<RaptorContactInformationVw>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  createdOn: Scalars['LocalDateTime']['output'];
  custDiscount?: Maybe<Scalars['Float']['output']>;
  customTaxRate: Scalars['Decimal']['output'];
  customerCommissionRate: Scalars['Float']['output'];
  customerSince?: Maybe<Scalars['LocalDateTime']['output']>;
  customerType?: Maybe<ContentType>;
  defaultJobPo?: Maybe<Scalars['String']['output']>;
  defaultRetentionPercentage: Scalars['Decimal']['output'];
  deletable: Scalars['Boolean']['output'];
  emailInvoice: Scalars['Boolean']['output'];
  emailStatement: Scalars['Boolean']['output'];
  guid?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invMinOverride: Scalars['Decimal']['output'];
  isExemptFromFc: Scalars['Boolean']['output'];
  isGeofenceEnabled: Scalars['Boolean']['output'];
  isJobNumReq: Scalars['Boolean']['output'];
  isLotBldgReq: Scalars['Boolean']['output'];
  isNonTaxable: Scalars['Boolean']['output'];
  isPorequired: Scalars['Boolean']['output'];
  jobSites?: Maybe<Array<JobSite>>;
  jobs?: Maybe<Array<RaptorJob>>;
  lastJobDate?: Maybe<Scalars['Date']['output']>;
  lastJobDateComputed?: Maybe<Scalars['Date']['output']>;
  mailAddress?: Maybe<Address>;
  mailAddressId?: Maybe<Scalars['Int']['output']>;
  maxCredit: Scalars['Decimal']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  pourForAddings?: Maybe<Array<PourForAdding>>;
  prelimed: Scalars['Int']['output'];
  preventAutoPricingVersionChangeOnJobsite: Scalars['Boolean']['output'];
  priceId?: Maybe<Scalars['Int']['output']>;
  pricingScheme?: Maybe<PricingScheme>;
  primaryAddressId?: Maybe<Scalars['Int']['output']>;
  primaryBillingContactId?: Maybe<Scalars['Int']['output']>;
  primaryContactId?: Maybe<Scalars['Int']['output']>;
  primaryEmailId?: Maybe<Scalars['Int']['output']>;
  primaryFaxId?: Maybe<Scalars['Int']['output']>;
  primaryPhoneId?: Maybe<Scalars['Int']['output']>;
  primaryWebsiteId?: Maybe<Scalars['Int']['output']>;
  salesAgent?: Maybe<Employee>;
  salesManId1?: Maybe<Scalars['Int']['output']>;
  salesRegion?: Maybe<SalesRegion>;
  salesRegionId?: Maybe<Scalars['Int']['output']>;
  statusCustomer?: Maybe<Scalars['Int']['output']>;
  subAcct?: Maybe<Scalars['String']['output']>;
  system?: Maybe<Scalars['Boolean']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Term>;
  termId1: Scalars['Int']['output'];
  typId?: Maybe<Scalars['Int']['output']>;
  ud1?: Maybe<Scalars['String']['output']>;
  ud2?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  updatedOn?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type CustomerDto = {
  __typename?: 'CustomerDto';
  accountType?: Maybe<AccountTypeDto>;
  address?: Maybe<AddressDto>;
  availableAccountTypes?: Maybe<Array<AccountTypeDto>>;
  availableCustomerTypes?: Maybe<Array<CustomerTypeDto>>;
  availablePricingSchemes?: Maybe<Array<Dtos_V1_PricingSchemeDto>>;
  availableSalesAgents?: Maybe<Array<EmployeeDto>>;
  availableSalesRegions?: Maybe<Array<Dtos_V1_SalesRegionDto>>;
  availableTerms?: Maybe<Array<Dtos_V1_TermDto>>;
  companyName?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<Array<ContactDto>>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  createdOn: Scalars['LocalDateTime']['output'];
  customerDiscount?: Maybe<Scalars['Float']['output']>;
  customerType?: Maybe<CustomerTypeDto>;
  deletable: Scalars['Boolean']['output'];
  financialSummary?: Maybe<FinancialSummaryDto>;
  id?: Maybe<Scalars['Int']['output']>;
  maxCredit: Scalars['Decimal']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  pricingScheme?: Maybe<PricingSchemeDto>;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryPhone?: Maybe<Scalars['String']['output']>;
  salesAgent?: Maybe<EmployeeDto>;
  salesRegion?: Maybe<SalesRegionDto>;
  taxNumber?: Maybe<Scalars['String']['output']>;
  term?: Maybe<TermDto>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  updatedOn?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type CustomerDtoFilterInput = {
  accountType?: InputMaybe<AccountTypeDtoFilterInput>;
  address?: InputMaybe<AddressDtoFilterInput>;
  and?: InputMaybe<Array<CustomerDtoFilterInput>>;
  availableAccountTypes?: InputMaybe<ListFilterInputTypeOfAccountTypeDtoFilterInput>;
  availableCustomerTypes?: InputMaybe<ListFilterInputTypeOfCustomerTypeDtoFilterInput>;
  availablePricingSchemes?: InputMaybe<ListFilterInputTypeOfDtos_V1_PricingSchemeDtoFilterInput>;
  availableSalesAgents?: InputMaybe<ListFilterInputTypeOfEmployeeDtoFilterInput>;
  availableSalesRegions?: InputMaybe<ListFilterInputTypeOfDtos_V1_SalesRegionDtoFilterInput>;
  availableTerms?: InputMaybe<ListFilterInputTypeOfDtos_V1_TermDtoFilterInput>;
  companyName?: InputMaybe<StringOperationFilterInput>;
  contacts?: InputMaybe<ListFilterInputTypeOfContactDtoFilterInput>;
  createdBy?: InputMaybe<IntOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  customerDiscount?: InputMaybe<FloatOperationFilterInput>;
  customerType?: InputMaybe<CustomerTypeDtoFilterInput>;
  deletable?: InputMaybe<BooleanOperationFilterInput>;
  financialSummary?: InputMaybe<FinancialSummaryDtoFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  maxCredit?: InputMaybe<DecimalOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerDtoFilterInput>>;
  pricingScheme?: InputMaybe<PricingSchemeDtoFilterInput>;
  primaryContacts?: InputMaybe<ListFilterInputTypeOfContactDtoFilterInput>;
  primaryEmail?: InputMaybe<StringOperationFilterInput>;
  primaryPhone?: InputMaybe<StringOperationFilterInput>;
  salesAgent?: InputMaybe<EmployeeDtoFilterInput>;
  salesRegion?: InputMaybe<SalesRegionDtoFilterInput>;
  taxNumber?: InputMaybe<StringOperationFilterInput>;
  term?: InputMaybe<TermDtoFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type CustomerDtoInput = {
  accountType?: InputMaybe<AccountTypeDtoInput>;
  address?: InputMaybe<AddressDtoInput>;
  availableAccountTypes?: InputMaybe<Array<AccountTypeDtoInput>>;
  availableCustomerTypes?: InputMaybe<Array<CustomerTypeDtoInput>>;
  availablePricingSchemes?: InputMaybe<Array<Dtos_V1_PricingSchemeDtoInput>>;
  availableSalesAgents?: InputMaybe<Array<EmployeeDtoInput>>;
  availableSalesRegions?: InputMaybe<Array<Dtos_V1_SalesRegionDtoInput>>;
  availableTerms?: InputMaybe<Array<Dtos_V1_TermDtoInput>>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contacts?: InputMaybe<Array<ContactDtoInput>>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  createdOn: Scalars['LocalDateTime']['input'];
  customerDiscount?: InputMaybe<Scalars['Float']['input']>;
  customerType?: InputMaybe<CustomerTypeDtoInput>;
  deletable: Scalars['Boolean']['input'];
  financialSummary?: InputMaybe<FinancialSummaryDtoInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  maxCredit: Scalars['Decimal']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  pricingScheme?: InputMaybe<PricingSchemeDtoInput>;
  primaryContacts?: InputMaybe<Array<ContactDtoInput>>;
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
  salesAgent?: InputMaybe<EmployeeDtoInput>;
  salesRegion?: InputMaybe<SalesRegionDtoInput>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<TermDtoInput>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
  updatedOn?: InputMaybe<Scalars['LocalDateTime']['input']>;
};

export type CustomerDtoSortInput = {
  accountType?: InputMaybe<AccountTypeDtoSortInput>;
  address?: InputMaybe<AddressDtoSortInput>;
  companyName?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  customerDiscount?: InputMaybe<SortEnumType>;
  customerType?: InputMaybe<CustomerTypeDtoSortInput>;
  deletable?: InputMaybe<SortEnumType>;
  financialSummary?: InputMaybe<FinancialSummaryDtoSortInput>;
  id?: InputMaybe<SortEnumType>;
  maxCredit?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  pricingScheme?: InputMaybe<PricingSchemeDtoSortInput>;
  primaryEmail?: InputMaybe<SortEnumType>;
  primaryPhone?: InputMaybe<SortEnumType>;
  salesAgent?: InputMaybe<EmployeeDtoSortInput>;
  salesRegion?: InputMaybe<SalesRegionDtoSortInput>;
  taxNumber?: InputMaybe<SortEnumType>;
  term?: InputMaybe<TermDtoSortInput>;
  updatedBy?: InputMaybe<SortEnumType>;
  updatedOn?: InputMaybe<SortEnumType>;
};

export type CustomerFilterInput = {
  accountType?: InputMaybe<BizObjectFilterInput>;
  accountTypeId?: InputMaybe<IntOperationFilterInput>;
  address?: InputMaybe<AddressFilterInput>;
  allowMobileAppAccess?: InputMaybe<BooleanOperationFilterInput>;
  allowWebPortalAccess?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CustomerFilterInput>>;
  billAddressId?: InputMaybe<IntOperationFilterInput>;
  cboGuid?: InputMaybe<StringOperationFilterInput>;
  checkListId?: InputMaybe<IntOperationFilterInput>;
  companyName?: InputMaybe<StringOperationFilterInput>;
  contactPeople?: InputMaybe<ListFilterInputTypeOfRaptorContactInformationVwFilterInput>;
  createdBy?: InputMaybe<IntOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  custDiscount?: InputMaybe<FloatOperationFilterInput>;
  customTaxRate?: InputMaybe<DecimalOperationFilterInput>;
  customerCommissionRate?: InputMaybe<FloatOperationFilterInput>;
  customerSince?: InputMaybe<DateTimeOperationFilterInput>;
  customerType?: InputMaybe<ContentTypeFilterInput>;
  defaultJobPo?: InputMaybe<StringOperationFilterInput>;
  defaultRetentionPercentage?: InputMaybe<DecimalOperationFilterInput>;
  deletable?: InputMaybe<BooleanOperationFilterInput>;
  emailInvoice?: InputMaybe<BooleanOperationFilterInput>;
  emailStatement?: InputMaybe<BooleanOperationFilterInput>;
  guid?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  invMinOverride?: InputMaybe<DecimalOperationFilterInput>;
  isExemptFromFc?: InputMaybe<BooleanOperationFilterInput>;
  isGeofenceEnabled?: InputMaybe<BooleanOperationFilterInput>;
  isJobNumReq?: InputMaybe<BooleanOperationFilterInput>;
  isLotBldgReq?: InputMaybe<BooleanOperationFilterInput>;
  isNonTaxable?: InputMaybe<BooleanOperationFilterInput>;
  isPorequired?: InputMaybe<BooleanOperationFilterInput>;
  jobSites?: InputMaybe<ListFilterInputTypeOfJobSiteFilterInput>;
  jobs?: InputMaybe<ListFilterInputTypeOfRaptorJobFilterInput>;
  lastJobDate?: InputMaybe<DateOperationFilterInput>;
  lastJobDateComputed?: InputMaybe<DateOperationFilterInput>;
  mailAddress?: InputMaybe<AddressFilterInput>;
  mailAddressId?: InputMaybe<IntOperationFilterInput>;
  maxCredit?: InputMaybe<DecimalOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerFilterInput>>;
  pourForAddings?: InputMaybe<ListFilterInputTypeOfPourForAddingFilterInput>;
  prelimed?: InputMaybe<IntOperationFilterInput>;
  preventAutoPricingVersionChangeOnJobsite?: InputMaybe<BooleanOperationFilterInput>;
  priceId?: InputMaybe<IntOperationFilterInput>;
  pricingScheme?: InputMaybe<PricingSchemeFilterInput>;
  primaryAddressId?: InputMaybe<IntOperationFilterInput>;
  primaryBillingContactId?: InputMaybe<IntOperationFilterInput>;
  primaryContactId?: InputMaybe<IntOperationFilterInput>;
  primaryEmailId?: InputMaybe<IntOperationFilterInput>;
  primaryFaxId?: InputMaybe<IntOperationFilterInput>;
  primaryPhoneId?: InputMaybe<IntOperationFilterInput>;
  primaryWebsiteId?: InputMaybe<IntOperationFilterInput>;
  salesAgent?: InputMaybe<EmployeeFilterInput>;
  salesManId1?: InputMaybe<IntOperationFilterInput>;
  salesRegion?: InputMaybe<SalesRegionFilterInput>;
  salesRegionId?: InputMaybe<IntOperationFilterInput>;
  statusCustomer?: InputMaybe<IntOperationFilterInput>;
  subAcct?: InputMaybe<StringOperationFilterInput>;
  system?: InputMaybe<BooleanOperationFilterInput>;
  taxId?: InputMaybe<StringOperationFilterInput>;
  term?: InputMaybe<TermFilterInput>;
  termId1?: InputMaybe<IntOperationFilterInput>;
  typId?: InputMaybe<IntOperationFilterInput>;
  ud1?: InputMaybe<StringOperationFilterInput>;
  ud2?: InputMaybe<StringOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type CustomerInvoice = {
  __typename?: 'CustomerInvoice';
  amountPaid: Scalars['Decimal']['output'];
  customerId: Scalars['Int']['output'];
  dueOn?: Maybe<Scalars['Date']['output']>;
  fullyPaidOn?: Maybe<Scalars['Date']['output']>;
  grandTotal?: Maybe<Scalars['Decimal']['output']>;
  hasBalance?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isEmailed: Scalars['Boolean']['output'];
  isProcessed: Scalars['Boolean']['output'];
  openBalance?: Maybe<Scalars['Decimal']['output']>;
  pour: PourForAdding;
  pourId: Scalars['Int']['output'];
};

export type CustomerInvoiceFilterInput = {
  amountPaid?: InputMaybe<DecimalOperationFilterInput>;
  and?: InputMaybe<Array<CustomerInvoiceFilterInput>>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  dueOn?: InputMaybe<DateOperationFilterInput>;
  fullyPaidOn?: InputMaybe<DateOperationFilterInput>;
  grandTotal?: InputMaybe<DecimalOperationFilterInput>;
  hasBalance?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isEmailed?: InputMaybe<BooleanOperationFilterInput>;
  isProcessed?: InputMaybe<BooleanOperationFilterInput>;
  openBalance?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<CustomerInvoiceFilterInput>>;
  pour?: InputMaybe<PourForAddingFilterInput>;
  pourId?: InputMaybe<IntOperationFilterInput>;
};

export type CustomerSortInput = {
  accountType?: InputMaybe<BizObjectSortInput>;
  accountTypeId?: InputMaybe<SortEnumType>;
  address?: InputMaybe<AddressSortInput>;
  allowMobileAppAccess?: InputMaybe<SortEnumType>;
  allowWebPortalAccess?: InputMaybe<SortEnumType>;
  billAddressId?: InputMaybe<SortEnumType>;
  cboGuid?: InputMaybe<SortEnumType>;
  checkListId?: InputMaybe<SortEnumType>;
  companyName?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  custDiscount?: InputMaybe<SortEnumType>;
  customTaxRate?: InputMaybe<SortEnumType>;
  customerCommissionRate?: InputMaybe<SortEnumType>;
  customerSince?: InputMaybe<SortEnumType>;
  customerType?: InputMaybe<ContentTypeSortInput>;
  defaultJobPo?: InputMaybe<SortEnumType>;
  defaultRetentionPercentage?: InputMaybe<SortEnumType>;
  deletable?: InputMaybe<SortEnumType>;
  emailInvoice?: InputMaybe<SortEnumType>;
  emailStatement?: InputMaybe<SortEnumType>;
  guid?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  invMinOverride?: InputMaybe<SortEnumType>;
  isExemptFromFc?: InputMaybe<SortEnumType>;
  isGeofenceEnabled?: InputMaybe<SortEnumType>;
  isJobNumReq?: InputMaybe<SortEnumType>;
  isLotBldgReq?: InputMaybe<SortEnumType>;
  isNonTaxable?: InputMaybe<SortEnumType>;
  isPorequired?: InputMaybe<SortEnumType>;
  lastJobDate?: InputMaybe<SortEnumType>;
  lastJobDateComputed?: InputMaybe<SortEnumType>;
  mailAddress?: InputMaybe<AddressSortInput>;
  mailAddressId?: InputMaybe<SortEnumType>;
  maxCredit?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  prelimed?: InputMaybe<SortEnumType>;
  preventAutoPricingVersionChangeOnJobsite?: InputMaybe<SortEnumType>;
  priceId?: InputMaybe<SortEnumType>;
  pricingScheme?: InputMaybe<PricingSchemeSortInput>;
  primaryAddressId?: InputMaybe<SortEnumType>;
  primaryBillingContactId?: InputMaybe<SortEnumType>;
  primaryContactId?: InputMaybe<SortEnumType>;
  primaryEmailId?: InputMaybe<SortEnumType>;
  primaryFaxId?: InputMaybe<SortEnumType>;
  primaryPhoneId?: InputMaybe<SortEnumType>;
  primaryWebsiteId?: InputMaybe<SortEnumType>;
  salesAgent?: InputMaybe<EmployeeSortInput>;
  salesManId1?: InputMaybe<SortEnumType>;
  salesRegion?: InputMaybe<SalesRegionSortInput>;
  salesRegionId?: InputMaybe<SortEnumType>;
  statusCustomer?: InputMaybe<SortEnumType>;
  subAcct?: InputMaybe<SortEnumType>;
  system?: InputMaybe<SortEnumType>;
  taxId?: InputMaybe<SortEnumType>;
  term?: InputMaybe<TermSortInput>;
  termId1?: InputMaybe<SortEnumType>;
  typId?: InputMaybe<SortEnumType>;
  ud1?: InputMaybe<SortEnumType>;
  ud2?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  updatedOn?: InputMaybe<SortEnumType>;
};

export enum CustomerStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type CustomerStatusOperationFilterInput = {
  eq?: InputMaybe<CustomerStatus>;
  in?: InputMaybe<Array<CustomerStatus>>;
  neq?: InputMaybe<CustomerStatus>;
  nin?: InputMaybe<Array<CustomerStatus>>;
};

export type CustomerTypeDto = {
  __typename?: 'CustomerTypeDto';
  id: Scalars['Int']['output'];
  typeName: Scalars['String']['output'];
};

export type CustomerTypeDtoFilterInput = {
  and?: InputMaybe<Array<CustomerTypeDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<CustomerTypeDtoFilterInput>>;
  typeName?: InputMaybe<StringOperationFilterInput>;
};

export type CustomerTypeDtoInput = {
  id: Scalars['Int']['input'];
  typeName: Scalars['String']['input'];
};

export type CustomerTypeDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  typeName?: InputMaybe<SortEnumType>;
};

export type CustomerTypeInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  typeName?: InputMaybe<Scalars['String']['input']>;
};

/** A segment of a collection. */
export type CustomerTypesCollectionSegment = {
  __typename?: 'CustomerTypesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CustomerTypeDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type CustomersCollectionSegment = {
  __typename?: 'CustomersCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V2_Customer_CustomerDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type CustomersContactsResultDto = {
  __typename?: 'CustomersContactsResultDto';
  customersContacts?: Maybe<Array<ContactDto>>;
  totalCount: Scalars['Int']['output'];
};

export type DateOperationFilterInput = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  neq?: InputMaybe<Scalars['Date']['input']>;
  ngt?: InputMaybe<Scalars['Date']['input']>;
  ngte?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  nlt?: InputMaybe<Scalars['Date']['input']>;
  nlte?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
  ngt?: InputMaybe<Scalars['Decimal']['input']>;
  ngte?: InputMaybe<Scalars['Decimal']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']['input']>>>;
  nlt?: InputMaybe<Scalars['Decimal']['input']>;
  nlte?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DeleteCustomerContactsMutationInput = {
  contactsToDelete: Array<Scalars['Int']['input']>;
};

export type DeleteCustomerMutationInput = {
  id: Scalars['Int']['input'];
};

export type DeleteJobSiteMutationInput = {
  id: Scalars['Int']['input'];
};

/** A segment of a collection. */
export type DispatchLocationsCollectionSegment = {
  __typename?: 'DispatchLocationsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V1_DispatchLocationDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type DispatchersCollectionSegment = {
  __typename?: 'DispatchersCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V2_Employee_EmployeeDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Dtos_V1_ClassDto = {
  __typename?: 'Dtos_V1_ClassDto';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V1_ClassDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_ClassDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_ClassDtoFilterInput>>;
};

export type Dtos_V1_ClassDtoInput = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Dtos_V1_ClassDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Dtos_V1_CrewAssingmentInputDtoInput = {
  fullName: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  role: Dtos_V1_CrewRoleDtoInput;
};

export type Dtos_V1_CrewDto = {
  __typename?: 'Dtos_V1_CrewDto';
  allowMobileAppAccess?: Maybe<Scalars['Boolean']['output']>;
  assignedEquipment?: Maybe<Scalars['String']['output']>;
  availableDispatchLocations?: Maybe<Array<Dtos_V1_LocationDto>>;
  availableEmploymentStatuses?: Maybe<Array<Dtos_V1_EmploymentStatusDto>>;
  availableEmploymentTypes?: Maybe<Array<Dtos_V1_EmploymentTypeDto>>;
  availableJobRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  availableOutOfOfficeReasons?: Maybe<Array<Dtos_V1_Employee_OutOfOfficeReasonDto>>;
  availableSystemRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  availableWorkLocations?: Maybe<Array<Dtos_V1_LocationDto>>;
  balance?: Maybe<Scalars['Float']['output']>;
  clockStatus?: Maybe<Scalars['String']['output']>;
  clockTime?: Maybe<Scalars['LocalDateTime']['output']>;
  clockingMode?: Maybe<Scalars['Short']['output']>;
  companyTemp?: Maybe<Scalars['String']['output']>;
  currentStatus?: Maybe<Scalars['Int']['output']>;
  dateOfBirth?: Maybe<Scalars['LocalDateTime']['output']>;
  daysOut?: Maybe<Scalars['Int']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  defaultEmployeeCrewRoleId?: Maybe<Scalars['Int']['output']>;
  deletable?: Maybe<Scalars['Boolean']['output']>;
  dispatchLocation?: Maybe<Dtos_V1_LocationDto>;
  dotHours5Day?: Maybe<Scalars['Decimal']['output']>;
  dotHours6Day?: Maybe<Scalars['Decimal']['output']>;
  dotHours7Day?: Maybe<Scalars['Decimal']['output']>;
  dotHours8Day?: Maybe<Scalars['Decimal']['output']>;
  driversLicense?: Maybe<Dtos_V1_DriversLicenseDto>;
  eid?: Maybe<Scalars['String']['output']>;
  email?: Maybe<ContactInformationDto>;
  employeeStatus?: Maybe<Scalars['Int']['output']>;
  employmentStatus?: Maybe<Dtos_V1_EmploymentStatusDto>;
  employmentType?: Maybe<EmploymentType>;
  endDate?: Maybe<Scalars['LocalDateTime']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gpsPasswordHash?: Maybe<Array<Scalars['Byte']['output']>>;
  gpsUsername?: Maybe<Scalars['String']['output']>;
  gridColor?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  inactive?: Maybe<Scalars['Boolean']['output']>;
  isGeofenceEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPayroll?: Maybe<Scalars['Boolean']['output']>;
  isSystem?: Maybe<Scalars['Boolean']['output']>;
  jobRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  notesTemp?: Maybe<Scalars['String']['output']>;
  outOfOfficeHistory?: Maybe<Array<Dtos_V1_Employee_EmployeeOutOfOfficeDto>>;
  payPerHour?: Maybe<Scalars['Decimal']['output']>;
  phoneNumber?: Maybe<ContactInformationDto>;
  photo?: Maybe<Array<Scalars['Byte']['output']>>;
  pinHashed?: Maybe<Scalars['String']['output']>;
  role: Dtos_V1_CrewRoleDto;
  salesmanCommissionRate?: Maybe<Scalars['Float']['output']>;
  seniorityCode?: Maybe<Scalars['String']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['LocalDateTime']['output']>;
  supportedRoleIds: Array<Scalars['Int']['output']>;
  systemRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  temporaryEmployee?: Maybe<Scalars['Int']['output']>;
  ud1?: Maybe<Scalars['String']['output']>;
  ud2?: Maybe<Scalars['String']['output']>;
  upcomingOutOfOffice?: Maybe<Array<Dtos_V1_Employee_EmployeeOutOfOfficeDto>>;
  updatedBy?: Maybe<Dtos_V1_Employee_EmployeeReferenceDto>;
  updatedOn?: Maybe<Scalars['LocalDateTime']['output']>;
  usable?: Maybe<Scalars['Boolean']['output']>;
  workLocation?: Maybe<Dtos_V1_LocationDto>;
};

export type Dtos_V1_CrewDtoFilterInput = {
  allowMobileAppAccess?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<Dtos_V1_CrewDtoFilterInput>>;
  assignedEquipment?: InputMaybe<StringOperationFilterInput>;
  availableDispatchLocations?: InputMaybe<ListFilterInputTypeOfDtos_V1_LocationDtoFilterInput>;
  availableEmploymentStatuses?: InputMaybe<ListFilterInputTypeOfDtos_V1_EmploymentStatusDtoFilterInput>;
  availableEmploymentTypes?: InputMaybe<ListFilterInputTypeOfDtos_V1_EmploymentTypeDtoFilterInput>;
  availableJobRoles?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput>;
  availableOutOfOfficeReasons?: InputMaybe<ListFilterInputTypeOfDtos_V1_Employee_OutOfOfficeReasonDtoFilterInput>;
  availableSystemRoles?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput>;
  availableWorkLocations?: InputMaybe<ListFilterInputTypeOfDtos_V1_LocationDtoFilterInput>;
  balance?: InputMaybe<FloatOperationFilterInput>;
  clockStatus?: InputMaybe<StringOperationFilterInput>;
  clockTime?: InputMaybe<DateTimeOperationFilterInput>;
  clockingMode?: InputMaybe<ShortOperationFilterInput>;
  companyTemp?: InputMaybe<StringOperationFilterInput>;
  currentStatus?: InputMaybe<IntOperationFilterInput>;
  dateOfBirth?: InputMaybe<DateTimeOperationFilterInput>;
  daysOut?: InputMaybe<IntOperationFilterInput>;
  default?: InputMaybe<BooleanOperationFilterInput>;
  defaultEmployeeCrewRoleId?: InputMaybe<IntOperationFilterInput>;
  deletable?: InputMaybe<BooleanOperationFilterInput>;
  dispatchLocation?: InputMaybe<Dtos_V1_LocationDtoFilterInput>;
  dotHours5Day?: InputMaybe<DecimalOperationFilterInput>;
  dotHours6Day?: InputMaybe<DecimalOperationFilterInput>;
  dotHours7Day?: InputMaybe<DecimalOperationFilterInput>;
  dotHours8Day?: InputMaybe<DecimalOperationFilterInput>;
  driversLicense?: InputMaybe<Dtos_V1_DriversLicenseDtoFilterInput>;
  eid?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<ContactInformationDtoFilterInput>;
  employeeStatus?: InputMaybe<IntOperationFilterInput>;
  employmentStatus?: InputMaybe<Dtos_V1_EmploymentStatusDtoFilterInput>;
  employmentType?: InputMaybe<NullableOfEmploymentTypeOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  fax?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  gpsPasswordHash?: InputMaybe<ListByteOperationFilterInput>;
  gpsUsername?: InputMaybe<StringOperationFilterInput>;
  gridColor?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  inactive?: InputMaybe<BooleanOperationFilterInput>;
  isGeofenceEnabled?: InputMaybe<BooleanOperationFilterInput>;
  isPayroll?: InputMaybe<BooleanOperationFilterInput>;
  isSystem?: InputMaybe<BooleanOperationFilterInput>;
  jobRoles?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  notesTemp?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_CrewDtoFilterInput>>;
  outOfOfficeHistory?: InputMaybe<ListFilterInputTypeOfDtos_V1_Employee_EmployeeOutOfOfficeDtoFilterInput>;
  payPerHour?: InputMaybe<DecimalOperationFilterInput>;
  phoneNumber?: InputMaybe<ContactInformationDtoFilterInput>;
  photo?: InputMaybe<ListByteOperationFilterInput>;
  pinHashed?: InputMaybe<StringOperationFilterInput>;
  role?: InputMaybe<Dtos_V1_CrewRoleDtoFilterInput>;
  salesmanCommissionRate?: InputMaybe<FloatOperationFilterInput>;
  seniorityCode?: InputMaybe<StringOperationFilterInput>;
  ssn?: InputMaybe<StringOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  supportedRoleIds?: InputMaybe<ListIntOperationFilterInput>;
  systemRoles?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput>;
  temporaryEmployee?: InputMaybe<IntOperationFilterInput>;
  ud1?: InputMaybe<StringOperationFilterInput>;
  ud2?: InputMaybe<StringOperationFilterInput>;
  upcomingOutOfOffice?: InputMaybe<ListFilterInputTypeOfDtos_V1_Employee_EmployeeOutOfOfficeDtoFilterInput>;
  updatedBy?: InputMaybe<Dtos_V1_Employee_EmployeeReferenceDtoFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
  usable?: InputMaybe<BooleanOperationFilterInput>;
  workLocation?: InputMaybe<Dtos_V1_LocationDtoFilterInput>;
};

export type Dtos_V1_CrewDtoInput = {
  allowMobileAppAccess?: InputMaybe<Scalars['Boolean']['input']>;
  assignedEquipment?: InputMaybe<Scalars['String']['input']>;
  availableDispatchLocations?: InputMaybe<Array<Dtos_V1_LocationDtoInput>>;
  availableEmploymentStatuses?: InputMaybe<Array<Dtos_V1_EmploymentStatusDtoInput>>;
  availableEmploymentTypes?: InputMaybe<Array<Dtos_V1_EmploymentTypeDtoInput>>;
  availableJobRoles?: InputMaybe<Array<Dtos_V1_CrewRoleDtoInput>>;
  availableOutOfOfficeReasons?: InputMaybe<Array<Dtos_V1_Employee_OutOfOfficeReasonDtoInput>>;
  availableSystemRoles?: InputMaybe<Array<Dtos_V1_CrewRoleDtoInput>>;
  availableWorkLocations?: InputMaybe<Array<Dtos_V1_LocationDtoInput>>;
  balance?: InputMaybe<Scalars['Float']['input']>;
  clockStatus?: InputMaybe<Scalars['String']['input']>;
  clockTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  clockingMode?: InputMaybe<Scalars['Short']['input']>;
  companyTemp?: InputMaybe<Scalars['String']['input']>;
  currentStatus?: InputMaybe<Scalars['Int']['input']>;
  dateOfBirth?: InputMaybe<Scalars['LocalDateTime']['input']>;
  daysOut?: InputMaybe<Scalars['Int']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  defaultEmployeeCrewRoleId?: InputMaybe<Scalars['Int']['input']>;
  deletable?: InputMaybe<Scalars['Boolean']['input']>;
  dispatchLocation?: InputMaybe<Dtos_V1_LocationDtoInput>;
  dotHours5Day?: InputMaybe<Scalars['Decimal']['input']>;
  dotHours6Day?: InputMaybe<Scalars['Decimal']['input']>;
  dotHours7Day?: InputMaybe<Scalars['Decimal']['input']>;
  dotHours8Day?: InputMaybe<Scalars['Decimal']['input']>;
  driversLicense?: InputMaybe<Dtos_V1_DriversLicenseDtoInput>;
  eid?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<ContactInformationDtoInput>;
  employeeStatus?: InputMaybe<Scalars['Int']['input']>;
  employmentStatus?: InputMaybe<Dtos_V1_EmploymentStatusDtoInput>;
  employmentType?: InputMaybe<EmploymentType>;
  endDate?: InputMaybe<Scalars['LocalDateTime']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gpsPasswordHash?: InputMaybe<Array<Scalars['Byte']['input']>>;
  gpsUsername?: InputMaybe<Scalars['String']['input']>;
  gridColor?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  isGeofenceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPayroll?: InputMaybe<Scalars['Boolean']['input']>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  jobRoles?: InputMaybe<Array<Dtos_V1_CrewRoleDtoInput>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notesTemp?: InputMaybe<Scalars['String']['input']>;
  outOfOfficeHistory?: InputMaybe<Array<Dtos_V1_Employee_EmployeeOutOfOfficeDtoInput>>;
  payPerHour?: InputMaybe<Scalars['Decimal']['input']>;
  phoneNumber?: InputMaybe<ContactInformationDtoInput>;
  photo?: InputMaybe<Array<Scalars['Byte']['input']>>;
  pinHashed?: InputMaybe<Scalars['String']['input']>;
  role: Dtos_V1_CrewRoleDtoInput;
  salesmanCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  seniorityCode?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['LocalDateTime']['input']>;
  supportedRoleIds: Array<Scalars['Int']['input']>;
  systemRoles?: InputMaybe<Array<Dtos_V1_CrewRoleDtoInput>>;
  temporaryEmployee?: InputMaybe<Scalars['Int']['input']>;
  ud1?: InputMaybe<Scalars['String']['input']>;
  ud2?: InputMaybe<Scalars['String']['input']>;
  upcomingOutOfOffice?: InputMaybe<Array<Dtos_V1_Employee_EmployeeOutOfOfficeDtoInput>>;
  updatedBy?: InputMaybe<Dtos_V1_Employee_EmployeeReferenceDtoInput>;
  updatedOn?: InputMaybe<Scalars['LocalDateTime']['input']>;
  usable?: InputMaybe<Scalars['Boolean']['input']>;
  workLocation?: InputMaybe<Dtos_V1_LocationDtoInput>;
};

export type Dtos_V1_CrewRoleDto = {
  __typename?: 'Dtos_V1_CrewRoleDto';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V1_CrewRoleDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_CrewRoleDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_CrewRoleDtoFilterInput>>;
};

export type Dtos_V1_CrewRoleDtoInput = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Dtos_V1_CrewRoleDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Dtos_V1_DispatchLocationDto = {
  __typename?: 'Dtos_V1_DispatchLocationDto';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V1_DispatchLocationDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_DispatchLocationDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_DispatchLocationDtoFilterInput>>;
};

export type Dtos_V1_DispatchLocationDtoInput = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Dtos_V1_DispatchLocationDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Dtos_V1_DriversLicenseDto = {
  __typename?: 'Dtos_V1_DriversLicenseDto';
  number?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V1_DriversLicenseDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_DriversLicenseDtoFilterInput>>;
  number?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_DriversLicenseDtoFilterInput>>;
  state?: InputMaybe<StringOperationFilterInput>;
};

export type Dtos_V1_DriversLicenseDtoInput = {
  number?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type Dtos_V1_DriversLicenseDtoSortInput = {
  number?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
};

export type Dtos_V1_EmployeeDto = {
  __typename?: 'Dtos_V1_EmployeeDto';
  allowMobileAppAccess?: Maybe<Scalars['Boolean']['output']>;
  assignedEquipment?: Maybe<Scalars['String']['output']>;
  availableDispatchLocations?: Maybe<Array<Dtos_V1_LocationDto>>;
  availableEmploymentStatuses?: Maybe<Array<Dtos_V1_EmploymentStatusDto>>;
  availableEmploymentTypes?: Maybe<Array<Dtos_V1_EmploymentTypeDto>>;
  availableJobRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  availableOutOfOfficeReasons?: Maybe<Array<Dtos_V1_Employee_OutOfOfficeReasonDto>>;
  availableSystemRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  availableWorkLocations?: Maybe<Array<Dtos_V1_LocationDto>>;
  balance?: Maybe<Scalars['Float']['output']>;
  clockStatus?: Maybe<Scalars['String']['output']>;
  clockTime?: Maybe<Scalars['LocalDateTime']['output']>;
  clockingMode?: Maybe<Scalars['Short']['output']>;
  companyTemp?: Maybe<Scalars['String']['output']>;
  currentStatus?: Maybe<Scalars['Int']['output']>;
  dateOfBirth?: Maybe<Scalars['LocalDateTime']['output']>;
  daysOut?: Maybe<Scalars['Int']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  defaultEmployeeCrewRoleId?: Maybe<Scalars['Int']['output']>;
  deletable?: Maybe<Scalars['Boolean']['output']>;
  dispatchLocation?: Maybe<Dtos_V1_LocationDto>;
  dotHours5Day?: Maybe<Scalars['Decimal']['output']>;
  dotHours6Day?: Maybe<Scalars['Decimal']['output']>;
  dotHours7Day?: Maybe<Scalars['Decimal']['output']>;
  dotHours8Day?: Maybe<Scalars['Decimal']['output']>;
  driversLicense?: Maybe<Dtos_V1_DriversLicenseDto>;
  eid?: Maybe<Scalars['String']['output']>;
  email?: Maybe<ContactInformationDto>;
  employeeStatus?: Maybe<Scalars['Int']['output']>;
  employmentStatus?: Maybe<Dtos_V1_EmploymentStatusDto>;
  employmentType?: Maybe<EmploymentType>;
  endDate?: Maybe<Scalars['LocalDateTime']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gpsPasswordHash?: Maybe<Array<Scalars['Byte']['output']>>;
  gpsUsername?: Maybe<Scalars['String']['output']>;
  gridColor?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  inactive?: Maybe<Scalars['Boolean']['output']>;
  isGeofenceEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPayroll?: Maybe<Scalars['Boolean']['output']>;
  isSystem?: Maybe<Scalars['Boolean']['output']>;
  jobRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  notesTemp?: Maybe<Scalars['String']['output']>;
  outOfOfficeHistory?: Maybe<Array<Dtos_V1_Employee_EmployeeOutOfOfficeDto>>;
  payPerHour?: Maybe<Scalars['Decimal']['output']>;
  phoneNumber?: Maybe<ContactInformationDto>;
  photo?: Maybe<Array<Scalars['Byte']['output']>>;
  pinHashed?: Maybe<Scalars['String']['output']>;
  salesmanCommissionRate?: Maybe<Scalars['Float']['output']>;
  seniorityCode?: Maybe<Scalars['String']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['LocalDateTime']['output']>;
  systemRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  temporaryEmployee?: Maybe<Scalars['Int']['output']>;
  ud1?: Maybe<Scalars['String']['output']>;
  ud2?: Maybe<Scalars['String']['output']>;
  upcomingOutOfOffice?: Maybe<Array<Dtos_V1_Employee_EmployeeOutOfOfficeDto>>;
  updatedBy?: Maybe<Dtos_V1_Employee_EmployeeReferenceDto>;
  updatedOn?: Maybe<Scalars['LocalDateTime']['output']>;
  usable?: Maybe<Scalars['Boolean']['output']>;
  workLocation?: Maybe<Dtos_V1_LocationDto>;
};

export type Dtos_V1_EmployeeDtoFilterInput = {
  allowMobileAppAccess?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<Dtos_V1_EmployeeDtoFilterInput>>;
  assignedEquipment?: InputMaybe<StringOperationFilterInput>;
  availableDispatchLocations?: InputMaybe<ListFilterInputTypeOfDtos_V1_LocationDtoFilterInput>;
  availableEmploymentStatuses?: InputMaybe<ListFilterInputTypeOfDtos_V1_EmploymentStatusDtoFilterInput>;
  availableEmploymentTypes?: InputMaybe<ListFilterInputTypeOfDtos_V1_EmploymentTypeDtoFilterInput>;
  availableJobRoles?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput>;
  availableOutOfOfficeReasons?: InputMaybe<ListFilterInputTypeOfDtos_V1_Employee_OutOfOfficeReasonDtoFilterInput>;
  availableSystemRoles?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput>;
  availableWorkLocations?: InputMaybe<ListFilterInputTypeOfDtos_V1_LocationDtoFilterInput>;
  balance?: InputMaybe<FloatOperationFilterInput>;
  clockStatus?: InputMaybe<StringOperationFilterInput>;
  clockTime?: InputMaybe<DateTimeOperationFilterInput>;
  clockingMode?: InputMaybe<ShortOperationFilterInput>;
  companyTemp?: InputMaybe<StringOperationFilterInput>;
  currentStatus?: InputMaybe<IntOperationFilterInput>;
  dateOfBirth?: InputMaybe<DateTimeOperationFilterInput>;
  daysOut?: InputMaybe<IntOperationFilterInput>;
  default?: InputMaybe<BooleanOperationFilterInput>;
  defaultEmployeeCrewRoleId?: InputMaybe<IntOperationFilterInput>;
  deletable?: InputMaybe<BooleanOperationFilterInput>;
  dispatchLocation?: InputMaybe<Dtos_V1_LocationDtoFilterInput>;
  dotHours5Day?: InputMaybe<DecimalOperationFilterInput>;
  dotHours6Day?: InputMaybe<DecimalOperationFilterInput>;
  dotHours7Day?: InputMaybe<DecimalOperationFilterInput>;
  dotHours8Day?: InputMaybe<DecimalOperationFilterInput>;
  driversLicense?: InputMaybe<Dtos_V1_DriversLicenseDtoFilterInput>;
  eid?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<ContactInformationDtoFilterInput>;
  employeeStatus?: InputMaybe<IntOperationFilterInput>;
  employmentStatus?: InputMaybe<Dtos_V1_EmploymentStatusDtoFilterInput>;
  employmentType?: InputMaybe<NullableOfEmploymentTypeOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  fax?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  gpsPasswordHash?: InputMaybe<ListByteOperationFilterInput>;
  gpsUsername?: InputMaybe<StringOperationFilterInput>;
  gridColor?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  inactive?: InputMaybe<BooleanOperationFilterInput>;
  isGeofenceEnabled?: InputMaybe<BooleanOperationFilterInput>;
  isPayroll?: InputMaybe<BooleanOperationFilterInput>;
  isSystem?: InputMaybe<BooleanOperationFilterInput>;
  jobRoles?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  notesTemp?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_EmployeeDtoFilterInput>>;
  outOfOfficeHistory?: InputMaybe<ListFilterInputTypeOfDtos_V1_Employee_EmployeeOutOfOfficeDtoFilterInput>;
  payPerHour?: InputMaybe<DecimalOperationFilterInput>;
  phoneNumber?: InputMaybe<ContactInformationDtoFilterInput>;
  photo?: InputMaybe<ListByteOperationFilterInput>;
  pinHashed?: InputMaybe<StringOperationFilterInput>;
  salesmanCommissionRate?: InputMaybe<FloatOperationFilterInput>;
  seniorityCode?: InputMaybe<StringOperationFilterInput>;
  ssn?: InputMaybe<StringOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  systemRoles?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput>;
  temporaryEmployee?: InputMaybe<IntOperationFilterInput>;
  ud1?: InputMaybe<StringOperationFilterInput>;
  ud2?: InputMaybe<StringOperationFilterInput>;
  upcomingOutOfOffice?: InputMaybe<ListFilterInputTypeOfDtos_V1_Employee_EmployeeOutOfOfficeDtoFilterInput>;
  updatedBy?: InputMaybe<Dtos_V1_Employee_EmployeeReferenceDtoFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
  usable?: InputMaybe<BooleanOperationFilterInput>;
  workLocation?: InputMaybe<Dtos_V1_LocationDtoFilterInput>;
};

export type Dtos_V1_EmployeeDtoInput = {
  allowMobileAppAccess?: InputMaybe<Scalars['Boolean']['input']>;
  assignedEquipment?: InputMaybe<Scalars['String']['input']>;
  availableDispatchLocations?: InputMaybe<Array<Dtos_V1_LocationDtoInput>>;
  availableEmploymentStatuses?: InputMaybe<Array<Dtos_V1_EmploymentStatusDtoInput>>;
  availableEmploymentTypes?: InputMaybe<Array<Dtos_V1_EmploymentTypeDtoInput>>;
  availableJobRoles?: InputMaybe<Array<Dtos_V1_CrewRoleDtoInput>>;
  availableOutOfOfficeReasons?: InputMaybe<Array<Dtos_V1_Employee_OutOfOfficeReasonDtoInput>>;
  availableSystemRoles?: InputMaybe<Array<Dtos_V1_CrewRoleDtoInput>>;
  availableWorkLocations?: InputMaybe<Array<Dtos_V1_LocationDtoInput>>;
  balance?: InputMaybe<Scalars['Float']['input']>;
  clockStatus?: InputMaybe<Scalars['String']['input']>;
  clockTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  clockingMode?: InputMaybe<Scalars['Short']['input']>;
  companyTemp?: InputMaybe<Scalars['String']['input']>;
  currentStatus?: InputMaybe<Scalars['Int']['input']>;
  dateOfBirth?: InputMaybe<Scalars['LocalDateTime']['input']>;
  daysOut?: InputMaybe<Scalars['Int']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  defaultEmployeeCrewRoleId?: InputMaybe<Scalars['Int']['input']>;
  deletable?: InputMaybe<Scalars['Boolean']['input']>;
  dispatchLocation?: InputMaybe<Dtos_V1_LocationDtoInput>;
  dotHours5Day?: InputMaybe<Scalars['Decimal']['input']>;
  dotHours6Day?: InputMaybe<Scalars['Decimal']['input']>;
  dotHours7Day?: InputMaybe<Scalars['Decimal']['input']>;
  dotHours8Day?: InputMaybe<Scalars['Decimal']['input']>;
  driversLicense?: InputMaybe<Dtos_V1_DriversLicenseDtoInput>;
  eid?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<ContactInformationDtoInput>;
  employeeStatus?: InputMaybe<Scalars['Int']['input']>;
  employmentStatus?: InputMaybe<Dtos_V1_EmploymentStatusDtoInput>;
  employmentType?: InputMaybe<EmploymentType>;
  endDate?: InputMaybe<Scalars['LocalDateTime']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gpsPasswordHash?: InputMaybe<Array<Scalars['Byte']['input']>>;
  gpsUsername?: InputMaybe<Scalars['String']['input']>;
  gridColor?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  isGeofenceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPayroll?: InputMaybe<Scalars['Boolean']['input']>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  jobRoles?: InputMaybe<Array<Dtos_V1_CrewRoleDtoInput>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  notesTemp?: InputMaybe<Scalars['String']['input']>;
  outOfOfficeHistory?: InputMaybe<Array<Dtos_V1_Employee_EmployeeOutOfOfficeDtoInput>>;
  payPerHour?: InputMaybe<Scalars['Decimal']['input']>;
  phoneNumber?: InputMaybe<ContactInformationDtoInput>;
  photo?: InputMaybe<Array<Scalars['Byte']['input']>>;
  pinHashed?: InputMaybe<Scalars['String']['input']>;
  salesmanCommissionRate?: InputMaybe<Scalars['Float']['input']>;
  seniorityCode?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['LocalDateTime']['input']>;
  systemRoles?: InputMaybe<Array<Dtos_V1_CrewRoleDtoInput>>;
  temporaryEmployee?: InputMaybe<Scalars['Int']['input']>;
  ud1?: InputMaybe<Scalars['String']['input']>;
  ud2?: InputMaybe<Scalars['String']['input']>;
  upcomingOutOfOffice?: InputMaybe<Array<Dtos_V1_Employee_EmployeeOutOfOfficeDtoInput>>;
  updatedBy?: InputMaybe<Dtos_V1_Employee_EmployeeReferenceDtoInput>;
  updatedOn?: InputMaybe<Scalars['LocalDateTime']['input']>;
  usable?: InputMaybe<Scalars['Boolean']['input']>;
  workLocation?: InputMaybe<Dtos_V1_LocationDtoInput>;
};

export type Dtos_V1_EmployeeDtoSortInput = {
  allowMobileAppAccess?: InputMaybe<SortEnumType>;
  assignedEquipment?: InputMaybe<SortEnumType>;
  balance?: InputMaybe<SortEnumType>;
  clockStatus?: InputMaybe<SortEnumType>;
  clockTime?: InputMaybe<SortEnumType>;
  clockingMode?: InputMaybe<SortEnumType>;
  companyTemp?: InputMaybe<SortEnumType>;
  currentStatus?: InputMaybe<SortEnumType>;
  dateOfBirth?: InputMaybe<SortEnumType>;
  daysOut?: InputMaybe<SortEnumType>;
  default?: InputMaybe<SortEnumType>;
  defaultEmployeeCrewRoleId?: InputMaybe<SortEnumType>;
  deletable?: InputMaybe<SortEnumType>;
  dispatchLocation?: InputMaybe<Dtos_V1_LocationDtoSortInput>;
  dotHours5Day?: InputMaybe<SortEnumType>;
  dotHours6Day?: InputMaybe<SortEnumType>;
  dotHours7Day?: InputMaybe<SortEnumType>;
  dotHours8Day?: InputMaybe<SortEnumType>;
  driversLicense?: InputMaybe<Dtos_V1_DriversLicenseDtoSortInput>;
  eid?: InputMaybe<SortEnumType>;
  email?: InputMaybe<ContactInformationDtoSortInput>;
  employeeStatus?: InputMaybe<SortEnumType>;
  employmentStatus?: InputMaybe<Dtos_V1_EmploymentStatusDtoSortInput>;
  employmentType?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  fax?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  gpsUsername?: InputMaybe<SortEnumType>;
  gridColor?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inactive?: InputMaybe<SortEnumType>;
  isGeofenceEnabled?: InputMaybe<SortEnumType>;
  isPayroll?: InputMaybe<SortEnumType>;
  isSystem?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  notesTemp?: InputMaybe<SortEnumType>;
  payPerHour?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<ContactInformationDtoSortInput>;
  pinHashed?: InputMaybe<SortEnumType>;
  salesmanCommissionRate?: InputMaybe<SortEnumType>;
  seniorityCode?: InputMaybe<SortEnumType>;
  ssn?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  temporaryEmployee?: InputMaybe<SortEnumType>;
  ud1?: InputMaybe<SortEnumType>;
  ud2?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<Dtos_V1_Employee_EmployeeReferenceDtoSortInput>;
  updatedOn?: InputMaybe<SortEnumType>;
  usable?: InputMaybe<SortEnumType>;
  workLocation?: InputMaybe<Dtos_V1_LocationDtoSortInput>;
};

export type Dtos_V1_Employee_EmployeeOutOfOfficeDto = {
  __typename?: 'Dtos_V1_Employee_EmployeeOutOfOfficeDto';
  employee: Dtos_V1_EmployeeDto;
  endDate: Scalars['LocalDateTime']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  reason: Dtos_V1_Employee_ReasonDto;
  startDate: Scalars['LocalDateTime']['output'];
  updateOn?: Maybe<Scalars['LocalDateTime']['output']>;
  updatedBy?: Maybe<Dtos_V1_EmployeeDto>;
};

export type Dtos_V1_Employee_EmployeeOutOfOfficeDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_Employee_EmployeeOutOfOfficeDtoFilterInput>>;
  employee?: InputMaybe<Dtos_V1_EmployeeDtoFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_Employee_EmployeeOutOfOfficeDtoFilterInput>>;
  reason?: InputMaybe<Dtos_V1_Employee_ReasonDtoFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  updateOn?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<Dtos_V1_EmployeeDtoFilterInput>;
};

export type Dtos_V1_Employee_EmployeeOutOfOfficeDtoInput = {
  employee: Dtos_V1_EmployeeDtoInput;
  endDate: Scalars['LocalDateTime']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reason: Dtos_V1_Employee_ReasonDtoInput;
  startDate: Scalars['LocalDateTime']['input'];
  updateOn?: InputMaybe<Scalars['LocalDateTime']['input']>;
  updatedBy?: InputMaybe<Dtos_V1_EmployeeDtoInput>;
};

export type Dtos_V1_Employee_EmployeeReferenceDto = {
  __typename?: 'Dtos_V1_Employee_EmployeeReferenceDto';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V1_Employee_EmployeeReferenceDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_Employee_EmployeeReferenceDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_Employee_EmployeeReferenceDtoFilterInput>>;
};

export type Dtos_V1_Employee_EmployeeReferenceDtoInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Dtos_V1_Employee_EmployeeReferenceDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Dtos_V1_Employee_EmployeeSupportingDataDto = {
  __typename?: 'Dtos_V1_Employee_EmployeeSupportingDataDto';
  availableDispatchLocations?: Maybe<Array<Dtos_V1_LocationDto>>;
  availableEmploymentStatuses?: Maybe<Array<Dtos_V1_EmploymentStatusDto>>;
  availableEmploymentTypes?: Maybe<Array<Dtos_V1_EmploymentTypeDto>>;
  availableJobRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  availableOutOfOfficeReasons?: Maybe<Array<Dtos_V1_Employee_OutOfOfficeReasonDto>>;
  availableSystemRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  availableWorkLocations?: Maybe<Array<Dtos_V1_LocationDto>>;
};

export type Dtos_V1_Employee_OutOfOfficeReasonDto = {
  __typename?: 'Dtos_V1_Employee_OutOfOfficeReasonDto';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Dtos_V1_Employee_OutOfOfficeReasonDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_Employee_OutOfOfficeReasonDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_Employee_OutOfOfficeReasonDtoFilterInput>>;
};

export type Dtos_V1_Employee_OutOfOfficeReasonDtoInput = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type Dtos_V1_Employee_ReasonDto = {
  __typename?: 'Dtos_V1_Employee_ReasonDto';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V1_Employee_ReasonDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_Employee_ReasonDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_Employee_ReasonDtoFilterInput>>;
};

export type Dtos_V1_Employee_ReasonDtoInput = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Dtos_V1_EmploymentStatusDto = {
  __typename?: 'Dtos_V1_EmploymentStatusDto';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V1_EmploymentStatusDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_EmploymentStatusDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_EmploymentStatusDtoFilterInput>>;
};

export type Dtos_V1_EmploymentStatusDtoInput = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Dtos_V1_EmploymentStatusDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Dtos_V1_EmploymentTypeDto = {
  __typename?: 'Dtos_V1_EmploymentTypeDto';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Dtos_V1_EmploymentTypeDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_EmploymentTypeDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_EmploymentTypeDtoFilterInput>>;
};

export type Dtos_V1_EmploymentTypeDtoInput = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type Dtos_V1_EquipmentClassDto = {
  __typename?: 'Dtos_V1_EquipmentClassDto';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V1_EquipmentClassDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_EquipmentClassDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_EquipmentClassDtoFilterInput>>;
};

export type Dtos_V1_EquipmentClassDtoInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Dtos_V1_EquipmentClassDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Dtos_V1_EquipmentMakeDto = {
  __typename?: 'Dtos_V1_EquipmentMakeDto';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V1_EquipmentMakeDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_EquipmentMakeDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_EquipmentMakeDtoFilterInput>>;
};

export type Dtos_V1_EquipmentMakeDtoInput = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Dtos_V1_EquipmentMakeDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Dtos_V1_EquipmentModelDto = {
  __typename?: 'Dtos_V1_EquipmentModelDto';
  id?: Maybe<Scalars['Int']['output']>;
  make: Dtos_V1_EquipmentMakeDto;
  name?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V1_EquipmentModelDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_EquipmentModelDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  make?: InputMaybe<Dtos_V1_EquipmentMakeDtoFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_EquipmentModelDtoFilterInput>>;
};

export type Dtos_V1_EquipmentModelDtoInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  make: Dtos_V1_EquipmentMakeDtoInput;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Dtos_V1_EquipmentModelDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  make?: InputMaybe<Dtos_V1_EquipmentMakeDtoSortInput>;
  name?: InputMaybe<SortEnumType>;
};

export type Dtos_V1_EquipmentSizeDto = {
  __typename?: 'Dtos_V1_EquipmentSizeDto';
  class: Dtos_V1_EquipmentClassDto;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V1_EquipmentSizeDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_EquipmentSizeDtoFilterInput>>;
  class?: InputMaybe<Dtos_V1_EquipmentClassDtoFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_EquipmentSizeDtoFilterInput>>;
};

export type Dtos_V1_EquipmentSizeDtoInput = {
  class: Dtos_V1_EquipmentClassDtoInput;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Dtos_V1_EquipmentSizeDtoSortInput = {
  class?: InputMaybe<Dtos_V1_EquipmentClassDtoSortInput>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Dtos_V1_EquipmentTypeDto = {
  __typename?: 'Dtos_V1_EquipmentTypeDto';
  class: Dtos_V1_EquipmentClassDto;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V1_EquipmentTypeDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_EquipmentTypeDtoFilterInput>>;
  class?: InputMaybe<Dtos_V1_EquipmentClassDtoFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_EquipmentTypeDtoFilterInput>>;
};

export type Dtos_V1_EquipmentTypeDtoInput = {
  class: Dtos_V1_EquipmentClassDtoInput;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Dtos_V1_EquipmentTypeDtoSortInput = {
  class?: InputMaybe<Dtos_V1_EquipmentClassDtoSortInput>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Dtos_V1_Equipment_EquipmentDto = {
  __typename?: 'Dtos_V1_Equipment_EquipmentDto';
  acquiredOn?: Maybe<Scalars['LocalDateTime']['output']>;
  availableClasses?: Maybe<Array<Dtos_V1_EquipmentClassDto>>;
  availableDefaultEmployees?: Maybe<Array<Dtos_V1_CrewDto>>;
  availableDispatchLocations?: Maybe<Array<Dtos_V1_LocationDto>>;
  availableEmployees?: Maybe<Array<Dtos_V1_EmployeeDto>>;
  availableJobRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  availableLocations?: Maybe<Array<Dtos_V1_LocationDto>>;
  availableMakes?: Maybe<Array<Dtos_V1_EquipmentMakeDto>>;
  availableModels?: Maybe<Array<Dtos_V1_EquipmentModelDto>>;
  availableOutOfServiceReasons?: Maybe<Array<Dtos_V1_Equipment_OutOfServiceReasonDto>>;
  availableSizes?: Maybe<Array<Dtos_V1_EquipmentSizeDto>>;
  availableStatuses?: Maybe<Array<Dtos_V1_JobStatusDto>>;
  availableTypes?: Maybe<Array<Dtos_V1_EquipmentTypeDto>>;
  backInServiceOn?: Maybe<Scalars['Date']['output']>;
  beganServiceMileage?: Maybe<Scalars['Int']['output']>;
  beganServiceOn?: Maybe<Scalars['LocalDateTime']['output']>;
  boomModelNum?: Maybe<Scalars['String']['output']>;
  boomSerialNumber?: Maybe<Scalars['String']['output']>;
  class?: Maybe<Dtos_V1_EquipmentClassDto>;
  clearTime?: Maybe<Scalars['LocalDateTime']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  daysDown?: Maybe<Scalars['Int']['output']>;
  defaultEmployee?: Maybe<Dtos_V1_EmployeeDto>;
  defaultEndStyle?: Maybe<Scalars['Int']['output']>;
  defaultInsideSystemDiameter?: Maybe<Scalars['Int']['output']>;
  defaultLocation?: Maybe<Dtos_V1_LocationDto>;
  deletable?: Maybe<Scalars['Boolean']['output']>;
  descriptor?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  dispatchLocation?: Maybe<Dtos_V1_DispatchLocationDto>;
  doubleBooking?: Maybe<Scalars['String']['output']>;
  engHrs?: Maybe<Scalars['Int']['output']>;
  fuelAvgStationaryConsumptionPerHour?: Maybe<Scalars['Decimal']['output']>;
  fuelAvgTravelingConsumptionPerHour?: Maybe<Scalars['Decimal']['output']>;
  fuelTankSize?: Maybe<Scalars['Int']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  geoFencingEnabled?: Maybe<Scalars['Boolean']['output']>;
  gpsTrackerSerialNumber?: Maybe<Scalars['String']['output']>;
  grossWeight?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  inService?: Maybe<Scalars['Int']['output']>;
  isSystem?: Maybe<Scalars['Boolean']['output']>;
  leaveTime?: Maybe<Scalars['LocalDateTime']['output']>;
  licensePlate?: Maybe<Dtos_V1_LicensePlateDto>;
  location?: Maybe<Dtos_V1_LocationDto>;
  machineSerialNumber?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Dtos_V1_EquipmentMakeDto>;
  maxGroundBearingPressure?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Dtos_V1_EquipmentModelDto>;
  mpEquipmentId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  onJobTime?: Maybe<Scalars['LocalDateTime']['output']>;
  outOfServiceHistory?: Maybe<Array<Dtos_V1_Equipment_EquipmentOutOfServiceDto>>;
  pumpHrs?: Maybe<Scalars['Int']['output']>;
  pumpMi?: Maybe<Scalars['Int']['output']>;
  purchasedMileage?: Maybe<Scalars['Int']['output']>;
  requiredJobRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  seniorityCode?: Maybe<Scalars['String']['output']>;
  showUpTime?: Maybe<Scalars['LocalDateTime']['output']>;
  size?: Maybe<Dtos_V1_EquipmentSizeDto>;
  startTime?: Maybe<Scalars['LocalDateTime']['output']>;
  status?: Maybe<Dtos_V1_JobStatusDto>;
  truckMi?: Maybe<Scalars['Int']['output']>;
  truckModelNumber?: Maybe<Scalars['String']['output']>;
  truckYear?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Dtos_V1_EquipmentTypeDto>;
  ud1?: Maybe<Scalars['String']['output']>;
  ud2?: Maybe<Scalars['String']['output']>;
  unworkable?: Maybe<Scalars['Boolean']['output']>;
  upcomingOutOfService?: Maybe<Array<Dtos_V1_Equipment_EquipmentOutOfServiceDto>>;
  vinNumber?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type Dtos_V1_Equipment_EquipmentDtoFilterInput = {
  acquiredOn?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<Dtos_V1_Equipment_EquipmentDtoFilterInput>>;
  availableClasses?: InputMaybe<ListFilterInputTypeOfDtos_V1_EquipmentClassDtoFilterInput>;
  availableDefaultEmployees?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewDtoFilterInput>;
  availableDispatchLocations?: InputMaybe<ListFilterInputTypeOfDtos_V1_LocationDtoFilterInput>;
  availableEmployees?: InputMaybe<ListFilterInputTypeOfDtos_V1_EmployeeDtoFilterInput>;
  availableJobRoles?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput>;
  availableLocations?: InputMaybe<ListFilterInputTypeOfDtos_V1_LocationDtoFilterInput>;
  availableMakes?: InputMaybe<ListFilterInputTypeOfDtos_V1_EquipmentMakeDtoFilterInput>;
  availableModels?: InputMaybe<ListFilterInputTypeOfDtos_V1_EquipmentModelDtoFilterInput>;
  availableOutOfServiceReasons?: InputMaybe<ListFilterInputTypeOfDtos_V1_Equipment_OutOfServiceReasonDtoFilterInput>;
  availableSizes?: InputMaybe<ListFilterInputTypeOfDtos_V1_EquipmentSizeDtoFilterInput>;
  availableStatuses?: InputMaybe<ListFilterInputTypeOfDtos_V1_JobStatusDtoFilterInput>;
  availableTypes?: InputMaybe<ListFilterInputTypeOfDtos_V1_EquipmentTypeDtoFilterInput>;
  backInServiceOn?: InputMaybe<DateOperationFilterInput>;
  beganServiceMileage?: InputMaybe<IntOperationFilterInput>;
  beganServiceOn?: InputMaybe<DateTimeOperationFilterInput>;
  boomModelNum?: InputMaybe<StringOperationFilterInput>;
  boomSerialNumber?: InputMaybe<StringOperationFilterInput>;
  class?: InputMaybe<Dtos_V1_EquipmentClassDtoFilterInput>;
  clearTime?: InputMaybe<DateTimeOperationFilterInput>;
  date?: InputMaybe<DateOperationFilterInput>;
  daysDown?: InputMaybe<IntOperationFilterInput>;
  defaultEmployee?: InputMaybe<Dtos_V1_EmployeeDtoFilterInput>;
  defaultEndStyle?: InputMaybe<IntOperationFilterInput>;
  defaultInsideSystemDiameter?: InputMaybe<IntOperationFilterInput>;
  defaultLocation?: InputMaybe<Dtos_V1_LocationDtoFilterInput>;
  deletable?: InputMaybe<BooleanOperationFilterInput>;
  descriptor?: InputMaybe<StringOperationFilterInput>;
  details?: InputMaybe<StringOperationFilterInput>;
  dispatchLocation?: InputMaybe<Dtos_V1_DispatchLocationDtoFilterInput>;
  doubleBooking?: InputMaybe<StringOperationFilterInput>;
  engHrs?: InputMaybe<IntOperationFilterInput>;
  fuelAvgStationaryConsumptionPerHour?: InputMaybe<DecimalOperationFilterInput>;
  fuelAvgTravelingConsumptionPerHour?: InputMaybe<DecimalOperationFilterInput>;
  fuelTankSize?: InputMaybe<IntOperationFilterInput>;
  fuelType?: InputMaybe<StringOperationFilterInput>;
  geoFencingEnabled?: InputMaybe<BooleanOperationFilterInput>;
  gpsTrackerSerialNumber?: InputMaybe<StringOperationFilterInput>;
  grossWeight?: InputMaybe<FloatOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  inService?: InputMaybe<IntOperationFilterInput>;
  isSystem?: InputMaybe<BooleanOperationFilterInput>;
  leaveTime?: InputMaybe<DateTimeOperationFilterInput>;
  licensePlate?: InputMaybe<Dtos_V1_LicensePlateDtoFilterInput>;
  location?: InputMaybe<Dtos_V1_LocationDtoFilterInput>;
  machineSerialNumber?: InputMaybe<StringOperationFilterInput>;
  make?: InputMaybe<Dtos_V1_EquipmentMakeDtoFilterInput>;
  maxGroundBearingPressure?: InputMaybe<IntOperationFilterInput>;
  model?: InputMaybe<Dtos_V1_EquipmentModelDtoFilterInput>;
  mpEquipmentId?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  onJobTime?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_Equipment_EquipmentDtoFilterInput>>;
  outOfServiceHistory?: InputMaybe<ListFilterInputTypeOfDtos_V1_Equipment_EquipmentOutOfServiceDtoFilterInput>;
  pumpHrs?: InputMaybe<IntOperationFilterInput>;
  pumpMi?: InputMaybe<IntOperationFilterInput>;
  purchasedMileage?: InputMaybe<IntOperationFilterInput>;
  requiredJobRoles?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput>;
  seniorityCode?: InputMaybe<StringOperationFilterInput>;
  showUpTime?: InputMaybe<DateTimeOperationFilterInput>;
  size?: InputMaybe<Dtos_V1_EquipmentSizeDtoFilterInput>;
  startTime?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<Dtos_V1_JobStatusDtoFilterInput>;
  truckMi?: InputMaybe<IntOperationFilterInput>;
  truckModelNumber?: InputMaybe<StringOperationFilterInput>;
  truckYear?: InputMaybe<IntOperationFilterInput>;
  type?: InputMaybe<Dtos_V1_EquipmentTypeDtoFilterInput>;
  ud1?: InputMaybe<StringOperationFilterInput>;
  ud2?: InputMaybe<StringOperationFilterInput>;
  unworkable?: InputMaybe<BooleanOperationFilterInput>;
  upcomingOutOfService?: InputMaybe<ListFilterInputTypeOfDtos_V1_Equipment_EquipmentOutOfServiceDtoFilterInput>;
  vinNumber?: InputMaybe<StringOperationFilterInput>;
  year?: InputMaybe<IntOperationFilterInput>;
};

export type Dtos_V1_Equipment_EquipmentDtoInput = {
  acquiredOn?: InputMaybe<Scalars['LocalDateTime']['input']>;
  availableClasses?: InputMaybe<Array<Dtos_V1_EquipmentClassDtoInput>>;
  availableDefaultEmployees?: InputMaybe<Array<Dtos_V1_CrewDtoInput>>;
  availableDispatchLocations?: InputMaybe<Array<Dtos_V1_LocationDtoInput>>;
  availableEmployees?: InputMaybe<Array<Dtos_V1_EmployeeDtoInput>>;
  availableJobRoles?: InputMaybe<Array<Dtos_V1_CrewRoleDtoInput>>;
  availableLocations?: InputMaybe<Array<Dtos_V1_LocationDtoInput>>;
  availableMakes?: InputMaybe<Array<Dtos_V1_EquipmentMakeDtoInput>>;
  availableModels?: InputMaybe<Array<Dtos_V1_EquipmentModelDtoInput>>;
  availableOutOfServiceReasons?: InputMaybe<Array<Dtos_V1_Equipment_OutOfServiceReasonDtoInput>>;
  availableSizes?: InputMaybe<Array<Dtos_V1_EquipmentSizeDtoInput>>;
  availableStatuses?: InputMaybe<Array<Dtos_V1_JobStatusDtoInput>>;
  availableTypes?: InputMaybe<Array<Dtos_V1_EquipmentTypeDtoInput>>;
  backInServiceOn?: InputMaybe<Scalars['Date']['input']>;
  beganServiceMileage?: InputMaybe<Scalars['Int']['input']>;
  beganServiceOn?: InputMaybe<Scalars['LocalDateTime']['input']>;
  boomModelNum?: InputMaybe<Scalars['String']['input']>;
  boomSerialNumber?: InputMaybe<Scalars['String']['input']>;
  class?: InputMaybe<Dtos_V1_EquipmentClassDtoInput>;
  clearTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  daysDown?: InputMaybe<Scalars['Int']['input']>;
  defaultEmployee?: InputMaybe<Dtos_V1_EmployeeDtoInput>;
  defaultEndStyle?: InputMaybe<Scalars['Int']['input']>;
  defaultInsideSystemDiameter?: InputMaybe<Scalars['Int']['input']>;
  defaultLocation?: InputMaybe<Dtos_V1_LocationDtoInput>;
  deletable?: InputMaybe<Scalars['Boolean']['input']>;
  descriptor?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  dispatchLocation?: InputMaybe<Dtos_V1_DispatchLocationDtoInput>;
  doubleBooking?: InputMaybe<Scalars['String']['input']>;
  engHrs?: InputMaybe<Scalars['Int']['input']>;
  fuelAvgStationaryConsumptionPerHour?: InputMaybe<Scalars['Decimal']['input']>;
  fuelAvgTravelingConsumptionPerHour?: InputMaybe<Scalars['Decimal']['input']>;
  fuelTankSize?: InputMaybe<Scalars['Int']['input']>;
  fuelType?: InputMaybe<Scalars['String']['input']>;
  geoFencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  gpsTrackerSerialNumber?: InputMaybe<Scalars['String']['input']>;
  grossWeight?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  inService?: InputMaybe<Scalars['Int']['input']>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  leaveTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  licensePlate?: InputMaybe<Dtos_V1_LicensePlateDtoInput>;
  location?: InputMaybe<Dtos_V1_LocationDtoInput>;
  machineSerialNumber?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Dtos_V1_EquipmentMakeDtoInput>;
  maxGroundBearingPressure?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Dtos_V1_EquipmentModelDtoInput>;
  mpEquipmentId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  onJobTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  outOfServiceHistory?: InputMaybe<Array<Dtos_V1_Equipment_EquipmentOutOfServiceDtoInput>>;
  pumpHrs?: InputMaybe<Scalars['Int']['input']>;
  pumpMi?: InputMaybe<Scalars['Int']['input']>;
  purchasedMileage?: InputMaybe<Scalars['Int']['input']>;
  requiredJobRoles?: InputMaybe<Array<Dtos_V1_CrewRoleDtoInput>>;
  seniorityCode?: InputMaybe<Scalars['String']['input']>;
  showUpTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  size?: InputMaybe<Dtos_V1_EquipmentSizeDtoInput>;
  startTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  status?: InputMaybe<Dtos_V1_JobStatusDtoInput>;
  truckMi?: InputMaybe<Scalars['Int']['input']>;
  truckModelNumber?: InputMaybe<Scalars['String']['input']>;
  truckYear?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Dtos_V1_EquipmentTypeDtoInput>;
  ud1?: InputMaybe<Scalars['String']['input']>;
  ud2?: InputMaybe<Scalars['String']['input']>;
  unworkable?: InputMaybe<Scalars['Boolean']['input']>;
  upcomingOutOfService?: InputMaybe<Array<Dtos_V1_Equipment_EquipmentOutOfServiceDtoInput>>;
  vinNumber?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type Dtos_V1_Equipment_EquipmentDtoSortInput = {
  acquiredOn?: InputMaybe<SortEnumType>;
  backInServiceOn?: InputMaybe<SortEnumType>;
  beganServiceMileage?: InputMaybe<SortEnumType>;
  beganServiceOn?: InputMaybe<SortEnumType>;
  boomModelNum?: InputMaybe<SortEnumType>;
  boomSerialNumber?: InputMaybe<SortEnumType>;
  class?: InputMaybe<Dtos_V1_EquipmentClassDtoSortInput>;
  clearTime?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  daysDown?: InputMaybe<SortEnumType>;
  defaultEmployee?: InputMaybe<Dtos_V1_EmployeeDtoSortInput>;
  defaultEndStyle?: InputMaybe<SortEnumType>;
  defaultInsideSystemDiameter?: InputMaybe<SortEnumType>;
  defaultLocation?: InputMaybe<Dtos_V1_LocationDtoSortInput>;
  deletable?: InputMaybe<SortEnumType>;
  descriptor?: InputMaybe<SortEnumType>;
  details?: InputMaybe<SortEnumType>;
  dispatchLocation?: InputMaybe<Dtos_V1_DispatchLocationDtoSortInput>;
  doubleBooking?: InputMaybe<SortEnumType>;
  engHrs?: InputMaybe<SortEnumType>;
  fuelAvgStationaryConsumptionPerHour?: InputMaybe<SortEnumType>;
  fuelAvgTravelingConsumptionPerHour?: InputMaybe<SortEnumType>;
  fuelTankSize?: InputMaybe<SortEnumType>;
  fuelType?: InputMaybe<SortEnumType>;
  geoFencingEnabled?: InputMaybe<SortEnumType>;
  gpsTrackerSerialNumber?: InputMaybe<SortEnumType>;
  grossWeight?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inService?: InputMaybe<SortEnumType>;
  isSystem?: InputMaybe<SortEnumType>;
  leaveTime?: InputMaybe<SortEnumType>;
  licensePlate?: InputMaybe<Dtos_V1_LicensePlateDtoSortInput>;
  location?: InputMaybe<Dtos_V1_LocationDtoSortInput>;
  machineSerialNumber?: InputMaybe<SortEnumType>;
  make?: InputMaybe<Dtos_V1_EquipmentMakeDtoSortInput>;
  maxGroundBearingPressure?: InputMaybe<SortEnumType>;
  model?: InputMaybe<Dtos_V1_EquipmentModelDtoSortInput>;
  mpEquipmentId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  onJobTime?: InputMaybe<SortEnumType>;
  pumpHrs?: InputMaybe<SortEnumType>;
  pumpMi?: InputMaybe<SortEnumType>;
  purchasedMileage?: InputMaybe<SortEnumType>;
  seniorityCode?: InputMaybe<SortEnumType>;
  showUpTime?: InputMaybe<SortEnumType>;
  size?: InputMaybe<Dtos_V1_EquipmentSizeDtoSortInput>;
  startTime?: InputMaybe<SortEnumType>;
  status?: InputMaybe<Dtos_V1_JobStatusDtoSortInput>;
  truckMi?: InputMaybe<SortEnumType>;
  truckModelNumber?: InputMaybe<SortEnumType>;
  truckYear?: InputMaybe<SortEnumType>;
  type?: InputMaybe<Dtos_V1_EquipmentTypeDtoSortInput>;
  ud1?: InputMaybe<SortEnumType>;
  ud2?: InputMaybe<SortEnumType>;
  unworkable?: InputMaybe<SortEnumType>;
  vinNumber?: InputMaybe<SortEnumType>;
  year?: InputMaybe<SortEnumType>;
};

export type Dtos_V1_Equipment_EquipmentOutOfServiceDto = {
  __typename?: 'Dtos_V1_Equipment_EquipmentOutOfServiceDto';
  createdBy?: Maybe<Dtos_V1_EmployeeDto>;
  createdOn?: Maybe<Scalars['LocalDateTime']['output']>;
  end: Scalars['LocalDateTime']['output'];
  equipment: Dtos_V1_Equipment_EquipmentDto;
  id?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Dtos_V1_Equipment_OutOfServiceReasonDto>;
  start: Scalars['LocalDateTime']['output'];
  updatedBy?: Maybe<Dtos_V1_EmployeeDto>;
  updatedOn?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type Dtos_V1_Equipment_EquipmentOutOfServiceDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_Equipment_EquipmentOutOfServiceDtoFilterInput>>;
  createdBy?: InputMaybe<Dtos_V1_EmployeeDtoFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  end?: InputMaybe<DateTimeOperationFilterInput>;
  equipment?: InputMaybe<Dtos_V1_Equipment_EquipmentDtoFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_Equipment_EquipmentOutOfServiceDtoFilterInput>>;
  reason?: InputMaybe<Dtos_V1_Equipment_OutOfServiceReasonDtoFilterInput>;
  start?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<Dtos_V1_EmployeeDtoFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type Dtos_V1_Equipment_EquipmentOutOfServiceDtoInput = {
  createdBy?: InputMaybe<Dtos_V1_EmployeeDtoInput>;
  createdOn?: InputMaybe<Scalars['LocalDateTime']['input']>;
  end: Scalars['LocalDateTime']['input'];
  equipment: Dtos_V1_Equipment_EquipmentDtoInput;
  id?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Dtos_V1_Equipment_OutOfServiceReasonDtoInput>;
  start: Scalars['LocalDateTime']['input'];
  updatedBy?: InputMaybe<Dtos_V1_EmployeeDtoInput>;
  updatedOn?: InputMaybe<Scalars['LocalDateTime']['input']>;
};

export type Dtos_V1_Equipment_EquipmentSupportingDataDto = {
  __typename?: 'Dtos_V1_Equipment_EquipmentSupportingDataDto';
  availableClasses?: Maybe<Array<Dtos_V1_EquipmentClassDto>>;
  availableDefaultEmployees?: Maybe<Array<Dtos_V1_CrewDto>>;
  availableDispatchLocations?: Maybe<Array<Dtos_V1_LocationDto>>;
  availableEmployees?: Maybe<Array<Dtos_V1_EmployeeDto>>;
  availableJobRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  availableLocations?: Maybe<Array<Dtos_V1_LocationDto>>;
  availableMakes?: Maybe<Array<Dtos_V1_EquipmentMakeDto>>;
  availableModels?: Maybe<Array<Dtos_V1_EquipmentModelDto>>;
  availableOutOfServiceReasons?: Maybe<Array<Dtos_V1_Equipment_OutOfServiceReasonDto>>;
  availableSizes?: Maybe<Array<Dtos_V1_EquipmentSizeDto>>;
  availableStatuses?: Maybe<Array<Dtos_V1_JobStatusDto>>;
  availableTypes?: Maybe<Array<Dtos_V1_EquipmentTypeDto>>;
};

export type Dtos_V1_Equipment_OutOfServiceReasonDto = {
  __typename?: 'Dtos_V1_Equipment_OutOfServiceReasonDto';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Dtos_V1_Equipment_OutOfServiceReasonDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_Equipment_OutOfServiceReasonDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_Equipment_OutOfServiceReasonDtoFilterInput>>;
};

export type Dtos_V1_Equipment_OutOfServiceReasonDtoInput = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type Dtos_V1_ExtraSystemDto = {
  __typename?: 'Dtos_V1_ExtraSystemDto';
  addToInvoiceMinimum?: Maybe<Scalars['Boolean']['output']>;
  applyToAll?: Maybe<Scalars['Boolean']['output']>;
  billable?: Maybe<Scalars['Boolean']['output']>;
  class: Dtos_V1_ClassDto;
  defaultItem?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  includePriceOnPrint?: Maybe<Scalars['Boolean']['output']>;
  jobId: Scalars['Int']['output'];
  lastSynced?: Maybe<Scalars['LocalDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price: Scalars['Decimal']['output'];
  quantity: Scalars['Decimal']['output'];
  rotg?: Maybe<Scalars['Boolean']['output']>;
  showAsExtraSystemOnJob?: Maybe<Scalars['Boolean']['output']>;
  taxable?: Maybe<Scalars['Boolean']['output']>;
  unitOfMeasure?: Maybe<Scalars['Int']['output']>;
};

export type Dtos_V1_ExtraSystemDtoFilterInput = {
  addToInvoiceMinimum?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<Dtos_V1_ExtraSystemDtoFilterInput>>;
  applyToAll?: InputMaybe<BooleanOperationFilterInput>;
  billable?: InputMaybe<BooleanOperationFilterInput>;
  class?: InputMaybe<Dtos_V1_ClassDtoFilterInput>;
  defaultItem?: InputMaybe<BooleanOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  includePriceOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  jobId?: InputMaybe<IntOperationFilterInput>;
  lastSynced?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_ExtraSystemDtoFilterInput>>;
  price?: InputMaybe<DecimalOperationFilterInput>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  rotg?: InputMaybe<BooleanOperationFilterInput>;
  showAsExtraSystemOnJob?: InputMaybe<BooleanOperationFilterInput>;
  taxable?: InputMaybe<BooleanOperationFilterInput>;
  unitOfMeasure?: InputMaybe<IntOperationFilterInput>;
};

export type Dtos_V1_ExtraSystemDtoInput = {
  addToInvoiceMinimum?: InputMaybe<Scalars['Boolean']['input']>;
  applyToAll?: InputMaybe<Scalars['Boolean']['input']>;
  billable?: InputMaybe<Scalars['Boolean']['input']>;
  class: Dtos_V1_ClassDtoInput;
  defaultItem?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  includePriceOnPrint?: InputMaybe<Scalars['Boolean']['input']>;
  jobId: Scalars['Int']['input'];
  lastSynced?: InputMaybe<Scalars['LocalDateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Decimal']['input'];
  quantity: Scalars['Decimal']['input'];
  rotg?: InputMaybe<Scalars['Boolean']['input']>;
  showAsExtraSystemOnJob?: InputMaybe<Scalars['Boolean']['input']>;
  taxable?: InputMaybe<Scalars['Boolean']['input']>;
  unitOfMeasure?: InputMaybe<Scalars['Int']['input']>;
};

export type Dtos_V1_ExtraSystemDtoSortInput = {
  addToInvoiceMinimum?: InputMaybe<SortEnumType>;
  applyToAll?: InputMaybe<SortEnumType>;
  billable?: InputMaybe<SortEnumType>;
  class?: InputMaybe<Dtos_V1_ClassDtoSortInput>;
  defaultItem?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  includePriceOnPrint?: InputMaybe<SortEnumType>;
  jobId?: InputMaybe<SortEnumType>;
  lastSynced?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  price?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  rotg?: InputMaybe<SortEnumType>;
  showAsExtraSystemOnJob?: InputMaybe<SortEnumType>;
  taxable?: InputMaybe<SortEnumType>;
  unitOfMeasure?: InputMaybe<SortEnumType>;
};

export type Dtos_V1_JobInformationDto = {
  __typename?: 'Dtos_V1_JobInformationDto';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V1_JobInformationDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_JobInformationDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_JobInformationDtoFilterInput>>;
};

export type Dtos_V1_JobInformationDtoInput = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Dtos_V1_JobInformationDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Dtos_V1_JobSiteDto = {
  __typename?: 'Dtos_V1_JobSiteDto';
  address?: Maybe<Scalars['String']['output']>;
  availableJobSiteTypes?: Maybe<Array<JobSiteTypeDto>>;
  availableStates?: Maybe<Array<StateDto>>;
  billableTravelHours?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<AddressDto>;
  buildingOrLotNumber?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  contractor?: Maybe<VendorDto>;
  cpr?: Maybe<Scalars['Boolean']['output']>;
  createdOn?: Maybe<Scalars['Date']['output']>;
  crossStreet?: Maybe<Scalars['String']['output']>;
  customId?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<CustomerDto>;
  customerId?: Maybe<Scalars['Int']['output']>;
  defaultBuilding?: Maybe<Scalars['String']['output']>;
  defaultPONumber?: Maybe<Scalars['String']['output']>;
  deletable?: Maybe<Scalars['Boolean']['output']>;
  disposal?: Maybe<SupplierDto>;
  emailInvoices?: Maybe<Scalars['Boolean']['output']>;
  geofencing?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  inactive?: Maybe<Scalars['Boolean']['output']>;
  jobNumber?: Maybe<Scalars['String']['output']>;
  jobPhone?: Maybe<Scalars['String']['output']>;
  jobSiteCheckList?: Maybe<CheckListDto>;
  jobSiteName?: Maybe<Scalars['String']['output']>;
  jobSitePrelimed?: Maybe<Array<JobSitePrelimedDto>>;
  jobSiteType?: Maybe<JobSiteTypeDto>;
  latitude?: Maybe<Scalars['Decimal']['output']>;
  latitudeAndLongitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
  mapPage?: Maybe<Scalars['String']['output']>;
  noSubs?: Maybe<Scalars['Boolean']['output']>;
  nonTaxable?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  ocip?: Maybe<Scalars['Boolean']['output']>;
  parcelNumber?: Maybe<Scalars['String']['output']>;
  poRequired?: Maybe<Scalars['Boolean']['output']>;
  powerlinePresent?: Maybe<Scalars['Boolean']['output']>;
  pricingScheme?: Maybe<PricingSchemeDto>;
  projectType?: Maybe<ProjectTypeDto>;
  publicProject?: Maybe<Scalars['Boolean']['output']>;
  released?: Maybe<Scalars['Boolean']['output']>;
  safetyRequired?: Maybe<Scalars['Boolean']['output']>;
  salesAgent?: Maybe<EmployeeDto>;
  salesRegion?: Maybe<SalesRegionDto>;
  specialInstruction?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V1_JobSiteDtoFilterInput = {
  address?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<Dtos_V1_JobSiteDtoFilterInput>>;
  availableJobSiteTypes?: InputMaybe<ListFilterInputTypeOfJobSiteTypeDtoFilterInput>;
  availableStates?: InputMaybe<ListFilterInputTypeOfStateDtoFilterInput>;
  billableTravelHours?: InputMaybe<StringOperationFilterInput>;
  billingAddress?: InputMaybe<AddressDtoFilterInput>;
  buildingOrLotNumber?: InputMaybe<StringOperationFilterInput>;
  city?: InputMaybe<StringOperationFilterInput>;
  contractNumber?: InputMaybe<StringOperationFilterInput>;
  contractor?: InputMaybe<VendorDtoFilterInput>;
  cpr?: InputMaybe<BooleanOperationFilterInput>;
  createdOn?: InputMaybe<DateOperationFilterInput>;
  crossStreet?: InputMaybe<StringOperationFilterInput>;
  customId?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<CustomerDtoFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  defaultBuilding?: InputMaybe<StringOperationFilterInput>;
  defaultPONumber?: InputMaybe<StringOperationFilterInput>;
  deletable?: InputMaybe<BooleanOperationFilterInput>;
  disposal?: InputMaybe<SupplierDtoFilterInput>;
  emailInvoices?: InputMaybe<BooleanOperationFilterInput>;
  geofencing?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  inactive?: InputMaybe<BooleanOperationFilterInput>;
  jobNumber?: InputMaybe<StringOperationFilterInput>;
  jobPhone?: InputMaybe<StringOperationFilterInput>;
  jobSiteCheckList?: InputMaybe<CheckListDtoFilterInput>;
  jobSiteName?: InputMaybe<StringOperationFilterInput>;
  jobSitePrelimed?: InputMaybe<ListFilterInputTypeOfJobSitePrelimedDtoFilterInput>;
  jobSiteType?: InputMaybe<JobSiteTypeDtoFilterInput>;
  latitude?: InputMaybe<DecimalOperationFilterInput>;
  latitudeAndLongitude?: InputMaybe<StringOperationFilterInput>;
  longitude?: InputMaybe<DecimalOperationFilterInput>;
  mapPage?: InputMaybe<StringOperationFilterInput>;
  noSubs?: InputMaybe<BooleanOperationFilterInput>;
  nonTaxable?: InputMaybe<BooleanOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  ocip?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_JobSiteDtoFilterInput>>;
  parcelNumber?: InputMaybe<StringOperationFilterInput>;
  poRequired?: InputMaybe<BooleanOperationFilterInput>;
  powerlinePresent?: InputMaybe<BooleanOperationFilterInput>;
  pricingScheme?: InputMaybe<PricingSchemeDtoFilterInput>;
  projectType?: InputMaybe<ProjectTypeDtoFilterInput>;
  publicProject?: InputMaybe<BooleanOperationFilterInput>;
  released?: InputMaybe<BooleanOperationFilterInput>;
  safetyRequired?: InputMaybe<BooleanOperationFilterInput>;
  salesAgent?: InputMaybe<EmployeeDtoFilterInput>;
  salesRegion?: InputMaybe<SalesRegionDtoFilterInput>;
  specialInstruction?: InputMaybe<StringOperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  zipCode?: InputMaybe<StringOperationFilterInput>;
};

export type Dtos_V1_JobSiteDtoInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  availableJobSiteTypes?: InputMaybe<Array<JobSiteTypeDtoInput>>;
  availableStates?: InputMaybe<Array<StateDtoInput>>;
  billableTravelHours?: InputMaybe<Scalars['String']['input']>;
  billingAddress?: InputMaybe<AddressDtoInput>;
  buildingOrLotNumber?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contractNumber?: InputMaybe<Scalars['String']['input']>;
  contractor?: InputMaybe<VendorDtoInput>;
  cpr?: InputMaybe<Scalars['Boolean']['input']>;
  createdOn?: InputMaybe<Scalars['Date']['input']>;
  crossStreet?: InputMaybe<Scalars['String']['input']>;
  customId?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<CustomerDtoInput>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  defaultBuilding?: InputMaybe<Scalars['String']['input']>;
  defaultPONumber?: InputMaybe<Scalars['String']['input']>;
  deletable?: InputMaybe<Scalars['Boolean']['input']>;
  disposal?: InputMaybe<SupplierDtoInput>;
  emailInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  geofencing?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  jobNumber?: InputMaybe<Scalars['String']['input']>;
  jobPhone?: InputMaybe<Scalars['String']['input']>;
  jobSiteCheckList?: InputMaybe<CheckListDtoInput>;
  jobSiteName?: InputMaybe<Scalars['String']['input']>;
  jobSitePrelimed?: InputMaybe<Array<JobSitePrelimedDtoInput>>;
  jobSiteType?: InputMaybe<JobSiteTypeDtoInput>;
  latitude?: InputMaybe<Scalars['Decimal']['input']>;
  latitudeAndLongitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['Decimal']['input']>;
  mapPage?: InputMaybe<Scalars['String']['input']>;
  noSubs?: InputMaybe<Scalars['Boolean']['input']>;
  nonTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  ocip?: InputMaybe<Scalars['Boolean']['input']>;
  parcelNumber?: InputMaybe<Scalars['String']['input']>;
  poRequired?: InputMaybe<Scalars['Boolean']['input']>;
  powerlinePresent?: InputMaybe<Scalars['Boolean']['input']>;
  pricingScheme?: InputMaybe<PricingSchemeDtoInput>;
  projectType?: InputMaybe<ProjectTypeDtoInput>;
  publicProject?: InputMaybe<Scalars['Boolean']['input']>;
  released?: InputMaybe<Scalars['Boolean']['input']>;
  safetyRequired?: InputMaybe<Scalars['Boolean']['input']>;
  salesAgent?: InputMaybe<EmployeeDtoInput>;
  salesRegion?: InputMaybe<SalesRegionDtoInput>;
  specialInstruction?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type Dtos_V1_JobSiteDtoSortInput = {
  address?: InputMaybe<SortEnumType>;
  billableTravelHours?: InputMaybe<SortEnumType>;
  billingAddress?: InputMaybe<AddressDtoSortInput>;
  buildingOrLotNumber?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  contractNumber?: InputMaybe<SortEnumType>;
  contractor?: InputMaybe<VendorDtoSortInput>;
  cpr?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  crossStreet?: InputMaybe<SortEnumType>;
  customId?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerDtoSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  defaultBuilding?: InputMaybe<SortEnumType>;
  defaultPONumber?: InputMaybe<SortEnumType>;
  deletable?: InputMaybe<SortEnumType>;
  disposal?: InputMaybe<SupplierDtoSortInput>;
  emailInvoices?: InputMaybe<SortEnumType>;
  geofencing?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inactive?: InputMaybe<SortEnumType>;
  jobNumber?: InputMaybe<SortEnumType>;
  jobPhone?: InputMaybe<SortEnumType>;
  jobSiteCheckList?: InputMaybe<CheckListDtoSortInput>;
  jobSiteName?: InputMaybe<SortEnumType>;
  jobSiteType?: InputMaybe<JobSiteTypeDtoSortInput>;
  latitude?: InputMaybe<SortEnumType>;
  latitudeAndLongitude?: InputMaybe<SortEnumType>;
  longitude?: InputMaybe<SortEnumType>;
  mapPage?: InputMaybe<SortEnumType>;
  noSubs?: InputMaybe<SortEnumType>;
  nonTaxable?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  ocip?: InputMaybe<SortEnumType>;
  parcelNumber?: InputMaybe<SortEnumType>;
  poRequired?: InputMaybe<SortEnumType>;
  powerlinePresent?: InputMaybe<SortEnumType>;
  pricingScheme?: InputMaybe<PricingSchemeDtoSortInput>;
  projectType?: InputMaybe<ProjectTypeDtoSortInput>;
  publicProject?: InputMaybe<SortEnumType>;
  released?: InputMaybe<SortEnumType>;
  safetyRequired?: InputMaybe<SortEnumType>;
  salesAgent?: InputMaybe<EmployeeDtoSortInput>;
  salesRegion?: InputMaybe<SalesRegionDtoSortInput>;
  specialInstruction?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  zipCode?: InputMaybe<SortEnumType>;
};

export type Dtos_V1_JobStatusDto = {
  __typename?: 'Dtos_V1_JobStatusDto';
  colorCode?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V1_JobStatusDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_JobStatusDtoFilterInput>>;
  colorCode?: InputMaybe<StringOperationFilterInput>;
  default?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_JobStatusDtoFilterInput>>;
};

export type Dtos_V1_JobStatusDtoInput = {
  colorCode?: InputMaybe<Scalars['String']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Dtos_V1_JobStatusDtoSortInput = {
  colorCode?: InputMaybe<SortEnumType>;
  default?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Dtos_V1_JobTypeDto = {
  __typename?: 'Dtos_V1_JobTypeDto';
  default?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V1_JobTypeDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_JobTypeDtoFilterInput>>;
  default?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_JobTypeDtoFilterInput>>;
};

export type Dtos_V1_JobTypeDtoInput = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Dtos_V1_LicensePlateDto = {
  __typename?: 'Dtos_V1_LicensePlateDto';
  number: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type Dtos_V1_LicensePlateDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_LicensePlateDtoFilterInput>>;
  number?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_LicensePlateDtoFilterInput>>;
  state?: InputMaybe<StringOperationFilterInput>;
};

export type Dtos_V1_LicensePlateDtoInput = {
  number: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type Dtos_V1_LicensePlateDtoSortInput = {
  number?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
};

export type Dtos_V1_LocationDto = {
  __typename?: 'Dtos_V1_LocationDto';
  default?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V1_LocationDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_LocationDtoFilterInput>>;
  default?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_LocationDtoFilterInput>>;
};

export type Dtos_V1_LocationDtoInput = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Dtos_V1_LocationDtoSortInput = {
  default?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Dtos_V1_PricingSchemeDto = {
  __typename?: 'Dtos_V1_PricingSchemeDto';
  default: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  schemeName: Scalars['String']['output'];
};

export type Dtos_V1_PricingSchemeDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_PricingSchemeDtoFilterInput>>;
  default?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_PricingSchemeDtoFilterInput>>;
  schemeName?: InputMaybe<StringOperationFilterInput>;
};

export type Dtos_V1_PricingSchemeDtoInput = {
  default: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  schemeName: Scalars['String']['input'];
};

export type Dtos_V1_SalesRegionDto = {
  __typename?: 'Dtos_V1_SalesRegionDto';
  default: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  salesRegionName?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V1_SalesRegionDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_SalesRegionDtoFilterInput>>;
  default?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_SalesRegionDtoFilterInput>>;
  salesRegionName?: InputMaybe<StringOperationFilterInput>;
};

export type Dtos_V1_SalesRegionDtoInput = {
  default: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  salesRegionName?: InputMaybe<Scalars['String']['input']>;
};

export type Dtos_V1_SpecialFlagDto = {
  __typename?: 'Dtos_V1_SpecialFlagDto';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V1_SpecialFlagDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_SpecialFlagDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_SpecialFlagDtoFilterInput>>;
};

export type Dtos_V1_SpecialFlagDtoInput = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Dtos_V1_SpecialFlagDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Dtos_V1_TermDto = {
  __typename?: 'Dtos_V1_TermDto';
  default: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  termName?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V1_TermDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_TermDtoFilterInput>>;
  default?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_TermDtoFilterInput>>;
  termName?: InputMaybe<StringOperationFilterInput>;
};

export type Dtos_V1_TermDtoInput = {
  default: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  termName?: InputMaybe<Scalars['String']['input']>;
};

export type Dtos_V1_VendorDto = {
  __typename?: 'Dtos_V1_VendorDto';
  default?: Maybe<Scalars['Boolean']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  emailAddressId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  mailAddress?: Maybe<Scalars['String']['output']>;
  mailAddressId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneId?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V1_VendorDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V1_VendorDtoFilterInput>>;
  default?: InputMaybe<BooleanOperationFilterInput>;
  emailAddress?: InputMaybe<StringOperationFilterInput>;
  emailAddressId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  mailAddress?: InputMaybe<StringOperationFilterInput>;
  mailAddressId?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V1_VendorDtoFilterInput>>;
  phoneId?: InputMaybe<IntOperationFilterInput>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
};

export type Dtos_V1_VendorDtoInput = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  emailAddressId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  mailAddress?: InputMaybe<Scalars['String']['input']>;
  mailAddressId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneId?: InputMaybe<Scalars['Int']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Dtos_V1_VendorDtoSortInput = {
  default?: InputMaybe<SortEnumType>;
  emailAddress?: InputMaybe<SortEnumType>;
  emailAddressId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  mailAddress?: InputMaybe<SortEnumType>;
  mailAddressId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  phoneId?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<SortEnumType>;
};

export type Dtos_V2_CrewDto = {
  __typename?: 'Dtos_V2_CrewDto';
  acknowledged: Scalars['Boolean']['output'];
  allowMobileAppAccess?: Maybe<Scalars['Boolean']['output']>;
  assignedEquipment?: Maybe<Scalars['String']['output']>;
  availableDispatchLocations?: Maybe<Array<Dtos_V1_LocationDto>>;
  availableEmploymentStatuses?: Maybe<Array<Dtos_V1_EmploymentStatusDto>>;
  availableEmploymentTypes?: Maybe<Array<Dtos_V1_EmploymentTypeDto>>;
  availableJobRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  availableOutOfOfficeReasons?: Maybe<Array<Dtos_V1_Employee_OutOfOfficeReasonDto>>;
  availableSystemRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  availableWorkLocations?: Maybe<Array<Dtos_V1_LocationDto>>;
  balance?: Maybe<Scalars['Float']['output']>;
  banEntries: Array<Dtos_V2_Employee_EmployeeBanDto>;
  clockStatus?: Maybe<Scalars['String']['output']>;
  clockTime?: Maybe<Scalars['LocalDateTime']['output']>;
  clockingMode?: Maybe<Scalars['Short']['output']>;
  companyTemp?: Maybe<Scalars['String']['output']>;
  currentStatus?: Maybe<Scalars['Int']['output']>;
  dateOfBirth?: Maybe<Scalars['LocalDateTime']['output']>;
  daysOut?: Maybe<Scalars['Int']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  defaultEmployeeCrewRoleId?: Maybe<Scalars['Int']['output']>;
  deletable?: Maybe<Scalars['Boolean']['output']>;
  dispatchLocation?: Maybe<Dtos_V1_LocationDto>;
  dotHours5Day?: Maybe<Scalars['Decimal']['output']>;
  dotHours6Day?: Maybe<Scalars['Decimal']['output']>;
  dotHours7Day?: Maybe<Scalars['Decimal']['output']>;
  dotHours8Day?: Maybe<Scalars['Decimal']['output']>;
  driversLicense?: Maybe<Dtos_V1_DriversLicenseDto>;
  eid?: Maybe<Scalars['String']['output']>;
  email?: Maybe<ContactInformationDto>;
  employeeStatus?: Maybe<Scalars['Int']['output']>;
  employmentStatus?: Maybe<Dtos_V1_EmploymentStatusDto>;
  employmentType?: Maybe<EmploymentType>;
  endDate?: Maybe<Scalars['LocalDateTime']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gpsPasswordHash?: Maybe<Array<Scalars['Byte']['output']>>;
  gpsUsername?: Maybe<Scalars['String']['output']>;
  gridColor?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  inactive?: Maybe<Scalars['Boolean']['output']>;
  isGeofenceEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPayroll?: Maybe<Scalars['Boolean']['output']>;
  isSystem?: Maybe<Scalars['Boolean']['output']>;
  jobRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  notesTemp?: Maybe<Scalars['String']['output']>;
  notified: Scalars['Boolean']['output'];
  outOfOfficeHistory?: Maybe<Array<Dtos_V1_Employee_EmployeeOutOfOfficeDto>>;
  payPerHour?: Maybe<Scalars['Decimal']['output']>;
  phoneNumber?: Maybe<ContactInformationDto>;
  photo?: Maybe<Array<Scalars['Byte']['output']>>;
  pinHashed?: Maybe<Scalars['String']['output']>;
  plannedAllocation: Dtos_V2_PlannedAllocationDto;
  role?: Maybe<Dtos_V1_CrewRoleDto>;
  salesmanCommissionRate?: Maybe<Scalars['Float']['output']>;
  seniorityCode?: Maybe<Scalars['String']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['LocalDateTime']['output']>;
  status: Array<CrewAssignmentStatus>;
  statusNotes: Scalars['String']['output'];
  supportedRoleIds: Array<Scalars['Int']['output']>;
  systemRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  temporaryEmployee?: Maybe<Scalars['Int']['output']>;
  ud1?: Maybe<Scalars['String']['output']>;
  ud2?: Maybe<Scalars['String']['output']>;
  upcomingOutOfOffice?: Maybe<Array<Dtos_V1_Employee_EmployeeOutOfOfficeDto>>;
  updatedBy?: Maybe<Dtos_V1_Employee_EmployeeReferenceDto>;
  updatedOn?: Maybe<Scalars['LocalDateTime']['output']>;
  usable?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<Dtos_V2_User_UserSummaryDto>;
  workLocation?: Maybe<Dtos_V1_LocationDto>;
};

export type Dtos_V2_CrewDtoFilterInput = {
  acknowledged?: InputMaybe<BooleanOperationFilterInput>;
  allowMobileAppAccess?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<Dtos_V2_CrewDtoFilterInput>>;
  assignedEquipment?: InputMaybe<StringOperationFilterInput>;
  availableDispatchLocations?: InputMaybe<ListFilterInputTypeOfDtos_V1_LocationDtoFilterInput>;
  availableEmploymentStatuses?: InputMaybe<ListFilterInputTypeOfDtos_V1_EmploymentStatusDtoFilterInput>;
  availableEmploymentTypes?: InputMaybe<ListFilterInputTypeOfDtos_V1_EmploymentTypeDtoFilterInput>;
  availableJobRoles?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput>;
  availableOutOfOfficeReasons?: InputMaybe<ListFilterInputTypeOfDtos_V1_Employee_OutOfOfficeReasonDtoFilterInput>;
  availableSystemRoles?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput>;
  availableWorkLocations?: InputMaybe<ListFilterInputTypeOfDtos_V1_LocationDtoFilterInput>;
  balance?: InputMaybe<FloatOperationFilterInput>;
  banEntries?: InputMaybe<ListFilterInputTypeOfDtos_V2_Employee_EmployeeBanDtoFilterInput>;
  clockStatus?: InputMaybe<StringOperationFilterInput>;
  clockTime?: InputMaybe<DateTimeOperationFilterInput>;
  clockingMode?: InputMaybe<ShortOperationFilterInput>;
  companyTemp?: InputMaybe<StringOperationFilterInput>;
  currentStatus?: InputMaybe<IntOperationFilterInput>;
  dateOfBirth?: InputMaybe<DateTimeOperationFilterInput>;
  daysOut?: InputMaybe<IntOperationFilterInput>;
  default?: InputMaybe<BooleanOperationFilterInput>;
  defaultEmployeeCrewRoleId?: InputMaybe<IntOperationFilterInput>;
  deletable?: InputMaybe<BooleanOperationFilterInput>;
  dispatchLocation?: InputMaybe<Dtos_V1_LocationDtoFilterInput>;
  dotHours5Day?: InputMaybe<DecimalOperationFilterInput>;
  dotHours6Day?: InputMaybe<DecimalOperationFilterInput>;
  dotHours7Day?: InputMaybe<DecimalOperationFilterInput>;
  dotHours8Day?: InputMaybe<DecimalOperationFilterInput>;
  driversLicense?: InputMaybe<Dtos_V1_DriversLicenseDtoFilterInput>;
  eid?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<ContactInformationDtoFilterInput>;
  employeeStatus?: InputMaybe<IntOperationFilterInput>;
  employmentStatus?: InputMaybe<Dtos_V1_EmploymentStatusDtoFilterInput>;
  employmentType?: InputMaybe<NullableOfEmploymentTypeOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  fax?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  gpsPasswordHash?: InputMaybe<ListByteOperationFilterInput>;
  gpsUsername?: InputMaybe<StringOperationFilterInput>;
  gridColor?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  inactive?: InputMaybe<BooleanOperationFilterInput>;
  isGeofenceEnabled?: InputMaybe<BooleanOperationFilterInput>;
  isPayroll?: InputMaybe<BooleanOperationFilterInput>;
  isSystem?: InputMaybe<BooleanOperationFilterInput>;
  jobRoles?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  notesTemp?: InputMaybe<StringOperationFilterInput>;
  notified?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V2_CrewDtoFilterInput>>;
  outOfOfficeHistory?: InputMaybe<ListFilterInputTypeOfDtos_V1_Employee_EmployeeOutOfOfficeDtoFilterInput>;
  payPerHour?: InputMaybe<DecimalOperationFilterInput>;
  phoneNumber?: InputMaybe<ContactInformationDtoFilterInput>;
  photo?: InputMaybe<ListByteOperationFilterInput>;
  pinHashed?: InputMaybe<StringOperationFilterInput>;
  plannedAllocation?: InputMaybe<Dtos_V2_PlannedAllocationDtoFilterInput>;
  role?: InputMaybe<Dtos_V1_CrewRoleDtoFilterInput>;
  salesmanCommissionRate?: InputMaybe<FloatOperationFilterInput>;
  seniorityCode?: InputMaybe<StringOperationFilterInput>;
  ssn?: InputMaybe<StringOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<ListCrewAssignmentStatusOperationFilterInput>;
  statusNotes?: InputMaybe<StringOperationFilterInput>;
  supportedRoleIds?: InputMaybe<ListIntOperationFilterInput>;
  systemRoles?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput>;
  temporaryEmployee?: InputMaybe<IntOperationFilterInput>;
  ud1?: InputMaybe<StringOperationFilterInput>;
  ud2?: InputMaybe<StringOperationFilterInput>;
  upcomingOutOfOffice?: InputMaybe<ListFilterInputTypeOfDtos_V1_Employee_EmployeeOutOfOfficeDtoFilterInput>;
  updatedBy?: InputMaybe<Dtos_V1_Employee_EmployeeReferenceDtoFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
  usable?: InputMaybe<BooleanOperationFilterInput>;
  user?: InputMaybe<Dtos_V2_User_UserSummaryDtoFilterInput>;
  workLocation?: InputMaybe<Dtos_V1_LocationDtoFilterInput>;
};

export type Dtos_V2_CrewDtoSortInput = {
  acknowledged?: InputMaybe<SortEnumType>;
  allowMobileAppAccess?: InputMaybe<SortEnumType>;
  assignedEquipment?: InputMaybe<SortEnumType>;
  balance?: InputMaybe<SortEnumType>;
  clockStatus?: InputMaybe<SortEnumType>;
  clockTime?: InputMaybe<SortEnumType>;
  clockingMode?: InputMaybe<SortEnumType>;
  companyTemp?: InputMaybe<SortEnumType>;
  currentStatus?: InputMaybe<SortEnumType>;
  dateOfBirth?: InputMaybe<SortEnumType>;
  daysOut?: InputMaybe<SortEnumType>;
  default?: InputMaybe<SortEnumType>;
  defaultEmployeeCrewRoleId?: InputMaybe<SortEnumType>;
  deletable?: InputMaybe<SortEnumType>;
  dispatchLocation?: InputMaybe<Dtos_V1_LocationDtoSortInput>;
  dotHours5Day?: InputMaybe<SortEnumType>;
  dotHours6Day?: InputMaybe<SortEnumType>;
  dotHours7Day?: InputMaybe<SortEnumType>;
  dotHours8Day?: InputMaybe<SortEnumType>;
  driversLicense?: InputMaybe<Dtos_V1_DriversLicenseDtoSortInput>;
  eid?: InputMaybe<SortEnumType>;
  email?: InputMaybe<ContactInformationDtoSortInput>;
  employeeStatus?: InputMaybe<SortEnumType>;
  employmentStatus?: InputMaybe<Dtos_V1_EmploymentStatusDtoSortInput>;
  employmentType?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  fax?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  gpsUsername?: InputMaybe<SortEnumType>;
  gridColor?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inactive?: InputMaybe<SortEnumType>;
  isGeofenceEnabled?: InputMaybe<SortEnumType>;
  isPayroll?: InputMaybe<SortEnumType>;
  isSystem?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  notesTemp?: InputMaybe<SortEnumType>;
  notified?: InputMaybe<SortEnumType>;
  payPerHour?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<ContactInformationDtoSortInput>;
  pinHashed?: InputMaybe<SortEnumType>;
  plannedAllocation?: InputMaybe<Dtos_V2_PlannedAllocationDtoSortInput>;
  role?: InputMaybe<Dtos_V1_CrewRoleDtoSortInput>;
  salesmanCommissionRate?: InputMaybe<SortEnumType>;
  seniorityCode?: InputMaybe<SortEnumType>;
  ssn?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  statusNotes?: InputMaybe<SortEnumType>;
  temporaryEmployee?: InputMaybe<SortEnumType>;
  ud1?: InputMaybe<SortEnumType>;
  ud2?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<Dtos_V1_Employee_EmployeeReferenceDtoSortInput>;
  updatedOn?: InputMaybe<SortEnumType>;
  usable?: InputMaybe<SortEnumType>;
  user?: InputMaybe<Dtos_V2_User_UserSummaryDtoSortInput>;
  workLocation?: InputMaybe<Dtos_V1_LocationDtoSortInput>;
};

export type Dtos_V2_Customer_CustomerDto = {
  __typename?: 'Dtos_V2_Customer_CustomerDto';
  accountType?: Maybe<AccountTypeDto>;
  address?: Maybe<AddressDto>;
  availableAccountTypes?: Maybe<Array<AccountTypeDto>>;
  availableCustomerTypes?: Maybe<Array<CustomerTypeDto>>;
  availablePricingSchemes?: Maybe<Array<Dtos_V1_PricingSchemeDto>>;
  availableSalesAgents?: Maybe<Array<EmployeeDto>>;
  availableSalesRegions?: Maybe<Array<Dtos_V1_SalesRegionDto>>;
  availableTerms?: Maybe<Array<Dtos_V1_TermDto>>;
  companyName?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<Array<ContactDto>>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  createdOn: Scalars['LocalDateTime']['output'];
  customerDiscount?: Maybe<Scalars['Float']['output']>;
  customerStatus: CustomerStatus;
  customerType?: Maybe<CustomerTypeDto>;
  deletable: Scalars['Boolean']['output'];
  financialSummary?: Maybe<FinancialSummaryDto>;
  id?: Maybe<Scalars['Int']['output']>;
  maxCredit: Scalars['Decimal']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  pricingScheme?: Maybe<PricingSchemeDto>;
  primaryContacts?: Maybe<Array<ContactDto>>;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryPhone?: Maybe<Scalars['String']['output']>;
  salesAgent?: Maybe<EmployeeDto>;
  salesRegion?: Maybe<SalesRegionDto>;
  taxNumber?: Maybe<Scalars['String']['output']>;
  term?: Maybe<TermDto>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  updatedOn?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type Dtos_V2_Customer_CustomerDtoFilterInput = {
  accountType?: InputMaybe<AccountTypeDtoFilterInput>;
  address?: InputMaybe<AddressDtoFilterInput>;
  and?: InputMaybe<Array<Dtos_V2_Customer_CustomerDtoFilterInput>>;
  availableAccountTypes?: InputMaybe<ListFilterInputTypeOfAccountTypeDtoFilterInput>;
  availableCustomerTypes?: InputMaybe<ListFilterInputTypeOfCustomerTypeDtoFilterInput>;
  availablePricingSchemes?: InputMaybe<ListFilterInputTypeOfDtos_V1_PricingSchemeDtoFilterInput>;
  availableSalesAgents?: InputMaybe<ListFilterInputTypeOfEmployeeDtoFilterInput>;
  availableSalesRegions?: InputMaybe<ListFilterInputTypeOfDtos_V1_SalesRegionDtoFilterInput>;
  availableTerms?: InputMaybe<ListFilterInputTypeOfDtos_V1_TermDtoFilterInput>;
  companyName?: InputMaybe<StringOperationFilterInput>;
  contacts?: InputMaybe<ListFilterInputTypeOfContactDtoFilterInput>;
  createdBy?: InputMaybe<IntOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  customerDiscount?: InputMaybe<FloatOperationFilterInput>;
  customerStatus?: InputMaybe<CustomerStatusOperationFilterInput>;
  customerType?: InputMaybe<CustomerTypeDtoFilterInput>;
  deletable?: InputMaybe<BooleanOperationFilterInput>;
  financialSummary?: InputMaybe<FinancialSummaryDtoFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  maxCredit?: InputMaybe<DecimalOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V2_Customer_CustomerDtoFilterInput>>;
  pricingScheme?: InputMaybe<PricingSchemeDtoFilterInput>;
  primaryContacts?: InputMaybe<ListFilterInputTypeOfContactDtoFilterInput>;
  primaryEmail?: InputMaybe<StringOperationFilterInput>;
  primaryPhone?: InputMaybe<StringOperationFilterInput>;
  salesAgent?: InputMaybe<EmployeeDtoFilterInput>;
  salesRegion?: InputMaybe<SalesRegionDtoFilterInput>;
  taxNumber?: InputMaybe<StringOperationFilterInput>;
  term?: InputMaybe<TermDtoFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type Dtos_V2_Customer_CustomerDtoSortInput = {
  accountType?: InputMaybe<AccountTypeDtoSortInput>;
  address?: InputMaybe<AddressDtoSortInput>;
  companyName?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  customerDiscount?: InputMaybe<SortEnumType>;
  customerStatus?: InputMaybe<SortEnumType>;
  customerType?: InputMaybe<CustomerTypeDtoSortInput>;
  deletable?: InputMaybe<SortEnumType>;
  financialSummary?: InputMaybe<FinancialSummaryDtoSortInput>;
  id?: InputMaybe<SortEnumType>;
  maxCredit?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  pricingScheme?: InputMaybe<PricingSchemeDtoSortInput>;
  primaryEmail?: InputMaybe<SortEnumType>;
  primaryPhone?: InputMaybe<SortEnumType>;
  salesAgent?: InputMaybe<EmployeeDtoSortInput>;
  salesRegion?: InputMaybe<SalesRegionDtoSortInput>;
  taxNumber?: InputMaybe<SortEnumType>;
  term?: InputMaybe<TermDtoSortInput>;
  updatedBy?: InputMaybe<SortEnumType>;
  updatedOn?: InputMaybe<SortEnumType>;
};

export type Dtos_V2_DailyNoteDto = {
  __typename?: 'Dtos_V2_DailyNoteDto';
  date: Scalars['LocalDateTime']['output'];
  notes: Scalars['String']['output'];
};

export type Dtos_V2_DailyNoteDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V2_DailyNoteDtoFilterInput>>;
  date?: InputMaybe<DateTimeOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V2_DailyNoteDtoFilterInput>>;
};

export type Dtos_V2_Employee_EmployeeBanDto = {
  __typename?: 'Dtos_V2_Employee_EmployeeBanDto';
  banType: Scalars['String']['output'];
  bannedFrom: Dtos_V2_Employee_EmployeeBannedFrom;
  createdBy?: Maybe<Dtos_V2_Employee_EmployeeDto>;
  createdOn: Scalars['LocalDateTime']['output'];
  id: Scalars['Int']['output'];
  updatedBy?: Maybe<Dtos_V2_Employee_EmployeeDto>;
  updatedOn: Scalars['LocalDateTime']['output'];
};

export type Dtos_V2_Employee_EmployeeBanDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V2_Employee_EmployeeBanDtoFilterInput>>;
  banType?: InputMaybe<StringOperationFilterInput>;
  bannedFrom?: InputMaybe<Dtos_V2_Employee_EmployeeBannedFromFilterInput>;
  createdBy?: InputMaybe<Dtos_V2_Employee_EmployeeDtoFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V2_Employee_EmployeeBanDtoFilterInput>>;
  updatedBy?: InputMaybe<Dtos_V2_Employee_EmployeeDtoFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type Dtos_V2_Employee_EmployeeBannedFrom = {
  __typename?: 'Dtos_V2_Employee_EmployeeBannedFrom';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Dtos_V2_Employee_EmployeeBannedFromFilterInput = {
  and?: InputMaybe<Array<Dtos_V2_Employee_EmployeeBannedFromFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V2_Employee_EmployeeBannedFromFilterInput>>;
};

export type Dtos_V2_Employee_EmployeeDto = {
  __typename?: 'Dtos_V2_Employee_EmployeeDto';
  allowMobileAppAccess?: Maybe<Scalars['Boolean']['output']>;
  assignedEquipment?: Maybe<Scalars['String']['output']>;
  availableDispatchLocations?: Maybe<Array<Dtos_V1_LocationDto>>;
  availableEmploymentStatuses?: Maybe<Array<Dtos_V1_EmploymentStatusDto>>;
  availableEmploymentTypes?: Maybe<Array<Dtos_V1_EmploymentTypeDto>>;
  availableJobRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  availableOutOfOfficeReasons?: Maybe<Array<Dtos_V1_Employee_OutOfOfficeReasonDto>>;
  availableSystemRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  availableWorkLocations?: Maybe<Array<Dtos_V1_LocationDto>>;
  balance?: Maybe<Scalars['Float']['output']>;
  banEntries: Array<Dtos_V2_Employee_EmployeeBanDto>;
  clockStatus?: Maybe<Scalars['String']['output']>;
  clockTime?: Maybe<Scalars['LocalDateTime']['output']>;
  clockingMode?: Maybe<Scalars['Short']['output']>;
  companyTemp?: Maybe<Scalars['String']['output']>;
  currentStatus?: Maybe<Scalars['Int']['output']>;
  dateOfBirth?: Maybe<Scalars['LocalDateTime']['output']>;
  daysOut?: Maybe<Scalars['Int']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  defaultEmployeeCrewRoleId?: Maybe<Scalars['Int']['output']>;
  deletable?: Maybe<Scalars['Boolean']['output']>;
  dispatchLocation?: Maybe<Dtos_V1_LocationDto>;
  dotHours5Day?: Maybe<Scalars['Decimal']['output']>;
  dotHours6Day?: Maybe<Scalars['Decimal']['output']>;
  dotHours7Day?: Maybe<Scalars['Decimal']['output']>;
  dotHours8Day?: Maybe<Scalars['Decimal']['output']>;
  driversLicense?: Maybe<Dtos_V1_DriversLicenseDto>;
  eid?: Maybe<Scalars['String']['output']>;
  email?: Maybe<ContactInformationDto>;
  employeeStatus?: Maybe<Scalars['Int']['output']>;
  employmentStatus?: Maybe<Dtos_V1_EmploymentStatusDto>;
  employmentType?: Maybe<EmploymentType>;
  endDate?: Maybe<Scalars['LocalDateTime']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gpsPasswordHash?: Maybe<Array<Scalars['Byte']['output']>>;
  gpsUsername?: Maybe<Scalars['String']['output']>;
  gridColor?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  inactive?: Maybe<Scalars['Boolean']['output']>;
  isGeofenceEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPayroll?: Maybe<Scalars['Boolean']['output']>;
  isSystem?: Maybe<Scalars['Boolean']['output']>;
  jobRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  notesTemp?: Maybe<Scalars['String']['output']>;
  outOfOfficeHistory?: Maybe<Array<Dtos_V1_Employee_EmployeeOutOfOfficeDto>>;
  payPerHour?: Maybe<Scalars['Decimal']['output']>;
  phoneNumber?: Maybe<ContactInformationDto>;
  photo?: Maybe<Array<Scalars['Byte']['output']>>;
  pinHashed?: Maybe<Scalars['String']['output']>;
  salesmanCommissionRate?: Maybe<Scalars['Float']['output']>;
  seniorityCode?: Maybe<Scalars['String']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['LocalDateTime']['output']>;
  systemRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  temporaryEmployee?: Maybe<Scalars['Int']['output']>;
  ud1?: Maybe<Scalars['String']['output']>;
  ud2?: Maybe<Scalars['String']['output']>;
  upcomingOutOfOffice?: Maybe<Array<Dtos_V1_Employee_EmployeeOutOfOfficeDto>>;
  updatedBy?: Maybe<Dtos_V1_Employee_EmployeeReferenceDto>;
  updatedOn?: Maybe<Scalars['LocalDateTime']['output']>;
  usable?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<Dtos_V2_User_UserSummaryDto>;
  workLocation?: Maybe<Dtos_V1_LocationDto>;
};

export type Dtos_V2_Employee_EmployeeDtoFilterInput = {
  allowMobileAppAccess?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<Dtos_V2_Employee_EmployeeDtoFilterInput>>;
  assignedEquipment?: InputMaybe<StringOperationFilterInput>;
  availableDispatchLocations?: InputMaybe<ListFilterInputTypeOfDtos_V1_LocationDtoFilterInput>;
  availableEmploymentStatuses?: InputMaybe<ListFilterInputTypeOfDtos_V1_EmploymentStatusDtoFilterInput>;
  availableEmploymentTypes?: InputMaybe<ListFilterInputTypeOfDtos_V1_EmploymentTypeDtoFilterInput>;
  availableJobRoles?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput>;
  availableOutOfOfficeReasons?: InputMaybe<ListFilterInputTypeOfDtos_V1_Employee_OutOfOfficeReasonDtoFilterInput>;
  availableSystemRoles?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput>;
  availableWorkLocations?: InputMaybe<ListFilterInputTypeOfDtos_V1_LocationDtoFilterInput>;
  balance?: InputMaybe<FloatOperationFilterInput>;
  banEntries?: InputMaybe<ListFilterInputTypeOfDtos_V2_Employee_EmployeeBanDtoFilterInput>;
  clockStatus?: InputMaybe<StringOperationFilterInput>;
  clockTime?: InputMaybe<DateTimeOperationFilterInput>;
  clockingMode?: InputMaybe<ShortOperationFilterInput>;
  companyTemp?: InputMaybe<StringOperationFilterInput>;
  currentStatus?: InputMaybe<IntOperationFilterInput>;
  dateOfBirth?: InputMaybe<DateTimeOperationFilterInput>;
  daysOut?: InputMaybe<IntOperationFilterInput>;
  default?: InputMaybe<BooleanOperationFilterInput>;
  defaultEmployeeCrewRoleId?: InputMaybe<IntOperationFilterInput>;
  deletable?: InputMaybe<BooleanOperationFilterInput>;
  dispatchLocation?: InputMaybe<Dtos_V1_LocationDtoFilterInput>;
  dotHours5Day?: InputMaybe<DecimalOperationFilterInput>;
  dotHours6Day?: InputMaybe<DecimalOperationFilterInput>;
  dotHours7Day?: InputMaybe<DecimalOperationFilterInput>;
  dotHours8Day?: InputMaybe<DecimalOperationFilterInput>;
  driversLicense?: InputMaybe<Dtos_V1_DriversLicenseDtoFilterInput>;
  eid?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<ContactInformationDtoFilterInput>;
  employeeStatus?: InputMaybe<IntOperationFilterInput>;
  employmentStatus?: InputMaybe<Dtos_V1_EmploymentStatusDtoFilterInput>;
  employmentType?: InputMaybe<NullableOfEmploymentTypeOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  fax?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  gpsPasswordHash?: InputMaybe<ListByteOperationFilterInput>;
  gpsUsername?: InputMaybe<StringOperationFilterInput>;
  gridColor?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  inactive?: InputMaybe<BooleanOperationFilterInput>;
  isGeofenceEnabled?: InputMaybe<BooleanOperationFilterInput>;
  isPayroll?: InputMaybe<BooleanOperationFilterInput>;
  isSystem?: InputMaybe<BooleanOperationFilterInput>;
  jobRoles?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  notesTemp?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V2_Employee_EmployeeDtoFilterInput>>;
  outOfOfficeHistory?: InputMaybe<ListFilterInputTypeOfDtos_V1_Employee_EmployeeOutOfOfficeDtoFilterInput>;
  payPerHour?: InputMaybe<DecimalOperationFilterInput>;
  phoneNumber?: InputMaybe<ContactInformationDtoFilterInput>;
  photo?: InputMaybe<ListByteOperationFilterInput>;
  pinHashed?: InputMaybe<StringOperationFilterInput>;
  salesmanCommissionRate?: InputMaybe<FloatOperationFilterInput>;
  seniorityCode?: InputMaybe<StringOperationFilterInput>;
  ssn?: InputMaybe<StringOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  systemRoles?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput>;
  temporaryEmployee?: InputMaybe<IntOperationFilterInput>;
  ud1?: InputMaybe<StringOperationFilterInput>;
  ud2?: InputMaybe<StringOperationFilterInput>;
  upcomingOutOfOffice?: InputMaybe<ListFilterInputTypeOfDtos_V1_Employee_EmployeeOutOfOfficeDtoFilterInput>;
  updatedBy?: InputMaybe<Dtos_V1_Employee_EmployeeReferenceDtoFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
  usable?: InputMaybe<BooleanOperationFilterInput>;
  user?: InputMaybe<Dtos_V2_User_UserSummaryDtoFilterInput>;
  workLocation?: InputMaybe<Dtos_V1_LocationDtoFilterInput>;
};

export type Dtos_V2_Employee_EmployeeDtoSortInput = {
  allowMobileAppAccess?: InputMaybe<SortEnumType>;
  assignedEquipment?: InputMaybe<SortEnumType>;
  balance?: InputMaybe<SortEnumType>;
  clockStatus?: InputMaybe<SortEnumType>;
  clockTime?: InputMaybe<SortEnumType>;
  clockingMode?: InputMaybe<SortEnumType>;
  companyTemp?: InputMaybe<SortEnumType>;
  currentStatus?: InputMaybe<SortEnumType>;
  dateOfBirth?: InputMaybe<SortEnumType>;
  daysOut?: InputMaybe<SortEnumType>;
  default?: InputMaybe<SortEnumType>;
  defaultEmployeeCrewRoleId?: InputMaybe<SortEnumType>;
  deletable?: InputMaybe<SortEnumType>;
  dispatchLocation?: InputMaybe<Dtos_V1_LocationDtoSortInput>;
  dotHours5Day?: InputMaybe<SortEnumType>;
  dotHours6Day?: InputMaybe<SortEnumType>;
  dotHours7Day?: InputMaybe<SortEnumType>;
  dotHours8Day?: InputMaybe<SortEnumType>;
  driversLicense?: InputMaybe<Dtos_V1_DriversLicenseDtoSortInput>;
  eid?: InputMaybe<SortEnumType>;
  email?: InputMaybe<ContactInformationDtoSortInput>;
  employeeStatus?: InputMaybe<SortEnumType>;
  employmentStatus?: InputMaybe<Dtos_V1_EmploymentStatusDtoSortInput>;
  employmentType?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  fax?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  gpsUsername?: InputMaybe<SortEnumType>;
  gridColor?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inactive?: InputMaybe<SortEnumType>;
  isGeofenceEnabled?: InputMaybe<SortEnumType>;
  isPayroll?: InputMaybe<SortEnumType>;
  isSystem?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  notesTemp?: InputMaybe<SortEnumType>;
  payPerHour?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<ContactInformationDtoSortInput>;
  pinHashed?: InputMaybe<SortEnumType>;
  salesmanCommissionRate?: InputMaybe<SortEnumType>;
  seniorityCode?: InputMaybe<SortEnumType>;
  ssn?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  temporaryEmployee?: InputMaybe<SortEnumType>;
  ud1?: InputMaybe<SortEnumType>;
  ud2?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<Dtos_V1_Employee_EmployeeReferenceDtoSortInput>;
  updatedOn?: InputMaybe<SortEnumType>;
  usable?: InputMaybe<SortEnumType>;
  user?: InputMaybe<Dtos_V2_User_UserSummaryDtoSortInput>;
  workLocation?: InputMaybe<Dtos_V1_LocationDtoSortInput>;
};

export type Dtos_V2_Equipment_EquipmentDto = {
  __typename?: 'Dtos_V2_Equipment_EquipmentDto';
  acquiredOn?: Maybe<Scalars['LocalDateTime']['output']>;
  availableClasses?: Maybe<Array<Dtos_V1_EquipmentClassDto>>;
  availableDefaultEmployees?: Maybe<Array<Dtos_V1_CrewDto>>;
  availableDispatchLocations?: Maybe<Array<Dtos_V1_LocationDto>>;
  availableEmployees?: Maybe<Array<Dtos_V1_EmployeeDto>>;
  availableJobRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  availableLocations?: Maybe<Array<Dtos_V1_LocationDto>>;
  availableMakes?: Maybe<Array<Dtos_V1_EquipmentMakeDto>>;
  availableModels?: Maybe<Array<Dtos_V1_EquipmentModelDto>>;
  availableOutOfServiceReasons?: Maybe<Array<Dtos_V1_Equipment_OutOfServiceReasonDto>>;
  availableSizes?: Maybe<Array<Dtos_V1_EquipmentSizeDto>>;
  availableStatuses?: Maybe<Array<Dtos_V1_JobStatusDto>>;
  availableTypes?: Maybe<Array<Dtos_V1_EquipmentTypeDto>>;
  backInServiceOn?: Maybe<Scalars['Date']['output']>;
  beganServiceMileage?: Maybe<Scalars['Int']['output']>;
  beganServiceOn?: Maybe<Scalars['LocalDateTime']['output']>;
  boomModelNum?: Maybe<Scalars['String']['output']>;
  boomSerialNumber?: Maybe<Scalars['String']['output']>;
  class?: Maybe<Dtos_V1_EquipmentClassDto>;
  clearTime?: Maybe<Scalars['LocalDateTime']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  daysDown?: Maybe<Scalars['Int']['output']>;
  defaultEmployee?: Maybe<Dtos_V2_CrewDto>;
  defaultEndStyle?: Maybe<Scalars['Int']['output']>;
  defaultInsideSystemDiameter?: Maybe<Scalars['Int']['output']>;
  defaultLocation?: Maybe<Dtos_V1_LocationDto>;
  deletable?: Maybe<Scalars['Boolean']['output']>;
  descriptor?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  dispatchLocation?: Maybe<Dtos_V1_DispatchLocationDto>;
  doubleBooking?: Maybe<Scalars['String']['output']>;
  engHrs?: Maybe<Scalars['Int']['output']>;
  equipmentStatus?: Maybe<EquipmentStatusType>;
  fuelAvgStationaryConsumptionPerHour?: Maybe<Scalars['Decimal']['output']>;
  fuelAvgTravelingConsumptionPerHour?: Maybe<Scalars['Decimal']['output']>;
  fuelTankSize?: Maybe<Scalars['Int']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  geoFencingEnabled?: Maybe<Scalars['Boolean']['output']>;
  gpsTrackerSerialNumber?: Maybe<Scalars['String']['output']>;
  grossWeight?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  inService?: Maybe<Scalars['Int']['output']>;
  isSystem?: Maybe<Scalars['Boolean']['output']>;
  leaveTime?: Maybe<Scalars['LocalDateTime']['output']>;
  licensePlate?: Maybe<Dtos_V1_LicensePlateDto>;
  location?: Maybe<Dtos_V1_LocationDto>;
  machineSerialNumber?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Dtos_V1_EquipmentMakeDto>;
  maxGroundBearingPressure?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Dtos_V1_EquipmentModelDto>;
  mpEquipmentId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  onJobTime?: Maybe<Scalars['LocalDateTime']['output']>;
  outOfServiceHistory?: Maybe<Array<Dtos_V1_Equipment_EquipmentOutOfServiceDto>>;
  plannedAllocation: Dtos_V2_Equipment_EquipmentPlannedAllocationDto;
  pumpHrs?: Maybe<Scalars['Int']['output']>;
  pumpMi?: Maybe<Scalars['Int']['output']>;
  purchasedMileage?: Maybe<Scalars['Int']['output']>;
  requiredJobRoles?: Maybe<Array<Dtos_V1_CrewRoleDto>>;
  seniorityCode?: Maybe<Scalars['String']['output']>;
  showUpTime?: Maybe<Scalars['LocalDateTime']['output']>;
  size?: Maybe<Dtos_V1_EquipmentSizeDto>;
  startTime?: Maybe<Scalars['LocalDateTime']['output']>;
  status?: Maybe<Dtos_V1_JobStatusDto>;
  statusNotes?: Maybe<Scalars['String']['output']>;
  truckMi?: Maybe<Scalars['Int']['output']>;
  truckModelNumber?: Maybe<Scalars['String']['output']>;
  truckYear?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Dtos_V1_EquipmentTypeDto>;
  ud1?: Maybe<Scalars['String']['output']>;
  ud2?: Maybe<Scalars['String']['output']>;
  unworkable?: Maybe<Scalars['Boolean']['output']>;
  upcomingOutOfService?: Maybe<Array<Dtos_V1_Equipment_EquipmentOutOfServiceDto>>;
  vinNumber?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type Dtos_V2_Equipment_EquipmentDtoFilterInput = {
  acquiredOn?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<Dtos_V2_Equipment_EquipmentDtoFilterInput>>;
  availableClasses?: InputMaybe<ListFilterInputTypeOfDtos_V1_EquipmentClassDtoFilterInput>;
  availableDefaultEmployees?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewDtoFilterInput>;
  availableDispatchLocations?: InputMaybe<ListFilterInputTypeOfDtos_V1_LocationDtoFilterInput>;
  availableEmployees?: InputMaybe<ListFilterInputTypeOfDtos_V1_EmployeeDtoFilterInput>;
  availableJobRoles?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput>;
  availableLocations?: InputMaybe<ListFilterInputTypeOfDtos_V1_LocationDtoFilterInput>;
  availableMakes?: InputMaybe<ListFilterInputTypeOfDtos_V1_EquipmentMakeDtoFilterInput>;
  availableModels?: InputMaybe<ListFilterInputTypeOfDtos_V1_EquipmentModelDtoFilterInput>;
  availableOutOfServiceReasons?: InputMaybe<ListFilterInputTypeOfDtos_V1_Equipment_OutOfServiceReasonDtoFilterInput>;
  availableSizes?: InputMaybe<ListFilterInputTypeOfDtos_V1_EquipmentSizeDtoFilterInput>;
  availableStatuses?: InputMaybe<ListFilterInputTypeOfDtos_V1_JobStatusDtoFilterInput>;
  availableTypes?: InputMaybe<ListFilterInputTypeOfDtos_V1_EquipmentTypeDtoFilterInput>;
  backInServiceOn?: InputMaybe<DateOperationFilterInput>;
  beganServiceMileage?: InputMaybe<IntOperationFilterInput>;
  beganServiceOn?: InputMaybe<DateTimeOperationFilterInput>;
  boomModelNum?: InputMaybe<StringOperationFilterInput>;
  boomSerialNumber?: InputMaybe<StringOperationFilterInput>;
  class?: InputMaybe<Dtos_V1_EquipmentClassDtoFilterInput>;
  clearTime?: InputMaybe<DateTimeOperationFilterInput>;
  date?: InputMaybe<DateOperationFilterInput>;
  daysDown?: InputMaybe<IntOperationFilterInput>;
  defaultEmployee?: InputMaybe<Dtos_V2_CrewDtoFilterInput>;
  defaultEndStyle?: InputMaybe<IntOperationFilterInput>;
  defaultInsideSystemDiameter?: InputMaybe<IntOperationFilterInput>;
  defaultLocation?: InputMaybe<Dtos_V1_LocationDtoFilterInput>;
  deletable?: InputMaybe<BooleanOperationFilterInput>;
  descriptor?: InputMaybe<StringOperationFilterInput>;
  details?: InputMaybe<StringOperationFilterInput>;
  dispatchLocation?: InputMaybe<Dtos_V1_DispatchLocationDtoFilterInput>;
  doubleBooking?: InputMaybe<StringOperationFilterInput>;
  engHrs?: InputMaybe<IntOperationFilterInput>;
  equipmentStatus?: InputMaybe<NullableOfEquipmentStatusTypeOperationFilterInput>;
  fuelAvgStationaryConsumptionPerHour?: InputMaybe<DecimalOperationFilterInput>;
  fuelAvgTravelingConsumptionPerHour?: InputMaybe<DecimalOperationFilterInput>;
  fuelTankSize?: InputMaybe<IntOperationFilterInput>;
  fuelType?: InputMaybe<StringOperationFilterInput>;
  geoFencingEnabled?: InputMaybe<BooleanOperationFilterInput>;
  gpsTrackerSerialNumber?: InputMaybe<StringOperationFilterInput>;
  grossWeight?: InputMaybe<FloatOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  inService?: InputMaybe<IntOperationFilterInput>;
  isSystem?: InputMaybe<BooleanOperationFilterInput>;
  leaveTime?: InputMaybe<DateTimeOperationFilterInput>;
  licensePlate?: InputMaybe<Dtos_V1_LicensePlateDtoFilterInput>;
  location?: InputMaybe<Dtos_V1_LocationDtoFilterInput>;
  machineSerialNumber?: InputMaybe<StringOperationFilterInput>;
  make?: InputMaybe<Dtos_V1_EquipmentMakeDtoFilterInput>;
  maxGroundBearingPressure?: InputMaybe<IntOperationFilterInput>;
  model?: InputMaybe<Dtos_V1_EquipmentModelDtoFilterInput>;
  mpEquipmentId?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  onJobTime?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V2_Equipment_EquipmentDtoFilterInput>>;
  outOfServiceHistory?: InputMaybe<ListFilterInputTypeOfDtos_V1_Equipment_EquipmentOutOfServiceDtoFilterInput>;
  pumpHrs?: InputMaybe<IntOperationFilterInput>;
  pumpMi?: InputMaybe<IntOperationFilterInput>;
  purchasedMileage?: InputMaybe<IntOperationFilterInput>;
  requiredJobRoles?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput>;
  seniorityCode?: InputMaybe<StringOperationFilterInput>;
  showUpTime?: InputMaybe<DateTimeOperationFilterInput>;
  size?: InputMaybe<Dtos_V1_EquipmentSizeDtoFilterInput>;
  startTime?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<Dtos_V1_JobStatusDtoFilterInput>;
  statusNotes?: InputMaybe<StringOperationFilterInput>;
  truckMi?: InputMaybe<IntOperationFilterInput>;
  truckModelNumber?: InputMaybe<StringOperationFilterInput>;
  truckYear?: InputMaybe<IntOperationFilterInput>;
  type?: InputMaybe<Dtos_V1_EquipmentTypeDtoFilterInput>;
  ud1?: InputMaybe<StringOperationFilterInput>;
  ud2?: InputMaybe<StringOperationFilterInput>;
  unworkable?: InputMaybe<BooleanOperationFilterInput>;
  upcomingOutOfService?: InputMaybe<ListFilterInputTypeOfDtos_V1_Equipment_EquipmentOutOfServiceDtoFilterInput>;
  vinNumber?: InputMaybe<StringOperationFilterInput>;
  year?: InputMaybe<IntOperationFilterInput>;
};

export type Dtos_V2_Equipment_EquipmentDtoSortInput = {
  acquiredOn?: InputMaybe<SortEnumType>;
  backInServiceOn?: InputMaybe<SortEnumType>;
  beganServiceMileage?: InputMaybe<SortEnumType>;
  beganServiceOn?: InputMaybe<SortEnumType>;
  boomModelNum?: InputMaybe<SortEnumType>;
  boomSerialNumber?: InputMaybe<SortEnumType>;
  class?: InputMaybe<Dtos_V1_EquipmentClassDtoSortInput>;
  clearTime?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  daysDown?: InputMaybe<SortEnumType>;
  defaultEmployee?: InputMaybe<Dtos_V2_CrewDtoSortInput>;
  defaultEndStyle?: InputMaybe<SortEnumType>;
  defaultInsideSystemDiameter?: InputMaybe<SortEnumType>;
  defaultLocation?: InputMaybe<Dtos_V1_LocationDtoSortInput>;
  deletable?: InputMaybe<SortEnumType>;
  descriptor?: InputMaybe<SortEnumType>;
  details?: InputMaybe<SortEnumType>;
  dispatchLocation?: InputMaybe<Dtos_V1_DispatchLocationDtoSortInput>;
  doubleBooking?: InputMaybe<SortEnumType>;
  engHrs?: InputMaybe<SortEnumType>;
  equipmentStatus?: InputMaybe<SortEnumType>;
  fuelAvgStationaryConsumptionPerHour?: InputMaybe<SortEnumType>;
  fuelAvgTravelingConsumptionPerHour?: InputMaybe<SortEnumType>;
  fuelTankSize?: InputMaybe<SortEnumType>;
  fuelType?: InputMaybe<SortEnumType>;
  geoFencingEnabled?: InputMaybe<SortEnumType>;
  gpsTrackerSerialNumber?: InputMaybe<SortEnumType>;
  grossWeight?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inService?: InputMaybe<SortEnumType>;
  isSystem?: InputMaybe<SortEnumType>;
  leaveTime?: InputMaybe<SortEnumType>;
  licensePlate?: InputMaybe<Dtos_V1_LicensePlateDtoSortInput>;
  location?: InputMaybe<Dtos_V1_LocationDtoSortInput>;
  machineSerialNumber?: InputMaybe<SortEnumType>;
  make?: InputMaybe<Dtos_V1_EquipmentMakeDtoSortInput>;
  maxGroundBearingPressure?: InputMaybe<SortEnumType>;
  model?: InputMaybe<Dtos_V1_EquipmentModelDtoSortInput>;
  mpEquipmentId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  onJobTime?: InputMaybe<SortEnumType>;
  plannedAllocation?: InputMaybe<Dtos_V2_Equipment_EquipmentPlannedAllocationDtoSortInput>;
  pumpHrs?: InputMaybe<SortEnumType>;
  pumpMi?: InputMaybe<SortEnumType>;
  purchasedMileage?: InputMaybe<SortEnumType>;
  seniorityCode?: InputMaybe<SortEnumType>;
  showUpTime?: InputMaybe<SortEnumType>;
  size?: InputMaybe<Dtos_V1_EquipmentSizeDtoSortInput>;
  startTime?: InputMaybe<SortEnumType>;
  status?: InputMaybe<Dtos_V1_JobStatusDtoSortInput>;
  statusNotes?: InputMaybe<SortEnumType>;
  truckMi?: InputMaybe<SortEnumType>;
  truckModelNumber?: InputMaybe<SortEnumType>;
  truckYear?: InputMaybe<SortEnumType>;
  type?: InputMaybe<Dtos_V1_EquipmentTypeDtoSortInput>;
  ud1?: InputMaybe<SortEnumType>;
  ud2?: InputMaybe<SortEnumType>;
  unworkable?: InputMaybe<SortEnumType>;
  vinNumber?: InputMaybe<SortEnumType>;
  year?: InputMaybe<SortEnumType>;
};

export type Dtos_V2_Equipment_EquipmentOutOfServiceDto = {
  __typename?: 'Dtos_V2_Equipment_EquipmentOutOfServiceDto';
  createdBy?: Maybe<EmployeeDto>;
  createdOn?: Maybe<Scalars['LocalDateTime']['output']>;
  end?: Maybe<Scalars['LocalDateTime']['output']>;
  equipment: Dtos_V2_Equipment_EquipmentDto;
  id?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Dtos_V2_Equipment_OutOfServiceReasonDto>;
  start: Scalars['LocalDateTime']['output'];
  updatedBy?: Maybe<EmployeeDto>;
  updatedOn?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type Dtos_V2_Equipment_EquipmentOutOfServiceDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V2_Equipment_EquipmentOutOfServiceDtoFilterInput>>;
  createdBy?: InputMaybe<EmployeeDtoFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  end?: InputMaybe<DateTimeOperationFilterInput>;
  equipment?: InputMaybe<Dtos_V2_Equipment_EquipmentDtoFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V2_Equipment_EquipmentOutOfServiceDtoFilterInput>>;
  reason?: InputMaybe<Dtos_V2_Equipment_OutOfServiceReasonDtoFilterInput>;
  start?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<EmployeeDtoFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type Dtos_V2_Equipment_EquipmentOutOfServiceDtoSortInput = {
  createdBy?: InputMaybe<EmployeeDtoSortInput>;
  createdOn?: InputMaybe<SortEnumType>;
  end?: InputMaybe<SortEnumType>;
  equipment?: InputMaybe<Dtos_V2_Equipment_EquipmentDtoSortInput>;
  id?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  reason?: InputMaybe<Dtos_V2_Equipment_OutOfServiceReasonDtoSortInput>;
  start?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<EmployeeDtoSortInput>;
  updatedOn?: InputMaybe<SortEnumType>;
};

export type Dtos_V2_Equipment_EquipmentPlannedAllocationDto = {
  __typename?: 'Dtos_V2_Equipment_EquipmentPlannedAllocationDto';
  clearTime?: Maybe<Scalars['TimeSpan']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  endTime?: Maybe<Scalars['TimeSpan']['output']>;
  estimatedArea?: Maybe<Scalars['Float']['output']>;
  estimatedHours?: Maybe<Scalars['Float']['output']>;
  estimatedVolume?: Maybe<Scalars['Float']['output']>;
  leaveTime?: Maybe<Scalars['TimeSpan']['output']>;
  onJobTime?: Maybe<Scalars['TimeSpan']['output']>;
  showUpTime?: Maybe<Scalars['TimeSpan']['output']>;
  startTime?: Maybe<Scalars['TimeSpan']['output']>;
};

export type Dtos_V2_Equipment_EquipmentPlannedAllocationDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V2_Equipment_EquipmentPlannedAllocationDtoFilterInput>>;
  clearTime?: InputMaybe<TimeSpanOperationFilterInput>;
  date?: InputMaybe<DateOperationFilterInput>;
  endTime?: InputMaybe<TimeSpanOperationFilterInput>;
  estimatedArea?: InputMaybe<FloatOperationFilterInput>;
  estimatedHours?: InputMaybe<FloatOperationFilterInput>;
  estimatedVolume?: InputMaybe<FloatOperationFilterInput>;
  leaveTime?: InputMaybe<TimeSpanOperationFilterInput>;
  onJobTime?: InputMaybe<TimeSpanOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V2_Equipment_EquipmentPlannedAllocationDtoFilterInput>>;
  showUpTime?: InputMaybe<TimeSpanOperationFilterInput>;
  startTime?: InputMaybe<TimeSpanOperationFilterInput>;
};

export type Dtos_V2_Equipment_EquipmentPlannedAllocationDtoSortInput = {
  clearTime?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  endTime?: InputMaybe<SortEnumType>;
  estimatedArea?: InputMaybe<SortEnumType>;
  estimatedHours?: InputMaybe<SortEnumType>;
  estimatedVolume?: InputMaybe<SortEnumType>;
  leaveTime?: InputMaybe<SortEnumType>;
  onJobTime?: InputMaybe<SortEnumType>;
  showUpTime?: InputMaybe<SortEnumType>;
  startTime?: InputMaybe<SortEnumType>;
};

export type Dtos_V2_Equipment_OutOfServiceReasonDto = {
  __typename?: 'Dtos_V2_Equipment_OutOfServiceReasonDto';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Dtos_V2_Equipment_OutOfServiceReasonDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V2_Equipment_OutOfServiceReasonDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V2_Equipment_OutOfServiceReasonDtoFilterInput>>;
};

export type Dtos_V2_Equipment_OutOfServiceReasonDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Dtos_V2_ExtraSystemDto = {
  __typename?: 'Dtos_V2_ExtraSystemDto';
  addToInvoiceMinimum?: Maybe<Scalars['Boolean']['output']>;
  applyToAll?: Maybe<Scalars['Boolean']['output']>;
  billable?: Maybe<Scalars['Boolean']['output']>;
  class: Dtos_V1_ClassDto;
  defaultItem?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  includePriceOnPrint?: Maybe<Scalars['Boolean']['output']>;
  jobId: Scalars['Int']['output'];
  lastSynced?: Maybe<Scalars['LocalDateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  plannedAllocation?: Maybe<Dtos_V2_PlannedAllocationDto>;
  price: Scalars['Decimal']['output'];
  quantity: Scalars['Decimal']['output'];
  rotg?: Maybe<Scalars['Boolean']['output']>;
  showAsExtraSystemOnJob?: Maybe<Scalars['Boolean']['output']>;
  taxable?: Maybe<Scalars['Boolean']['output']>;
  unitOfMeasure?: Maybe<Scalars['Int']['output']>;
};

export type Dtos_V2_ExtraSystemDtoFilterInput = {
  addToInvoiceMinimum?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<Dtos_V2_ExtraSystemDtoFilterInput>>;
  applyToAll?: InputMaybe<BooleanOperationFilterInput>;
  billable?: InputMaybe<BooleanOperationFilterInput>;
  class?: InputMaybe<Dtos_V1_ClassDtoFilterInput>;
  defaultItem?: InputMaybe<BooleanOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  includePriceOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  jobId?: InputMaybe<IntOperationFilterInput>;
  lastSynced?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V2_ExtraSystemDtoFilterInput>>;
  plannedAllocation?: InputMaybe<Dtos_V2_PlannedAllocationDtoFilterInput>;
  price?: InputMaybe<DecimalOperationFilterInput>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  rotg?: InputMaybe<BooleanOperationFilterInput>;
  showAsExtraSystemOnJob?: InputMaybe<BooleanOperationFilterInput>;
  taxable?: InputMaybe<BooleanOperationFilterInput>;
  unitOfMeasure?: InputMaybe<IntOperationFilterInput>;
};

export type Dtos_V2_JobSite_ContractorInfoDto = {
  __typename?: 'Dtos_V2_JobSite_ContractorInfoDto';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V2_JobSite_ContractorInfoDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V2_JobSite_ContractorInfoDtoFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V2_JobSite_ContractorInfoDtoFilterInput>>;
};

export type Dtos_V2_JobSite_ContractorInfoDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Dtos_V2_JobSite_CustomerInfoDto = {
  __typename?: 'Dtos_V2_JobSite_CustomerInfoDto';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V2_JobSite_CustomerInfoDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V2_JobSite_CustomerInfoDtoFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V2_JobSite_CustomerInfoDtoFilterInput>>;
};

export type Dtos_V2_JobSite_CustomerInfoDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Dtos_V2_JobSite_FlagsDto = {
  __typename?: 'Dtos_V2_JobSite_FlagsDto';
  noSubs: Scalars['Boolean']['output'];
  powerline: Scalars['Boolean']['output'];
};

export type Dtos_V2_JobSite_FlagsDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V2_JobSite_FlagsDtoFilterInput>>;
  noSubs?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V2_JobSite_FlagsDtoFilterInput>>;
  powerline?: InputMaybe<BooleanOperationFilterInput>;
};

export type Dtos_V2_JobSite_FlagsDtoSortInput = {
  noSubs?: InputMaybe<SortEnumType>;
  powerline?: InputMaybe<SortEnumType>;
};

export type Dtos_V2_JobSite_JobHistoryDto = {
  __typename?: 'Dtos_V2_JobSite_JobHistoryDto';
  date: Scalars['String']['output'];
  ticket: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Dtos_V2_JobSite_JobHistoryDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V2_JobSite_JobHistoryDtoFilterInput>>;
  date?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V2_JobSite_JobHistoryDtoFilterInput>>;
  ticket?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type Dtos_V2_JobSite_JobSiteDto = {
  __typename?: 'Dtos_V2_JobSite_JobSiteDto';
  assignId: Scalars['String']['output'];
  availableJobSiteTypes?: Maybe<Array<JobSiteTypeDto>>;
  availableStates?: Maybe<Array<StateDto>>;
  billableTravelHours: Scalars['Decimal']['output'];
  billingAddress: Scalars['String']['output'];
  cityTown: Scalars['String']['output'];
  contractNumber: Scalars['String']['output'];
  contractor?: Maybe<Dtos_V2_JobSite_ContractorInfoDto>;
  createdOn: Scalars['String']['output'];
  crossStreet: Scalars['String']['output'];
  customId: Scalars['String']['output'];
  customer?: Maybe<Dtos_V2_JobSite_CustomerInfoDto>;
  defaultBidLot: Scalars['String']['output'];
  defaultPoNumber: Scalars['String']['output'];
  deletable?: Maybe<Scalars['Boolean']['output']>;
  disposal: Scalars['String']['output'];
  flags?: Maybe<Dtos_V2_JobSite_FlagsDto>;
  id: Scalars['String']['output'];
  jobHistory?: Maybe<Array<Dtos_V2_JobSite_JobHistoryDto>>;
  jobName: Scalars['String']['output'];
  jobNumber: Scalars['String']['output'];
  jobPhone: Scalars['String']['output'];
  jobsiteChecklist: Scalars['String']['output'];
  jobsiteId: Scalars['String']['output'];
  jobsiteType: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Decimal']['output']>;
  location: Scalars['String']['output'];
  longitude?: Maybe<Scalars['Decimal']['output']>;
  mapPage: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  parcelNumber: Scalars['String']['output'];
  permitPresent: Scalars['Boolean']['output'];
  prelimed: Scalars['String']['output'];
  pricingScheme: Scalars['String']['output'];
  projectType: Scalars['String']['output'];
  reportGroup: Scalars['String']['output'];
  salesAgent: Scalars['String']['output'];
  salesRegion: Scalars['String']['output'];
  settings?: Maybe<Dtos_V2_JobSite_SettingsDto>;
  specialInstruction: Scalars['String']['output'];
  state: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
  verifiedBy: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type Dtos_V2_JobSite_JobSiteDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V2_JobSite_JobSiteDtoFilterInput>>;
  assignId?: InputMaybe<StringOperationFilterInput>;
  availableJobSiteTypes?: InputMaybe<ListFilterInputTypeOfJobSiteTypeDtoFilterInput>;
  availableStates?: InputMaybe<ListFilterInputTypeOfStateDtoFilterInput>;
  billableTravelHours?: InputMaybe<DecimalOperationFilterInput>;
  billingAddress?: InputMaybe<StringOperationFilterInput>;
  cityTown?: InputMaybe<StringOperationFilterInput>;
  contractNumber?: InputMaybe<StringOperationFilterInput>;
  contractor?: InputMaybe<Dtos_V2_JobSite_ContractorInfoDtoFilterInput>;
  createdOn?: InputMaybe<StringOperationFilterInput>;
  crossStreet?: InputMaybe<StringOperationFilterInput>;
  customId?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<Dtos_V2_JobSite_CustomerInfoDtoFilterInput>;
  defaultBidLot?: InputMaybe<StringOperationFilterInput>;
  defaultPoNumber?: InputMaybe<StringOperationFilterInput>;
  deletable?: InputMaybe<BooleanOperationFilterInput>;
  disposal?: InputMaybe<StringOperationFilterInput>;
  flags?: InputMaybe<Dtos_V2_JobSite_FlagsDtoFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  jobHistory?: InputMaybe<ListFilterInputTypeOfDtos_V2_JobSite_JobHistoryDtoFilterInput>;
  jobName?: InputMaybe<StringOperationFilterInput>;
  jobNumber?: InputMaybe<StringOperationFilterInput>;
  jobPhone?: InputMaybe<StringOperationFilterInput>;
  jobsiteChecklist?: InputMaybe<StringOperationFilterInput>;
  jobsiteId?: InputMaybe<StringOperationFilterInput>;
  jobsiteType?: InputMaybe<StringOperationFilterInput>;
  latitude?: InputMaybe<DecimalOperationFilterInput>;
  location?: InputMaybe<StringOperationFilterInput>;
  longitude?: InputMaybe<DecimalOperationFilterInput>;
  mapPage?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V2_JobSite_JobSiteDtoFilterInput>>;
  parcelNumber?: InputMaybe<StringOperationFilterInput>;
  permitPresent?: InputMaybe<BooleanOperationFilterInput>;
  prelimed?: InputMaybe<StringOperationFilterInput>;
  pricingScheme?: InputMaybe<StringOperationFilterInput>;
  projectType?: InputMaybe<StringOperationFilterInput>;
  reportGroup?: InputMaybe<StringOperationFilterInput>;
  salesAgent?: InputMaybe<StringOperationFilterInput>;
  salesRegion?: InputMaybe<StringOperationFilterInput>;
  settings?: InputMaybe<Dtos_V2_JobSite_SettingsDtoFilterInput>;
  specialInstruction?: InputMaybe<StringOperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  verified?: InputMaybe<BooleanOperationFilterInput>;
  verifiedBy?: InputMaybe<StringOperationFilterInput>;
  zip?: InputMaybe<StringOperationFilterInput>;
};

export type Dtos_V2_JobSite_JobSiteDtoSortInput = {
  assignId?: InputMaybe<SortEnumType>;
  billableTravelHours?: InputMaybe<SortEnumType>;
  billingAddress?: InputMaybe<SortEnumType>;
  cityTown?: InputMaybe<SortEnumType>;
  contractNumber?: InputMaybe<SortEnumType>;
  contractor?: InputMaybe<Dtos_V2_JobSite_ContractorInfoDtoSortInput>;
  createdOn?: InputMaybe<SortEnumType>;
  crossStreet?: InputMaybe<SortEnumType>;
  customId?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<Dtos_V2_JobSite_CustomerInfoDtoSortInput>;
  defaultBidLot?: InputMaybe<SortEnumType>;
  defaultPoNumber?: InputMaybe<SortEnumType>;
  deletable?: InputMaybe<SortEnumType>;
  disposal?: InputMaybe<SortEnumType>;
  flags?: InputMaybe<Dtos_V2_JobSite_FlagsDtoSortInput>;
  id?: InputMaybe<SortEnumType>;
  jobName?: InputMaybe<SortEnumType>;
  jobNumber?: InputMaybe<SortEnumType>;
  jobPhone?: InputMaybe<SortEnumType>;
  jobsiteChecklist?: InputMaybe<SortEnumType>;
  jobsiteId?: InputMaybe<SortEnumType>;
  jobsiteType?: InputMaybe<SortEnumType>;
  latitude?: InputMaybe<SortEnumType>;
  location?: InputMaybe<SortEnumType>;
  longitude?: InputMaybe<SortEnumType>;
  mapPage?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  parcelNumber?: InputMaybe<SortEnumType>;
  permitPresent?: InputMaybe<SortEnumType>;
  prelimed?: InputMaybe<SortEnumType>;
  pricingScheme?: InputMaybe<SortEnumType>;
  projectType?: InputMaybe<SortEnumType>;
  reportGroup?: InputMaybe<SortEnumType>;
  salesAgent?: InputMaybe<SortEnumType>;
  salesRegion?: InputMaybe<SortEnumType>;
  settings?: InputMaybe<Dtos_V2_JobSite_SettingsDtoSortInput>;
  specialInstruction?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  verified?: InputMaybe<SortEnumType>;
  verifiedBy?: InputMaybe<SortEnumType>;
  zip?: InputMaybe<SortEnumType>;
};

export type Dtos_V2_JobSite_SettingsDto = {
  __typename?: 'Dtos_V2_JobSite_SettingsDto';
  cprPrevailing: Scalars['Boolean']['output'];
  emailInvoices: Scalars['Boolean']['output'];
  geofencing: Scalars['Boolean']['output'];
  inactive: Scalars['Boolean']['output'];
  nonTaxable: Scalars['Boolean']['output'];
  ocip: Scalars['Boolean']['output'];
  poRequired: Scalars['Boolean']['output'];
  publicProject: Scalars['Boolean']['output'];
  released: Scalars['Boolean']['output'];
  safetyRequired: Scalars['Boolean']['output'];
};

export type Dtos_V2_JobSite_SettingsDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V2_JobSite_SettingsDtoFilterInput>>;
  cprPrevailing?: InputMaybe<BooleanOperationFilterInput>;
  emailInvoices?: InputMaybe<BooleanOperationFilterInput>;
  geofencing?: InputMaybe<BooleanOperationFilterInput>;
  inactive?: InputMaybe<BooleanOperationFilterInput>;
  nonTaxable?: InputMaybe<BooleanOperationFilterInput>;
  ocip?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V2_JobSite_SettingsDtoFilterInput>>;
  poRequired?: InputMaybe<BooleanOperationFilterInput>;
  publicProject?: InputMaybe<BooleanOperationFilterInput>;
  released?: InputMaybe<BooleanOperationFilterInput>;
  safetyRequired?: InputMaybe<BooleanOperationFilterInput>;
};

export type Dtos_V2_JobSite_SettingsDtoSortInput = {
  cprPrevailing?: InputMaybe<SortEnumType>;
  emailInvoices?: InputMaybe<SortEnumType>;
  geofencing?: InputMaybe<SortEnumType>;
  inactive?: InputMaybe<SortEnumType>;
  nonTaxable?: InputMaybe<SortEnumType>;
  ocip?: InputMaybe<SortEnumType>;
  poRequired?: InputMaybe<SortEnumType>;
  publicProject?: InputMaybe<SortEnumType>;
  released?: InputMaybe<SortEnumType>;
  safetyRequired?: InputMaybe<SortEnumType>;
};

export type Dtos_V2_JobTypeDto = {
  __typename?: 'Dtos_V2_JobTypeDto';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V2_JobTypeDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V2_JobTypeDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V2_JobTypeDtoFilterInput>>;
};

export type Dtos_V2_JobTypeDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Dtos_V2_PlannedAllocationDto = {
  __typename?: 'Dtos_V2_PlannedAllocationDto';
  clearTime?: Maybe<Scalars['TimeSpan']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  endTime?: Maybe<Scalars['TimeSpan']['output']>;
  estimatedHours?: Maybe<Scalars['Float']['output']>;
  leaveTime?: Maybe<Scalars['TimeSpan']['output']>;
  onJobTime?: Maybe<Scalars['TimeSpan']['output']>;
  showUpTime?: Maybe<Scalars['TimeSpan']['output']>;
  startTime?: Maybe<Scalars['TimeSpan']['output']>;
};

export type Dtos_V2_PlannedAllocationDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V2_PlannedAllocationDtoFilterInput>>;
  clearTime?: InputMaybe<TimeSpanOperationFilterInput>;
  date?: InputMaybe<DateOperationFilterInput>;
  endTime?: InputMaybe<TimeSpanOperationFilterInput>;
  estimatedHours?: InputMaybe<FloatOperationFilterInput>;
  leaveTime?: InputMaybe<TimeSpanOperationFilterInput>;
  onJobTime?: InputMaybe<TimeSpanOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V2_PlannedAllocationDtoFilterInput>>;
  showUpTime?: InputMaybe<TimeSpanOperationFilterInput>;
  startTime?: InputMaybe<TimeSpanOperationFilterInput>;
};

export type Dtos_V2_PlannedAllocationDtoSortInput = {
  clearTime?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  endTime?: InputMaybe<SortEnumType>;
  estimatedHours?: InputMaybe<SortEnumType>;
  leaveTime?: InputMaybe<SortEnumType>;
  onJobTime?: InputMaybe<SortEnumType>;
  showUpTime?: InputMaybe<SortEnumType>;
  startTime?: InputMaybe<SortEnumType>;
};

export type Dtos_V2_RaptorJob_JobFieldDto = {
  __typename?: 'Dtos_V2_RaptorJob_JobFieldDto';
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
};

export type Dtos_V2_RaptorJob_JobFieldUiBehaviorRuleDto = {
  __typename?: 'Dtos_V2_RaptorJob_JobFieldUiBehaviorRuleDto';
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type Dtos_V2_RaptorJob_RaptorJobDto = {
  __typename?: 'Dtos_V2_RaptorJob_RaptorJobDto';
  availableCrewMembers: Array<Dtos_V2_CrewDto>;
  availableCrewRoles: Array<Dtos_V1_CrewRoleDto>;
  availableCustomers: Array<CustomerDto>;
  availableDispatchLocations: Array<Dtos_V1_LocationDto>;
  availableDispatchers: Array<Dtos_V1_EmployeeDto>;
  availableEquipment: Array<Dtos_V2_Equipment_EquipmentDto>;
  availableEquipmentLocations: Array<Dtos_V1_LocationDto>;
  availableEquipmentSizes: Array<Dtos_V1_EquipmentSizeDto>;
  availableEquipmentTypes: Array<Dtos_V1_EquipmentTypeDto>;
  availableExtraSystems: Array<Dtos_V2_ExtraSystemDto>;
  availableJobInformation: Array<Dtos_V1_JobInformationDto>;
  availableJobStatuses: Array<Dtos_V1_JobStatusDto>;
  availableJobTypes: Array<Dtos_V1_JobTypeDto>;
  availableSalesAgents: Array<Dtos_V1_EmployeeDto>;
  availableSpecialFlags: Array<Dtos_V1_SpecialFlagDto>;
  availableVendors: Array<Dtos_V1_VendorDto>;
  calledInTime: Scalars['LocalDateTime']['output'];
  caller?: Maybe<Scalars['String']['output']>;
  cancelable: Scalars['Boolean']['output'];
  cod: Scalars['Boolean']['output'];
  confirmedBy: Dtos_V1_EmployeeDto;
  confirmedTime: Scalars['TimeSpan']['output'];
  createdBy?: Maybe<Dtos_V1_EmployeeDto>;
  createdOn: Scalars['LocalDateTime']['output'];
  crew: Array<Dtos_V2_CrewDto>;
  customer: CustomerDto;
  dailyNotes?: Maybe<Array<Dtos_V2_DailyNoteDto>>;
  dispatchLocation: Dtos_V1_DispatchLocationDto;
  dispatchNotes: Scalars['String']['output'];
  dispatcher: Dtos_V1_EmployeeDto;
  endDate?: Maybe<Scalars['Date']['output']>;
  equipment: Array<Dtos_V2_Equipment_EquipmentDto>;
  equipmentLocation: Dtos_V1_LocationDto;
  estimatedClearedTime?: Maybe<Scalars['LocalDateTime']['output']>;
  extraSystems: Array<Dtos_V2_ExtraSystemDto>;
  finishedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  id: Scalars['Int']['output'];
  isMultiDay: Scalars['Boolean']['output'];
  jobInformation: Dtos_V1_JobInformationDto;
  jobName: Scalars['String']['output'];
  jobNotes?: Maybe<Scalars['String']['output']>;
  jobNumber: Scalars['String']['output'];
  jobSite: Dtos_V1_JobSiteDto;
  notesForCrew?: Maybe<Scalars['String']['output']>;
  plannedAllocation: Dtos_V2_Equipment_EquipmentPlannedAllocationDto;
  poNumber: Scalars['String']['output'];
  priorityCode?: Maybe<Scalars['String']['output']>;
  salesAgent: Dtos_V1_EmployeeDto;
  sequence?: Maybe<Scalars['String']['output']>;
  sizeRequested: Dtos_V1_EquipmentSizeDto;
  specialFlag1?: Maybe<Dtos_V1_SpecialFlagDto>;
  specialFlag2?: Maybe<Dtos_V1_SpecialFlagDto>;
  specialFlag3?: Maybe<Dtos_V1_SpecialFlagDto>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['Date']['output'];
  status: Dtos_V1_JobStatusDto;
  strictSizeRequested: Scalars['Boolean']['output'];
  timeZone?: Maybe<Scalars['String']['output']>;
  type: Dtos_V2_JobTypeDto;
  updatedBy: Dtos_V1_EmployeeDto;
  updatedOn: Scalars['LocalDateTime']['output'];
  vendor?: Maybe<Dtos_V1_VendorDto>;
};

export type Dtos_V2_RaptorJob_RaptorJobDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V2_RaptorJob_RaptorJobDtoFilterInput>>;
  availableCrewMembers?: InputMaybe<ListFilterInputTypeOfDtos_V2_CrewDtoFilterInput>;
  availableCrewRoles?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput>;
  availableCustomers?: InputMaybe<ListFilterInputTypeOfCustomerDtoFilterInput>;
  availableDispatchLocations?: InputMaybe<ListFilterInputTypeOfDtos_V1_LocationDtoFilterInput>;
  availableDispatchers?: InputMaybe<ListFilterInputTypeOfDtos_V1_EmployeeDtoFilterInput>;
  availableEquipment?: InputMaybe<ListFilterInputTypeOfDtos_V2_Equipment_EquipmentDtoFilterInput>;
  availableEquipmentLocations?: InputMaybe<ListFilterInputTypeOfDtos_V1_LocationDtoFilterInput>;
  availableEquipmentSizes?: InputMaybe<ListFilterInputTypeOfDtos_V1_EquipmentSizeDtoFilterInput>;
  availableEquipmentTypes?: InputMaybe<ListFilterInputTypeOfDtos_V1_EquipmentTypeDtoFilterInput>;
  availableExtraSystems?: InputMaybe<ListFilterInputTypeOfDtos_V2_ExtraSystemDtoFilterInput>;
  availableJobInformation?: InputMaybe<ListFilterInputTypeOfDtos_V1_JobInformationDtoFilterInput>;
  availableJobStatuses?: InputMaybe<ListFilterInputTypeOfDtos_V1_JobStatusDtoFilterInput>;
  availableJobTypes?: InputMaybe<ListFilterInputTypeOfDtos_V1_JobTypeDtoFilterInput>;
  availableSalesAgents?: InputMaybe<ListFilterInputTypeOfDtos_V1_EmployeeDtoFilterInput>;
  availableSpecialFlags?: InputMaybe<ListFilterInputTypeOfDtos_V1_SpecialFlagDtoFilterInput>;
  availableVendors?: InputMaybe<ListFilterInputTypeOfDtos_V1_VendorDtoFilterInput>;
  calledInTime?: InputMaybe<DateTimeOperationFilterInput>;
  caller?: InputMaybe<StringOperationFilterInput>;
  cancelable?: InputMaybe<BooleanOperationFilterInput>;
  cod?: InputMaybe<BooleanOperationFilterInput>;
  confirmedBy?: InputMaybe<Dtos_V1_EmployeeDtoFilterInput>;
  confirmedTime?: InputMaybe<TimeSpanOperationFilterInput>;
  createdBy?: InputMaybe<Dtos_V1_EmployeeDtoFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  crew?: InputMaybe<ListFilterInputTypeOfDtos_V2_CrewDtoFilterInput>;
  customer?: InputMaybe<CustomerDtoFilterInput>;
  dailyNotes?: InputMaybe<ListFilterInputTypeOfDtos_V2_DailyNoteDtoFilterInput>;
  dispatchLocation?: InputMaybe<Dtos_V1_DispatchLocationDtoFilterInput>;
  dispatchNotes?: InputMaybe<StringOperationFilterInput>;
  dispatcher?: InputMaybe<Dtos_V1_EmployeeDtoFilterInput>;
  endDate?: InputMaybe<DateOperationFilterInput>;
  equipment?: InputMaybe<ListFilterInputTypeOfDtos_V2_Equipment_EquipmentDtoFilterInput>;
  equipmentLocation?: InputMaybe<Dtos_V1_LocationDtoFilterInput>;
  estimatedClearedTime?: InputMaybe<DateTimeOperationFilterInput>;
  extraSystems?: InputMaybe<ListFilterInputTypeOfDtos_V2_ExtraSystemDtoFilterInput>;
  finishedAt?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isMultiDay?: InputMaybe<BooleanOperationFilterInput>;
  jobInformation?: InputMaybe<Dtos_V1_JobInformationDtoFilterInput>;
  jobName?: InputMaybe<StringOperationFilterInput>;
  jobNotes?: InputMaybe<StringOperationFilterInput>;
  jobNumber?: InputMaybe<StringOperationFilterInput>;
  jobSite?: InputMaybe<Dtos_V1_JobSiteDtoFilterInput>;
  notesForCrew?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V2_RaptorJob_RaptorJobDtoFilterInput>>;
  plannedAllocation?: InputMaybe<Dtos_V2_Equipment_EquipmentPlannedAllocationDtoFilterInput>;
  poNumber?: InputMaybe<StringOperationFilterInput>;
  priorityCode?: InputMaybe<StringOperationFilterInput>;
  salesAgent?: InputMaybe<Dtos_V1_EmployeeDtoFilterInput>;
  sequence?: InputMaybe<StringOperationFilterInput>;
  sizeRequested?: InputMaybe<Dtos_V1_EquipmentSizeDtoFilterInput>;
  specialFlag1?: InputMaybe<Dtos_V1_SpecialFlagDtoFilterInput>;
  specialFlag2?: InputMaybe<Dtos_V1_SpecialFlagDtoFilterInput>;
  specialFlag3?: InputMaybe<Dtos_V1_SpecialFlagDtoFilterInput>;
  specialInstructions?: InputMaybe<StringOperationFilterInput>;
  startDate?: InputMaybe<DateOperationFilterInput>;
  status?: InputMaybe<Dtos_V1_JobStatusDtoFilterInput>;
  strictSizeRequested?: InputMaybe<BooleanOperationFilterInput>;
  timeZone?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<Dtos_V2_JobTypeDtoFilterInput>;
  updatedBy?: InputMaybe<Dtos_V1_EmployeeDtoFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
  vendor?: InputMaybe<Dtos_V1_VendorDtoFilterInput>;
};

export type Dtos_V2_RaptorJob_RaptorJobDtoSortInput = {
  calledInTime?: InputMaybe<SortEnumType>;
  caller?: InputMaybe<SortEnumType>;
  cancelable?: InputMaybe<SortEnumType>;
  cod?: InputMaybe<SortEnumType>;
  confirmedBy?: InputMaybe<Dtos_V1_EmployeeDtoSortInput>;
  confirmedTime?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<Dtos_V1_EmployeeDtoSortInput>;
  createdOn?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerDtoSortInput>;
  dispatchLocation?: InputMaybe<Dtos_V1_DispatchLocationDtoSortInput>;
  dispatchNotes?: InputMaybe<SortEnumType>;
  dispatcher?: InputMaybe<Dtos_V1_EmployeeDtoSortInput>;
  endDate?: InputMaybe<SortEnumType>;
  equipmentLocation?: InputMaybe<Dtos_V1_LocationDtoSortInput>;
  estimatedClearedTime?: InputMaybe<SortEnumType>;
  finishedAt?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isMultiDay?: InputMaybe<SortEnumType>;
  jobInformation?: InputMaybe<Dtos_V1_JobInformationDtoSortInput>;
  jobName?: InputMaybe<SortEnumType>;
  jobNotes?: InputMaybe<SortEnumType>;
  jobNumber?: InputMaybe<SortEnumType>;
  jobSite?: InputMaybe<Dtos_V1_JobSiteDtoSortInput>;
  notesForCrew?: InputMaybe<SortEnumType>;
  plannedAllocation?: InputMaybe<Dtos_V2_Equipment_EquipmentPlannedAllocationDtoSortInput>;
  poNumber?: InputMaybe<SortEnumType>;
  priorityCode?: InputMaybe<SortEnumType>;
  salesAgent?: InputMaybe<Dtos_V1_EmployeeDtoSortInput>;
  sequence?: InputMaybe<SortEnumType>;
  sizeRequested?: InputMaybe<Dtos_V1_EquipmentSizeDtoSortInput>;
  specialFlag1?: InputMaybe<Dtos_V1_SpecialFlagDtoSortInput>;
  specialFlag2?: InputMaybe<Dtos_V1_SpecialFlagDtoSortInput>;
  specialFlag3?: InputMaybe<Dtos_V1_SpecialFlagDtoSortInput>;
  specialInstructions?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<Dtos_V1_JobStatusDtoSortInput>;
  strictSizeRequested?: InputMaybe<SortEnumType>;
  timeZone?: InputMaybe<SortEnumType>;
  type?: InputMaybe<Dtos_V2_JobTypeDtoSortInput>;
  updatedBy?: InputMaybe<Dtos_V1_EmployeeDtoSortInput>;
  updatedOn?: InputMaybe<SortEnumType>;
  vendor?: InputMaybe<Dtos_V1_VendorDtoSortInput>;
};

export type Dtos_V2_RaptorJob_RaptorJobSupportingDataDto = {
  __typename?: 'Dtos_V2_RaptorJob_RaptorJobSupportingDataDto';
  availableClasses: Array<Dtos_V1_EquipmentClassDto>;
  availableCrewMembers: Array<Dtos_V1_CrewDto>;
  availableCrewRoles: Array<Dtos_V1_CrewRoleDto>;
  availableCustomers: Array<CustomerDto>;
  availableDispatchLocations: Array<Dtos_V1_LocationDto>;
  availableDispatchers: Array<Dtos_V1_EmployeeDto>;
  availableEquipment: Array<Dtos_V1_Equipment_EquipmentDto>;
  availableEquipmentLocations: Array<Dtos_V1_LocationDto>;
  availableEquipmentSizes: Array<Dtos_V1_EquipmentSizeDto>;
  availableEquipmentTypes: Array<Dtos_V1_EquipmentTypeDto>;
  availableExtraSystems: Array<Dtos_V1_ExtraSystemDto>;
  availableJobInformation: Array<Dtos_V1_JobInformationDto>;
  availableJobStatuses: Array<Dtos_V1_JobStatusDto>;
  availableJobTypes: Array<Dtos_V1_JobTypeDto>;
  availableSalesAgents: Array<EmployeeDto>;
  availableSpecialFlags: Array<Dtos_V1_SpecialFlagDto>;
  availableVendors: Array<Dtos_V1_VendorDto>;
  requiredFields: Array<Dtos_V2_RaptorJob_JobFieldDto>;
  uiBehaviorRules: Array<Dtos_V2_RaptorJob_JobFieldUiBehaviorRuleDto>;
};

export type Dtos_V2_TimeZone_TimeZoneDto = {
  __typename?: 'Dtos_V2_TimeZone_TimeZoneDto';
  default: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V2_TimeZone_TimeZoneDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V2_TimeZone_TimeZoneDtoFilterInput>>;
  default?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Dtos_V2_TimeZone_TimeZoneDtoFilterInput>>;
  shortName?: InputMaybe<StringOperationFilterInput>;
  timeZone?: InputMaybe<StringOperationFilterInput>;
};

export type Dtos_V2_TimeZone_TimeZoneDtoSortInput = {
  default?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  shortName?: InputMaybe<SortEnumType>;
  timeZone?: InputMaybe<SortEnumType>;
};

export type Dtos_V2_User_UserSummaryDto = {
  __typename?: 'Dtos_V2_User_UserSummaryDto';
  userId: Scalars['Int']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type Dtos_V2_User_UserSummaryDtoFilterInput = {
  and?: InputMaybe<Array<Dtos_V2_User_UserSummaryDtoFilterInput>>;
  or?: InputMaybe<Array<Dtos_V2_User_UserSummaryDtoFilterInput>>;
  userId?: InputMaybe<IntOperationFilterInput>;
  userName?: InputMaybe<StringOperationFilterInput>;
};

export type Dtos_V2_User_UserSummaryDtoSortInput = {
  userId?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
};

export type Employee = {
  __typename?: 'Employee';
  allJobs: Array<RaptorAllJobsVw>;
  allowMobileAppAccess: Scalars['Boolean']['output'];
  appBlobRemotes: Array<AppBlobRemote>;
  balance?: Maybe<Scalars['Float']['output']>;
  bannedAssignments: Array<EmployeeBan>;
  cboGuid?: Maybe<Scalars['String']['output']>;
  clockingMode: Scalars['Short']['output'];
  companyTemp?: Maybe<Scalars['String']['output']>;
  contentTypes: Array<ContentType>;
  crews: Array<Crew>;
  currentStatus: Scalars['Int']['output'];
  customer: Customer;
  customerWithContacts: RaptorCustomerWithContacts;
  deletable?: Maybe<RaptorDeletableEmployeeVw>;
  dispatchLocId: Scalars['Int']['output'];
  dispatchLocation?: Maybe<BizObject>;
  dispatchedJobs: Array<RaptorAllJobsVw>;
  dln?: Maybe<Scalars['String']['output']>;
  dlnstate?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['LocalDateTime']['output']>;
  eid?: Maybe<Scalars['String']['output']>;
  email?: Maybe<ContactSource>;
  emergencyContact1Id?: Maybe<Scalars['Int']['output']>;
  emergencyContact2Id?: Maybe<Scalars['Int']['output']>;
  emergencyContact3Id?: Maybe<Scalars['Int']['output']>;
  empId: Scalars['Int']['output'];
  employeeBansCreated: Array<EmployeeBan>;
  employeeBansUpdated: Array<EmployeeBan>;
  employeeContentTypes: Array<EmployeeContentType>;
  employeeRoleVw?: Maybe<Entities_V1_EmployeeRoleVw>;
  employeeStatus: BizObject;
  employeesOutOfOffice: Array<Entities_V1_RaptorEmployeeOutOfOffice>;
  employeesOutOfOfficeDays: Array<Entities_V1_EmployeeOutOfOfficeDay>;
  equipmentCrews: Array<Entities_V1_EquipmentCrew>;
  fax?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  gpspasswordHash?: Maybe<Array<Scalars['Byte']['output']>>;
  gpsusername?: Maybe<Scalars['String']['output']>;
  gridColor?: Maybe<Scalars['Int']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  hireDate?: Maybe<Scalars['LocalDateTime']['output']>;
  isAdmin: Scalars['Int']['output'];
  isGeofenceEnabled: Scalars['Boolean']['output'];
  isPayroll: Scalars['Boolean']['output'];
  jobSites: JobSite;
  jobs: Array<RaptorJob>;
  lastName?: Maybe<Scalars['String']['output']>;
  locationId: Scalars['Int']['output'];
  mailAddressId?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  notesTemp?: Maybe<Scalars['String']['output']>;
  payPerHour?: Maybe<Scalars['Decimal']['output']>;
  permissions: Array<AppUserAccess>;
  phoneNumber?: Maybe<ContactSource>;
  photoId?: Maybe<Array<Scalars['Byte']['output']>>;
  pinhashed?: Maybe<Scalars['String']['output']>;
  poursCreated: Array<PourForAdding>;
  poursDispatched: Array<PourForAdding>;
  poursSold: Array<PourForAdding>;
  poursUpdated: Array<PourForAdding>;
  primaryAddressId?: Maybe<Scalars['Int']['output']>;
  primaryEmailId?: Maybe<Scalars['Int']['output']>;
  primaryFaxId?: Maybe<Scalars['Int']['output']>;
  primaryPhoneId?: Maybe<Scalars['Int']['output']>;
  primaryWebsiteId?: Maybe<Scalars['Int']['output']>;
  raptorAppUser?: Maybe<AppUser>;
  raptorCertificateAssignment?: Maybe<RaptorCertificateAssignmentVw>;
  raptorDefaultEmployees: Array<Entities_V2_RaptorDefaultEmployee>;
  raptorEmployees: Array<RaptorEmployee>;
  raptorPermitAssignment?: Maybe<RaptorPermitAssignmentVw>;
  releaseDate?: Maybe<Scalars['LocalDateTime']['output']>;
  rowId: Scalars['UUID']['output'];
  salesmanCommissionRate: Scalars['Float']['output'];
  seniorityCode?: Maybe<Scalars['String']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  stationedAt: Yard;
  statusEmployee?: Maybe<Scalars['Int']['output']>;
  system?: Maybe<Scalars['Boolean']['output']>;
  temporaryEmployee?: Maybe<Scalars['Int']['output']>;
  ud1?: Maybe<Scalars['String']['output']>;
  ud2?: Maybe<Scalars['String']['output']>;
  update: ResultOfEmployee;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  updatedByEmployee?: Maybe<Employee>;
  updatedOn?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type EmployeeBan = {
  __typename?: 'EmployeeBan';
  bannedEmployee: Employee;
  comment: Scalars['String']['output'];
  createdBy: Scalars['Int']['output'];
  createdByEmployee: Employee;
  createdOn: Scalars['LocalDateTime']['output'];
  employeeId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isInactive: Scalars['Boolean']['output'];
  parentId: Scalars['Int']['output'];
  parentTypeId: BannedFrom;
  updatedBy: Scalars['Int']['output'];
  updatedByEmployee: Employee;
  updatedOn: Scalars['LocalDateTime']['output'];
};

export type EmployeeBanFilterInput = {
  and?: InputMaybe<Array<EmployeeBanFilterInput>>;
  bannedEmployee?: InputMaybe<EmployeeFilterInput>;
  comment?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<IntOperationFilterInput>;
  createdByEmployee?: InputMaybe<EmployeeFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  employeeId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<EmployeeBanFilterInput>>;
  parentId?: InputMaybe<IntOperationFilterInput>;
  parentTypeId?: InputMaybe<BannedFromOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedByEmployee?: InputMaybe<EmployeeFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type EmployeeCheckList = {
  __typename?: 'EmployeeCheckList';
  approvedBy?: Maybe<Scalars['Int']['output']>;
  checkList?: Maybe<CheckList>;
  comments?: Maybe<Scalars['String']['output']>;
  empId: Scalars['Int']['output'];
  empSignature?: Maybe<Array<Scalars['Byte']['output']>>;
  employeeCheckListItems: Array<EmployeeCheckListItem>;
  id: Scalars['Int']['output'];
  isRequired: Scalars['Boolean']['output'];
  jobId: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['Decimal']['output']>;
  listId: Scalars['Int']['output'];
  longitude?: Maybe<Scalars['Decimal']['output']>;
  mapImage?: Maybe<Array<Scalars['Byte']['output']>>;
  rowId: Scalars['UUID']['output'];
  signed?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['Int']['output'];
  utcApprovedOn?: Maybe<Scalars['LocalDateTime']['output']>;
  utcCompletedOn?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type EmployeeCheckListFilterInput = {
  and?: InputMaybe<Array<EmployeeCheckListFilterInput>>;
  approvedBy?: InputMaybe<IntOperationFilterInput>;
  checkList?: InputMaybe<CheckListFilterInput>;
  comments?: InputMaybe<StringOperationFilterInput>;
  empId?: InputMaybe<IntOperationFilterInput>;
  empSignature?: InputMaybe<ListByteOperationFilterInput>;
  employeeCheckListItems?: InputMaybe<ListFilterInputTypeOfEmployeeCheckListItemFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isRequired?: InputMaybe<BooleanOperationFilterInput>;
  jobId?: InputMaybe<IntOperationFilterInput>;
  latitude?: InputMaybe<DecimalOperationFilterInput>;
  listId?: InputMaybe<IntOperationFilterInput>;
  longitude?: InputMaybe<DecimalOperationFilterInput>;
  mapImage?: InputMaybe<ListByteOperationFilterInput>;
  or?: InputMaybe<Array<EmployeeCheckListFilterInput>>;
  rowId?: InputMaybe<UuidOperationFilterInput>;
  signed?: InputMaybe<BooleanOperationFilterInput>;
  sortOrder?: InputMaybe<IntOperationFilterInput>;
  utcApprovedOn?: InputMaybe<DateTimeOperationFilterInput>;
  utcCompletedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type EmployeeCheckListItem = {
  __typename?: 'EmployeeCheckListItem';
  comment?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptor: Scalars['String']['output'];
  employeeCheckList?: Maybe<EmployeeCheckList>;
  employeeCheckListId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isRequired: Scalars['Boolean']['output'];
  itemId: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['Decimal']['output']>;
  longitude?: Maybe<Scalars['Decimal']['output']>;
  optionId?: Maybe<Scalars['Int']['output']>;
  optionName?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['UUID']['output'];
  selectedOptionIds?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Array<Scalars['Byte']['output']>>;
  sortOrder: Scalars['Int']['output'];
  utcCompletedOn?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type EmployeeCheckListItemFilterInput = {
  and?: InputMaybe<Array<EmployeeCheckListItemFilterInput>>;
  comment?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  descriptor?: InputMaybe<StringOperationFilterInput>;
  employeeCheckList?: InputMaybe<EmployeeCheckListFilterInput>;
  employeeCheckListId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isRequired?: InputMaybe<BooleanOperationFilterInput>;
  itemId?: InputMaybe<IntOperationFilterInput>;
  latitude?: InputMaybe<DecimalOperationFilterInput>;
  longitude?: InputMaybe<DecimalOperationFilterInput>;
  optionId?: InputMaybe<IntOperationFilterInput>;
  optionName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EmployeeCheckListItemFilterInput>>;
  rowId?: InputMaybe<UuidOperationFilterInput>;
  selectedOptionIds?: InputMaybe<StringOperationFilterInput>;
  signature?: InputMaybe<ListByteOperationFilterInput>;
  sortOrder?: InputMaybe<IntOperationFilterInput>;
  utcCompletedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type EmployeeContentType = {
  __typename?: 'EmployeeContentType';
  cboGuid?: Maybe<Scalars['String']['output']>;
  contentType: ContentType;
  contentTypeId: Scalars['Int']['output'];
  employee: Employee;
  employeeContTypeId: Scalars['Int']['output'];
  employeeId: Scalars['Int']['output'];
  primary: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  system: Scalars['Int']['output'];
};

export type EmployeeContentTypeFilterInput = {
  and?: InputMaybe<Array<EmployeeContentTypeFilterInput>>;
  cboGuid?: InputMaybe<StringOperationFilterInput>;
  contentType?: InputMaybe<ContentTypeFilterInput>;
  contentTypeId?: InputMaybe<IntOperationFilterInput>;
  employee?: InputMaybe<EmployeeFilterInput>;
  employeeContTypeId?: InputMaybe<IntOperationFilterInput>;
  employeeId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<EmployeeContentTypeFilterInput>>;
  primary?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<IntOperationFilterInput>;
  system?: InputMaybe<IntOperationFilterInput>;
};

export type EmployeeDto = {
  __typename?: 'EmployeeDto';
  default?: Maybe<Scalars['Boolean']['output']>;
  empId: Scalars['Int']['output'];
  fullName: Scalars['String']['output'];
  hireDate?: Maybe<Scalars['LocalDateTime']['output']>;
  jobRoles: Array<Dtos_V1_CrewRoleDto>;
  releaseDate?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type EmployeeDtoFilterInput = {
  and?: InputMaybe<Array<EmployeeDtoFilterInput>>;
  default?: InputMaybe<BooleanOperationFilterInput>;
  empId?: InputMaybe<IntOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  hireDate?: InputMaybe<DateTimeOperationFilterInput>;
  jobRoles?: InputMaybe<ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput>;
  or?: InputMaybe<Array<EmployeeDtoFilterInput>>;
  releaseDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type EmployeeDtoInput = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  empId: Scalars['Int']['input'];
  fullName: Scalars['String']['input'];
  hireDate?: InputMaybe<Scalars['LocalDateTime']['input']>;
  jobRoles: Array<Dtos_V1_CrewRoleDtoInput>;
  releaseDate?: InputMaybe<Scalars['LocalDateTime']['input']>;
};

export type EmployeeDtoSortInput = {
  default?: InputMaybe<SortEnumType>;
  empId?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  hireDate?: InputMaybe<SortEnumType>;
  releaseDate?: InputMaybe<SortEnumType>;
};

export type EmployeeFilterInput = {
  allJobs?: InputMaybe<ListFilterInputTypeOfRaptorAllJobsVwFilterInput>;
  allowMobileAppAccess?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<EmployeeFilterInput>>;
  appBlobRemotes?: InputMaybe<ListFilterInputTypeOfAppBlobRemoteFilterInput>;
  balance?: InputMaybe<FloatOperationFilterInput>;
  bannedAssignments?: InputMaybe<ListFilterInputTypeOfEmployeeBanFilterInput>;
  cboGuid?: InputMaybe<StringOperationFilterInput>;
  clockingMode?: InputMaybe<ShortOperationFilterInput>;
  companyTemp?: InputMaybe<StringOperationFilterInput>;
  contentTypes?: InputMaybe<ListFilterInputTypeOfContentTypeFilterInput>;
  crews?: InputMaybe<ListFilterInputTypeOfCrewFilterInput>;
  currentStatus?: InputMaybe<IntOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerWithContacts?: InputMaybe<RaptorCustomerWithContactsFilterInput>;
  deletable?: InputMaybe<RaptorDeletableEmployeeVwFilterInput>;
  dispatchLocId?: InputMaybe<IntOperationFilterInput>;
  dispatchLocation?: InputMaybe<BizObjectFilterInput>;
  dispatchedJobs?: InputMaybe<ListFilterInputTypeOfRaptorAllJobsVwFilterInput>;
  dln?: InputMaybe<StringOperationFilterInput>;
  dlnstate?: InputMaybe<StringOperationFilterInput>;
  dob?: InputMaybe<DateTimeOperationFilterInput>;
  eid?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<ContactSourceFilterInput>;
  emergencyContact1Id?: InputMaybe<IntOperationFilterInput>;
  emergencyContact2Id?: InputMaybe<IntOperationFilterInput>;
  emergencyContact3Id?: InputMaybe<IntOperationFilterInput>;
  empId?: InputMaybe<IntOperationFilterInput>;
  employeeBansCreated?: InputMaybe<ListFilterInputTypeOfEmployeeBanFilterInput>;
  employeeBansUpdated?: InputMaybe<ListFilterInputTypeOfEmployeeBanFilterInput>;
  employeeContentTypes?: InputMaybe<ListFilterInputTypeOfEmployeeContentTypeFilterInput>;
  employeeRoleVw?: InputMaybe<Entities_V1_EmployeeRoleVwFilterInput>;
  employeeStatus?: InputMaybe<BizObjectFilterInput>;
  employeesOutOfOffice?: InputMaybe<ListFilterInputTypeOfEntities_V1_RaptorEmployeeOutOfOfficeFilterInput>;
  employeesOutOfOfficeDays?: InputMaybe<ListFilterInputTypeOfEntities_V1_EmployeeOutOfOfficeDayFilterInput>;
  equipmentCrews?: InputMaybe<ListFilterInputTypeOfEntities_V1_EquipmentCrewFilterInput>;
  fax?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  gpspasswordHash?: InputMaybe<ListByteOperationFilterInput>;
  gpsusername?: InputMaybe<StringOperationFilterInput>;
  gridColor?: InputMaybe<IntOperationFilterInput>;
  guid?: InputMaybe<StringOperationFilterInput>;
  hireDate?: InputMaybe<DateTimeOperationFilterInput>;
  isAdmin?: InputMaybe<IntOperationFilterInput>;
  isGeofenceEnabled?: InputMaybe<BooleanOperationFilterInput>;
  isPayroll?: InputMaybe<BooleanOperationFilterInput>;
  jobSites?: InputMaybe<JobSiteFilterInput>;
  jobs?: InputMaybe<ListFilterInputTypeOfRaptorJobFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<IntOperationFilterInput>;
  mailAddressId?: InputMaybe<IntOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  notesTemp?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EmployeeFilterInput>>;
  payPerHour?: InputMaybe<DecimalOperationFilterInput>;
  permissions?: InputMaybe<ListFilterInputTypeOfAppUserAccessFilterInput>;
  phoneNumber?: InputMaybe<ContactSourceFilterInput>;
  photoId?: InputMaybe<ListByteOperationFilterInput>;
  pinhashed?: InputMaybe<StringOperationFilterInput>;
  poursCreated?: InputMaybe<ListFilterInputTypeOfPourForAddingFilterInput>;
  poursDispatched?: InputMaybe<ListFilterInputTypeOfPourForAddingFilterInput>;
  poursSold?: InputMaybe<ListFilterInputTypeOfPourForAddingFilterInput>;
  poursUpdated?: InputMaybe<ListFilterInputTypeOfPourForAddingFilterInput>;
  primaryAddressId?: InputMaybe<IntOperationFilterInput>;
  primaryEmailId?: InputMaybe<IntOperationFilterInput>;
  primaryFaxId?: InputMaybe<IntOperationFilterInput>;
  primaryPhoneId?: InputMaybe<IntOperationFilterInput>;
  primaryWebsiteId?: InputMaybe<IntOperationFilterInput>;
  raptorAppUser?: InputMaybe<AppUserFilterInput>;
  raptorCertificateAssignment?: InputMaybe<RaptorCertificateAssignmentVwFilterInput>;
  raptorDefaultEmployees?: InputMaybe<ListFilterInputTypeOfEntities_V2_RaptorDefaultEmployeeFilterInput>;
  raptorEmployees?: InputMaybe<ListFilterInputTypeOfRaptorEmployeeFilterInput>;
  raptorPermitAssignment?: InputMaybe<RaptorPermitAssignmentVwFilterInput>;
  releaseDate?: InputMaybe<DateTimeOperationFilterInput>;
  rowId?: InputMaybe<UuidOperationFilterInput>;
  salesmanCommissionRate?: InputMaybe<FloatOperationFilterInput>;
  seniorityCode?: InputMaybe<StringOperationFilterInput>;
  ssn?: InputMaybe<StringOperationFilterInput>;
  stationedAt?: InputMaybe<YardFilterInput>;
  statusEmployee?: InputMaybe<IntOperationFilterInput>;
  system?: InputMaybe<BooleanOperationFilterInput>;
  temporaryEmployee?: InputMaybe<IntOperationFilterInput>;
  ud1?: InputMaybe<StringOperationFilterInput>;
  ud2?: InputMaybe<StringOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedByEmployee?: InputMaybe<EmployeeFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type EmployeeSortInput = {
  allowMobileAppAccess?: InputMaybe<SortEnumType>;
  balance?: InputMaybe<SortEnumType>;
  cboGuid?: InputMaybe<SortEnumType>;
  clockingMode?: InputMaybe<SortEnumType>;
  companyTemp?: InputMaybe<SortEnumType>;
  currentStatus?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerWithContacts?: InputMaybe<RaptorCustomerWithContactsSortInput>;
  deletable?: InputMaybe<RaptorDeletableEmployeeVwSortInput>;
  dispatchLocId?: InputMaybe<SortEnumType>;
  dispatchLocation?: InputMaybe<BizObjectSortInput>;
  dln?: InputMaybe<SortEnumType>;
  dlnstate?: InputMaybe<SortEnumType>;
  dob?: InputMaybe<SortEnumType>;
  eid?: InputMaybe<SortEnumType>;
  email?: InputMaybe<ContactSourceSortInput>;
  emergencyContact1Id?: InputMaybe<SortEnumType>;
  emergencyContact2Id?: InputMaybe<SortEnumType>;
  emergencyContact3Id?: InputMaybe<SortEnumType>;
  empId?: InputMaybe<SortEnumType>;
  employeeRoleVw?: InputMaybe<Entities_V1_EmployeeRoleVwSortInput>;
  employeeStatus?: InputMaybe<BizObjectSortInput>;
  fax?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  gpsusername?: InputMaybe<SortEnumType>;
  gridColor?: InputMaybe<SortEnumType>;
  guid?: InputMaybe<SortEnumType>;
  hireDate?: InputMaybe<SortEnumType>;
  isAdmin?: InputMaybe<SortEnumType>;
  isGeofenceEnabled?: InputMaybe<SortEnumType>;
  isPayroll?: InputMaybe<SortEnumType>;
  jobSites?: InputMaybe<JobSiteSortInput>;
  lastName?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  mailAddressId?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  notesTemp?: InputMaybe<SortEnumType>;
  payPerHour?: InputMaybe<SortEnumType>;
  phoneNumber?: InputMaybe<ContactSourceSortInput>;
  pinhashed?: InputMaybe<SortEnumType>;
  primaryAddressId?: InputMaybe<SortEnumType>;
  primaryEmailId?: InputMaybe<SortEnumType>;
  primaryFaxId?: InputMaybe<SortEnumType>;
  primaryPhoneId?: InputMaybe<SortEnumType>;
  primaryWebsiteId?: InputMaybe<SortEnumType>;
  raptorAppUser?: InputMaybe<AppUserSortInput>;
  raptorCertificateAssignment?: InputMaybe<RaptorCertificateAssignmentVwSortInput>;
  raptorPermitAssignment?: InputMaybe<RaptorPermitAssignmentVwSortInput>;
  releaseDate?: InputMaybe<SortEnumType>;
  rowId?: InputMaybe<SortEnumType>;
  salesmanCommissionRate?: InputMaybe<SortEnumType>;
  seniorityCode?: InputMaybe<SortEnumType>;
  ssn?: InputMaybe<SortEnumType>;
  stationedAt?: InputMaybe<YardSortInput>;
  statusEmployee?: InputMaybe<SortEnumType>;
  system?: InputMaybe<SortEnumType>;
  temporaryEmployee?: InputMaybe<SortEnumType>;
  ud1?: InputMaybe<SortEnumType>;
  ud2?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  updatedByEmployee?: InputMaybe<EmployeeSortInput>;
  updatedOn?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type EmployeesCollectionSegment = {
  __typename?: 'EmployeesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V1_EmployeeDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum EmploymentType {
  Regular = 'REGULAR',
  Temporary = 'TEMPORARY'
}

export type Entities_V1_CrewTitle = {
  __typename?: 'Entities_V1_CrewTitle';
  cboGuid?: Maybe<Scalars['UUID']['output']>;
  crews: Array<Crew>;
  id: Scalars['Int']['output'];
  roleName?: Maybe<Scalars['String']['output']>;
  status: Scalars['Int']['output'];
};

export type Entities_V1_CrewTitleFilterInput = {
  and?: InputMaybe<Array<Entities_V1_CrewTitleFilterInput>>;
  cboGuid?: InputMaybe<UuidOperationFilterInput>;
  crews?: InputMaybe<ListFilterInputTypeOfCrewFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Entities_V1_CrewTitleFilterInput>>;
  roleName?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<IntOperationFilterInput>;
};

export type Entities_V1_EmployeeOutOfOfficeDay = {
  __typename?: 'Entities_V1_EmployeeOutOfOfficeDay';
  comments?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  createdOn: Scalars['LocalDateTime']['output'];
  employee: Employee;
  employeeId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isUnavailable: Scalars['Boolean']['output'];
  reason: BizObject;
  reasonId: Scalars['Int']['output'];
  rowId: Scalars['UUID']['output'];
  statusDay: Scalars['LocalDateTime']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
  updatedOn: Scalars['LocalDateTime']['output'];
};

export type Entities_V1_EmployeeOutOfOfficeDayFilterInput = {
  and?: InputMaybe<Array<Entities_V1_EmployeeOutOfOfficeDayFilterInput>>;
  comments?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<IntOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  employee?: InputMaybe<EmployeeFilterInput>;
  employeeId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isUnavailable?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<Entities_V1_EmployeeOutOfOfficeDayFilterInput>>;
  reason?: InputMaybe<BizObjectFilterInput>;
  reasonId?: InputMaybe<IntOperationFilterInput>;
  rowId?: InputMaybe<UuidOperationFilterInput>;
  statusDay?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type Entities_V1_EmployeeRoleVw = {
  __typename?: 'Entities_V1_EmployeeRoleVw';
  clockStatus?: Maybe<Scalars['String']['output']>;
  clockStatusID?: Maybe<Scalars['Int']['output']>;
  clockTime?: Maybe<Scalars['LocalDateTime']['output']>;
  clockingMode?: Maybe<Scalars['Short']['output']>;
  currentStatus?: Maybe<Scalars['String']['output']>;
  customID?: Maybe<Scalars['String']['output']>;
  dispatchLocation?: Maybe<Scalars['String']['output']>;
  dln?: Maybe<Scalars['String']['output']>;
  dlnState?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['LocalDateTime']['output']>;
  dothos5?: Maybe<Scalars['Decimal']['output']>;
  dothos6?: Maybe<Scalars['Decimal']['output']>;
  dothos7?: Maybe<Scalars['Decimal']['output']>;
  dothos8?: Maybe<Scalars['Decimal']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  empId: Scalars['Int']['output'];
  employee?: Maybe<Employee>;
  equipment?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  hireDate?: Maybe<Scalars['LocalDateTime']['output']>;
  isDispatcher: Scalars['Boolean']['output'];
  isInactive: Scalars['Boolean']['output'];
  isLaborer: Scalars['Boolean']['output'];
  isMechanic: Scalars['Boolean']['output'];
  isOiler: Scalars['Boolean']['output'];
  isOperator: Scalars['Boolean']['output'];
  isSalesAgent: Scalars['Boolean']['output'];
  isTemp: Scalars['Boolean']['output'];
  isUsable: Scalars['Boolean']['output'];
  lastClock?: Maybe<Scalars['LocalDateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  locID?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  releaseDate?: Maybe<Scalars['LocalDateTime']['output']>;
  seniorityCode?: Maybe<Scalars['String']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
  stationedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  updatedOn?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type Entities_V1_EmployeeRoleVwFilterInput = {
  and?: InputMaybe<Array<Entities_V1_EmployeeRoleVwFilterInput>>;
  clockStatus?: InputMaybe<StringOperationFilterInput>;
  clockStatusID?: InputMaybe<IntOperationFilterInput>;
  clockTime?: InputMaybe<DateTimeOperationFilterInput>;
  clockingMode?: InputMaybe<ShortOperationFilterInput>;
  currentStatus?: InputMaybe<StringOperationFilterInput>;
  customID?: InputMaybe<StringOperationFilterInput>;
  dispatchLocation?: InputMaybe<StringOperationFilterInput>;
  dln?: InputMaybe<StringOperationFilterInput>;
  dlnState?: InputMaybe<StringOperationFilterInput>;
  dob?: InputMaybe<DateTimeOperationFilterInput>;
  dothos5?: InputMaybe<DecimalOperationFilterInput>;
  dothos6?: InputMaybe<DecimalOperationFilterInput>;
  dothos7?: InputMaybe<DecimalOperationFilterInput>;
  dothos8?: InputMaybe<DecimalOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  empId?: InputMaybe<IntOperationFilterInput>;
  employee?: InputMaybe<EmployeeFilterInput>;
  equipment?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  fullName?: InputMaybe<StringOperationFilterInput>;
  hireDate?: InputMaybe<DateTimeOperationFilterInput>;
  isDispatcher?: InputMaybe<BooleanOperationFilterInput>;
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  isLaborer?: InputMaybe<BooleanOperationFilterInput>;
  isMechanic?: InputMaybe<BooleanOperationFilterInput>;
  isOiler?: InputMaybe<BooleanOperationFilterInput>;
  isOperator?: InputMaybe<BooleanOperationFilterInput>;
  isSalesAgent?: InputMaybe<BooleanOperationFilterInput>;
  isTemp?: InputMaybe<BooleanOperationFilterInput>;
  isUsable?: InputMaybe<BooleanOperationFilterInput>;
  lastClock?: InputMaybe<DateTimeOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  locID?: InputMaybe<IntOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Entities_V1_EmployeeRoleVwFilterInput>>;
  phone?: InputMaybe<StringOperationFilterInput>;
  releaseDate?: InputMaybe<DateTimeOperationFilterInput>;
  seniorityCode?: InputMaybe<StringOperationFilterInput>;
  ssn?: InputMaybe<StringOperationFilterInput>;
  stationedAt?: InputMaybe<StringOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type Entities_V1_EmployeeRoleVwSortInput = {
  clockStatus?: InputMaybe<SortEnumType>;
  clockStatusID?: InputMaybe<SortEnumType>;
  clockTime?: InputMaybe<SortEnumType>;
  clockingMode?: InputMaybe<SortEnumType>;
  currentStatus?: InputMaybe<SortEnumType>;
  customID?: InputMaybe<SortEnumType>;
  dispatchLocation?: InputMaybe<SortEnumType>;
  dln?: InputMaybe<SortEnumType>;
  dlnState?: InputMaybe<SortEnumType>;
  dob?: InputMaybe<SortEnumType>;
  dothos5?: InputMaybe<SortEnumType>;
  dothos6?: InputMaybe<SortEnumType>;
  dothos7?: InputMaybe<SortEnumType>;
  dothos8?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  empId?: InputMaybe<SortEnumType>;
  employee?: InputMaybe<EmployeeSortInput>;
  equipment?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  fullName?: InputMaybe<SortEnumType>;
  hireDate?: InputMaybe<SortEnumType>;
  isDispatcher?: InputMaybe<SortEnumType>;
  isInactive?: InputMaybe<SortEnumType>;
  isLaborer?: InputMaybe<SortEnumType>;
  isMechanic?: InputMaybe<SortEnumType>;
  isOiler?: InputMaybe<SortEnumType>;
  isOperator?: InputMaybe<SortEnumType>;
  isSalesAgent?: InputMaybe<SortEnumType>;
  isTemp?: InputMaybe<SortEnumType>;
  isUsable?: InputMaybe<SortEnumType>;
  lastClock?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  locID?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  releaseDate?: InputMaybe<SortEnumType>;
  seniorityCode?: InputMaybe<SortEnumType>;
  ssn?: InputMaybe<SortEnumType>;
  stationedAt?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  updatedOn?: InputMaybe<SortEnumType>;
};

export type Entities_V1_EquipmentClass = {
  __typename?: 'Entities_V1_EquipmentClass';
  equipmentSizes: Array<EquipmentSize>;
  equipmentTypes: Array<EquipmentType>;
  id: Scalars['Int']['output'];
  jobResourceGroupEquipments: Array<RaptorJobResourceGroupEquipment>;
  name: Scalars['String']['output'];
  raptorJobResourceGroup: RaptorJobResourceGroup;
};

export type Entities_V1_EquipmentClassFilterInput = {
  and?: InputMaybe<Array<Entities_V1_EquipmentClassFilterInput>>;
  equipmentSizes?: InputMaybe<ListFilterInputTypeOfEquipmentSizeFilterInput>;
  equipmentTypes?: InputMaybe<ListFilterInputTypeOfEquipmentTypeFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  jobResourceGroupEquipments?: InputMaybe<ListFilterInputTypeOfRaptorJobResourceGroupEquipmentFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Entities_V1_EquipmentClassFilterInput>>;
  raptorJobResourceGroup?: InputMaybe<RaptorJobResourceGroupFilterInput>;
};

export type Entities_V1_EquipmentClassSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  raptorJobResourceGroup?: InputMaybe<RaptorJobResourceGroupSortInput>;
};

export type Entities_V1_EquipmentCrew = {
  __typename?: 'Entities_V1_EquipmentCrew';
  empId?: Maybe<Scalars['Int']['output']>;
  employee?: Maybe<Employee>;
  eqId?: Maybe<Scalars['Int']['output']>;
  equipment?: Maybe<Equipment>;
  id: Scalars['Int']['output'];
  isPrimary: Scalars['Boolean']['output'];
  system?: Maybe<Scalars['Boolean']['output']>;
  titleId?: Maybe<Scalars['Int']['output']>;
};

export type Entities_V1_EquipmentCrewFilterInput = {
  and?: InputMaybe<Array<Entities_V1_EquipmentCrewFilterInput>>;
  empId?: InputMaybe<IntOperationFilterInput>;
  employee?: InputMaybe<EmployeeFilterInput>;
  eqId?: InputMaybe<IntOperationFilterInput>;
  equipment?: InputMaybe<EquipmentFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isPrimary?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<Entities_V1_EquipmentCrewFilterInput>>;
  system?: InputMaybe<BooleanOperationFilterInput>;
  titleId?: InputMaybe<IntOperationFilterInput>;
};

export type Entities_V1_EquipmentMake = {
  __typename?: 'Entities_V1_EquipmentMake';
  id: Scalars['Int']['output'];
  models: Array<Entities_V1_EquipmentModel>;
  name: Scalars['String']['output'];
  system: Scalars['Int']['output'];
};

export type Entities_V1_EquipmentMakeFilterInput = {
  and?: InputMaybe<Array<Entities_V1_EquipmentMakeFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  models?: InputMaybe<ListFilterInputTypeOfEntities_V1_EquipmentModelFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Entities_V1_EquipmentMakeFilterInput>>;
  system?: InputMaybe<IntOperationFilterInput>;
};

export type Entities_V1_EquipmentMakeSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  system?: InputMaybe<SortEnumType>;
};

export type Entities_V1_EquipmentModel = {
  __typename?: 'Entities_V1_EquipmentModel';
  equipment?: Maybe<Equipment>;
  id: Scalars['Int']['output'];
  make?: Maybe<Entities_V1_EquipmentMake>;
  makeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Entities_V1_EquipmentModelFilterInput = {
  and?: InputMaybe<Array<Entities_V1_EquipmentModelFilterInput>>;
  equipment?: InputMaybe<EquipmentFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  make?: InputMaybe<Entities_V1_EquipmentMakeFilterInput>;
  makeId?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Entities_V1_EquipmentModelFilterInput>>;
};

export type Entities_V1_EquipmentModelSortInput = {
  equipment?: InputMaybe<EquipmentSortInput>;
  id?: InputMaybe<SortEnumType>;
  make?: InputMaybe<Entities_V1_EquipmentMakeSortInput>;
  makeId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Entities_V1_EquipmentServiceStatusDay = {
  __typename?: 'Entities_V1_EquipmentServiceStatusDay';
  comments?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  createdOn: Scalars['LocalDateTime']['output'];
  equipment?: Maybe<Equipment>;
  equipmentId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isUnWorkable: Scalars['Boolean']['output'];
  legacyOutOfServiceInitialStatusDays: Array<Entities_V1_RaptorEquipmentOutOfService>;
  reason: BizObject;
  reasonId: Scalars['Int']['output'];
  rowId: Scalars['UUID']['output'];
  statusDay: Scalars['LocalDateTime']['output'];
  updatedBy?: Maybe<Scalars['Int']['output']>;
  updatedOn: Scalars['LocalDateTime']['output'];
};

export type Entities_V1_EquipmentServiceStatusDayFilterInput = {
  and?: InputMaybe<Array<Entities_V1_EquipmentServiceStatusDayFilterInput>>;
  comments?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<IntOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  equipment?: InputMaybe<EquipmentFilterInput>;
  equipmentId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isUnWorkable?: InputMaybe<BooleanOperationFilterInput>;
  legacyOutOfServiceInitialStatusDays?: InputMaybe<ListFilterInputTypeOfEntities_V1_RaptorEquipmentOutOfServiceFilterInput>;
  or?: InputMaybe<Array<Entities_V1_EquipmentServiceStatusDayFilterInput>>;
  reason?: InputMaybe<BizObjectFilterInput>;
  reasonId?: InputMaybe<IntOperationFilterInput>;
  rowId?: InputMaybe<UuidOperationFilterInput>;
  statusDay?: InputMaybe<DateTimeOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type Entities_V1_EquipmentStatus = {
  __typename?: 'Entities_V1_EquipmentStatus';
  equipment: Equipment;
  equipmentId: Scalars['Int']['output'];
  isOutOfService?: Maybe<Scalars['Boolean']['output']>;
  isUnWorkable?: Maybe<Scalars['Boolean']['output']>;
  jobCount?: Maybe<Scalars['Int']['output']>;
};

export type Entities_V1_EquipmentStatusFilterInput = {
  and?: InputMaybe<Array<Entities_V1_EquipmentStatusFilterInput>>;
  equipment?: InputMaybe<EquipmentFilterInput>;
  equipmentId?: InputMaybe<IntOperationFilterInput>;
  isOutOfService?: InputMaybe<BooleanOperationFilterInput>;
  isUnWorkable?: InputMaybe<BooleanOperationFilterInput>;
  jobCount?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Entities_V1_EquipmentStatusFilterInput>>;
};

export type Entities_V1_EquipmentStatusSortInput = {
  equipment?: InputMaybe<EquipmentSortInput>;
  equipmentId?: InputMaybe<SortEnumType>;
  isOutOfService?: InputMaybe<SortEnumType>;
  isUnWorkable?: InputMaybe<SortEnumType>;
  jobCount?: InputMaybe<SortEnumType>;
};

export type Entities_V1_Item = {
  __typename?: 'Entities_V1_Item';
  applyToAllInvoices: Scalars['Int']['output'];
  cboGuid?: Maybe<Scalars['String']['output']>;
  class: BizObject;
  classId: Scalars['Int']['output'];
  descriptor?: Maybe<Scalars['String']['output']>;
  extraSystem?: Maybe<Entities_V1_JobExtraSystem>;
  isBillMinimum: Scalars['Boolean']['output'];
  isPayrollMeal?: Maybe<Scalars['Boolean']['output']>;
  isTaxable: Scalars['Boolean']['output'];
  itemId: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity: Scalars['Float']['output'];
  resourceGroupItem: RaptorJobResourceGroupItem;
  rotg: Scalars['Boolean']['output'];
  showAsExtraSysOnJob: Scalars['Boolean']['output'];
  status?: Maybe<Scalars['Int']['output']>;
  system?: Maybe<Scalars['Boolean']['output']>;
  umId?: Maybe<Scalars['Int']['output']>;
  upsizeTs?: Maybe<Array<Scalars['Byte']['output']>>;
};

export type Entities_V1_ItemFilterInput = {
  and?: InputMaybe<Array<Entities_V1_ItemFilterInput>>;
  applyToAllInvoices?: InputMaybe<IntOperationFilterInput>;
  cboGuid?: InputMaybe<StringOperationFilterInput>;
  class?: InputMaybe<BizObjectFilterInput>;
  classId?: InputMaybe<IntOperationFilterInput>;
  descriptor?: InputMaybe<StringOperationFilterInput>;
  extraSystem?: InputMaybe<Entities_V1_JobExtraSystemFilterInput>;
  isBillMinimum?: InputMaybe<BooleanOperationFilterInput>;
  isPayrollMeal?: InputMaybe<BooleanOperationFilterInput>;
  isTaxable?: InputMaybe<BooleanOperationFilterInput>;
  itemId?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Entities_V1_ItemFilterInput>>;
  price?: InputMaybe<FloatOperationFilterInput>;
  quantity?: InputMaybe<FloatOperationFilterInput>;
  resourceGroupItem?: InputMaybe<RaptorJobResourceGroupItemFilterInput>;
  rotg?: InputMaybe<BooleanOperationFilterInput>;
  showAsExtraSysOnJob?: InputMaybe<BooleanOperationFilterInput>;
  status?: InputMaybe<IntOperationFilterInput>;
  system?: InputMaybe<BooleanOperationFilterInput>;
  umId?: InputMaybe<IntOperationFilterInput>;
  upsizeTs?: InputMaybe<ListByteOperationFilterInput>;
};

export type Entities_V1_ItemSortInput = {
  applyToAllInvoices?: InputMaybe<SortEnumType>;
  cboGuid?: InputMaybe<SortEnumType>;
  class?: InputMaybe<BizObjectSortInput>;
  classId?: InputMaybe<SortEnumType>;
  descriptor?: InputMaybe<SortEnumType>;
  extraSystem?: InputMaybe<Entities_V1_JobExtraSystemSortInput>;
  isBillMinimum?: InputMaybe<SortEnumType>;
  isPayrollMeal?: InputMaybe<SortEnumType>;
  isTaxable?: InputMaybe<SortEnumType>;
  itemId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  price?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  resourceGroupItem?: InputMaybe<RaptorJobResourceGroupItemSortInput>;
  rotg?: InputMaybe<SortEnumType>;
  showAsExtraSysOnJob?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  system?: InputMaybe<SortEnumType>;
  umId?: InputMaybe<SortEnumType>;
};

export type Entities_V1_JobExtraSystem = {
  __typename?: 'Entities_V1_JobExtraSystem';
  class: BizObject;
  classId: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  includePriceOnPrint: Scalars['Boolean']['output'];
  isBillable: Scalars['Boolean']['output'];
  isTaxable: Scalars['Boolean']['output'];
  item: Entities_V1_Item;
  itemId: Scalars['Int']['output'];
  jobId: Scalars['Int']['output'];
  lineItemId?: Maybe<Scalars['Int']['output']>;
  partId?: Maybe<Scalars['Int']['output']>;
  pourForAdding?: Maybe<PourForAdding>;
  price: Scalars['Decimal']['output'];
  quantity: Scalars['Decimal']['output'];
  rowId: Scalars['UUID']['output'];
};

export type Entities_V1_JobExtraSystemFilterInput = {
  and?: InputMaybe<Array<Entities_V1_JobExtraSystemFilterInput>>;
  class?: InputMaybe<BizObjectFilterInput>;
  classId?: InputMaybe<IntOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  includePriceOnPrint?: InputMaybe<BooleanOperationFilterInput>;
  isBillable?: InputMaybe<BooleanOperationFilterInput>;
  isTaxable?: InputMaybe<BooleanOperationFilterInput>;
  item?: InputMaybe<Entities_V1_ItemFilterInput>;
  itemId?: InputMaybe<IntOperationFilterInput>;
  jobId?: InputMaybe<IntOperationFilterInput>;
  lineItemId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Entities_V1_JobExtraSystemFilterInput>>;
  partId?: InputMaybe<IntOperationFilterInput>;
  pourForAdding?: InputMaybe<PourForAddingFilterInput>;
  price?: InputMaybe<DecimalOperationFilterInput>;
  quantity?: InputMaybe<DecimalOperationFilterInput>;
  rowId?: InputMaybe<UuidOperationFilterInput>;
};

export type Entities_V1_JobExtraSystemSortInput = {
  class?: InputMaybe<BizObjectSortInput>;
  classId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  includePriceOnPrint?: InputMaybe<SortEnumType>;
  isBillable?: InputMaybe<SortEnumType>;
  isTaxable?: InputMaybe<SortEnumType>;
  item?: InputMaybe<Entities_V1_ItemSortInput>;
  itemId?: InputMaybe<SortEnumType>;
  jobId?: InputMaybe<SortEnumType>;
  lineItemId?: InputMaybe<SortEnumType>;
  partId?: InputMaybe<SortEnumType>;
  pourForAdding?: InputMaybe<PourForAddingSortInput>;
  price?: InputMaybe<SortEnumType>;
  quantity?: InputMaybe<SortEnumType>;
  rowId?: InputMaybe<SortEnumType>;
};

export type Entities_V1_RaptorEmployeeOutOfOffice = {
  __typename?: 'Entities_V1_RaptorEmployeeOutOfOffice';
  employee: Employee;
  employeeId: Scalars['Int']['output'];
  endDate: Scalars['LocalDateTime']['output'];
  id: Scalars['Int']['output'];
  legacyOutOfOfficeFinalId: Scalars['Int']['output'];
  legacyOutOfOfficeInitialId: Scalars['Int']['output'];
  startDate: Scalars['LocalDateTime']['output'];
};

export type Entities_V1_RaptorEmployeeOutOfOfficeFilterInput = {
  and?: InputMaybe<Array<Entities_V1_RaptorEmployeeOutOfOfficeFilterInput>>;
  employee?: InputMaybe<EmployeeFilterInput>;
  employeeId?: InputMaybe<IntOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  legacyOutOfOfficeFinalId?: InputMaybe<IntOperationFilterInput>;
  legacyOutOfOfficeInitialId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<Entities_V1_RaptorEmployeeOutOfOfficeFilterInput>>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
};

export type Entities_V1_RaptorEquipmentOutOfService = {
  __typename?: 'Entities_V1_RaptorEquipmentOutOfService';
  end?: Maybe<Scalars['LocalDateTime']['output']>;
  equipment: Equipment;
  equipmentId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  legacyOutOfServiceFinalId: Scalars['Int']['output'];
  legacyOutOfServiceInitialId: Scalars['Int']['output'];
  legacyOutOfServiceInitialStatusDay: Entities_V1_EquipmentServiceStatusDay;
  start: Scalars['LocalDateTime']['output'];
};

export type Entities_V1_RaptorEquipmentOutOfServiceFilterInput = {
  and?: InputMaybe<Array<Entities_V1_RaptorEquipmentOutOfServiceFilterInput>>;
  end?: InputMaybe<DateTimeOperationFilterInput>;
  equipment?: InputMaybe<EquipmentFilterInput>;
  equipmentId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  legacyOutOfServiceFinalId?: InputMaybe<IntOperationFilterInput>;
  legacyOutOfServiceInitialId?: InputMaybe<IntOperationFilterInput>;
  legacyOutOfServiceInitialStatusDay?: InputMaybe<Entities_V1_EquipmentServiceStatusDayFilterInput>;
  or?: InputMaybe<Array<Entities_V1_RaptorEquipmentOutOfServiceFilterInput>>;
  start?: InputMaybe<DateTimeOperationFilterInput>;
};

export type Entities_V2_Equipment_EquipmentJobInfo = {
  __typename?: 'Entities_V2_Equipment_EquipmentJobInfo';
  jobEstEndTime?: Maybe<Scalars['LocalDateTime']['output']>;
  jobStartTime?: Maybe<Scalars['LocalDateTime']['output']>;
  pourDate: Scalars['Date']['output'];
  pourId: Scalars['Int']['output'];
};

export type Entities_V2_Equipment_EquipmentJobInfoFilterInput = {
  and?: InputMaybe<Array<Entities_V2_Equipment_EquipmentJobInfoFilterInput>>;
  jobEstEndTime?: InputMaybe<DateTimeOperationFilterInput>;
  jobStartTime?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<Entities_V2_Equipment_EquipmentJobInfoFilterInput>>;
  pourDate?: InputMaybe<DateOperationFilterInput>;
  pourId?: InputMaybe<IntOperationFilterInput>;
};

export type Entities_V2_Equipment_EquipmentUsageData = {
  __typename?: 'Entities_V2_Equipment_EquipmentUsageData';
  equipmentId: Scalars['Int']['output'];
  jobs: Array<Entities_V2_Equipment_EquipmentJobInfo>;
  raptorEquipmentOutOfServices: Array<Entities_V1_RaptorEquipmentOutOfService>;
};

export type Entities_V2_Equipment_EquipmentUsageDataFilterInput = {
  and?: InputMaybe<Array<Entities_V2_Equipment_EquipmentUsageDataFilterInput>>;
  equipmentId?: InputMaybe<IntOperationFilterInput>;
  jobs?: InputMaybe<ListFilterInputTypeOfEntities_V2_Equipment_EquipmentJobInfoFilterInput>;
  or?: InputMaybe<Array<Entities_V2_Equipment_EquipmentUsageDataFilterInput>>;
  raptorEquipmentOutOfServices?: InputMaybe<ListFilterInputTypeOfEntities_V1_RaptorEquipmentOutOfServiceFilterInput>;
};

export type Entities_V2_Equipment_EquipmentUsageDataSortInput = {
  equipmentId?: InputMaybe<SortEnumType>;
};

export type Entities_V2_RaptorDefaultEmployee = {
  __typename?: 'Entities_V2_RaptorDefaultEmployee';
  empId: Scalars['Int']['output'];
  employee: Employee;
  eqId: Scalars['Int']['output'];
  equipment?: Maybe<Equipment>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type Entities_V2_RaptorDefaultEmployeeFilterInput = {
  and?: InputMaybe<Array<Entities_V2_RaptorDefaultEmployeeFilterInput>>;
  empId?: InputMaybe<IntOperationFilterInput>;
  employee?: InputMaybe<EmployeeFilterInput>;
  eqId?: InputMaybe<IntOperationFilterInput>;
  equipment?: InputMaybe<EquipmentFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<Entities_V2_RaptorDefaultEmployeeFilterInput>>;
};

export type Entities_V2_RaptorDefaultEmployeeSortInput = {
  empId?: InputMaybe<SortEnumType>;
  employee?: InputMaybe<EmployeeSortInput>;
  eqId?: InputMaybe<SortEnumType>;
  equipment?: InputMaybe<EquipmentSortInput>;
  firstName?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
};

export type Equipment = {
  __typename?: 'Equipment';
  backInServiceOn?: Maybe<Scalars['Date']['output']>;
  boomModelNum?: Maybe<Scalars['String']['output']>;
  boomSerialNum?: Maybe<Scalars['String']['output']>;
  cboGuid?: Maybe<Scalars['String']['output']>;
  curYdId?: Maybe<Scalars['Int']['output']>;
  defaultEmployee?: Maybe<Entities_V2_RaptorDefaultEmployee>;
  defaultEmployeeCrewRoleId?: Maybe<Scalars['Int']['output']>;
  defaultEndStyle?: Maybe<Scalars['Int']['output']>;
  defaultInsideSysDiameter?: Maybe<Scalars['Int']['output']>;
  defaultLocation: Yard;
  deletable: RaptorDeletableEquipmentVw;
  descriptor?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  dispatchLocId: Scalars['Int']['output'];
  dispatchLocation: BizObject;
  doubleBooking?: Maybe<Scalars['String']['output']>;
  engHrs?: Maybe<Scalars['Int']['output']>;
  eqId: Scalars['Int']['output'];
  equipmentCrews: Array<Entities_V1_EquipmentCrew>;
  equipmentServiceStatusDays?: Maybe<Array<Entities_V1_EquipmentServiceStatusDay>>;
  equipmentUsageData?: Maybe<Entities_V2_Equipment_EquipmentUsageData>;
  equipmentsOutOfService: Array<Entities_V1_RaptorEquipmentOutOfService>;
  fuelAvgStationaryConsumptionPerHour?: Maybe<Scalars['Decimal']['output']>;
  fuelAvgTravelingConsumptionPerHour?: Maybe<Scalars['Decimal']['output']>;
  fuelTankSize?: Maybe<Scalars['Int']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  gpshardwareSn?: Maybe<Scalars['String']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  gvwr?: Maybe<Scalars['Float']['output']>;
  homYdId?: Maybe<Scalars['Int']['output']>;
  idnum?: Maybe<Scalars['String']['output']>;
  inService?: Maybe<Scalars['Int']['output']>;
  inSvcD?: Maybe<Scalars['LocalDateTime']['output']>;
  isGeofenceEnabled: Scalars['Boolean']['output'];
  lic?: Maybe<Scalars['String']['output']>;
  licState?: Maybe<Scalars['String']['output']>;
  location: Yard;
  machineSerialNum?: Maybe<Scalars['String']['output']>;
  make: Entities_V1_EquipmentMake;
  makeName?: Maybe<Scalars['String']['output']>;
  manifacturerId: Scalars['Int']['output'];
  maxGroundBearingPressure?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Entities_V1_EquipmentModel>;
  modelName?: Maybe<Scalars['String']['output']>;
  mpequipmentId?: Maybe<Scalars['Int']['output']>;
  mpsizeId?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outOfServiceReasonId?: Maybe<Scalars['Int']['output']>;
  pours: Array<PourForAdding>;
  pumpHrs?: Maybe<Scalars['Int']['output']>;
  pumpMi?: Maybe<Scalars['Int']['output']>;
  purchD?: Maybe<Scalars['LocalDateTime']['output']>;
  purchM?: Maybe<Scalars['Float']['output']>;
  raptorCertificateAssignment: RaptorCertificateAssignmentVw;
  raptorPermitAssignment: RaptorPermitAssignmentVw;
  raptorTicketResourceGroupEquipments: Array<RaptorTicketResourceGroupEquipment>;
  requiredJobRoles?: Maybe<Array<Entities_V1_CrewTitle>>;
  seniorityCode?: Maybe<Scalars['String']['output']>;
  size: EquipmentSize;
  startM?: Maybe<Scalars['Float']['output']>;
  status: Entities_V1_EquipmentStatus;
  statusEquipment?: Maybe<Scalars['Int']['output']>;
  statusEquipmentType: EquipmentStatusType;
  system?: Maybe<Scalars['Boolean']['output']>;
  truckId: Scalars['Int']['output'];
  truckMi?: Maybe<Scalars['Int']['output']>;
  truckModelNum?: Maybe<Scalars['String']['output']>;
  truckYear?: Maybe<Scalars['Int']['output']>;
  typId: Scalars['Int']['output'];
  type: EquipmentType;
  typeOfEquipmentId: Scalars['Int']['output'];
  ud1?: Maybe<Scalars['String']['output']>;
  ud2?: Maybe<Scalars['String']['output']>;
  unitId?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Short']['output']>;
};

/** A segment of a collection. */
export type EquipmentClassesCollectionSegment = {
  __typename?: 'EquipmentClassesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V1_EquipmentClassDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type EquipmentFilterInput = {
  and?: InputMaybe<Array<EquipmentFilterInput>>;
  backInServiceOn?: InputMaybe<DateOperationFilterInput>;
  boomModelNum?: InputMaybe<StringOperationFilterInput>;
  boomSerialNum?: InputMaybe<StringOperationFilterInput>;
  cboGuid?: InputMaybe<StringOperationFilterInput>;
  curYdId?: InputMaybe<IntOperationFilterInput>;
  defaultEmployee?: InputMaybe<Entities_V2_RaptorDefaultEmployeeFilterInput>;
  defaultEmployeeCrewRoleId?: InputMaybe<IntOperationFilterInput>;
  defaultEndStyle?: InputMaybe<IntOperationFilterInput>;
  defaultInsideSysDiameter?: InputMaybe<IntOperationFilterInput>;
  defaultLocation?: InputMaybe<YardFilterInput>;
  deletable?: InputMaybe<RaptorDeletableEquipmentVwFilterInput>;
  descriptor?: InputMaybe<StringOperationFilterInput>;
  details?: InputMaybe<StringOperationFilterInput>;
  dispatchLocId?: InputMaybe<IntOperationFilterInput>;
  dispatchLocation?: InputMaybe<BizObjectFilterInput>;
  doubleBooking?: InputMaybe<StringOperationFilterInput>;
  engHrs?: InputMaybe<IntOperationFilterInput>;
  eqId?: InputMaybe<IntOperationFilterInput>;
  equipmentCrews?: InputMaybe<ListFilterInputTypeOfEntities_V1_EquipmentCrewFilterInput>;
  equipmentServiceStatusDays?: InputMaybe<ListFilterInputTypeOfEntities_V1_EquipmentServiceStatusDayFilterInput>;
  equipmentUsageData?: InputMaybe<Entities_V2_Equipment_EquipmentUsageDataFilterInput>;
  equipmentsOutOfService?: InputMaybe<ListFilterInputTypeOfEntities_V1_RaptorEquipmentOutOfServiceFilterInput>;
  fuelAvgStationaryConsumptionPerHour?: InputMaybe<DecimalOperationFilterInput>;
  fuelAvgTravelingConsumptionPerHour?: InputMaybe<DecimalOperationFilterInput>;
  fuelTankSize?: InputMaybe<IntOperationFilterInput>;
  fuelType?: InputMaybe<StringOperationFilterInput>;
  gpshardwareSn?: InputMaybe<StringOperationFilterInput>;
  guid?: InputMaybe<StringOperationFilterInput>;
  gvwr?: InputMaybe<FloatOperationFilterInput>;
  homYdId?: InputMaybe<IntOperationFilterInput>;
  idnum?: InputMaybe<StringOperationFilterInput>;
  inService?: InputMaybe<IntOperationFilterInput>;
  inSvcD?: InputMaybe<DateTimeOperationFilterInput>;
  isGeofenceEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lic?: InputMaybe<StringOperationFilterInput>;
  licState?: InputMaybe<StringOperationFilterInput>;
  location?: InputMaybe<YardFilterInput>;
  machineSerialNum?: InputMaybe<StringOperationFilterInput>;
  make?: InputMaybe<Entities_V1_EquipmentMakeFilterInput>;
  makeName?: InputMaybe<StringOperationFilterInput>;
  manifacturerId?: InputMaybe<IntOperationFilterInput>;
  maxGroundBearingPressure?: InputMaybe<IntOperationFilterInput>;
  model?: InputMaybe<Entities_V1_EquipmentModelFilterInput>;
  modelName?: InputMaybe<StringOperationFilterInput>;
  mpequipmentId?: InputMaybe<IntOperationFilterInput>;
  mpsizeId?: InputMaybe<IntOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EquipmentFilterInput>>;
  outOfServiceReasonId?: InputMaybe<IntOperationFilterInput>;
  pours?: InputMaybe<ListFilterInputTypeOfPourForAddingFilterInput>;
  pumpHrs?: InputMaybe<IntOperationFilterInput>;
  pumpMi?: InputMaybe<IntOperationFilterInput>;
  purchD?: InputMaybe<DateTimeOperationFilterInput>;
  purchM?: InputMaybe<FloatOperationFilterInput>;
  raptorCertificateAssignment?: InputMaybe<RaptorCertificateAssignmentVwFilterInput>;
  raptorPermitAssignment?: InputMaybe<RaptorPermitAssignmentVwFilterInput>;
  raptorTicketResourceGroupEquipments?: InputMaybe<ListFilterInputTypeOfRaptorTicketResourceGroupEquipmentFilterInput>;
  requiredJobRoles?: InputMaybe<ListFilterInputTypeOfEntities_V1_CrewTitleFilterInput>;
  seniorityCode?: InputMaybe<StringOperationFilterInput>;
  size?: InputMaybe<EquipmentSizeFilterInput>;
  startM?: InputMaybe<FloatOperationFilterInput>;
  status?: InputMaybe<Entities_V1_EquipmentStatusFilterInput>;
  statusEquipment?: InputMaybe<IntOperationFilterInput>;
  statusEquipmentType?: InputMaybe<EquipmentStatusTypeOperationFilterInput>;
  system?: InputMaybe<BooleanOperationFilterInput>;
  truckId?: InputMaybe<IntOperationFilterInput>;
  truckMi?: InputMaybe<IntOperationFilterInput>;
  truckModelNum?: InputMaybe<StringOperationFilterInput>;
  truckYear?: InputMaybe<IntOperationFilterInput>;
  typId?: InputMaybe<IntOperationFilterInput>;
  type?: InputMaybe<EquipmentTypeFilterInput>;
  typeOfEquipmentId?: InputMaybe<IntOperationFilterInput>;
  ud1?: InputMaybe<StringOperationFilterInput>;
  ud2?: InputMaybe<StringOperationFilterInput>;
  unitId?: InputMaybe<StringOperationFilterInput>;
  year?: InputMaybe<ShortOperationFilterInput>;
};

/** A segment of a collection. */
export type EquipmentMakesCollectionSegment = {
  __typename?: 'EquipmentMakesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V1_EquipmentMakeDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type EquipmentModelsCollectionSegment = {
  __typename?: 'EquipmentModelsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V1_EquipmentModelDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type EquipmentSize = {
  __typename?: 'EquipmentSize';
  cboGuid?: Maybe<Scalars['String']['output']>;
  checklistId?: Maybe<Scalars['Int']['output']>;
  class: Entities_V1_EquipmentClass;
  descriptor?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  equipmentClassId?: Maybe<Scalars['Int']['output']>;
  excludeFromPerformanceMetrics: Scalars['Boolean']['output'];
  fldMsk?: Maybe<Scalars['Int']['output']>;
  guid?: Maybe<Scalars['String']['output']>;
  hourlyRevClassId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isPump: Scalars['Int']['output'];
  jobResourceGroupEquipments: Array<RaptorJobResourceGroupEquipment>;
  laborRevClassId: Scalars['Int']['output'];
  pours: Array<PourForAdding>;
  raptorJobResourceGroup: RaptorJobResourceGroup;
  statusEqType?: Maybe<Scalars['Int']['output']>;
  system?: Maybe<Scalars['Boolean']['output']>;
  travelRevClassId: Scalars['Int']['output'];
  volumeRevClassId: Scalars['Int']['output'];
};

export type EquipmentSizeFilterInput = {
  and?: InputMaybe<Array<EquipmentSizeFilterInput>>;
  cboGuid?: InputMaybe<StringOperationFilterInput>;
  checklistId?: InputMaybe<IntOperationFilterInput>;
  class?: InputMaybe<Entities_V1_EquipmentClassFilterInput>;
  descriptor?: InputMaybe<StringOperationFilterInput>;
  details?: InputMaybe<StringOperationFilterInput>;
  equipmentClassId?: InputMaybe<IntOperationFilterInput>;
  excludeFromPerformanceMetrics?: InputMaybe<BooleanOperationFilterInput>;
  fldMsk?: InputMaybe<IntOperationFilterInput>;
  guid?: InputMaybe<StringOperationFilterInput>;
  hourlyRevClassId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isPump?: InputMaybe<IntOperationFilterInput>;
  jobResourceGroupEquipments?: InputMaybe<ListFilterInputTypeOfRaptorJobResourceGroupEquipmentFilterInput>;
  laborRevClassId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<EquipmentSizeFilterInput>>;
  pours?: InputMaybe<ListFilterInputTypeOfPourForAddingFilterInput>;
  raptorJobResourceGroup?: InputMaybe<RaptorJobResourceGroupFilterInput>;
  statusEqType?: InputMaybe<IntOperationFilterInput>;
  system?: InputMaybe<BooleanOperationFilterInput>;
  travelRevClassId?: InputMaybe<IntOperationFilterInput>;
  volumeRevClassId?: InputMaybe<IntOperationFilterInput>;
};

export type EquipmentSizeSortInput = {
  cboGuid?: InputMaybe<SortEnumType>;
  checklistId?: InputMaybe<SortEnumType>;
  class?: InputMaybe<Entities_V1_EquipmentClassSortInput>;
  descriptor?: InputMaybe<SortEnumType>;
  details?: InputMaybe<SortEnumType>;
  equipmentClassId?: InputMaybe<SortEnumType>;
  excludeFromPerformanceMetrics?: InputMaybe<SortEnumType>;
  fldMsk?: InputMaybe<SortEnumType>;
  guid?: InputMaybe<SortEnumType>;
  hourlyRevClassId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isPump?: InputMaybe<SortEnumType>;
  laborRevClassId?: InputMaybe<SortEnumType>;
  raptorJobResourceGroup?: InputMaybe<RaptorJobResourceGroupSortInput>;
  statusEqType?: InputMaybe<SortEnumType>;
  system?: InputMaybe<SortEnumType>;
  travelRevClassId?: InputMaybe<SortEnumType>;
  volumeRevClassId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type EquipmentSizesCollectionSegment = {
  __typename?: 'EquipmentSizesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V1_EquipmentSizeDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type EquipmentSortInput = {
  backInServiceOn?: InputMaybe<SortEnumType>;
  boomModelNum?: InputMaybe<SortEnumType>;
  boomSerialNum?: InputMaybe<SortEnumType>;
  cboGuid?: InputMaybe<SortEnumType>;
  curYdId?: InputMaybe<SortEnumType>;
  defaultEmployee?: InputMaybe<Entities_V2_RaptorDefaultEmployeeSortInput>;
  defaultEmployeeCrewRoleId?: InputMaybe<SortEnumType>;
  defaultEndStyle?: InputMaybe<SortEnumType>;
  defaultInsideSysDiameter?: InputMaybe<SortEnumType>;
  defaultLocation?: InputMaybe<YardSortInput>;
  deletable?: InputMaybe<RaptorDeletableEquipmentVwSortInput>;
  descriptor?: InputMaybe<SortEnumType>;
  details?: InputMaybe<SortEnumType>;
  dispatchLocId?: InputMaybe<SortEnumType>;
  dispatchLocation?: InputMaybe<BizObjectSortInput>;
  doubleBooking?: InputMaybe<SortEnumType>;
  engHrs?: InputMaybe<SortEnumType>;
  eqId?: InputMaybe<SortEnumType>;
  equipmentUsageData?: InputMaybe<Entities_V2_Equipment_EquipmentUsageDataSortInput>;
  fuelAvgStationaryConsumptionPerHour?: InputMaybe<SortEnumType>;
  fuelAvgTravelingConsumptionPerHour?: InputMaybe<SortEnumType>;
  fuelTankSize?: InputMaybe<SortEnumType>;
  fuelType?: InputMaybe<SortEnumType>;
  gpshardwareSn?: InputMaybe<SortEnumType>;
  guid?: InputMaybe<SortEnumType>;
  gvwr?: InputMaybe<SortEnumType>;
  homYdId?: InputMaybe<SortEnumType>;
  idnum?: InputMaybe<SortEnumType>;
  inService?: InputMaybe<SortEnumType>;
  inSvcD?: InputMaybe<SortEnumType>;
  isGeofenceEnabled?: InputMaybe<SortEnumType>;
  lic?: InputMaybe<SortEnumType>;
  licState?: InputMaybe<SortEnumType>;
  location?: InputMaybe<YardSortInput>;
  machineSerialNum?: InputMaybe<SortEnumType>;
  make?: InputMaybe<Entities_V1_EquipmentMakeSortInput>;
  makeName?: InputMaybe<SortEnumType>;
  manifacturerId?: InputMaybe<SortEnumType>;
  maxGroundBearingPressure?: InputMaybe<SortEnumType>;
  model?: InputMaybe<Entities_V1_EquipmentModelSortInput>;
  modelName?: InputMaybe<SortEnumType>;
  mpequipmentId?: InputMaybe<SortEnumType>;
  mpsizeId?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  outOfServiceReasonId?: InputMaybe<SortEnumType>;
  pumpHrs?: InputMaybe<SortEnumType>;
  pumpMi?: InputMaybe<SortEnumType>;
  purchD?: InputMaybe<SortEnumType>;
  purchM?: InputMaybe<SortEnumType>;
  raptorCertificateAssignment?: InputMaybe<RaptorCertificateAssignmentVwSortInput>;
  raptorPermitAssignment?: InputMaybe<RaptorPermitAssignmentVwSortInput>;
  seniorityCode?: InputMaybe<SortEnumType>;
  size?: InputMaybe<EquipmentSizeSortInput>;
  startM?: InputMaybe<SortEnumType>;
  status?: InputMaybe<Entities_V1_EquipmentStatusSortInput>;
  statusEquipment?: InputMaybe<SortEnumType>;
  statusEquipmentType?: InputMaybe<SortEnumType>;
  system?: InputMaybe<SortEnumType>;
  truckId?: InputMaybe<SortEnumType>;
  truckMi?: InputMaybe<SortEnumType>;
  truckModelNum?: InputMaybe<SortEnumType>;
  truckYear?: InputMaybe<SortEnumType>;
  typId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<EquipmentTypeSortInput>;
  typeOfEquipmentId?: InputMaybe<SortEnumType>;
  ud1?: InputMaybe<SortEnumType>;
  ud2?: InputMaybe<SortEnumType>;
  unitId?: InputMaybe<SortEnumType>;
  year?: InputMaybe<SortEnumType>;
};

export enum EquipmentStatusType {
  Booked = 'BOOKED',
  Inactive = 'INACTIVE',
  InService = 'IN_SERVICE',
  OutOfService = 'OUT_OF_SERVICE'
}

export type EquipmentStatusTypeOperationFilterInput = {
  eq?: InputMaybe<EquipmentStatusType>;
  in?: InputMaybe<Array<EquipmentStatusType>>;
  neq?: InputMaybe<EquipmentStatusType>;
  nin?: InputMaybe<Array<EquipmentStatusType>>;
};

export type EquipmentType = {
  __typename?: 'EquipmentType';
  appObjectId: Scalars['Int']['output'];
  cboGuid?: Maybe<Scalars['String']['output']>;
  class: Entities_V1_EquipmentClass;
  description?: Maybe<Scalars['String']['output']>;
  equipmentClassId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isInactive: Scalars['Boolean']['output'];
  isNonTaxable: Scalars['Boolean']['output'];
  jobResourceGroupEquipments: Array<RaptorJobResourceGroupEquipment>;
  raptorJobResourceGroup: RaptorJobResourceGroup;
  system: Scalars['Int']['output'];
  typeDescription?: Maybe<Scalars['String']['output']>;
};

export type EquipmentTypeFilterInput = {
  and?: InputMaybe<Array<EquipmentTypeFilterInput>>;
  appObjectId?: InputMaybe<IntOperationFilterInput>;
  cboGuid?: InputMaybe<StringOperationFilterInput>;
  class?: InputMaybe<Entities_V1_EquipmentClassFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  equipmentClassId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  isNonTaxable?: InputMaybe<BooleanOperationFilterInput>;
  jobResourceGroupEquipments?: InputMaybe<ListFilterInputTypeOfRaptorJobResourceGroupEquipmentFilterInput>;
  or?: InputMaybe<Array<EquipmentTypeFilterInput>>;
  raptorJobResourceGroup?: InputMaybe<RaptorJobResourceGroupFilterInput>;
  system?: InputMaybe<IntOperationFilterInput>;
  typeDescription?: InputMaybe<StringOperationFilterInput>;
};

export type EquipmentTypeSortInput = {
  appObjectId?: InputMaybe<SortEnumType>;
  cboGuid?: InputMaybe<SortEnumType>;
  class?: InputMaybe<Entities_V1_EquipmentClassSortInput>;
  description?: InputMaybe<SortEnumType>;
  equipmentClassId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isInactive?: InputMaybe<SortEnumType>;
  isNonTaxable?: InputMaybe<SortEnumType>;
  raptorJobResourceGroup?: InputMaybe<RaptorJobResourceGroupSortInput>;
  system?: InputMaybe<SortEnumType>;
  typeDescription?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type EquipmentTypesCollectionSegment = {
  __typename?: 'EquipmentTypesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V1_EquipmentTypeDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type EquipmentsCollectionSegment = {
  __typename?: 'EquipmentsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V1_Equipment_EquipmentDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Error = IError & {
  __typename?: 'Error';
  errorMessage: Scalars['String']['output'];
  errorType: ErrorType;
  statusCode: Scalars['Int']['output'];
  validationErrors: Array<ValidationException>;
};

export enum ErrorType {
  Conflict = 'CONFLICT',
  InvalidInput = 'INVALID_INPUT',
  None = 'NONE',
  NotFound = 'NOT_FOUND',
  OperationFailed = 'OPERATION_FAILED',
  PermissionDenied = 'PERMISSION_DENIED',
  ValidationFailed = 'VALIDATION_FAILED'
}

/** A segment of a collection. */
export type ExtraSystemsCollectionSegment = {
  __typename?: 'ExtraSystemsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V1_ExtraSystemDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type FinancialSummaryDto = {
  __typename?: 'FinancialSummaryDto';
  dueAt?: Maybe<Scalars['Decimal']['output']>;
  dueInDays?: Maybe<Scalars['Decimal']['output']>;
  overDue?: Maybe<Scalars['Decimal']['output']>;
  revenue?: Maybe<Scalars['Decimal']['output']>;
};

export type FinancialSummaryDtoFilterInput = {
  and?: InputMaybe<Array<FinancialSummaryDtoFilterInput>>;
  dueAt?: InputMaybe<DecimalOperationFilterInput>;
  dueInDays?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<FinancialSummaryDtoFilterInput>>;
  overDue?: InputMaybe<DecimalOperationFilterInput>;
  revenue?: InputMaybe<DecimalOperationFilterInput>;
};

export type FinancialSummaryDtoInput = {
  dueAt?: InputMaybe<Scalars['Decimal']['input']>;
  dueInDays?: InputMaybe<Scalars['Decimal']['input']>;
  overDue?: InputMaybe<Scalars['Decimal']['input']>;
  revenue?: InputMaybe<Scalars['Decimal']['input']>;
};

export type FinancialSummaryDtoSortInput = {
  dueAt?: InputMaybe<SortEnumType>;
  dueInDays?: InputMaybe<SortEnumType>;
  overDue?: InputMaybe<SortEnumType>;
  revenue?: InputMaybe<SortEnumType>;
};

export type FinancialSummaryInput = {
  dueAtDayInput?: InputMaybe<GetDueAtInput>;
  dueInDaysInput?: InputMaybe<GetDueInDaysInput>;
  overDueInput?: InputMaybe<GetOverDueInput>;
  revenueInput?: InputMaybe<GetRevenueInput>;
};

export type FloatOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  ngt?: InputMaybe<Scalars['Float']['input']>;
  ngte?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nlt?: InputMaybe<Scalars['Float']['input']>;
  nlte?: InputMaybe<Scalars['Float']['input']>;
};

export type GetCitiesInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  stateAbbreviation?: InputMaybe<Scalars['String']['input']>;
  stateName?: InputMaybe<Scalars['String']['input']>;
};

export type GetCustomerDetailsInput = {
  customerId: Scalars['Int']['input'];
  financialSummaryInput?: InputMaybe<FinancialSummaryInput>;
};

export type GetCustomersInput = {
  financialSummaryInput?: InputMaybe<FinancialSummaryInput>;
};

export type GetDueAtInput = {
  referenceDay: Scalars['Date']['input'];
};

export type GetDueInDaysInput = {
  days: Scalars['Int']['input'];
  referenceDay: Scalars['Date']['input'];
};

export type GetJobsiteDetailsInput = {
  jobsiteId: Scalars['Int']['input'];
};

export type GetOverDueInput = {
  referenceDay: Scalars['Date']['input'];
};

export type GetRevenueInput = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};

export type GetStatesInput = {
  countryAbbreviation?: InputMaybe<Scalars['String']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
};

export type IError = {
  errorMessage: Scalars['String']['output'];
  errorType: ErrorType;
  statusCode: Scalars['Int']['output'];
  validationErrors: Array<Maybe<ValidationException>>;
};

export type Input_V1_Mutations_Employee_CreateEmployeeMutationInput = {
  dispatchLocation?: InputMaybe<Dtos_V1_LocationDtoInput>;
  driversLicense?: InputMaybe<Dtos_V1_DriversLicenseDtoInput>;
  email?: InputMaybe<ContactInformationDtoInput>;
  employmentStatus?: InputMaybe<Dtos_V1_EmploymentStatusDtoInput>;
  employmentType?: InputMaybe<EmploymentType>;
  endDate?: InputMaybe<Scalars['LocalDateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  jobRolesToAdd?: InputMaybe<Array<Dtos_V1_CrewRoleDtoInput>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<ContactInformationDtoInput>;
  startDate?: InputMaybe<Scalars['LocalDateTime']['input']>;
  workLocation?: InputMaybe<Dtos_V1_LocationDtoInput>;
};

export type Input_V1_Mutations_Employee_UpdateEmployeeMutationInput = {
  dispatchLocation?: InputMaybe<Dtos_V1_LocationDtoInput>;
  driversLicense?: InputMaybe<Dtos_V1_DriversLicenseDtoInput>;
  email?: InputMaybe<ContactInformationDtoInput>;
  employmentStatus?: InputMaybe<Dtos_V1_EmploymentStatusDtoInput>;
  employmentType?: InputMaybe<EmploymentType>;
  endDate?: InputMaybe<Scalars['LocalDateTime']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  jobRolesToAdd?: InputMaybe<Array<Dtos_V1_CrewRoleDtoInput>>;
  jobRolesToDelete?: InputMaybe<Array<Scalars['Int']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outOfOfficesToCreate?: InputMaybe<Array<Dtos_V1_Employee_EmployeeOutOfOfficeDtoInput>>;
  outOfOfficesToDelete?: InputMaybe<Array<Scalars['Int']['input']>>;
  outOfOfficesToUpdate?: InputMaybe<Array<Dtos_V1_Employee_EmployeeOutOfOfficeDtoInput>>;
  phoneNumber?: InputMaybe<ContactInformationDtoInput>;
  startDate?: InputMaybe<Scalars['LocalDateTime']['input']>;
  workLocation?: InputMaybe<Dtos_V1_LocationDtoInput>;
};

export type Input_V1_Mutations_Equipment_DeleteEquipmentMutationInput = {
  id: Scalars['Int']['input'];
};

export type Input_V1_Mutations_RaptorJob_DuplicateRaptorJobMutationInput = {
  equipment: Dtos_V1_Equipment_EquipmentDtoInput;
  id: Scalars['Int']['input'];
  startDate: Scalars['LocalDateTime']['input'];
};

export type Input_V1_Mutations_RaptorJob_UpdateRaptorJobMutationInput = {
  calledInTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  cod?: InputMaybe<Scalars['Boolean']['input']>;
  crewMembersToAdd?: InputMaybe<Array<Dtos_V1_CrewAssingmentInputDtoInput>>;
  crewMembersToDelete?: InputMaybe<Array<Dtos_V1_CrewAssingmentInputDtoInput>>;
  customer?: InputMaybe<CustomerDtoInput>;
  dispatchLocation?: InputMaybe<Dtos_V1_DispatchLocationDtoInput>;
  dispatchNotes?: InputMaybe<Scalars['String']['input']>;
  dispatcher?: InputMaybe<Dtos_V1_EmployeeDtoInput>;
  equipment?: InputMaybe<Array<Dtos_V1_Equipment_EquipmentDtoInput>>;
  estimatedArea?: InputMaybe<Scalars['Decimal']['input']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']['input']>;
  estimatedVolume?: InputMaybe<Scalars['Decimal']['input']>;
  extraSystemsToAdd?: InputMaybe<Array<Dtos_V1_ExtraSystemDtoInput>>;
  extraSystemsToRemove?: InputMaybe<Array<Scalars['Int']['input']>>;
  id: Scalars['Int']['input'];
  jobInformation?: InputMaybe<Dtos_V1_JobInformationDtoInput>;
  jobNotes?: InputMaybe<Scalars['String']['input']>;
  jobNumber?: InputMaybe<Scalars['String']['input']>;
  jobSite?: InputMaybe<Dtos_V1_JobSiteDtoInput>;
  notesForCrew?: InputMaybe<Scalars['String']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  powerlinePresent?: InputMaybe<Scalars['Boolean']['input']>;
  priorityCode?: InputMaybe<Scalars['String']['input']>;
  salesAgent?: InputMaybe<Dtos_V1_EmployeeDtoInput>;
  sizeRequested?: InputMaybe<Dtos_V1_EquipmentSizeDtoInput>;
  specialFlag1?: InputMaybe<Dtos_V1_SpecialFlagDtoInput>;
  specialFlag2?: InputMaybe<Dtos_V1_SpecialFlagDtoInput>;
  specialFlag3?: InputMaybe<Dtos_V1_SpecialFlagDtoInput>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['LocalDateTime']['input']>;
  status?: InputMaybe<Dtos_V1_JobStatusDtoInput>;
  strictSizeRequested?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Dtos_V1_JobTypeDtoInput>;
  vendor?: InputMaybe<Dtos_V1_VendorDtoInput>;
};

export type Input_V1_Queries_Employee_GetEmployeeDetailsInput = {
  id: Scalars['Int']['input'];
  outOfOfficeHistoryInput?: InputMaybe<Input_V1_Queries_Employee_GetEmployeesOutOfOfficeInput>;
  upcomingOutOfOfficeInput?: InputMaybe<Input_V1_Queries_Employee_GetEmployeesOutOfOfficeInput>;
};

export type Input_V1_Queries_Employee_GetEmployeesInput = {
  outOfOfficeHistoryInput?: InputMaybe<Input_V1_Queries_Employee_GetEmployeesOutOfOfficeInput>;
  upcomingOutOfOfficeInput?: InputMaybe<Input_V1_Queries_Employee_GetEmployeesOutOfOfficeInput>;
};

export type Input_V1_Queries_Employee_GetEmployeesOutOfOfficeInput = {
  referenceEndDate?: InputMaybe<Scalars['LocalDateTime']['input']>;
  referenceStartDate?: InputMaybe<Scalars['LocalDateTime']['input']>;
};

export type Input_V1_Queries_Equipment_GetEquipmentDetailsInput = {
  id: Scalars['Int']['input'];
  outOfServiceHistoryInput?: InputMaybe<Input_V1_Queries_Equipment_GetEquipmentOutOfServiceInput>;
  upcomingOutOfServiceInput?: InputMaybe<Input_V1_Queries_Equipment_GetEquipmentOutOfServiceInput>;
};

export type Input_V1_Queries_Equipment_GetEquipmentOutOfServiceInput = {
  operationType?: InputMaybe<UnavailableOperation>;
  referenceEndDate: Scalars['Date']['input'];
  referenceStartDate: Scalars['Date']['input'];
};

export type Input_V1_Queries_Equipment_GetEquipmentsInput = {
  outOfServiceHistoryInput?: InputMaybe<Input_V1_Queries_Equipment_GetEquipmentOutOfServiceInput>;
  upcomingOutOfServiceInput?: InputMaybe<Input_V1_Queries_Equipment_GetEquipmentOutOfServiceInput>;
};

export type Input_V2_Mutations_Equipment_CreateEquipmentMutationInput = {
  classId?: InputMaybe<Scalars['Int']['input']>;
  defaultCrewRoleId?: InputMaybe<Scalars['Int']['input']>;
  defaultEmployeeId?: InputMaybe<Scalars['Int']['input']>;
  defaultLocationId?: InputMaybe<Scalars['Int']['input']>;
  dispatchLocationId?: InputMaybe<Scalars['Int']['input']>;
  geofencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  gpsTrackerSerialNumber?: InputMaybe<Scalars['String']['input']>;
  licensePlateNumber?: InputMaybe<Scalars['String']['input']>;
  licensePlateState?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  makeId?: InputMaybe<Scalars['Int']['input']>;
  makeName?: InputMaybe<Scalars['String']['input']>;
  modelId?: InputMaybe<Scalars['Int']['input']>;
  modelName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  requiredJobRolesId?: InputMaybe<Array<Scalars['Int']['input']>>;
  sizeId: Scalars['Int']['input'];
  statusId?: InputMaybe<Scalars['Int']['input']>;
  typeId: Scalars['Int']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type Input_V2_Mutations_Equipment_UpdateEquipmentMutationInput = {
  classId?: InputMaybe<Scalars['Int']['input']>;
  defaultCrewRoleId?: InputMaybe<Scalars['Int']['input']>;
  defaultEmployeeId?: InputMaybe<Scalars['Int']['input']>;
  defaultLocationId?: InputMaybe<Scalars['Int']['input']>;
  dispatchLocationId?: InputMaybe<Scalars['Int']['input']>;
  geofencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  gpsTrackerSerialNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  licensePlateNumber?: InputMaybe<Scalars['String']['input']>;
  licensePlateState?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  makeId?: InputMaybe<Scalars['Int']['input']>;
  makeName?: InputMaybe<Scalars['String']['input']>;
  modelId?: InputMaybe<Scalars['Int']['input']>;
  modelName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  outOfServicesToCreate?: InputMaybe<Array<Dtos_V1_Equipment_EquipmentOutOfServiceDtoInput>>;
  outOfServicesToDelete?: InputMaybe<Array<Scalars['Int']['input']>>;
  outOfServicesToUpdate?: InputMaybe<Array<Dtos_V1_Equipment_EquipmentOutOfServiceDtoInput>>;
  requiredJobRolesId?: InputMaybe<Array<Scalars['Int']['input']>>;
  sizeId: Scalars['Int']['input'];
  statusId?: InputMaybe<Scalars['Int']['input']>;
  typeId: Scalars['Int']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type Input_V2_Mutations_RaptorJob_CreateRaptorJobMutationInput = {
  calledInTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  callerId?: InputMaybe<Scalars['Int']['input']>;
  clearTime?: InputMaybe<Scalars['TimeSpan']['input']>;
  cod?: InputMaybe<Scalars['Boolean']['input']>;
  confirmedBy?: InputMaybe<Scalars['String']['input']>;
  crewMembersToAdd?: InputMaybe<Array<Input_V2_Mutations_RaptorJob_CrewAssignmentInputDtoInput>>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  dailyNotes?: InputMaybe<Scalars['String']['input']>;
  dispatchLocationId?: InputMaybe<Scalars['Int']['input']>;
  dispatchNotes?: InputMaybe<Scalars['String']['input']>;
  dispatcherId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  equipmentLocationId?: InputMaybe<Scalars['Int']['input']>;
  equipmentToAdd?: InputMaybe<Array<Scalars['Int']['input']>>;
  estimatedArea?: InputMaybe<Scalars['Decimal']['input']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']['input']>;
  estimatedVolume?: InputMaybe<Scalars['Decimal']['input']>;
  extraSystemsToAdd?: InputMaybe<Array<Scalars['Int']['input']>>;
  jobInformationId?: InputMaybe<Scalars['Int']['input']>;
  jobName?: InputMaybe<Scalars['String']['input']>;
  jobNotes?: InputMaybe<Scalars['String']['input']>;
  jobNumber?: InputMaybe<Scalars['String']['input']>;
  jobSiteId?: InputMaybe<Scalars['Int']['input']>;
  jobStatusId?: InputMaybe<Scalars['Int']['input']>;
  leaveTime?: InputMaybe<Scalars['TimeSpan']['input']>;
  notesForCrew?: InputMaybe<Scalars['String']['input']>;
  onJobTime?: InputMaybe<Scalars['TimeSpan']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  priorityCode?: InputMaybe<Scalars['String']['input']>;
  salesAgentId?: InputMaybe<Scalars['Int']['input']>;
  showUpTime?: InputMaybe<Scalars['TimeSpan']['input']>;
  sizeRequestedId?: InputMaybe<Scalars['Int']['input']>;
  specialFlag1Id?: InputMaybe<Scalars['Int']['input']>;
  specialFlag2Id?: InputMaybe<Scalars['Int']['input']>;
  specialFlag3Id?: InputMaybe<Scalars['Int']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  startTime?: InputMaybe<Scalars['TimeSpan']['input']>;
  strictSizeRequested?: InputMaybe<Scalars['Boolean']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['Int']['input']>;
};

export type Input_V2_Mutations_RaptorJob_CrewAssignmentInputDtoInput = {
  id: Scalars['Int']['input'];
  roleId: Scalars['Int']['input'];
};

export type Input_V2_Mutations_RaptorJob_UpdateRaptorJobMutationInput = {
  calledInTime?: InputMaybe<Scalars['LocalDateTime']['input']>;
  callerId?: InputMaybe<Scalars['Int']['input']>;
  clearTime?: InputMaybe<Scalars['TimeSpan']['input']>;
  cod?: InputMaybe<Scalars['Boolean']['input']>;
  confirmedBy?: InputMaybe<Scalars['String']['input']>;
  crewMembersToAdd?: InputMaybe<Array<Input_V2_Mutations_RaptorJob_CrewAssignmentInputDtoInput>>;
  crewMembersToDelete?: InputMaybe<Array<Scalars['Int']['input']>>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  dailyNotes?: InputMaybe<Scalars['String']['input']>;
  dispatchLocationId?: InputMaybe<Scalars['Int']['input']>;
  dispatchNotes?: InputMaybe<Scalars['String']['input']>;
  dispatcherId?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endTime?: InputMaybe<Scalars['TimeSpan']['input']>;
  equipmentLocationId?: InputMaybe<Scalars['Int']['input']>;
  equipmentToAdd?: InputMaybe<Array<Scalars['Int']['input']>>;
  equipmentToDelete?: InputMaybe<Array<Scalars['Int']['input']>>;
  estimatedArea?: InputMaybe<Scalars['Decimal']['input']>;
  estimatedHours?: InputMaybe<Scalars['Decimal']['input']>;
  estimatedVolume?: InputMaybe<Scalars['Decimal']['input']>;
  extraSystemsToAdd?: InputMaybe<Array<Scalars['Int']['input']>>;
  extraSystemsToDelete?: InputMaybe<Array<Scalars['Int']['input']>>;
  id: Scalars['Int']['input'];
  jobInformationId?: InputMaybe<Scalars['Int']['input']>;
  jobName?: InputMaybe<Scalars['String']['input']>;
  jobNotes?: InputMaybe<Scalars['String']['input']>;
  jobNumber?: InputMaybe<Scalars['String']['input']>;
  jobSiteId?: InputMaybe<Scalars['Int']['input']>;
  jobStatusId?: InputMaybe<Scalars['Int']['input']>;
  leaveTime?: InputMaybe<Scalars['TimeSpan']['input']>;
  notesForCrew?: InputMaybe<Scalars['String']['input']>;
  onJobTime?: InputMaybe<Scalars['TimeSpan']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  priorityCode?: InputMaybe<Scalars['String']['input']>;
  salesAgentId?: InputMaybe<Scalars['Int']['input']>;
  showUpTime?: InputMaybe<Scalars['TimeSpan']['input']>;
  sizeRequestedId?: InputMaybe<Scalars['Int']['input']>;
  specialFlag1Id?: InputMaybe<Scalars['Int']['input']>;
  specialFlag2Id?: InputMaybe<Scalars['Int']['input']>;
  specialFlag3Id?: InputMaybe<Scalars['Int']['input']>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  startTime?: InputMaybe<Scalars['TimeSpan']['input']>;
  strictSizeRequested?: InputMaybe<Scalars['Boolean']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['Int']['input']>;
  vendorId?: InputMaybe<Scalars['Int']['input']>;
};

export type Input_V2_Queries_CrewMembersInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  jobSiteId?: InputMaybe<Scalars['Int']['input']>;
  referenceEndDate?: InputMaybe<Scalars['Date']['input']>;
  referenceStartDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Input_V2_Queries_Equipment_AvailableEquipmentsInput = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  jobSiteId?: InputMaybe<Scalars['Int']['input']>;
  referenceEndDate?: InputMaybe<Scalars['LocalDateTime']['input']>;
  referenceStartDate?: InputMaybe<Scalars['LocalDateTime']['input']>;
};

export type Input_V2_Queries_Equipment_GetOutOfServiceEquipmentsInput = {
  referenceEndDate: Scalars['LocalDateTime']['input'];
  referenceStartDate: Scalars['LocalDateTime']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type JobSite = {
  __typename?: 'JobSite';
  address: Scalars['String']['output'];
  allJobs: Array<RaptorAllJobsVw>;
  billAddressId?: Maybe<Scalars['Int']['output']>;
  billableTravelHours: Scalars['Decimal']['output'];
  billingAddress: Address;
  bldgLot?: Maybe<Scalars['String']['output']>;
  checkList?: Maybe<CheckList>;
  checkListId?: Maybe<Scalars['Int']['output']>;
  city: Scalars['String']['output'];
  collectionNotes?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['Int']['output']>;
  contractNumber?: Maybe<Scalars['String']['output']>;
  contractor: Supplier;
  contractorId?: Maybe<Scalars['Int']['output']>;
  cpr: Scalars['Int']['output'];
  cus: Customer;
  customerId?: Maybe<Scalars['Int']['output']>;
  customerWithContacts: RaptorCustomerWithContacts;
  dateCreated: Scalars['Date']['output'];
  defaultJobPo?: Maybe<Scalars['String']['output']>;
  deletable: RaptorDeletableJobSiteVw;
  description?: Maybe<Scalars['String']['output']>;
  emailInvoice: Scalars['Boolean']['output'];
  hasNoLocation?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  includeCustomerContacts: Scalars['Boolean']['output'];
  isGeofenceEnabled: Scalars['Boolean']['output'];
  isNoSubs?: Maybe<Scalars['Boolean']['output']>;
  isNonTaxable: Scalars['Boolean']['output'];
  isOcip: Scalars['Boolean']['output'];
  isPorequired: Scalars['Boolean']['output'];
  isPowerLinePresent: Scalars['Boolean']['output'];
  isProspect: Scalars['Boolean']['output'];
  isPublicProject: Scalars['Boolean']['output'];
  isSafetyRequired: Scalars['Boolean']['output'];
  isVerifiedOnSite: Scalars['Boolean']['output'];
  jobNum?: Maybe<Scalars['String']['output']>;
  jobPhone?: Maybe<Scalars['String']['output']>;
  jobSiteName?: Maybe<Scalars['String']['output']>;
  jobSiteType: JobSiteType;
  jobs: Array<RaptorJob>;
  latitude: Scalars['Decimal']['output'];
  latitudeAndLongitude: Scalars['String']['output'];
  longitude: Scalars['Decimal']['output'];
  mapPage?: Maybe<Scalars['String']['output']>;
  parcelNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  pourForAddings: Array<PourForAdding>;
  prelimed: Scalars['Int']['output'];
  prelimedNotes?: Maybe<Scalars['String']['output']>;
  preventAutoPricingVersionChange: Scalars['Boolean']['output'];
  priceId?: Maybe<Scalars['Int']['output']>;
  pricingScheme: PricingScheme;
  pricingVersionId?: Maybe<Scalars['Int']['output']>;
  projectType: BizObject;
  projectTypeId?: Maybe<Scalars['Int']['output']>;
  raptorCertificateAssignment: RaptorCertificateAssignmentVw;
  raptorPermitAssignment: RaptorPermitAssignmentVw;
  readyMixVendor: Supplier;
  released: Scalars['Int']['output'];
  rmxid: Scalars['Int']['output'];
  salesAgent: Employee;
  salesAgentId?: Maybe<Scalars['Int']['output']>;
  salesRegion: SalesRegion;
  salesRegionId?: Maybe<Scalars['Int']['output']>;
  specialInst?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  statusJobSite: Scalars['Int']['output'];
  typeId: Scalars['Int']['output'];
  ud1?: Maybe<Scalars['String']['output']>;
  ud2?: Maybe<Scalars['String']['output']>;
  updatedBy: Scalars['Int']['output'];
  useCustomEmailList: Scalars['Boolean']['output'];
  verifiedBy?: Maybe<Scalars['Int']['output']>;
  verifyStatus: Scalars['Byte']['output'];
  xstreet?: Maybe<Scalars['String']['output']>;
};

export type JobSiteFilterInput = {
  address?: InputMaybe<StringOperationFilterInput>;
  allJobs?: InputMaybe<ListFilterInputTypeOfRaptorAllJobsVwFilterInput>;
  and?: InputMaybe<Array<JobSiteFilterInput>>;
  billAddressId?: InputMaybe<IntOperationFilterInput>;
  billableTravelHours?: InputMaybe<DecimalOperationFilterInput>;
  billingAddress?: InputMaybe<AddressFilterInput>;
  bldgLot?: InputMaybe<StringOperationFilterInput>;
  checkList?: InputMaybe<CheckListFilterInput>;
  checkListId?: InputMaybe<IntOperationFilterInput>;
  city?: InputMaybe<StringOperationFilterInput>;
  collectionNotes?: InputMaybe<StringOperationFilterInput>;
  comments?: InputMaybe<StringOperationFilterInput>;
  contactId?: InputMaybe<IntOperationFilterInput>;
  contractNumber?: InputMaybe<StringOperationFilterInput>;
  contractor?: InputMaybe<SupplierFilterInput>;
  contractorId?: InputMaybe<IntOperationFilterInput>;
  cpr?: InputMaybe<IntOperationFilterInput>;
  cus?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  customerWithContacts?: InputMaybe<RaptorCustomerWithContactsFilterInput>;
  dateCreated?: InputMaybe<DateOperationFilterInput>;
  defaultJobPo?: InputMaybe<StringOperationFilterInput>;
  deletable?: InputMaybe<RaptorDeletableJobSiteVwFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  emailInvoice?: InputMaybe<BooleanOperationFilterInput>;
  hasNoLocation?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  includeCustomerContacts?: InputMaybe<BooleanOperationFilterInput>;
  isGeofenceEnabled?: InputMaybe<BooleanOperationFilterInput>;
  isNoSubs?: InputMaybe<BooleanOperationFilterInput>;
  isNonTaxable?: InputMaybe<BooleanOperationFilterInput>;
  isOcip?: InputMaybe<BooleanOperationFilterInput>;
  isPorequired?: InputMaybe<BooleanOperationFilterInput>;
  isPowerLinePresent?: InputMaybe<BooleanOperationFilterInput>;
  isProspect?: InputMaybe<BooleanOperationFilterInput>;
  isPublicProject?: InputMaybe<BooleanOperationFilterInput>;
  isSafetyRequired?: InputMaybe<BooleanOperationFilterInput>;
  isVerifiedOnSite?: InputMaybe<BooleanOperationFilterInput>;
  jobNum?: InputMaybe<StringOperationFilterInput>;
  jobPhone?: InputMaybe<StringOperationFilterInput>;
  jobSiteName?: InputMaybe<StringOperationFilterInput>;
  jobSiteType?: InputMaybe<JobSiteTypeFilterInput>;
  jobs?: InputMaybe<ListFilterInputTypeOfRaptorJobFilterInput>;
  latitude?: InputMaybe<DecimalOperationFilterInput>;
  latitudeAndLongitude?: InputMaybe<StringOperationFilterInput>;
  longitude?: InputMaybe<DecimalOperationFilterInput>;
  mapPage?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<JobSiteFilterInput>>;
  parcelNumber?: InputMaybe<StringOperationFilterInput>;
  postalCode?: InputMaybe<StringOperationFilterInput>;
  pourForAddings?: InputMaybe<ListFilterInputTypeOfPourForAddingFilterInput>;
  prelimed?: InputMaybe<IntOperationFilterInput>;
  prelimedNotes?: InputMaybe<StringOperationFilterInput>;
  preventAutoPricingVersionChange?: InputMaybe<BooleanOperationFilterInput>;
  priceId?: InputMaybe<IntOperationFilterInput>;
  pricingScheme?: InputMaybe<PricingSchemeFilterInput>;
  pricingVersionId?: InputMaybe<IntOperationFilterInput>;
  projectType?: InputMaybe<BizObjectFilterInput>;
  projectTypeId?: InputMaybe<IntOperationFilterInput>;
  raptorCertificateAssignment?: InputMaybe<RaptorCertificateAssignmentVwFilterInput>;
  raptorPermitAssignment?: InputMaybe<RaptorPermitAssignmentVwFilterInput>;
  readyMixVendor?: InputMaybe<SupplierFilterInput>;
  released?: InputMaybe<IntOperationFilterInput>;
  rmxid?: InputMaybe<IntOperationFilterInput>;
  salesAgent?: InputMaybe<EmployeeFilterInput>;
  salesAgentId?: InputMaybe<IntOperationFilterInput>;
  salesRegion?: InputMaybe<SalesRegionFilterInput>;
  salesRegionId?: InputMaybe<IntOperationFilterInput>;
  specialInst?: InputMaybe<StringOperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  statusJobSite?: InputMaybe<IntOperationFilterInput>;
  typeId?: InputMaybe<IntOperationFilterInput>;
  ud1?: InputMaybe<StringOperationFilterInput>;
  ud2?: InputMaybe<StringOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  useCustomEmailList?: InputMaybe<BooleanOperationFilterInput>;
  verifiedBy?: InputMaybe<IntOperationFilterInput>;
  verifyStatus?: InputMaybe<ByteOperationFilterInput>;
  xstreet?: InputMaybe<StringOperationFilterInput>;
};

export type JobSitePrelimedDto = {
  __typename?: 'JobSitePrelimedDto';
  estimatedAmount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isReleased?: Maybe<Scalars['Boolean']['output']>;
  jobSiteId?: Maybe<Scalars['Int']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  prelimedOn?: Maybe<Scalars['Date']['output']>;
  projectName: Scalars['String']['output'];
};

export type JobSitePrelimedDtoFilterInput = {
  and?: InputMaybe<Array<JobSitePrelimedDtoFilterInput>>;
  estimatedAmount?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isReleased?: InputMaybe<BooleanOperationFilterInput>;
  jobSiteId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<JobSitePrelimedDtoFilterInput>>;
  ownerName?: InputMaybe<StringOperationFilterInput>;
  prelimedOn?: InputMaybe<DateOperationFilterInput>;
  projectName?: InputMaybe<StringOperationFilterInput>;
};

export type JobSitePrelimedDtoInput = {
  estimatedAmount?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  isReleased?: InputMaybe<Scalars['Boolean']['input']>;
  jobSiteId?: InputMaybe<Scalars['Int']['input']>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  prelimedOn?: InputMaybe<Scalars['Date']['input']>;
  projectName: Scalars['String']['input'];
};

export type JobSiteSortInput = {
  address?: InputMaybe<SortEnumType>;
  billAddressId?: InputMaybe<SortEnumType>;
  billableTravelHours?: InputMaybe<SortEnumType>;
  billingAddress?: InputMaybe<AddressSortInput>;
  bldgLot?: InputMaybe<SortEnumType>;
  checkList?: InputMaybe<CheckListSortInput>;
  checkListId?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  collectionNotes?: InputMaybe<SortEnumType>;
  comments?: InputMaybe<SortEnumType>;
  contactId?: InputMaybe<SortEnumType>;
  contractNumber?: InputMaybe<SortEnumType>;
  contractor?: InputMaybe<SupplierSortInput>;
  contractorId?: InputMaybe<SortEnumType>;
  cpr?: InputMaybe<SortEnumType>;
  cus?: InputMaybe<CustomerSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  customerWithContacts?: InputMaybe<RaptorCustomerWithContactsSortInput>;
  dateCreated?: InputMaybe<SortEnumType>;
  defaultJobPo?: InputMaybe<SortEnumType>;
  deletable?: InputMaybe<RaptorDeletableJobSiteVwSortInput>;
  description?: InputMaybe<SortEnumType>;
  emailInvoice?: InputMaybe<SortEnumType>;
  hasNoLocation?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  includeCustomerContacts?: InputMaybe<SortEnumType>;
  isGeofenceEnabled?: InputMaybe<SortEnumType>;
  isNoSubs?: InputMaybe<SortEnumType>;
  isNonTaxable?: InputMaybe<SortEnumType>;
  isOcip?: InputMaybe<SortEnumType>;
  isPorequired?: InputMaybe<SortEnumType>;
  isPowerLinePresent?: InputMaybe<SortEnumType>;
  isProspect?: InputMaybe<SortEnumType>;
  isPublicProject?: InputMaybe<SortEnumType>;
  isSafetyRequired?: InputMaybe<SortEnumType>;
  isVerifiedOnSite?: InputMaybe<SortEnumType>;
  jobNum?: InputMaybe<SortEnumType>;
  jobPhone?: InputMaybe<SortEnumType>;
  jobSiteName?: InputMaybe<SortEnumType>;
  jobSiteType?: InputMaybe<JobSiteTypeSortInput>;
  latitude?: InputMaybe<SortEnumType>;
  latitudeAndLongitude?: InputMaybe<SortEnumType>;
  longitude?: InputMaybe<SortEnumType>;
  mapPage?: InputMaybe<SortEnumType>;
  parcelNumber?: InputMaybe<SortEnumType>;
  postalCode?: InputMaybe<SortEnumType>;
  prelimed?: InputMaybe<SortEnumType>;
  prelimedNotes?: InputMaybe<SortEnumType>;
  preventAutoPricingVersionChange?: InputMaybe<SortEnumType>;
  priceId?: InputMaybe<SortEnumType>;
  pricingScheme?: InputMaybe<PricingSchemeSortInput>;
  pricingVersionId?: InputMaybe<SortEnumType>;
  projectType?: InputMaybe<BizObjectSortInput>;
  projectTypeId?: InputMaybe<SortEnumType>;
  raptorCertificateAssignment?: InputMaybe<RaptorCertificateAssignmentVwSortInput>;
  raptorPermitAssignment?: InputMaybe<RaptorPermitAssignmentVwSortInput>;
  readyMixVendor?: InputMaybe<SupplierSortInput>;
  released?: InputMaybe<SortEnumType>;
  rmxid?: InputMaybe<SortEnumType>;
  salesAgent?: InputMaybe<EmployeeSortInput>;
  salesAgentId?: InputMaybe<SortEnumType>;
  salesRegion?: InputMaybe<SalesRegionSortInput>;
  salesRegionId?: InputMaybe<SortEnumType>;
  specialInst?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  statusJobSite?: InputMaybe<SortEnumType>;
  typeId?: InputMaybe<SortEnumType>;
  ud1?: InputMaybe<SortEnumType>;
  ud2?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  useCustomEmailList?: InputMaybe<SortEnumType>;
  verifiedBy?: InputMaybe<SortEnumType>;
  verifyStatus?: InputMaybe<SortEnumType>;
  xstreet?: InputMaybe<SortEnumType>;
};

export type JobSiteType = {
  __typename?: 'JobSiteType';
  createdOn?: Maybe<Scalars['LocalDateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isInactive: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  isUsable: Scalars['Boolean']['output'];
  jobSites: JobSite;
  miscValues?: Maybe<Scalars['String']['output']>;
  objectName: Scalars['String']['output'];
  parentObjectId?: Maybe<Scalars['Int']['output']>;
  rowId: Scalars['UUID']['output'];
  sortOrder: Scalars['Int']['output'];
  updatedBy: Scalars['Int']['output'];
  updatedOn: Scalars['LocalDateTime']['output'];
};

export type JobSiteTypeDto = {
  __typename?: 'JobSiteTypeDto';
  default: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  objectName: Scalars['String']['output'];
};

export type JobSiteTypeDtoFilterInput = {
  and?: InputMaybe<Array<JobSiteTypeDtoFilterInput>>;
  default?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  objectName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<JobSiteTypeDtoFilterInput>>;
};

export type JobSiteTypeDtoInput = {
  default: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  objectName: Scalars['String']['input'];
};

export type JobSiteTypeDtoSortInput = {
  default?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  objectName?: InputMaybe<SortEnumType>;
};

export type JobSiteTypeFilterInput = {
  and?: InputMaybe<Array<JobSiteTypeFilterInput>>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  isSystem?: InputMaybe<BooleanOperationFilterInput>;
  isUsable?: InputMaybe<BooleanOperationFilterInput>;
  jobSites?: InputMaybe<JobSiteFilterInput>;
  miscValues?: InputMaybe<StringOperationFilterInput>;
  objectName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<JobSiteTypeFilterInput>>;
  parentObjectId?: InputMaybe<IntOperationFilterInput>;
  rowId?: InputMaybe<UuidOperationFilterInput>;
  sortOrder?: InputMaybe<IntOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type JobSiteTypeInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type JobSiteTypeSortInput = {
  createdOn?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isInactive?: InputMaybe<SortEnumType>;
  isSystem?: InputMaybe<SortEnumType>;
  isUsable?: InputMaybe<SortEnumType>;
  jobSites?: InputMaybe<JobSiteSortInput>;
  miscValues?: InputMaybe<SortEnumType>;
  objectName?: InputMaybe<SortEnumType>;
  parentObjectId?: InputMaybe<SortEnumType>;
  rowId?: InputMaybe<SortEnumType>;
  sortOrder?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  updatedOn?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type JobSitesCollectionSegment = {
  __typename?: 'JobSitesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V2_JobSite_JobSiteDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type JobStatus = {
  __typename?: 'JobStatus';
  color?: Maybe<Scalars['Int']['output']>;
  colorHex?: Maybe<Scalars['String']['output']>;
  createdOn?: Maybe<Scalars['LocalDateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isInactive: Scalars['Boolean']['output'];
  isSystem: Scalars['Boolean']['output'];
  jobs: Array<PourForAdding>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  statusCodeID: Scalars['Int']['output'];
  statusID: Scalars['Int']['output'];
  updatedOn?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type JobStatusFilterInput = {
  and?: InputMaybe<Array<JobStatusFilterInput>>;
  color?: InputMaybe<IntOperationFilterInput>;
  colorHex?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  isSystem?: InputMaybe<BooleanOperationFilterInput>;
  jobs?: InputMaybe<ListFilterInputTypeOfPourForAddingFilterInput>;
  or?: InputMaybe<Array<JobStatusFilterInput>>;
  sortOrder?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  statusCodeID?: InputMaybe<IntOperationFilterInput>;
  statusID?: InputMaybe<IntOperationFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type JobStatusSortInput = {
  color?: InputMaybe<SortEnumType>;
  colorHex?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  isInactive?: InputMaybe<SortEnumType>;
  isSystem?: InputMaybe<SortEnumType>;
  sortOrder?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  statusCodeID?: InputMaybe<SortEnumType>;
  statusID?: InputMaybe<SortEnumType>;
  updatedOn?: InputMaybe<SortEnumType>;
};

export type JobTicket = {
  __typename?: 'JobTicket';
  area?: Maybe<Scalars['Float']['output']>;
  arrivalPumpHrs?: Maybe<Scalars['Float']['output']>;
  arrivalPumpMiles?: Maybe<Scalars['Float']['output']>;
  arriveTime?: Maybe<Scalars['LocalDateTime']['output']>;
  arriveTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  authBy?: Maybe<Scalars['String']['output']>;
  cboGuid?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  finishPumpTime?: Maybe<Scalars['LocalDateTime']['output']>;
  finishPumpTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  fromJobMiles?: Maybe<Scalars['Float']['output']>;
  fuel?: Maybe<Scalars['Float']['output']>;
  hoursOnJob?: Maybe<Scalars['Decimal']['output']>;
  hoursTravel?: Maybe<Scalars['Decimal']['output']>;
  isAccepted: Scalars['Boolean']['output'];
  isAttentionRequired: Scalars['Boolean']['output'];
  isComplete?: Maybe<Scalars['Boolean']['output']>;
  jobPumpHours?: Maybe<Scalars['Float']['output']>;
  jobSiteHours?: Maybe<Scalars['Decimal']['output']>;
  jobSitePumpHours?: Maybe<Scalars['Decimal']['output']>;
  jobSuper?: Maybe<Scalars['String']['output']>;
  jtid: Scalars['Int']['output'];
  jtprinted?: Maybe<Scalars['Int']['output']>;
  lvJobPumpMiles?: Maybe<Scalars['Float']['output']>;
  lvJobTime?: Maybe<Scalars['LocalDateTime']['output']>;
  lvJobTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  lvYdTime?: Maybe<Scalars['LocalDateTime']['output']>;
  lvYdTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  lvYdTruckHrs?: Maybe<Scalars['Float']['output']>;
  lvYdTruckMiles?: Maybe<Scalars['Float']['output']>;
  oil?: Maybe<Scalars['Float']['output']>;
  onJobMiles?: Maybe<Scalars['Float']['output']>;
  postDisclaimerId?: Maybe<Scalars['Int']['output']>;
  postJobSignature?: Maybe<Array<Scalars['Byte']['output']>>;
  pour?: Maybe<PourForAdding>;
  pourId?: Maybe<Scalars['Int']['output']>;
  preDisclaimerId?: Maybe<Scalars['Int']['output']>;
  preJobSignature?: Maybe<Array<Scalars['Byte']['output']>>;
  radios?: Maybe<Scalars['String']['output']>;
  rdyTime?: Maybe<Scalars['LocalDateTime']['output']>;
  rdyTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  returnPumpHrs?: Maybe<Scalars['Float']['output']>;
  returnTime?: Maybe<Scalars['LocalDateTime']['output']>;
  returnTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  returnTruckHrs?: Maybe<Scalars['Float']['output']>;
  returnTruckMiles?: Maybe<Scalars['Float']['output']>;
  slurry?: Maybe<Scalars['String']['output']>;
  startPumpTime?: Maybe<Scalars['LocalDateTime']['output']>;
  startPumpTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  sysLeft?: Maybe<Scalars['String']['output']>;
  toJobMiles?: Maybe<Scalars['Float']['output']>;
  totalJobHours?: Maybe<Scalars['Decimal']['output']>;
  totalJobMiles?: Maybe<Scalars['Float']['output']>;
  totalTicketHours?: Maybe<Scalars['Decimal']['output']>;
  travelHours?: Maybe<Scalars['Decimal']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  updatedOn?: Maybe<Scalars['LocalDateTime']['output']>;
  upsizeTs?: Maybe<Array<Scalars['Byte']['output']>>;
  utcTicketedOn?: Maybe<Scalars['LocalDateTime']['output']>;
  utcpostJobSignature?: Maybe<Scalars['LocalDateTime']['output']>;
  utcpreJobSignature?: Maybe<Scalars['LocalDateTime']['output']>;
  ydsPumped?: Maybe<Scalars['Float']['output']>;
};

export type JobTicketFilterInput = {
  and?: InputMaybe<Array<JobTicketFilterInput>>;
  area?: InputMaybe<FloatOperationFilterInput>;
  arrivalPumpHrs?: InputMaybe<FloatOperationFilterInput>;
  arrivalPumpMiles?: InputMaybe<FloatOperationFilterInput>;
  arriveTime?: InputMaybe<DateTimeOperationFilterInput>;
  arriveTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
  authBy?: InputMaybe<StringOperationFilterInput>;
  cboGuid?: InputMaybe<StringOperationFilterInput>;
  comments?: InputMaybe<StringOperationFilterInput>;
  finishPumpTime?: InputMaybe<DateTimeOperationFilterInput>;
  finishPumpTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
  fromJobMiles?: InputMaybe<FloatOperationFilterInput>;
  fuel?: InputMaybe<FloatOperationFilterInput>;
  hoursOnJob?: InputMaybe<DecimalOperationFilterInput>;
  hoursTravel?: InputMaybe<DecimalOperationFilterInput>;
  isAccepted?: InputMaybe<BooleanOperationFilterInput>;
  isAttentionRequired?: InputMaybe<BooleanOperationFilterInput>;
  isComplete?: InputMaybe<BooleanOperationFilterInput>;
  jobPumpHours?: InputMaybe<FloatOperationFilterInput>;
  jobSiteHours?: InputMaybe<DecimalOperationFilterInput>;
  jobSitePumpHours?: InputMaybe<DecimalOperationFilterInput>;
  jobSuper?: InputMaybe<StringOperationFilterInput>;
  jtid?: InputMaybe<IntOperationFilterInput>;
  jtprinted?: InputMaybe<IntOperationFilterInput>;
  lvJobPumpMiles?: InputMaybe<FloatOperationFilterInput>;
  lvJobTime?: InputMaybe<DateTimeOperationFilterInput>;
  lvJobTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
  lvYdTime?: InputMaybe<DateTimeOperationFilterInput>;
  lvYdTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
  lvYdTruckHrs?: InputMaybe<FloatOperationFilterInput>;
  lvYdTruckMiles?: InputMaybe<FloatOperationFilterInput>;
  oil?: InputMaybe<FloatOperationFilterInput>;
  onJobMiles?: InputMaybe<FloatOperationFilterInput>;
  or?: InputMaybe<Array<JobTicketFilterInput>>;
  postDisclaimerId?: InputMaybe<IntOperationFilterInput>;
  postJobSignature?: InputMaybe<ListByteOperationFilterInput>;
  pour?: InputMaybe<PourForAddingFilterInput>;
  pourId?: InputMaybe<IntOperationFilterInput>;
  preDisclaimerId?: InputMaybe<IntOperationFilterInput>;
  preJobSignature?: InputMaybe<ListByteOperationFilterInput>;
  radios?: InputMaybe<StringOperationFilterInput>;
  rdyTime?: InputMaybe<DateTimeOperationFilterInput>;
  rdyTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
  returnPumpHrs?: InputMaybe<FloatOperationFilterInput>;
  returnTime?: InputMaybe<DateTimeOperationFilterInput>;
  returnTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
  returnTruckHrs?: InputMaybe<FloatOperationFilterInput>;
  returnTruckMiles?: InputMaybe<FloatOperationFilterInput>;
  slurry?: InputMaybe<StringOperationFilterInput>;
  startPumpTime?: InputMaybe<DateTimeOperationFilterInput>;
  startPumpTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
  sysLeft?: InputMaybe<StringOperationFilterInput>;
  toJobMiles?: InputMaybe<FloatOperationFilterInput>;
  totalJobHours?: InputMaybe<DecimalOperationFilterInput>;
  totalJobMiles?: InputMaybe<FloatOperationFilterInput>;
  totalTicketHours?: InputMaybe<DecimalOperationFilterInput>;
  travelHours?: InputMaybe<DecimalOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
  upsizeTs?: InputMaybe<ListByteOperationFilterInput>;
  utcTicketedOn?: InputMaybe<DateTimeOperationFilterInput>;
  utcpostJobSignature?: InputMaybe<DateTimeOperationFilterInput>;
  utcpreJobSignature?: InputMaybe<DateTimeOperationFilterInput>;
  ydsPumped?: InputMaybe<FloatOperationFilterInput>;
};

export type JobTicketSortInput = {
  area?: InputMaybe<SortEnumType>;
  arrivalPumpHrs?: InputMaybe<SortEnumType>;
  arrivalPumpMiles?: InputMaybe<SortEnumType>;
  arriveTime?: InputMaybe<SortEnumType>;
  arriveTimeUtc?: InputMaybe<SortEnumType>;
  authBy?: InputMaybe<SortEnumType>;
  cboGuid?: InputMaybe<SortEnumType>;
  comments?: InputMaybe<SortEnumType>;
  finishPumpTime?: InputMaybe<SortEnumType>;
  finishPumpTimeUtc?: InputMaybe<SortEnumType>;
  fromJobMiles?: InputMaybe<SortEnumType>;
  fuel?: InputMaybe<SortEnumType>;
  hoursOnJob?: InputMaybe<SortEnumType>;
  hoursTravel?: InputMaybe<SortEnumType>;
  isAccepted?: InputMaybe<SortEnumType>;
  isAttentionRequired?: InputMaybe<SortEnumType>;
  isComplete?: InputMaybe<SortEnumType>;
  jobPumpHours?: InputMaybe<SortEnumType>;
  jobSiteHours?: InputMaybe<SortEnumType>;
  jobSitePumpHours?: InputMaybe<SortEnumType>;
  jobSuper?: InputMaybe<SortEnumType>;
  jtid?: InputMaybe<SortEnumType>;
  jtprinted?: InputMaybe<SortEnumType>;
  lvJobPumpMiles?: InputMaybe<SortEnumType>;
  lvJobTime?: InputMaybe<SortEnumType>;
  lvJobTimeUtc?: InputMaybe<SortEnumType>;
  lvYdTime?: InputMaybe<SortEnumType>;
  lvYdTimeUtc?: InputMaybe<SortEnumType>;
  lvYdTruckHrs?: InputMaybe<SortEnumType>;
  lvYdTruckMiles?: InputMaybe<SortEnumType>;
  oil?: InputMaybe<SortEnumType>;
  onJobMiles?: InputMaybe<SortEnumType>;
  postDisclaimerId?: InputMaybe<SortEnumType>;
  pour?: InputMaybe<PourForAddingSortInput>;
  pourId?: InputMaybe<SortEnumType>;
  preDisclaimerId?: InputMaybe<SortEnumType>;
  radios?: InputMaybe<SortEnumType>;
  rdyTime?: InputMaybe<SortEnumType>;
  rdyTimeUtc?: InputMaybe<SortEnumType>;
  returnPumpHrs?: InputMaybe<SortEnumType>;
  returnTime?: InputMaybe<SortEnumType>;
  returnTimeUtc?: InputMaybe<SortEnumType>;
  returnTruckHrs?: InputMaybe<SortEnumType>;
  returnTruckMiles?: InputMaybe<SortEnumType>;
  slurry?: InputMaybe<SortEnumType>;
  startPumpTime?: InputMaybe<SortEnumType>;
  startPumpTimeUtc?: InputMaybe<SortEnumType>;
  sysLeft?: InputMaybe<SortEnumType>;
  toJobMiles?: InputMaybe<SortEnumType>;
  totalJobHours?: InputMaybe<SortEnumType>;
  totalJobMiles?: InputMaybe<SortEnumType>;
  totalTicketHours?: InputMaybe<SortEnumType>;
  travelHours?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  updatedOn?: InputMaybe<SortEnumType>;
  utcTicketedOn?: InputMaybe<SortEnumType>;
  utcpostJobSignature?: InputMaybe<SortEnumType>;
  utcpreJobSignature?: InputMaybe<SortEnumType>;
  ydsPumped?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type JobTypesCollectionSegment = {
  __typename?: 'JobTypesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V2_JobTypeDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type JobsiteTypesCollectionSegment = {
  __typename?: 'JobsiteTypesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<JobSiteTypeDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ListByteOperationFilterInput = {
  all?: InputMaybe<ByteOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ByteOperationFilterInput>;
  some?: InputMaybe<ByteOperationFilterInput>;
};

export type ListCrewAssignmentStatusOperationFilterInput = {
  all?: InputMaybe<CrewAssignmentStatusOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CrewAssignmentStatusOperationFilterInput>;
  some?: InputMaybe<CrewAssignmentStatusOperationFilterInput>;
};

export type ListFilterInputTypeOfAccountTypeDtoFilterInput = {
  all?: InputMaybe<AccountTypeDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AccountTypeDtoFilterInput>;
  some?: InputMaybe<AccountTypeDtoFilterInput>;
};

export type ListFilterInputTypeOfAppBlobRemoteAccessFilterInput = {
  all?: InputMaybe<AppBlobRemoteAccessFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AppBlobRemoteAccessFilterInput>;
  some?: InputMaybe<AppBlobRemoteAccessFilterInput>;
};

export type ListFilterInputTypeOfAppBlobRemoteFilterInput = {
  all?: InputMaybe<AppBlobRemoteFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AppBlobRemoteFilterInput>;
  some?: InputMaybe<AppBlobRemoteFilterInput>;
};

export type ListFilterInputTypeOfAppUserAccessFilterInput = {
  all?: InputMaybe<AppUserAccessFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AppUserAccessFilterInput>;
  some?: InputMaybe<AppUserAccessFilterInput>;
};

export type ListFilterInputTypeOfAppUserFilterInput = {
  all?: InputMaybe<AppUserFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AppUserFilterInput>;
  some?: InputMaybe<AppUserFilterInput>;
};

export type ListFilterInputTypeOfChecklistMappingFilterInput = {
  all?: InputMaybe<ChecklistMappingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ChecklistMappingFilterInput>;
  some?: InputMaybe<ChecklistMappingFilterInput>;
};

export type ListFilterInputTypeOfContactDtoFilterInput = {
  all?: InputMaybe<ContactDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ContactDtoFilterInput>;
  some?: InputMaybe<ContactDtoFilterInput>;
};

export type ListFilterInputTypeOfContactInformationDtoFilterInput = {
  all?: InputMaybe<ContactInformationDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ContactInformationDtoFilterInput>;
  some?: InputMaybe<ContactInformationDtoFilterInput>;
};

export type ListFilterInputTypeOfContentTypeFilterInput = {
  all?: InputMaybe<ContentTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ContentTypeFilterInput>;
  some?: InputMaybe<ContentTypeFilterInput>;
};

export type ListFilterInputTypeOfCrewFilterInput = {
  all?: InputMaybe<CrewFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CrewFilterInput>;
  some?: InputMaybe<CrewFilterInput>;
};

export type ListFilterInputTypeOfCustomerDtoFilterInput = {
  all?: InputMaybe<CustomerDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomerDtoFilterInput>;
  some?: InputMaybe<CustomerDtoFilterInput>;
};

export type ListFilterInputTypeOfCustomerFilterInput = {
  all?: InputMaybe<CustomerFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomerFilterInput>;
  some?: InputMaybe<CustomerFilterInput>;
};

export type ListFilterInputTypeOfCustomerInvoiceFilterInput = {
  all?: InputMaybe<CustomerInvoiceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomerInvoiceFilterInput>;
  some?: InputMaybe<CustomerInvoiceFilterInput>;
};

export type ListFilterInputTypeOfCustomerTypeDtoFilterInput = {
  all?: InputMaybe<CustomerTypeDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomerTypeDtoFilterInput>;
  some?: InputMaybe<CustomerTypeDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_CrewDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_CrewDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_CrewDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_CrewDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_CrewRoleDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_CrewRoleDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_CrewRoleDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_CrewRoleDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_EmployeeDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_EmployeeDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_EmployeeDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_EmployeeDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_Employee_EmployeeOutOfOfficeDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_Employee_EmployeeOutOfOfficeDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_Employee_EmployeeOutOfOfficeDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_Employee_EmployeeOutOfOfficeDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_Employee_OutOfOfficeReasonDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_Employee_OutOfOfficeReasonDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_Employee_OutOfOfficeReasonDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_Employee_OutOfOfficeReasonDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_EmploymentStatusDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_EmploymentStatusDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_EmploymentStatusDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_EmploymentStatusDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_EmploymentTypeDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_EmploymentTypeDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_EmploymentTypeDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_EmploymentTypeDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_EquipmentClassDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_EquipmentClassDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_EquipmentClassDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_EquipmentClassDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_EquipmentMakeDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_EquipmentMakeDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_EquipmentMakeDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_EquipmentMakeDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_EquipmentModelDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_EquipmentModelDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_EquipmentModelDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_EquipmentModelDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_EquipmentSizeDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_EquipmentSizeDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_EquipmentSizeDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_EquipmentSizeDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_EquipmentTypeDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_EquipmentTypeDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_EquipmentTypeDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_EquipmentTypeDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_Equipment_EquipmentOutOfServiceDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_Equipment_EquipmentOutOfServiceDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_Equipment_EquipmentOutOfServiceDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_Equipment_EquipmentOutOfServiceDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_Equipment_OutOfServiceReasonDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_Equipment_OutOfServiceReasonDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_Equipment_OutOfServiceReasonDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_Equipment_OutOfServiceReasonDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_JobInformationDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_JobInformationDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_JobInformationDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_JobInformationDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_JobStatusDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_JobStatusDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_JobStatusDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_JobStatusDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_JobTypeDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_JobTypeDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_JobTypeDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_JobTypeDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_LocationDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_LocationDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_LocationDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_LocationDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_PricingSchemeDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_PricingSchemeDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_PricingSchemeDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_PricingSchemeDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_SalesRegionDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_SalesRegionDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_SalesRegionDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_SalesRegionDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_SpecialFlagDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_SpecialFlagDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_SpecialFlagDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_SpecialFlagDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_TermDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_TermDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_TermDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_TermDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V1_VendorDtoFilterInput = {
  all?: InputMaybe<Dtos_V1_VendorDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V1_VendorDtoFilterInput>;
  some?: InputMaybe<Dtos_V1_VendorDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V2_CrewDtoFilterInput = {
  all?: InputMaybe<Dtos_V2_CrewDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V2_CrewDtoFilterInput>;
  some?: InputMaybe<Dtos_V2_CrewDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V2_DailyNoteDtoFilterInput = {
  all?: InputMaybe<Dtos_V2_DailyNoteDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V2_DailyNoteDtoFilterInput>;
  some?: InputMaybe<Dtos_V2_DailyNoteDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V2_Employee_EmployeeBanDtoFilterInput = {
  all?: InputMaybe<Dtos_V2_Employee_EmployeeBanDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V2_Employee_EmployeeBanDtoFilterInput>;
  some?: InputMaybe<Dtos_V2_Employee_EmployeeBanDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V2_Equipment_EquipmentDtoFilterInput = {
  all?: InputMaybe<Dtos_V2_Equipment_EquipmentDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V2_Equipment_EquipmentDtoFilterInput>;
  some?: InputMaybe<Dtos_V2_Equipment_EquipmentDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V2_ExtraSystemDtoFilterInput = {
  all?: InputMaybe<Dtos_V2_ExtraSystemDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V2_ExtraSystemDtoFilterInput>;
  some?: InputMaybe<Dtos_V2_ExtraSystemDtoFilterInput>;
};

export type ListFilterInputTypeOfDtos_V2_JobSite_JobHistoryDtoFilterInput = {
  all?: InputMaybe<Dtos_V2_JobSite_JobHistoryDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Dtos_V2_JobSite_JobHistoryDtoFilterInput>;
  some?: InputMaybe<Dtos_V2_JobSite_JobHistoryDtoFilterInput>;
};

export type ListFilterInputTypeOfEmployeeBanFilterInput = {
  all?: InputMaybe<EmployeeBanFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EmployeeBanFilterInput>;
  some?: InputMaybe<EmployeeBanFilterInput>;
};

export type ListFilterInputTypeOfEmployeeCheckListFilterInput = {
  all?: InputMaybe<EmployeeCheckListFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EmployeeCheckListFilterInput>;
  some?: InputMaybe<EmployeeCheckListFilterInput>;
};

export type ListFilterInputTypeOfEmployeeCheckListItemFilterInput = {
  all?: InputMaybe<EmployeeCheckListItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EmployeeCheckListItemFilterInput>;
  some?: InputMaybe<EmployeeCheckListItemFilterInput>;
};

export type ListFilterInputTypeOfEmployeeContentTypeFilterInput = {
  all?: InputMaybe<EmployeeContentTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EmployeeContentTypeFilterInput>;
  some?: InputMaybe<EmployeeContentTypeFilterInput>;
};

export type ListFilterInputTypeOfEmployeeDtoFilterInput = {
  all?: InputMaybe<EmployeeDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EmployeeDtoFilterInput>;
  some?: InputMaybe<EmployeeDtoFilterInput>;
};

export type ListFilterInputTypeOfEmployeeFilterInput = {
  all?: InputMaybe<EmployeeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EmployeeFilterInput>;
  some?: InputMaybe<EmployeeFilterInput>;
};

export type ListFilterInputTypeOfEntities_V1_CrewTitleFilterInput = {
  all?: InputMaybe<Entities_V1_CrewTitleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Entities_V1_CrewTitleFilterInput>;
  some?: InputMaybe<Entities_V1_CrewTitleFilterInput>;
};

export type ListFilterInputTypeOfEntities_V1_EmployeeOutOfOfficeDayFilterInput = {
  all?: InputMaybe<Entities_V1_EmployeeOutOfOfficeDayFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Entities_V1_EmployeeOutOfOfficeDayFilterInput>;
  some?: InputMaybe<Entities_V1_EmployeeOutOfOfficeDayFilterInput>;
};

export type ListFilterInputTypeOfEntities_V1_EquipmentCrewFilterInput = {
  all?: InputMaybe<Entities_V1_EquipmentCrewFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Entities_V1_EquipmentCrewFilterInput>;
  some?: InputMaybe<Entities_V1_EquipmentCrewFilterInput>;
};

export type ListFilterInputTypeOfEntities_V1_EquipmentModelFilterInput = {
  all?: InputMaybe<Entities_V1_EquipmentModelFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Entities_V1_EquipmentModelFilterInput>;
  some?: InputMaybe<Entities_V1_EquipmentModelFilterInput>;
};

export type ListFilterInputTypeOfEntities_V1_EquipmentServiceStatusDayFilterInput = {
  all?: InputMaybe<Entities_V1_EquipmentServiceStatusDayFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Entities_V1_EquipmentServiceStatusDayFilterInput>;
  some?: InputMaybe<Entities_V1_EquipmentServiceStatusDayFilterInput>;
};

export type ListFilterInputTypeOfEntities_V1_ItemFilterInput = {
  all?: InputMaybe<Entities_V1_ItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Entities_V1_ItemFilterInput>;
  some?: InputMaybe<Entities_V1_ItemFilterInput>;
};

export type ListFilterInputTypeOfEntities_V1_JobExtraSystemFilterInput = {
  all?: InputMaybe<Entities_V1_JobExtraSystemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Entities_V1_JobExtraSystemFilterInput>;
  some?: InputMaybe<Entities_V1_JobExtraSystemFilterInput>;
};

export type ListFilterInputTypeOfEntities_V1_RaptorEmployeeOutOfOfficeFilterInput = {
  all?: InputMaybe<Entities_V1_RaptorEmployeeOutOfOfficeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Entities_V1_RaptorEmployeeOutOfOfficeFilterInput>;
  some?: InputMaybe<Entities_V1_RaptorEmployeeOutOfOfficeFilterInput>;
};

export type ListFilterInputTypeOfEntities_V1_RaptorEquipmentOutOfServiceFilterInput = {
  all?: InputMaybe<Entities_V1_RaptorEquipmentOutOfServiceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Entities_V1_RaptorEquipmentOutOfServiceFilterInput>;
  some?: InputMaybe<Entities_V1_RaptorEquipmentOutOfServiceFilterInput>;
};

export type ListFilterInputTypeOfEntities_V2_Equipment_EquipmentJobInfoFilterInput = {
  all?: InputMaybe<Entities_V2_Equipment_EquipmentJobInfoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Entities_V2_Equipment_EquipmentJobInfoFilterInput>;
  some?: InputMaybe<Entities_V2_Equipment_EquipmentJobInfoFilterInput>;
};

export type ListFilterInputTypeOfEntities_V2_RaptorDefaultEmployeeFilterInput = {
  all?: InputMaybe<Entities_V2_RaptorDefaultEmployeeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<Entities_V2_RaptorDefaultEmployeeFilterInput>;
  some?: InputMaybe<Entities_V2_RaptorDefaultEmployeeFilterInput>;
};

export type ListFilterInputTypeOfEquipmentFilterInput = {
  all?: InputMaybe<EquipmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EquipmentFilterInput>;
  some?: InputMaybe<EquipmentFilterInput>;
};

export type ListFilterInputTypeOfEquipmentSizeFilterInput = {
  all?: InputMaybe<EquipmentSizeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EquipmentSizeFilterInput>;
  some?: InputMaybe<EquipmentSizeFilterInput>;
};

export type ListFilterInputTypeOfEquipmentTypeFilterInput = {
  all?: InputMaybe<EquipmentTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EquipmentTypeFilterInput>;
  some?: InputMaybe<EquipmentTypeFilterInput>;
};

export type ListFilterInputTypeOfJobSiteFilterInput = {
  all?: InputMaybe<JobSiteFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<JobSiteFilterInput>;
  some?: InputMaybe<JobSiteFilterInput>;
};

export type ListFilterInputTypeOfJobSitePrelimedDtoFilterInput = {
  all?: InputMaybe<JobSitePrelimedDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<JobSitePrelimedDtoFilterInput>;
  some?: InputMaybe<JobSitePrelimedDtoFilterInput>;
};

export type ListFilterInputTypeOfJobSiteTypeDtoFilterInput = {
  all?: InputMaybe<JobSiteTypeDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<JobSiteTypeDtoFilterInput>;
  some?: InputMaybe<JobSiteTypeDtoFilterInput>;
};

export type ListFilterInputTypeOfPourForAddingFilterInput = {
  all?: InputMaybe<PourForAddingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PourForAddingFilterInput>;
  some?: InputMaybe<PourForAddingFilterInput>;
};

export type ListFilterInputTypeOfRaptorAllJobsVwFilterInput = {
  all?: InputMaybe<RaptorAllJobsVwFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorAllJobsVwFilterInput>;
  some?: InputMaybe<RaptorAllJobsVwFilterInput>;
};

export type ListFilterInputTypeOfRaptorCertificateAssignmentVwFilterInput = {
  all?: InputMaybe<RaptorCertificateAssignmentVwFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorCertificateAssignmentVwFilterInput>;
  some?: InputMaybe<RaptorCertificateAssignmentVwFilterInput>;
};

export type ListFilterInputTypeOfRaptorCommentFilterInput = {
  all?: InputMaybe<RaptorCommentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorCommentFilterInput>;
  some?: InputMaybe<RaptorCommentFilterInput>;
};

export type ListFilterInputTypeOfRaptorContactInformationVwFilterInput = {
  all?: InputMaybe<RaptorContactInformationVwFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorContactInformationVwFilterInput>;
  some?: InputMaybe<RaptorContactInformationVwFilterInput>;
};

export type ListFilterInputTypeOfRaptorCustomerWithContactsFilterInput = {
  all?: InputMaybe<RaptorCustomerWithContactsFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorCustomerWithContactsFilterInput>;
  some?: InputMaybe<RaptorCustomerWithContactsFilterInput>;
};

export type ListFilterInputTypeOfRaptorEmployeeFilterInput = {
  all?: InputMaybe<RaptorEmployeeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorEmployeeFilterInput>;
  some?: InputMaybe<RaptorEmployeeFilterInput>;
};

export type ListFilterInputTypeOfRaptorJobContactFilterInput = {
  all?: InputMaybe<RaptorJobContactFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorJobContactFilterInput>;
  some?: InputMaybe<RaptorJobContactFilterInput>;
};

export type ListFilterInputTypeOfRaptorJobFieldValueFilterInput = {
  all?: InputMaybe<RaptorJobFieldValueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorJobFieldValueFilterInput>;
  some?: InputMaybe<RaptorJobFieldValueFilterInput>;
};

export type ListFilterInputTypeOfRaptorJobFilterInput = {
  all?: InputMaybe<RaptorJobFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorJobFilterInput>;
  some?: InputMaybe<RaptorJobFilterInput>;
};

export type ListFilterInputTypeOfRaptorJobMetricEstimateFilterInput = {
  all?: InputMaybe<RaptorJobMetricEstimateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorJobMetricEstimateFilterInput>;
  some?: InputMaybe<RaptorJobMetricEstimateFilterInput>;
};

export type ListFilterInputTypeOfRaptorJobResourceGroupEquipmentFilterInput = {
  all?: InputMaybe<RaptorJobResourceGroupEquipmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorJobResourceGroupEquipmentFilterInput>;
  some?: InputMaybe<RaptorJobResourceGroupEquipmentFilterInput>;
};

export type ListFilterInputTypeOfRaptorJobResourceGroupFilterInput = {
  all?: InputMaybe<RaptorJobResourceGroupFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorJobResourceGroupFilterInput>;
  some?: InputMaybe<RaptorJobResourceGroupFilterInput>;
};

export type ListFilterInputTypeOfRaptorJobResourceGroupItemFilterInput = {
  all?: InputMaybe<RaptorJobResourceGroupItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorJobResourceGroupItemFilterInput>;
  some?: InputMaybe<RaptorJobResourceGroupItemFilterInput>;
};

export type ListFilterInputTypeOfRaptorJobResourceGroupRoleFilterInput = {
  all?: InputMaybe<RaptorJobResourceGroupRoleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorJobResourceGroupRoleFilterInput>;
  some?: InputMaybe<RaptorJobResourceGroupRoleFilterInput>;
};

export type ListFilterInputTypeOfRaptorJobTicketRecurrenceFilterInput = {
  all?: InputMaybe<RaptorJobTicketRecurrenceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorJobTicketRecurrenceFilterInput>;
  some?: InputMaybe<RaptorJobTicketRecurrenceFilterInput>;
};

export type ListFilterInputTypeOfRaptorJobTypeFieldFilterInput = {
  all?: InputMaybe<RaptorJobTypeFieldFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorJobTypeFieldFilterInput>;
  some?: InputMaybe<RaptorJobTypeFieldFilterInput>;
};

export type ListFilterInputTypeOfRaptorJobTypeFilterInput = {
  all?: InputMaybe<RaptorJobTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorJobTypeFilterInput>;
  some?: InputMaybe<RaptorJobTypeFilterInput>;
};

export type ListFilterInputTypeOfRaptorPermitAssignmentVwFilterInput = {
  all?: InputMaybe<RaptorPermitAssignmentVwFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorPermitAssignmentVwFilterInput>;
  some?: InputMaybe<RaptorPermitAssignmentVwFilterInput>;
};

export type ListFilterInputTypeOfRaptorTicketActivityFilterInput = {
  all?: InputMaybe<RaptorTicketActivityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorTicketActivityFilterInput>;
  some?: InputMaybe<RaptorTicketActivityFilterInput>;
};

export type ListFilterInputTypeOfRaptorTicketFilterInput = {
  all?: InputMaybe<RaptorTicketFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorTicketFilterInput>;
  some?: InputMaybe<RaptorTicketFilterInput>;
};

export type ListFilterInputTypeOfRaptorTicketResourceGroupCrewFilterInput = {
  all?: InputMaybe<RaptorTicketResourceGroupCrewFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorTicketResourceGroupCrewFilterInput>;
  some?: InputMaybe<RaptorTicketResourceGroupCrewFilterInput>;
};

export type ListFilterInputTypeOfRaptorTicketResourceGroupEquipmentFilterInput = {
  all?: InputMaybe<RaptorTicketResourceGroupEquipmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorTicketResourceGroupEquipmentFilterInput>;
  some?: InputMaybe<RaptorTicketResourceGroupEquipmentFilterInput>;
};

export type ListFilterInputTypeOfRaptorTicketResourceGroupFilterInput = {
  all?: InputMaybe<RaptorTicketResourceGroupFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorTicketResourceGroupFilterInput>;
  some?: InputMaybe<RaptorTicketResourceGroupFilterInput>;
};

export type ListFilterInputTypeOfRaptorTicketResourceGroupItemFilterInput = {
  all?: InputMaybe<RaptorTicketResourceGroupItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorTicketResourceGroupItemFilterInput>;
  some?: InputMaybe<RaptorTicketResourceGroupItemFilterInput>;
};

export type ListFilterInputTypeOfRaptorTicketResourcesVwFilterInput = {
  all?: InputMaybe<RaptorTicketResourcesVwFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RaptorTicketResourcesVwFilterInput>;
  some?: InputMaybe<RaptorTicketResourcesVwFilterInput>;
};

export type ListFilterInputTypeOfStateDtoFilterInput = {
  all?: InputMaybe<StateDtoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StateDtoFilterInput>;
  some?: InputMaybe<StateDtoFilterInput>;
};

export type ListIntOperationFilterInput = {
  all?: InputMaybe<IntOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IntOperationFilterInput>;
  some?: InputMaybe<IntOperationFilterInput>;
};

export enum MapParentType {
  Customer = 'CUSTOMER',
  Employee = 'EMPLOYEE',
  Equipment = 'EQUIPMENT',
  JobSite = 'JOB_SITE',
  RaptorJob = 'RAPTOR_JOB'
}

export type MapParentTypeOperationFilterInput = {
  eq?: InputMaybe<MapParentType>;
  in?: InputMaybe<Array<MapParentType>>;
  neq?: InputMaybe<MapParentType>;
  nin?: InputMaybe<Array<MapParentType>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  banEmployee: Result;
  cancelBanAssignment: Result;
  cancelRaptorJob: Result;
  createCustomer: ResultOfCreateCustomerDto;
  createCustomerContact: ResultOfCustomersContactsResultDto;
  createEmployee: ResultOfDtos_V1_EmployeeDto;
  createEquipment: ResultOfDtos_V2_Equipment_EquipmentDto;
  createJobSite: ResultOfCreateJobsiteDto;
  createRaptorJob: ResultOfDtos_V2_RaptorJob_RaptorJobDto;
  deleteCustomer: Result;
  deleteCustomerContact: Result;
  deleteEmployee: Result;
  deleteEquipment: Result;
  deleteJobSite: Result;
  duplicateRaptorJob: Result;
  notifyCrewMembers: Result;
  updateCustomer: Result;
  updateCustomerContact: ResultOfCustomersContactsResultDto;
  updateEmployee: ResultOfDtos_V1_EmployeeDto;
  updateEquipment: ResultOfDtos_V2_Equipment_EquipmentDto;
  updateJobSite: Result;
  updateRaptorJob: ResultOfDtos_V2_RaptorJob_RaptorJobDto;
};

export type MutationBanEmployeeArgs = {
  banType: Scalars['String']['input'];
  bannedFromId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};

export type MutationCancelBanAssignmentArgs = {
  id: Scalars['Int']['input'];
};

export type MutationCancelRaptorJobArgs = {
  raptorJobId: Scalars['Int']['input'];
};

export type MutationCreateCustomerArgs = {
  input: CreateCustomerMutationInput;
};

export type MutationCreateCustomerContactArgs = {
  input: CreateCustomerContactsMutationInput;
};

export type MutationCreateEmployeeArgs = {
  input: Input_V1_Mutations_Employee_CreateEmployeeMutationInput;
};

export type MutationCreateEquipmentArgs = {
  input: Input_V2_Mutations_Equipment_CreateEquipmentMutationInput;
};

export type MutationCreateJobSiteArgs = {
  input: CreateJobsiteMutationInput;
};

export type MutationCreateRaptorJobArgs = {
  input: Input_V2_Mutations_RaptorJob_CreateRaptorJobMutationInput;
};

export type MutationDeleteCustomerArgs = {
  input: DeleteCustomerMutationInput;
};

export type MutationDeleteCustomerContactArgs = {
  input: DeleteCustomerContactsMutationInput;
};

export type MutationDeleteEmployeeArgs = {
  id: Scalars['Int']['input'];
};

export type MutationDeleteEquipmentArgs = {
  input: Input_V1_Mutations_Equipment_DeleteEquipmentMutationInput;
};

export type MutationDeleteJobSiteArgs = {
  input: DeleteJobSiteMutationInput;
};

export type MutationDuplicateRaptorJobArgs = {
  input: Input_V1_Mutations_RaptorJob_DuplicateRaptorJobMutationInput;
};

export type MutationNotifyCrewMembersArgs = {
  input: NotifyCrewMembersInput;
};

export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerMutationInput;
};

export type MutationUpdateCustomerContactArgs = {
  input: UpdateCustomerContactsMutationInput;
};

export type MutationUpdateEmployeeArgs = {
  input: Input_V1_Mutations_Employee_UpdateEmployeeMutationInput;
};

export type MutationUpdateEquipmentArgs = {
  input: Input_V2_Mutations_Equipment_UpdateEquipmentMutationInput;
};

export type MutationUpdateJobSiteArgs = {
  input: UpdateJobSiteMutationInput;
};

export type MutationUpdateRaptorJobArgs = {
  input: Input_V2_Mutations_RaptorJob_UpdateRaptorJobMutationInput;
};

export type NotifyCrewMembersInput = {
  changeStatus: Scalars['Boolean']['input'];
  crewToNotify: NotifyCrewMembersOptions;
  jobId: Scalars['Int']['input'];
};

export enum NotifyCrewMembersOptions {
  All = 'ALL',
  Unacknowledged = 'UNACKNOWLEDGED'
}

export type NullableOfEmploymentTypeOperationFilterInput = {
  eq?: InputMaybe<EmploymentType>;
  in?: InputMaybe<Array<InputMaybe<EmploymentType>>>;
  neq?: InputMaybe<EmploymentType>;
  nin?: InputMaybe<Array<InputMaybe<EmploymentType>>>;
};

export type NullableOfEquipmentStatusTypeOperationFilterInput = {
  eq?: InputMaybe<EquipmentStatusType>;
  in?: InputMaybe<Array<InputMaybe<EquipmentStatusType>>>;
  neq?: InputMaybe<EquipmentStatusType>;
  nin?: InputMaybe<Array<InputMaybe<EquipmentStatusType>>>;
};

export type NullableOfParentContactTypeIdOperationFilterInput = {
  eq?: InputMaybe<ParentContactTypeId>;
  in?: InputMaybe<Array<InputMaybe<ParentContactTypeId>>>;
  neq?: InputMaybe<ParentContactTypeId>;
  nin?: InputMaybe<Array<InputMaybe<ParentContactTypeId>>>;
};

/** A segment of a collection. */
export type OutOfServiceEquipmentCollectionSegment = {
  __typename?: 'OutOfServiceEquipmentCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V2_Equipment_EquipmentOutOfServiceDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum ParentContactTypeId {
  ContactPerson = 'CONTACT_PERSON',
  Customer = 'CUSTOMER',
  Employee = 'EMPLOYEE',
  JobSite = 'JOB_SITE',
  JobSiteContact = 'JOB_SITE_CONTACT'
}

export type ParentContactTypeIdOperationFilterInput = {
  eq?: InputMaybe<ParentContactTypeId>;
  in?: InputMaybe<Array<ParentContactTypeId>>;
  neq?: InputMaybe<ParentContactTypeId>;
  nin?: InputMaybe<Array<ParentContactTypeId>>;
};

export type PourForAdding = {
  __typename?: 'PourForAdding';
  bldgLot?: Maybe<Scalars['String']['output']>;
  callTime?: Maybe<Scalars['LocalDateTime']['output']>;
  caller?: Maybe<Scalars['String']['output']>;
  callerContactPersonId?: Maybe<Scalars['Int']['output']>;
  cancelDate?: Maybe<Scalars['LocalDateTime']['output']>;
  cancelable: RaptorCancelableJobVw;
  canceledBy?: Maybe<Scalars['String']['output']>;
  checkListId?: Maybe<Scalars['Int']['output']>;
  clearTime?: Maybe<Scalars['LocalDateTime']['output']>;
  confBy?: Maybe<Scalars['String']['output']>;
  confTime?: Maybe<Scalars['LocalDateTime']['output']>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  createdByEmployee: Employee;
  createdOn: Scalars['LocalDateTime']['output'];
  crews: Array<Crew>;
  cusId: Scalars['Int']['output'];
  customField1?: Maybe<Scalars['String']['output']>;
  customField2?: Maybe<Scalars['String']['output']>;
  customField3?: Maybe<Scalars['String']['output']>;
  customField4?: Maybe<Scalars['String']['output']>;
  customField5?: Maybe<Scalars['String']['output']>;
  customer: Customer;
  customerInvoices: Array<CustomerInvoice>;
  customerWithContacts: RaptorCustomerWithContacts;
  deletable: Scalars['Boolean']['output'];
  dispId: Scalars['Int']['output'];
  dispatchLocId: Scalars['Int']['output'];
  dispatchLocation: BizObject;
  dispatcher: Employee;
  displayTimeZone?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  equipment: Equipment;
  equipmentId: Scalars['Int']['output'];
  equipments: Array<Equipment>;
  estArea?: Maybe<Scalars['Float']['output']>;
  estDuration: Scalars['Float']['output'];
  estYards?: Maybe<Scalars['Float']['output']>;
  extraSys?: Maybe<Scalars['String']['output']>;
  flag1?: Maybe<BizObject>;
  flag2?: Maybe<BizObject>;
  flag3?: Maybe<BizObject>;
  geofenceLeftJob?: Maybe<Scalars['DateTime']['output']>;
  geofenceLeftYard?: Maybe<Scalars['DateTime']['output']>;
  geofenceOnJob?: Maybe<Scalars['DateTime']['output']>;
  geofenceReturned?: Maybe<Scalars['DateTime']['output']>;
  geofenceStartTime?: Maybe<Scalars['LocalDateTime']['output']>;
  geofenceStartTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  info?: Maybe<Scalars['String']['output']>;
  isAcceptedByCrew: Scalars['Boolean']['output'];
  isCod: Scalars['Boolean']['output'];
  isCrewBooked: Scalars['Boolean']['output'];
  isCrewNotified: Scalars['Boolean']['output'];
  isGeofenceEnabled: Scalars['Boolean']['output'];
  isJobTime?: Maybe<Scalars['Boolean']['output']>;
  isMoved: Scalars['Boolean']['output'];
  isMultiDay: Scalars['Boolean']['output'];
  isPowerLinePresent: Scalars['Boolean']['output'];
  isRequestStrict: Scalars['Boolean']['output'];
  job: JobSite;
  jobEndTime?: Maybe<Scalars['LocalDateTime']['output']>;
  jobEquipmentRequirements?: Maybe<RaptorJobEquipmentRequirements>;
  jobEstEndTime?: Maybe<Scalars['LocalDateTime']['output']>;
  jobExtraSystems: Array<Entities_V1_JobExtraSystem>;
  jobId: Scalars['Int']['output'];
  jobStartTime?: Maybe<Scalars['LocalDateTime']['output']>;
  jobTicket?: Maybe<JobTicket>;
  lastChanged: Scalars['LocalDateTime']['output'];
  locationYard: Yard;
  lvYdTime?: Maybe<Scalars['LocalDateTime']['output']>;
  lvYdTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  maxSize?: Maybe<Scalars['Int']['output']>;
  maxSizeRequested: EquipmentSize;
  notes?: Maybe<Scalars['String']['output']>;
  oldStatus?: Maybe<Scalars['Int']['output']>;
  onJobTime?: Maybe<Scalars['LocalDateTime']['output']>;
  onJobTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  pfaStatus?: Maybe<Scalars['Int']['output']>;
  plspotterProvider?: Maybe<Scalars['Int']['output']>;
  ponum?: Maybe<Scalars['String']['output']>;
  pourDate: Scalars['Date']['output'];
  pourGuid: Scalars['UUID']['output'];
  pourId: Scalars['Int']['output'];
  pourTime?: Maybe<Scalars['LocalDateTime']['output']>;
  pourTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  pourTypId: Scalars['Int']['output'];
  pourType: PourType;
  priorityCode?: Maybe<Scalars['String']['output']>;
  raptorJobInfo?: Maybe<RaptorJobInformation>;
  raptorJobName?: Maybe<RaptorJobName>;
  reportDay?: Maybe<Scalars['String']['output']>;
  reportMonth?: Maybe<Scalars['String']['output']>;
  reportQuarter?: Maybe<Scalars['String']['output']>;
  reportWeek?: Maybe<Scalars['String']['output']>;
  reportYear?: Maybe<Scalars['String']['output']>;
  requestSiteId?: Maybe<Scalars['Int']['output']>;
  revDate: Scalars['Date']['output'];
  rmxid?: Maybe<Scalars['Int']['output']>;
  salesman2: Employee;
  salesmanId2: Scalars['Int']['output'];
  showUpTime?: Maybe<Scalars['LocalDateTime']['output']>;
  showUpTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  sizeReq: Scalars['Int']['output'];
  sizeRequested: EquipmentSize;
  specialFlag?: Maybe<Scalars['Int']['output']>;
  specialFlag2?: Maybe<Scalars['Int']['output']>;
  specialFlag3?: Maybe<Scalars['Int']['output']>;
  status: JobStatus;
  statusUpdateMethod: Scalars['Int']['output'];
  ud1?: Maybe<Scalars['String']['output']>;
  update: ResultOfPourForAdding;
  updatedBy: Scalars['Int']['output'];
  updatedByEmployee: Employee;
  vendor: Supplier;
  whoCanceled?: Maybe<Scalars['String']['output']>;
  whyCncld?: Maybe<Scalars['String']['output']>;
  yardId: Scalars['Int']['output'];
};

export type PourForAddingUpdateArgs = {
  dispId: Scalars['Int']['input'];
  jobId: Scalars['Int']['input'];
};

export type PourForAddingFilterInput = {
  and?: InputMaybe<Array<PourForAddingFilterInput>>;
  bldgLot?: InputMaybe<StringOperationFilterInput>;
  callTime?: InputMaybe<DateTimeOperationFilterInput>;
  caller?: InputMaybe<StringOperationFilterInput>;
  callerContactPersonId?: InputMaybe<IntOperationFilterInput>;
  cancelDate?: InputMaybe<DateTimeOperationFilterInput>;
  cancelable?: InputMaybe<RaptorCancelableJobVwFilterInput>;
  canceledBy?: InputMaybe<StringOperationFilterInput>;
  checkListId?: InputMaybe<IntOperationFilterInput>;
  clearTime?: InputMaybe<DateTimeOperationFilterInput>;
  confBy?: InputMaybe<StringOperationFilterInput>;
  confTime?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<IntOperationFilterInput>;
  createdByEmployee?: InputMaybe<EmployeeFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  crews?: InputMaybe<ListFilterInputTypeOfCrewFilterInput>;
  cusId?: InputMaybe<IntOperationFilterInput>;
  customField1?: InputMaybe<StringOperationFilterInput>;
  customField2?: InputMaybe<StringOperationFilterInput>;
  customField3?: InputMaybe<StringOperationFilterInput>;
  customField4?: InputMaybe<StringOperationFilterInput>;
  customField5?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerInvoices?: InputMaybe<ListFilterInputTypeOfCustomerInvoiceFilterInput>;
  customerWithContacts?: InputMaybe<RaptorCustomerWithContactsFilterInput>;
  deletable?: InputMaybe<BooleanOperationFilterInput>;
  dispId?: InputMaybe<IntOperationFilterInput>;
  dispatchLocId?: InputMaybe<IntOperationFilterInput>;
  dispatchLocation?: InputMaybe<BizObjectFilterInput>;
  dispatcher?: InputMaybe<EmployeeFilterInput>;
  displayTimeZone?: InputMaybe<StringOperationFilterInput>;
  endDate?: InputMaybe<DateOperationFilterInput>;
  equipment?: InputMaybe<EquipmentFilterInput>;
  equipmentId?: InputMaybe<IntOperationFilterInput>;
  equipments?: InputMaybe<ListFilterInputTypeOfEquipmentFilterInput>;
  estArea?: InputMaybe<FloatOperationFilterInput>;
  estDuration?: InputMaybe<FloatOperationFilterInput>;
  estYards?: InputMaybe<FloatOperationFilterInput>;
  extraSys?: InputMaybe<StringOperationFilterInput>;
  flag1?: InputMaybe<BizObjectFilterInput>;
  flag2?: InputMaybe<BizObjectFilterInput>;
  flag3?: InputMaybe<BizObjectFilterInput>;
  geofenceLeftJob?: InputMaybe<DateTimeOperationFilterInput>;
  geofenceLeftYard?: InputMaybe<DateTimeOperationFilterInput>;
  geofenceOnJob?: InputMaybe<DateTimeOperationFilterInput>;
  geofenceReturned?: InputMaybe<DateTimeOperationFilterInput>;
  geofenceStartTime?: InputMaybe<DateTimeOperationFilterInput>;
  geofenceStartTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
  info?: InputMaybe<StringOperationFilterInput>;
  isAcceptedByCrew?: InputMaybe<BooleanOperationFilterInput>;
  isCod?: InputMaybe<BooleanOperationFilterInput>;
  isCrewBooked?: InputMaybe<BooleanOperationFilterInput>;
  isCrewNotified?: InputMaybe<BooleanOperationFilterInput>;
  isGeofenceEnabled?: InputMaybe<BooleanOperationFilterInput>;
  isJobTime?: InputMaybe<BooleanOperationFilterInput>;
  isMoved?: InputMaybe<BooleanOperationFilterInput>;
  isMultiDay?: InputMaybe<BooleanOperationFilterInput>;
  isPowerLinePresent?: InputMaybe<BooleanOperationFilterInput>;
  isRequestStrict?: InputMaybe<BooleanOperationFilterInput>;
  job?: InputMaybe<JobSiteFilterInput>;
  jobEndTime?: InputMaybe<DateTimeOperationFilterInput>;
  jobEquipmentRequirements?: InputMaybe<RaptorJobEquipmentRequirementsFilterInput>;
  jobEstEndTime?: InputMaybe<DateTimeOperationFilterInput>;
  jobExtraSystems?: InputMaybe<ListFilterInputTypeOfEntities_V1_JobExtraSystemFilterInput>;
  jobId?: InputMaybe<IntOperationFilterInput>;
  jobStartTime?: InputMaybe<DateTimeOperationFilterInput>;
  jobTicket?: InputMaybe<JobTicketFilterInput>;
  lastChanged?: InputMaybe<DateTimeOperationFilterInput>;
  locationYard?: InputMaybe<YardFilterInput>;
  lvYdTime?: InputMaybe<DateTimeOperationFilterInput>;
  lvYdTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
  maxSize?: InputMaybe<IntOperationFilterInput>;
  maxSizeRequested?: InputMaybe<EquipmentSizeFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  oldStatus?: InputMaybe<IntOperationFilterInput>;
  onJobTime?: InputMaybe<DateTimeOperationFilterInput>;
  onJobTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<PourForAddingFilterInput>>;
  pfaStatus?: InputMaybe<IntOperationFilterInput>;
  plspotterProvider?: InputMaybe<IntOperationFilterInput>;
  ponum?: InputMaybe<StringOperationFilterInput>;
  pourDate?: InputMaybe<DateOperationFilterInput>;
  pourGuid?: InputMaybe<UuidOperationFilterInput>;
  pourId?: InputMaybe<IntOperationFilterInput>;
  pourTime?: InputMaybe<DateTimeOperationFilterInput>;
  pourTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
  pourTypId?: InputMaybe<IntOperationFilterInput>;
  pourType?: InputMaybe<PourTypeFilterInput>;
  priorityCode?: InputMaybe<StringOperationFilterInput>;
  raptorJobInfo?: InputMaybe<RaptorJobInformationFilterInput>;
  raptorJobName?: InputMaybe<RaptorJobNameFilterInput>;
  reportDay?: InputMaybe<StringOperationFilterInput>;
  reportMonth?: InputMaybe<StringOperationFilterInput>;
  reportQuarter?: InputMaybe<StringOperationFilterInput>;
  reportWeek?: InputMaybe<StringOperationFilterInput>;
  reportYear?: InputMaybe<StringOperationFilterInput>;
  requestSiteId?: InputMaybe<IntOperationFilterInput>;
  revDate?: InputMaybe<DateOperationFilterInput>;
  rmxid?: InputMaybe<IntOperationFilterInput>;
  salesman2?: InputMaybe<EmployeeFilterInput>;
  salesmanId2?: InputMaybe<IntOperationFilterInput>;
  showUpTime?: InputMaybe<DateTimeOperationFilterInput>;
  showUpTimeUtc?: InputMaybe<DateTimeOperationFilterInput>;
  sizeReq?: InputMaybe<IntOperationFilterInput>;
  sizeRequested?: InputMaybe<EquipmentSizeFilterInput>;
  specialFlag?: InputMaybe<IntOperationFilterInput>;
  specialFlag2?: InputMaybe<IntOperationFilterInput>;
  specialFlag3?: InputMaybe<IntOperationFilterInput>;
  status?: InputMaybe<JobStatusFilterInput>;
  statusUpdateMethod?: InputMaybe<IntOperationFilterInput>;
  ud1?: InputMaybe<StringOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedByEmployee?: InputMaybe<EmployeeFilterInput>;
  vendor?: InputMaybe<SupplierFilterInput>;
  whoCanceled?: InputMaybe<StringOperationFilterInput>;
  whyCncld?: InputMaybe<StringOperationFilterInput>;
  yardId?: InputMaybe<IntOperationFilterInput>;
};

export type PourForAddingSortInput = {
  bldgLot?: InputMaybe<SortEnumType>;
  callTime?: InputMaybe<SortEnumType>;
  caller?: InputMaybe<SortEnumType>;
  callerContactPersonId?: InputMaybe<SortEnumType>;
  cancelDate?: InputMaybe<SortEnumType>;
  cancelable?: InputMaybe<RaptorCancelableJobVwSortInput>;
  canceledBy?: InputMaybe<SortEnumType>;
  checkListId?: InputMaybe<SortEnumType>;
  clearTime?: InputMaybe<SortEnumType>;
  confBy?: InputMaybe<SortEnumType>;
  confTime?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdByEmployee?: InputMaybe<EmployeeSortInput>;
  createdOn?: InputMaybe<SortEnumType>;
  cusId?: InputMaybe<SortEnumType>;
  customField1?: InputMaybe<SortEnumType>;
  customField2?: InputMaybe<SortEnumType>;
  customField3?: InputMaybe<SortEnumType>;
  customField4?: InputMaybe<SortEnumType>;
  customField5?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerWithContacts?: InputMaybe<RaptorCustomerWithContactsSortInput>;
  deletable?: InputMaybe<SortEnumType>;
  dispId?: InputMaybe<SortEnumType>;
  dispatchLocId?: InputMaybe<SortEnumType>;
  dispatchLocation?: InputMaybe<BizObjectSortInput>;
  dispatcher?: InputMaybe<EmployeeSortInput>;
  displayTimeZone?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  equipment?: InputMaybe<EquipmentSortInput>;
  equipmentId?: InputMaybe<SortEnumType>;
  estArea?: InputMaybe<SortEnumType>;
  estDuration?: InputMaybe<SortEnumType>;
  estYards?: InputMaybe<SortEnumType>;
  extraSys?: InputMaybe<SortEnumType>;
  flag1?: InputMaybe<BizObjectSortInput>;
  flag2?: InputMaybe<BizObjectSortInput>;
  flag3?: InputMaybe<BizObjectSortInput>;
  geofenceLeftJob?: InputMaybe<SortEnumType>;
  geofenceLeftYard?: InputMaybe<SortEnumType>;
  geofenceOnJob?: InputMaybe<SortEnumType>;
  geofenceReturned?: InputMaybe<SortEnumType>;
  geofenceStartTime?: InputMaybe<SortEnumType>;
  geofenceStartTimeUtc?: InputMaybe<SortEnumType>;
  info?: InputMaybe<SortEnumType>;
  isAcceptedByCrew?: InputMaybe<SortEnumType>;
  isCod?: InputMaybe<SortEnumType>;
  isCrewBooked?: InputMaybe<SortEnumType>;
  isCrewNotified?: InputMaybe<SortEnumType>;
  isGeofenceEnabled?: InputMaybe<SortEnumType>;
  isJobTime?: InputMaybe<SortEnumType>;
  isMoved?: InputMaybe<SortEnumType>;
  isMultiDay?: InputMaybe<SortEnumType>;
  isPowerLinePresent?: InputMaybe<SortEnumType>;
  isRequestStrict?: InputMaybe<SortEnumType>;
  job?: InputMaybe<JobSiteSortInput>;
  jobEndTime?: InputMaybe<SortEnumType>;
  jobEquipmentRequirements?: InputMaybe<RaptorJobEquipmentRequirementsSortInput>;
  jobEstEndTime?: InputMaybe<SortEnumType>;
  jobId?: InputMaybe<SortEnumType>;
  jobStartTime?: InputMaybe<SortEnumType>;
  jobTicket?: InputMaybe<JobTicketSortInput>;
  lastChanged?: InputMaybe<SortEnumType>;
  locationYard?: InputMaybe<YardSortInput>;
  lvYdTime?: InputMaybe<SortEnumType>;
  lvYdTimeUtc?: InputMaybe<SortEnumType>;
  maxSize?: InputMaybe<SortEnumType>;
  maxSizeRequested?: InputMaybe<EquipmentSizeSortInput>;
  notes?: InputMaybe<SortEnumType>;
  oldStatus?: InputMaybe<SortEnumType>;
  onJobTime?: InputMaybe<SortEnumType>;
  onJobTimeUtc?: InputMaybe<SortEnumType>;
  pfaStatus?: InputMaybe<SortEnumType>;
  plspotterProvider?: InputMaybe<SortEnumType>;
  ponum?: InputMaybe<SortEnumType>;
  pourDate?: InputMaybe<SortEnumType>;
  pourGuid?: InputMaybe<SortEnumType>;
  pourId?: InputMaybe<SortEnumType>;
  pourTime?: InputMaybe<SortEnumType>;
  pourTimeUtc?: InputMaybe<SortEnumType>;
  pourTypId?: InputMaybe<SortEnumType>;
  pourType?: InputMaybe<PourTypeSortInput>;
  priorityCode?: InputMaybe<SortEnumType>;
  raptorJobInfo?: InputMaybe<RaptorJobInformationSortInput>;
  raptorJobName?: InputMaybe<RaptorJobNameSortInput>;
  reportDay?: InputMaybe<SortEnumType>;
  reportMonth?: InputMaybe<SortEnumType>;
  reportQuarter?: InputMaybe<SortEnumType>;
  reportWeek?: InputMaybe<SortEnumType>;
  reportYear?: InputMaybe<SortEnumType>;
  requestSiteId?: InputMaybe<SortEnumType>;
  revDate?: InputMaybe<SortEnumType>;
  rmxid?: InputMaybe<SortEnumType>;
  salesman2?: InputMaybe<EmployeeSortInput>;
  salesmanId2?: InputMaybe<SortEnumType>;
  showUpTime?: InputMaybe<SortEnumType>;
  showUpTimeUtc?: InputMaybe<SortEnumType>;
  sizeReq?: InputMaybe<SortEnumType>;
  sizeRequested?: InputMaybe<EquipmentSizeSortInput>;
  specialFlag?: InputMaybe<SortEnumType>;
  specialFlag2?: InputMaybe<SortEnumType>;
  specialFlag3?: InputMaybe<SortEnumType>;
  status?: InputMaybe<JobStatusSortInput>;
  statusUpdateMethod?: InputMaybe<SortEnumType>;
  ud1?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  updatedByEmployee?: InputMaybe<EmployeeSortInput>;
  vendor?: InputMaybe<SupplierSortInput>;
  whoCanceled?: InputMaybe<SortEnumType>;
  whyCncld?: InputMaybe<SortEnumType>;
  yardId?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type PourForAddingsCollectionSegment = {
  __typename?: 'PourForAddingsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<PourForAdding>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
};

export type PourType = {
  __typename?: 'PourType';
  categoryId: Scalars['Int']['output'];
  cboGuid?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptor?: Maybe<Scalars['String']['output']>;
  estimatedJobTime: Scalars['Decimal']['output'];
  guid?: Maybe<Scalars['String']['output']>;
  pourId: Scalars['Int']['output'];
  pours: Array<PourForAdding>;
  statusPourType?: Maybe<Scalars['Int']['output']>;
  system?: Maybe<Scalars['Boolean']['output']>;
};

export type PourTypeFilterInput = {
  and?: InputMaybe<Array<PourTypeFilterInput>>;
  categoryId?: InputMaybe<IntOperationFilterInput>;
  cboGuid?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  descriptor?: InputMaybe<StringOperationFilterInput>;
  estimatedJobTime?: InputMaybe<DecimalOperationFilterInput>;
  guid?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PourTypeFilterInput>>;
  pourId?: InputMaybe<IntOperationFilterInput>;
  pours?: InputMaybe<ListFilterInputTypeOfPourForAddingFilterInput>;
  statusPourType?: InputMaybe<IntOperationFilterInput>;
  system?: InputMaybe<BooleanOperationFilterInput>;
};

export type PourTypeSortInput = {
  categoryId?: InputMaybe<SortEnumType>;
  cboGuid?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  descriptor?: InputMaybe<SortEnumType>;
  estimatedJobTime?: InputMaybe<SortEnumType>;
  guid?: InputMaybe<SortEnumType>;
  pourId?: InputMaybe<SortEnumType>;
  statusPourType?: InputMaybe<SortEnumType>;
  system?: InputMaybe<SortEnumType>;
};

export type PricingScheme = {
  __typename?: 'PricingScheme';
  allowMasterSurchargeUpdate: Scalars['Boolean']['output'];
  allowTieredPricing: Scalars['Boolean']['output'];
  applySurchargeOnEq: Scalars['Boolean']['output'];
  applySurchargeOnLabor: Scalars['Boolean']['output'];
  applySurchargeOnLineItems: Scalars['Boolean']['output'];
  applyTaxOnSurcharge: Scalars['Boolean']['output'];
  areaChargeDescription: Scalars['String']['output'];
  billingIncrement?: Maybe<Scalars['Decimal']['output']>;
  createdBy: Scalars['Int']['output'];
  createdOn: Scalars['LocalDateTime']['output'];
  customer: Customer;
  customerWithContacts: RaptorCustomerWithContacts;
  description?: Maybe<Scalars['String']['output']>;
  eqHourlyChargeDescription: Scalars['String']['output'];
  eqHoursMin?: Maybe<Scalars['Decimal']['output']>;
  eqHoursMinAfter: Scalars['Decimal']['output'];
  eqHoursMinAfterTime?: Maybe<Scalars['LocalDateTime']['output']>;
  eqHoursMinBefore: Scalars['Decimal']['output'];
  eqHoursMinBeforeTime?: Maybe<Scalars['LocalDateTime']['output']>;
  eqSetupChargeDescription: Scalars['String']['output'];
  eqVolumeChargeDescription: Scalars['String']['output'];
  expiresOn?: Maybe<Scalars['LocalDateTime']['output']>;
  id: Scalars['Int']['output'];
  isInactive: Scalars['Boolean']['output'];
  jobSites: JobSite;
  laborOTAfterTime?: Maybe<Scalars['LocalDateTime']['output']>;
  laborOTBeforeTime?: Maybe<Scalars['LocalDateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  rowId: Scalars['UUID']['output'];
  schemeName: Scalars['String']['output'];
  surchargeDescription: Scalars['String']['output'];
  surchargePercentage?: Maybe<Scalars['Decimal']['output']>;
  typeId: Scalars['Int']['output'];
  updatedBy: Scalars['Int']['output'];
  updatedOn: Scalars['LocalDateTime']['output'];
  useCustomVersioning: Scalars['Boolean']['output'];
  useDTOnHolidays: Scalars['Boolean']['output'];
  useDTOnSundays: Scalars['Boolean']['output'];
  useDayBasedDT: Scalars['Boolean']['output'];
  useIndependentOT: Scalars['Boolean']['output'];
  useOTOnSaturdays: Scalars['Boolean']['output'];
  useOTOnSundays: Scalars['Boolean']['output'];
  usePortToPortBilling: Scalars['Boolean']['output'];
  useTimeBasedEqHoursMin: Scalars['Boolean']['output'];
  useTimeBasedOT: Scalars['Boolean']['output'];
  useTravelDT: Scalars['Boolean']['output'];
  useTravelOT: Scalars['Boolean']['output'];
};

export type PricingSchemeDto = {
  __typename?: 'PricingSchemeDto';
  id: Scalars['Int']['output'];
  schemeName: Scalars['String']['output'];
};

export type PricingSchemeDtoFilterInput = {
  and?: InputMaybe<Array<PricingSchemeDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<PricingSchemeDtoFilterInput>>;
  schemeName?: InputMaybe<StringOperationFilterInput>;
};

export type PricingSchemeDtoInput = {
  id: Scalars['Int']['input'];
  schemeName: Scalars['String']['input'];
};

export type PricingSchemeDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  schemeName?: InputMaybe<SortEnumType>;
};

export type PricingSchemeFilterInput = {
  allowMasterSurchargeUpdate?: InputMaybe<BooleanOperationFilterInput>;
  allowTieredPricing?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<PricingSchemeFilterInput>>;
  applySurchargeOnEq?: InputMaybe<BooleanOperationFilterInput>;
  applySurchargeOnLabor?: InputMaybe<BooleanOperationFilterInput>;
  applySurchargeOnLineItems?: InputMaybe<BooleanOperationFilterInput>;
  applyTaxOnSurcharge?: InputMaybe<BooleanOperationFilterInput>;
  areaChargeDescription?: InputMaybe<StringOperationFilterInput>;
  billingIncrement?: InputMaybe<DecimalOperationFilterInput>;
  createdBy?: InputMaybe<IntOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerWithContacts?: InputMaybe<RaptorCustomerWithContactsFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  eqHourlyChargeDescription?: InputMaybe<StringOperationFilterInput>;
  eqHoursMin?: InputMaybe<DecimalOperationFilterInput>;
  eqHoursMinAfter?: InputMaybe<DecimalOperationFilterInput>;
  eqHoursMinAfterTime?: InputMaybe<DateTimeOperationFilterInput>;
  eqHoursMinBefore?: InputMaybe<DecimalOperationFilterInput>;
  eqHoursMinBeforeTime?: InputMaybe<DateTimeOperationFilterInput>;
  eqSetupChargeDescription?: InputMaybe<StringOperationFilterInput>;
  eqVolumeChargeDescription?: InputMaybe<StringOperationFilterInput>;
  expiresOn?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  jobSites?: InputMaybe<JobSiteFilterInput>;
  laborOTAfterTime?: InputMaybe<DateTimeOperationFilterInput>;
  laborOTBeforeTime?: InputMaybe<DateTimeOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PricingSchemeFilterInput>>;
  rowId?: InputMaybe<UuidOperationFilterInput>;
  schemeName?: InputMaybe<StringOperationFilterInput>;
  surchargeDescription?: InputMaybe<StringOperationFilterInput>;
  surchargePercentage?: InputMaybe<DecimalOperationFilterInput>;
  typeId?: InputMaybe<IntOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
  useCustomVersioning?: InputMaybe<BooleanOperationFilterInput>;
  useDTOnHolidays?: InputMaybe<BooleanOperationFilterInput>;
  useDTOnSundays?: InputMaybe<BooleanOperationFilterInput>;
  useDayBasedDT?: InputMaybe<BooleanOperationFilterInput>;
  useIndependentOT?: InputMaybe<BooleanOperationFilterInput>;
  useOTOnSaturdays?: InputMaybe<BooleanOperationFilterInput>;
  useOTOnSundays?: InputMaybe<BooleanOperationFilterInput>;
  usePortToPortBilling?: InputMaybe<BooleanOperationFilterInput>;
  useTimeBasedEqHoursMin?: InputMaybe<BooleanOperationFilterInput>;
  useTimeBasedOT?: InputMaybe<BooleanOperationFilterInput>;
  useTravelDT?: InputMaybe<BooleanOperationFilterInput>;
  useTravelOT?: InputMaybe<BooleanOperationFilterInput>;
};

export type PricingSchemeInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  schemeName?: InputMaybe<Scalars['String']['input']>;
};

export type PricingSchemeSortInput = {
  allowMasterSurchargeUpdate?: InputMaybe<SortEnumType>;
  allowTieredPricing?: InputMaybe<SortEnumType>;
  applySurchargeOnEq?: InputMaybe<SortEnumType>;
  applySurchargeOnLabor?: InputMaybe<SortEnumType>;
  applySurchargeOnLineItems?: InputMaybe<SortEnumType>;
  applyTaxOnSurcharge?: InputMaybe<SortEnumType>;
  areaChargeDescription?: InputMaybe<SortEnumType>;
  billingIncrement?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerWithContacts?: InputMaybe<RaptorCustomerWithContactsSortInput>;
  description?: InputMaybe<SortEnumType>;
  eqHourlyChargeDescription?: InputMaybe<SortEnumType>;
  eqHoursMin?: InputMaybe<SortEnumType>;
  eqHoursMinAfter?: InputMaybe<SortEnumType>;
  eqHoursMinAfterTime?: InputMaybe<SortEnumType>;
  eqHoursMinBefore?: InputMaybe<SortEnumType>;
  eqHoursMinBeforeTime?: InputMaybe<SortEnumType>;
  eqSetupChargeDescription?: InputMaybe<SortEnumType>;
  eqVolumeChargeDescription?: InputMaybe<SortEnumType>;
  expiresOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isInactive?: InputMaybe<SortEnumType>;
  jobSites?: InputMaybe<JobSiteSortInput>;
  laborOTAfterTime?: InputMaybe<SortEnumType>;
  laborOTBeforeTime?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  rowId?: InputMaybe<SortEnumType>;
  schemeName?: InputMaybe<SortEnumType>;
  surchargeDescription?: InputMaybe<SortEnumType>;
  surchargePercentage?: InputMaybe<SortEnumType>;
  typeId?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  updatedOn?: InputMaybe<SortEnumType>;
  useCustomVersioning?: InputMaybe<SortEnumType>;
  useDTOnHolidays?: InputMaybe<SortEnumType>;
  useDTOnSundays?: InputMaybe<SortEnumType>;
  useDayBasedDT?: InputMaybe<SortEnumType>;
  useIndependentOT?: InputMaybe<SortEnumType>;
  useOTOnSaturdays?: InputMaybe<SortEnumType>;
  useOTOnSundays?: InputMaybe<SortEnumType>;
  usePortToPortBilling?: InputMaybe<SortEnumType>;
  useTimeBasedEqHoursMin?: InputMaybe<SortEnumType>;
  useTimeBasedOT?: InputMaybe<SortEnumType>;
  useTravelDT?: InputMaybe<SortEnumType>;
  useTravelOT?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type PricingSchemesCollectionSegment = {
  __typename?: 'PricingSchemesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V1_PricingSchemeDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProjectTypeDto = {
  __typename?: 'ProjectTypeDto';
  id: Scalars['Int']['output'];
  typeName: Scalars['String']['output'];
};

export type ProjectTypeDtoFilterInput = {
  and?: InputMaybe<Array<ProjectTypeDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ProjectTypeDtoFilterInput>>;
  typeName?: InputMaybe<StringOperationFilterInput>;
};

export type ProjectTypeDtoInput = {
  id: Scalars['Int']['input'];
  typeName: Scalars['String']['input'];
};

export type ProjectTypeDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  typeName?: InputMaybe<SortEnumType>;
};

export type Query = {
  __typename?: 'Query';
  accountTypes?: Maybe<AccountTypesCollectionSegment>;
  appUsers?: Maybe<AppUsersCollectionSegment>;
  availableCrewMembers?: Maybe<AvailableCrewMembersCollectionSegment>;
  availableEmployees?: Maybe<AvailableEmployeesCollectionSegment>;
  availableEquipments?: Maybe<AvailableEquipmentsCollectionSegment>;
  bizObjects?: Maybe<BizObjectsCollectionSegment>;
  cities?: Maybe<CitiesCollectionSegment>;
  contacts?: Maybe<ContactsCollectionSegment>;
  customerDetails?: Maybe<Dtos_V2_Customer_CustomerDto>;
  customerTypes?: Maybe<CustomerTypesCollectionSegment>;
  customers?: Maybe<CustomersCollectionSegment>;
  dispatchLocations?: Maybe<DispatchLocationsCollectionSegment>;
  dispatchers?: Maybe<DispatchersCollectionSegment>;
  employeeDetails: ResultOfDtos_V2_Employee_EmployeeDto;
  employees?: Maybe<EmployeesCollectionSegment>;
  equipmentClasses?: Maybe<EquipmentClassesCollectionSegment>;
  equipmentDetails: Dtos_V1_Equipment_EquipmentDto;
  equipmentMakes?: Maybe<EquipmentMakesCollectionSegment>;
  equipmentModels?: Maybe<EquipmentModelsCollectionSegment>;
  equipmentSizes?: Maybe<EquipmentSizesCollectionSegment>;
  equipmentTypes?: Maybe<EquipmentTypesCollectionSegment>;
  equipments?: Maybe<EquipmentsCollectionSegment>;
  extraSystems?: Maybe<ExtraSystemsCollectionSegment>;
  jobSites?: Maybe<JobSitesCollectionSegment>;
  jobTypes?: Maybe<JobTypesCollectionSegment>;
  jobsiteDetails?: Maybe<Dtos_V2_JobSite_JobSiteDto>;
  jobsiteTypes?: Maybe<JobsiteTypesCollectionSegment>;
  outOfServiceEquipment?: Maybe<OutOfServiceEquipmentCollectionSegment>;
  pourForAddings?: Maybe<PourForAddingsCollectionSegment>;
  pricingSchemes?: Maybe<PricingSchemesCollectionSegment>;
  raptorJobDetails: ResultOfDtos_V2_RaptorJob_RaptorJobDto;
  raptorJobSupportingDataQuery: ResultOfDtos_V2_RaptorJob_RaptorJobSupportingDataDto;
  raptorJobs?: Maybe<RaptorJobsCollectionSegment>;
  salesAgents?: Maybe<SalesAgentsCollectionSegment>;
  salesRegions?: Maybe<SalesRegionsCollectionSegment>;
  states?: Maybe<StatesCollectionSegment>;
  supportingEmployeeDataQuery: ResultOfDtos_V1_Employee_EmployeeSupportingDataDto;
  supportingEquipmentData: Dtos_V1_Equipment_EquipmentSupportingDataDto;
  terms?: Maybe<TermsCollectionSegment>;
  timeZones?: Maybe<TimeZonesCollectionSegment>;
  workLocations?: Maybe<WorkLocationsCollectionSegment>;
};

export type QueryAccountTypesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccountTypeDtoFilterInput>;
};

export type QueryAppUsersArgs = {
  order?: InputMaybe<Array<AppUserDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryAvailableCrewMembersArgs = {
  availableCrewMembersInput?: InputMaybe<Input_V2_Queries_CrewMembersInput>;
  order?: InputMaybe<Array<Dtos_V2_CrewDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V2_CrewDtoFilterInput>;
};

export type QueryAvailableEmployeesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryAvailableEquipmentsArgs = {
  availableEquipmentsInput?: InputMaybe<Input_V2_Queries_Equipment_AvailableEquipmentsInput>;
  order?: InputMaybe<Array<Dtos_V2_Equipment_EquipmentDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V2_Equipment_EquipmentDtoFilterInput>;
};

export type QueryBizObjectsArgs = {
  order?: InputMaybe<Array<BizObjectDtoSortInput>>;
  parentObjectId: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryCitiesArgs = {
  input: GetCitiesInput;
  order?: InputMaybe<Array<CityDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CityDtoFilterInput>;
};

export type QueryContactsArgs = {
  order?: InputMaybe<Array<ContactDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContactDtoFilterInput>;
};

export type QueryCustomerDetailsArgs = {
  input: GetCustomerDetailsInput;
};

export type QueryCustomerTypesArgs = {
  order?: InputMaybe<Array<CustomerTypeDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerTypeDtoFilterInput>;
};

export type QueryCustomersArgs = {
  input?: InputMaybe<GetCustomersInput>;
  order?: InputMaybe<Array<Dtos_V2_Customer_CustomerDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V2_Customer_CustomerDtoFilterInput>;
};

export type QueryDispatchLocationsArgs = {
  order?: InputMaybe<Array<Dtos_V1_DispatchLocationDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V1_DispatchLocationDtoFilterInput>;
};

export type QueryDispatchersArgs = {
  order?: InputMaybe<Array<Dtos_V2_Employee_EmployeeDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V2_Employee_EmployeeDtoFilterInput>;
};

export type QueryEmployeeDetailsArgs = {
  input: Input_V1_Queries_Employee_GetEmployeeDetailsInput;
};

export type QueryEmployeesArgs = {
  employeesInput?: InputMaybe<Input_V1_Queries_Employee_GetEmployeesInput>;
  order?: InputMaybe<Array<Dtos_V1_EmployeeDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V1_EmployeeDtoFilterInput>;
};

export type QueryEquipmentClassesArgs = {
  order?: InputMaybe<Array<Dtos_V1_EquipmentClassDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V1_EquipmentClassDtoFilterInput>;
};

export type QueryEquipmentDetailsArgs = {
  equipmentInput: Input_V1_Queries_Equipment_GetEquipmentDetailsInput;
};

export type QueryEquipmentMakesArgs = {
  order?: InputMaybe<Array<Dtos_V1_EquipmentMakeDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V1_EquipmentMakeDtoFilterInput>;
};

export type QueryEquipmentModelsArgs = {
  order?: InputMaybe<Array<Dtos_V1_EquipmentModelDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V1_EquipmentModelDtoFilterInput>;
};

export type QueryEquipmentSizesArgs = {
  order?: InputMaybe<Array<Dtos_V1_EquipmentSizeDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V1_EquipmentSizeDtoFilterInput>;
};

export type QueryEquipmentTypesArgs = {
  order?: InputMaybe<Array<Dtos_V1_EquipmentTypeDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V1_EquipmentTypeDtoFilterInput>;
};

export type QueryEquipmentsArgs = {
  equipmentsInput?: InputMaybe<Input_V1_Queries_Equipment_GetEquipmentsInput>;
  order?: InputMaybe<Array<Dtos_V1_Equipment_EquipmentDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V1_Equipment_EquipmentDtoFilterInput>;
};

export type QueryExtraSystemsArgs = {
  order?: InputMaybe<Array<Dtos_V1_ExtraSystemDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V1_ExtraSystemDtoFilterInput>;
};

export type QueryJobSitesArgs = {
  order?: InputMaybe<Array<Dtos_V2_JobSite_JobSiteDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V2_JobSite_JobSiteDtoFilterInput>;
};

export type QueryJobTypesArgs = {
  order?: InputMaybe<Array<Dtos_V2_JobTypeDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V2_JobTypeDtoFilterInput>;
};

export type QueryJobsiteDetailsArgs = {
  input: GetJobsiteDetailsInput;
};

export type QueryJobsiteTypesArgs = {
  order?: InputMaybe<Array<JobSiteTypeDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<JobSiteTypeDtoFilterInput>;
};

export type QueryOutOfServiceEquipmentArgs = {
  input?: InputMaybe<Input_V2_Queries_Equipment_GetOutOfServiceEquipmentsInput>;
  order?: InputMaybe<Array<Dtos_V2_Equipment_EquipmentOutOfServiceDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V2_Equipment_EquipmentOutOfServiceDtoFilterInput>;
};

export type QueryPourForAddingsArgs = {
  order?: InputMaybe<Array<PourForAddingSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PourForAddingFilterInput>;
};

export type QueryPricingSchemesArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V1_PricingSchemeDtoFilterInput>;
};

export type QueryRaptorJobDetailsArgs = {
  id: Scalars['Int']['input'];
};

export type QueryRaptorJobsArgs = {
  customTimezone?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  order?: InputMaybe<Array<Dtos_V2_RaptorJob_RaptorJobDtoSortInput>>;
  plannedAllocation?: InputMaybe<VolumetricPlannedAllocationInput>;
  referenceEndDate?: InputMaybe<Scalars['LocalDate']['input']>;
  referenceStartDate?: InputMaybe<Scalars['LocalDate']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V2_RaptorJob_RaptorJobDtoFilterInput>;
};

export type QuerySalesAgentsArgs = {
  order?: InputMaybe<Array<Dtos_V1_EmployeeDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V1_EmployeeDtoFilterInput>;
};

export type QuerySalesRegionsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V1_SalesRegionDtoFilterInput>;
};

export type QueryStatesArgs = {
  input: GetStatesInput;
  order?: InputMaybe<Array<StateDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StateDtoFilterInput>;
};

export type QueryTermsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V1_TermDtoFilterInput>;
};

export type QueryTimeZonesArgs = {
  order?: InputMaybe<Array<Dtos_V2_TimeZone_TimeZoneDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V2_TimeZone_TimeZoneDtoFilterInput>;
};

export type QueryWorkLocationsArgs = {
  order?: InputMaybe<Array<Dtos_V1_LocationDtoSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V1_LocationDtoFilterInput>;
};

export type RaptorAllJobsVw = {
  __typename?: 'RaptorAllJobsVw';
  calledAt?: Maybe<Scalars['LocalDateTime']['output']>;
  callerId?: Maybe<Scalars['String']['output']>;
  cancelable: Scalars['Boolean']['output'];
  cod?: Maybe<Scalars['Boolean']['output']>;
  confirmedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  confirmedBy?: Maybe<Scalars['String']['output']>;
  crewNotes?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<RaptorCustomerWithContacts>;
  customerId?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dispatchLocation?: Maybe<BizObject>;
  dispatchLocationId?: Maybe<Scalars['Int']['output']>;
  dispatcher?: Maybe<Employee>;
  dispatcherId?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  estimatedArea?: Maybe<Scalars['Float']['output']>;
  estimatedClearedTime?: Maybe<Scalars['LocalDateTime']['output']>;
  estimatedDuration?: Maybe<Scalars['Float']['output']>;
  estimatedYards?: Maybe<Scalars['Float']['output']>;
  flag1?: Maybe<Scalars['Int']['output']>;
  flag2?: Maybe<Scalars['Int']['output']>;
  flag3?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  internalNotes?: Maybe<Scalars['String']['output']>;
  jobSite?: Maybe<JobSite>;
  jobSiteId?: Maybe<Scalars['Int']['output']>;
  jobType?: Maybe<RaptorJobType>;
  jobTypeId?: Maybe<Scalars['Int']['output']>;
  legacy: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  salesAgent?: Maybe<Employee>;
  salesAgentId?: Maybe<Scalars['Int']['output']>;
  salesRegion?: Maybe<SalesRegion>;
  salesRegionId?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  ticketCount: Scalars['Int']['output'];
  tickets: Array<RaptorTicket>;
  timeZone?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Supplier>;
  vendorId?: Maybe<Scalars['Int']['output']>;
};

export type RaptorAllJobsVwFilterInput = {
  and?: InputMaybe<Array<RaptorAllJobsVwFilterInput>>;
  calledAt?: InputMaybe<DateTimeOperationFilterInput>;
  callerId?: InputMaybe<StringOperationFilterInput>;
  cancelable?: InputMaybe<BooleanOperationFilterInput>;
  cod?: InputMaybe<BooleanOperationFilterInput>;
  confirmedAt?: InputMaybe<DateTimeOperationFilterInput>;
  confirmedBy?: InputMaybe<StringOperationFilterInput>;
  crewNotes?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<RaptorCustomerWithContactsFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  dispatchLocation?: InputMaybe<BizObjectFilterInput>;
  dispatchLocationId?: InputMaybe<IntOperationFilterInput>;
  dispatcher?: InputMaybe<EmployeeFilterInput>;
  dispatcherId?: InputMaybe<IntOperationFilterInput>;
  endDate?: InputMaybe<DateOperationFilterInput>;
  estimatedArea?: InputMaybe<FloatOperationFilterInput>;
  estimatedClearedTime?: InputMaybe<DateTimeOperationFilterInput>;
  estimatedDuration?: InputMaybe<FloatOperationFilterInput>;
  estimatedYards?: InputMaybe<FloatOperationFilterInput>;
  flag1?: InputMaybe<IntOperationFilterInput>;
  flag2?: InputMaybe<IntOperationFilterInput>;
  flag3?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  internalNotes?: InputMaybe<StringOperationFilterInput>;
  jobSite?: InputMaybe<JobSiteFilterInput>;
  jobSiteId?: InputMaybe<IntOperationFilterInput>;
  jobType?: InputMaybe<RaptorJobTypeFilterInput>;
  jobTypeId?: InputMaybe<IntOperationFilterInput>;
  legacy?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RaptorAllJobsVwFilterInput>>;
  poNumber?: InputMaybe<StringOperationFilterInput>;
  salesAgent?: InputMaybe<EmployeeFilterInput>;
  salesAgentId?: InputMaybe<IntOperationFilterInput>;
  salesRegion?: InputMaybe<SalesRegionFilterInput>;
  salesRegionId?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<DateOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  ticketCount?: InputMaybe<IntOperationFilterInput>;
  tickets?: InputMaybe<ListFilterInputTypeOfRaptorTicketFilterInput>;
  timeZone?: InputMaybe<StringOperationFilterInput>;
  vendor?: InputMaybe<SupplierFilterInput>;
  vendorId?: InputMaybe<IntOperationFilterInput>;
};

export type RaptorAllJobsVwSortInput = {
  calledAt?: InputMaybe<SortEnumType>;
  callerId?: InputMaybe<SortEnumType>;
  cancelable?: InputMaybe<SortEnumType>;
  cod?: InputMaybe<SortEnumType>;
  confirmedAt?: InputMaybe<SortEnumType>;
  confirmedBy?: InputMaybe<SortEnumType>;
  crewNotes?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<RaptorCustomerWithContactsSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  dispatchLocation?: InputMaybe<BizObjectSortInput>;
  dispatchLocationId?: InputMaybe<SortEnumType>;
  dispatcher?: InputMaybe<EmployeeSortInput>;
  dispatcherId?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  estimatedArea?: InputMaybe<SortEnumType>;
  estimatedClearedTime?: InputMaybe<SortEnumType>;
  estimatedDuration?: InputMaybe<SortEnumType>;
  estimatedYards?: InputMaybe<SortEnumType>;
  flag1?: InputMaybe<SortEnumType>;
  flag2?: InputMaybe<SortEnumType>;
  flag3?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  internalNotes?: InputMaybe<SortEnumType>;
  jobSite?: InputMaybe<JobSiteSortInput>;
  jobSiteId?: InputMaybe<SortEnumType>;
  jobType?: InputMaybe<RaptorJobTypeSortInput>;
  jobTypeId?: InputMaybe<SortEnumType>;
  legacy?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  poNumber?: InputMaybe<SortEnumType>;
  salesAgent?: InputMaybe<EmployeeSortInput>;
  salesAgentId?: InputMaybe<SortEnumType>;
  salesRegion?: InputMaybe<SalesRegionSortInput>;
  salesRegionId?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  ticketCount?: InputMaybe<SortEnumType>;
  timeZone?: InputMaybe<SortEnumType>;
  vendor?: InputMaybe<SupplierSortInput>;
  vendorId?: InputMaybe<SortEnumType>;
};

export type RaptorCancelableJobVw = {
  __typename?: 'RaptorCancelableJobVW';
  hasDependencies: Scalars['Int']['output'];
  job: PourForAdding;
  pourId: Scalars['Int']['output'];
};

export type RaptorCancelableJobVwFilterInput = {
  and?: InputMaybe<Array<RaptorCancelableJobVwFilterInput>>;
  hasDependencies?: InputMaybe<IntOperationFilterInput>;
  job?: InputMaybe<PourForAddingFilterInput>;
  or?: InputMaybe<Array<RaptorCancelableJobVwFilterInput>>;
  pourId?: InputMaybe<IntOperationFilterInput>;
};

export type RaptorCancelableJobVwSortInput = {
  hasDependencies?: InputMaybe<SortEnumType>;
  job?: InputMaybe<PourForAddingSortInput>;
  pourId?: InputMaybe<SortEnumType>;
};

export type RaptorCertificateAssignmentVw = {
  __typename?: 'RaptorCertificateAssignmentVw';
  attachments: Array<AppBlobRemote>;
  certificates: RaptorCertificateVw;
  comments?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['LocalDateTime']['output'];
  employee?: Maybe<Employee>;
  equipment?: Maybe<Equipment>;
  expiresOn?: Maybe<Scalars['LocalDateTime']['output']>;
  id: Scalars['Int']['output'];
  isReminderDisabled: Scalars['Boolean']['output'];
  jobSite?: Maybe<JobSite>;
  legacyRecordId?: Maybe<Scalars['Int']['output']>;
  mapParentType: MapParentType;
  parentId: Scalars['Int']['output'];
  permitId: Scalars['Int']['output'];
  permitName: Scalars['String']['output'];
  permitNumber: Scalars['String']['output'];
  remindOn?: Maybe<Scalars['LocalDateTime']['output']>;
  reminderDisabledBy?: Maybe<Scalars['Int']['output']>;
  reminderDisabledOn?: Maybe<Scalars['LocalDateTime']['output']>;
  resourceId?: Maybe<Scalars['Int']['output']>;
  resourceName?: Maybe<Scalars['String']['output']>;
  statusId: Scalars['Int']['output'];
  updatedBy: Scalars['Int']['output'];
  updatedOn: Scalars['LocalDateTime']['output'];
  validity: Scalars['String']['output'];
};

export type RaptorCertificateAssignmentVwFilterInput = {
  and?: InputMaybe<Array<RaptorCertificateAssignmentVwFilterInput>>;
  attachments?: InputMaybe<ListFilterInputTypeOfAppBlobRemoteFilterInput>;
  certificates?: InputMaybe<RaptorCertificateVwFilterInput>;
  comments?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  employee?: InputMaybe<EmployeeFilterInput>;
  equipment?: InputMaybe<EquipmentFilterInput>;
  expiresOn?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isReminderDisabled?: InputMaybe<BooleanOperationFilterInput>;
  jobSite?: InputMaybe<JobSiteFilterInput>;
  legacyRecordId?: InputMaybe<IntOperationFilterInput>;
  mapParentType?: InputMaybe<MapParentTypeOperationFilterInput>;
  or?: InputMaybe<Array<RaptorCertificateAssignmentVwFilterInput>>;
  parentId?: InputMaybe<IntOperationFilterInput>;
  permitId?: InputMaybe<IntOperationFilterInput>;
  permitName?: InputMaybe<StringOperationFilterInput>;
  permitNumber?: InputMaybe<StringOperationFilterInput>;
  remindOn?: InputMaybe<DateTimeOperationFilterInput>;
  reminderDisabledBy?: InputMaybe<IntOperationFilterInput>;
  reminderDisabledOn?: InputMaybe<DateTimeOperationFilterInput>;
  resourceId?: InputMaybe<IntOperationFilterInput>;
  resourceName?: InputMaybe<StringOperationFilterInput>;
  statusId?: InputMaybe<IntOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
  validity?: InputMaybe<StringOperationFilterInput>;
};

export type RaptorCertificateAssignmentVwSortInput = {
  certificates?: InputMaybe<RaptorCertificateVwSortInput>;
  comments?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  employee?: InputMaybe<EmployeeSortInput>;
  equipment?: InputMaybe<EquipmentSortInput>;
  expiresOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isReminderDisabled?: InputMaybe<SortEnumType>;
  jobSite?: InputMaybe<JobSiteSortInput>;
  legacyRecordId?: InputMaybe<SortEnumType>;
  mapParentType?: InputMaybe<SortEnumType>;
  parentId?: InputMaybe<SortEnumType>;
  permitId?: InputMaybe<SortEnumType>;
  permitName?: InputMaybe<SortEnumType>;
  permitNumber?: InputMaybe<SortEnumType>;
  remindOn?: InputMaybe<SortEnumType>;
  reminderDisabledBy?: InputMaybe<SortEnumType>;
  reminderDisabledOn?: InputMaybe<SortEnumType>;
  resourceId?: InputMaybe<SortEnumType>;
  resourceName?: InputMaybe<SortEnumType>;
  statusId?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  updatedOn?: InputMaybe<SortEnumType>;
  validity?: InputMaybe<SortEnumType>;
};

export type RaptorCertificateVw = {
  __typename?: 'RaptorCertificateVw';
  active: Scalars['Boolean']['output'];
  categoryDescription?: Maybe<Scalars['String']['output']>;
  categoryId: Scalars['Int']['output'];
  categoryName: Scalars['String']['output'];
  certificatesAssignments: Array<RaptorCertificateAssignmentVw>;
  classification: Scalars['String']['output'];
  deletable: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  regionDescription?: Maybe<Scalars['String']['output']>;
  regionId?: Maybe<Scalars['Int']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  renewCycleInDays?: Maybe<Scalars['Short']['output']>;
  renewable: Scalars['Boolean']['output'];
};

export type RaptorCertificateVwFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<RaptorCertificateVwFilterInput>>;
  categoryDescription?: InputMaybe<StringOperationFilterInput>;
  categoryId?: InputMaybe<IntOperationFilterInput>;
  categoryName?: InputMaybe<StringOperationFilterInput>;
  certificatesAssignments?: InputMaybe<ListFilterInputTypeOfRaptorCertificateAssignmentVwFilterInput>;
  classification?: InputMaybe<StringOperationFilterInput>;
  deletable?: InputMaybe<BooleanOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RaptorCertificateVwFilterInput>>;
  regionDescription?: InputMaybe<StringOperationFilterInput>;
  regionId?: InputMaybe<IntOperationFilterInput>;
  regionName?: InputMaybe<StringOperationFilterInput>;
  renewCycleInDays?: InputMaybe<ShortOperationFilterInput>;
  renewable?: InputMaybe<BooleanOperationFilterInput>;
};

export type RaptorCertificateVwSortInput = {
  active?: InputMaybe<SortEnumType>;
  categoryDescription?: InputMaybe<SortEnumType>;
  categoryId?: InputMaybe<SortEnumType>;
  categoryName?: InputMaybe<SortEnumType>;
  classification?: InputMaybe<SortEnumType>;
  deletable?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  regionDescription?: InputMaybe<SortEnumType>;
  regionId?: InputMaybe<SortEnumType>;
  regionName?: InputMaybe<SortEnumType>;
  renewCycleInDays?: InputMaybe<SortEnumType>;
  renewable?: InputMaybe<SortEnumType>;
};

export type RaptorComment = {
  __typename?: 'RaptorComment';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  job: RaptorJob;
  parentId: Scalars['Int']['output'];
  postedAt: Scalars['LocalDateTime']['output'];
  postedBy: Scalars['Int']['output'];
  postedByEmployee: Employee;
  type: Scalars['Int']['output'];
};

export type RaptorCommentFilterInput = {
  and?: InputMaybe<Array<RaptorCommentFilterInput>>;
  comment?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  job?: InputMaybe<RaptorJobFilterInput>;
  or?: InputMaybe<Array<RaptorCommentFilterInput>>;
  parentId?: InputMaybe<IntOperationFilterInput>;
  postedAt?: InputMaybe<DateTimeOperationFilterInput>;
  postedBy?: InputMaybe<IntOperationFilterInput>;
  postedByEmployee?: InputMaybe<EmployeeFilterInput>;
  type?: InputMaybe<IntOperationFilterInput>;
};

export type RaptorContactInformationVw = {
  __typename?: 'RaptorContactInformationVw';
  contact: Scalars['String']['output'];
  contactOrCustomerId: Scalars['Int']['output'];
  customer: Customer;
  customerId: Scalars['Int']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  customerWithContacts: RaptorCustomerWithContacts;
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  parentTypeId: ParentContactTypeId;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type RaptorContactInformationVwFilterInput = {
  and?: InputMaybe<Array<RaptorContactInformationVwFilterInput>>;
  contact?: InputMaybe<StringOperationFilterInput>;
  contactOrCustomerId?: InputMaybe<IntOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  customerWithContacts?: InputMaybe<RaptorCustomerWithContactsFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RaptorContactInformationVwFilterInput>>;
  parentTypeId?: InputMaybe<ParentContactTypeIdOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type RaptorCrewRole = {
  __typename?: 'RaptorCrewRole';
  crewRole: RaptorJobResourceGroupRole;
  id: Scalars['Int']['output'];
  lead: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type RaptorCrewRoleFilterInput = {
  and?: InputMaybe<Array<RaptorCrewRoleFilterInput>>;
  crewRole?: InputMaybe<RaptorJobResourceGroupRoleFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  lead?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RaptorCrewRoleFilterInput>>;
};

export type RaptorCustomField = {
  __typename?: 'RaptorCustomField';
  dataType: CustomFieldDataType;
  description?: Maybe<Scalars['String']['output']>;
  fieldValues: Array<RaptorJobFieldValue>;
  id: Scalars['Int']['output'];
  jobTypeFields: Array<RaptorJobTypeField>;
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  placeholder?: Maybe<Scalars['String']['output']>;
};

export type RaptorCustomFieldFilterInput = {
  and?: InputMaybe<Array<RaptorCustomFieldFilterInput>>;
  dataType?: InputMaybe<CustomFieldDataTypeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  fieldValues?: InputMaybe<ListFilterInputTypeOfRaptorJobFieldValueFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  jobTypeFields?: InputMaybe<ListFilterInputTypeOfRaptorJobTypeFieldFilterInput>;
  label?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RaptorCustomFieldFilterInput>>;
  placeholder?: InputMaybe<StringOperationFilterInput>;
};

export type RaptorCustomerWithContacts = {
  __typename?: 'RaptorCustomerWithContacts';
  accountType?: Maybe<BizObject>;
  accountTypeId?: Maybe<Scalars['Int']['output']>;
  address?: Maybe<Address>;
  allJobs: Array<RaptorAllJobsVw>;
  allowMobileAppAccess: Scalars['Boolean']['output'];
  allowWebPortalAccess: Scalars['Boolean']['output'];
  billAddressId?: Maybe<Scalars['Int']['output']>;
  cboGuid?: Maybe<Scalars['String']['output']>;
  checkListId?: Maybe<Scalars['Int']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  contactPeople?: Maybe<Array<RaptorContactInformationVw>>;
  createdBy?: Maybe<Scalars['Int']['output']>;
  createdOn: Scalars['LocalDateTime']['output'];
  custDiscount?: Maybe<Scalars['Float']['output']>;
  customTaxRate: Scalars['Decimal']['output'];
  customerCommissionRate: Scalars['Float']['output'];
  customerSince?: Maybe<Scalars['LocalDateTime']['output']>;
  customerType?: Maybe<ContentType>;
  defaultJobPo?: Maybe<Scalars['String']['output']>;
  defaultRetentionPercentage: Scalars['Decimal']['output'];
  deletable: RaptorDeletableCustomerVw;
  emailInvoice: Scalars['Boolean']['output'];
  emailStatement: Scalars['Boolean']['output'];
  guid?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invMinOverride: Scalars['Decimal']['output'];
  isExemptFromFc: Scalars['Boolean']['output'];
  isGeofenceEnabled: Scalars['Boolean']['output'];
  isJobNumReq: Scalars['Boolean']['output'];
  isLotBldgReq: Scalars['Boolean']['output'];
  isNonTaxable: Scalars['Boolean']['output'];
  isPorequired: Scalars['Boolean']['output'];
  jobSites: Array<JobSite>;
  lastJobDate?: Maybe<Scalars['Date']['output']>;
  lastJobDateComputed?: Maybe<Scalars['Date']['output']>;
  mailAddress?: Maybe<Address>;
  mailAddressId?: Maybe<Scalars['Int']['output']>;
  maxCredit: Scalars['Decimal']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  pourForAddings: Array<PourForAdding>;
  poursCount: Scalars['Int']['output'];
  prelimed: Scalars['Int']['output'];
  preventAutoPricingVersionChangeOnJobsite: Scalars['Boolean']['output'];
  priceId?: Maybe<Scalars['Int']['output']>;
  pricingScheme?: Maybe<PricingScheme>;
  primaryAddressId?: Maybe<Scalars['Int']['output']>;
  primaryBillingContactId?: Maybe<Scalars['Int']['output']>;
  primaryContactId?: Maybe<Scalars['Int']['output']>;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryEmailId?: Maybe<Scalars['Int']['output']>;
  primaryFaxId?: Maybe<Scalars['Int']['output']>;
  primaryPhone?: Maybe<Scalars['String']['output']>;
  primaryPhoneId?: Maybe<Scalars['Int']['output']>;
  primaryWebsiteId?: Maybe<Scalars['Int']['output']>;
  salesAgent?: Maybe<Employee>;
  salesManId1?: Maybe<Scalars['Int']['output']>;
  salesRegion?: Maybe<SalesRegion>;
  salesRegionId?: Maybe<Scalars['Int']['output']>;
  statusCustomer?: Maybe<Scalars['Int']['output']>;
  subAcct?: Maybe<Scalars['String']['output']>;
  system?: Maybe<Scalars['Boolean']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Term>;
  termId1: Scalars['Int']['output'];
  typId?: Maybe<Scalars['Int']['output']>;
  ud1?: Maybe<Scalars['String']['output']>;
  ud2?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  updatedOn?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type RaptorCustomerWithContactsFilterInput = {
  accountType?: InputMaybe<BizObjectFilterInput>;
  accountTypeId?: InputMaybe<IntOperationFilterInput>;
  address?: InputMaybe<AddressFilterInput>;
  allJobs?: InputMaybe<ListFilterInputTypeOfRaptorAllJobsVwFilterInput>;
  allowMobileAppAccess?: InputMaybe<BooleanOperationFilterInput>;
  allowWebPortalAccess?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<RaptorCustomerWithContactsFilterInput>>;
  billAddressId?: InputMaybe<IntOperationFilterInput>;
  cboGuid?: InputMaybe<StringOperationFilterInput>;
  checkListId?: InputMaybe<IntOperationFilterInput>;
  companyName?: InputMaybe<StringOperationFilterInput>;
  contactPeople?: InputMaybe<ListFilterInputTypeOfRaptorContactInformationVwFilterInput>;
  createdBy?: InputMaybe<IntOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  custDiscount?: InputMaybe<FloatOperationFilterInput>;
  customTaxRate?: InputMaybe<DecimalOperationFilterInput>;
  customerCommissionRate?: InputMaybe<FloatOperationFilterInput>;
  customerSince?: InputMaybe<DateTimeOperationFilterInput>;
  customerType?: InputMaybe<ContentTypeFilterInput>;
  defaultJobPo?: InputMaybe<StringOperationFilterInput>;
  defaultRetentionPercentage?: InputMaybe<DecimalOperationFilterInput>;
  deletable?: InputMaybe<RaptorDeletableCustomerVwFilterInput>;
  emailInvoice?: InputMaybe<BooleanOperationFilterInput>;
  emailStatement?: InputMaybe<BooleanOperationFilterInput>;
  guid?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  invMinOverride?: InputMaybe<DecimalOperationFilterInput>;
  isExemptFromFc?: InputMaybe<BooleanOperationFilterInput>;
  isGeofenceEnabled?: InputMaybe<BooleanOperationFilterInput>;
  isJobNumReq?: InputMaybe<BooleanOperationFilterInput>;
  isLotBldgReq?: InputMaybe<BooleanOperationFilterInput>;
  isNonTaxable?: InputMaybe<BooleanOperationFilterInput>;
  isPorequired?: InputMaybe<BooleanOperationFilterInput>;
  jobSites?: InputMaybe<ListFilterInputTypeOfJobSiteFilterInput>;
  lastJobDate?: InputMaybe<DateOperationFilterInput>;
  lastJobDateComputed?: InputMaybe<DateOperationFilterInput>;
  mailAddress?: InputMaybe<AddressFilterInput>;
  mailAddressId?: InputMaybe<IntOperationFilterInput>;
  maxCredit?: InputMaybe<DecimalOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RaptorCustomerWithContactsFilterInput>>;
  pourForAddings?: InputMaybe<ListFilterInputTypeOfPourForAddingFilterInput>;
  poursCount?: InputMaybe<IntOperationFilterInput>;
  prelimed?: InputMaybe<IntOperationFilterInput>;
  preventAutoPricingVersionChangeOnJobsite?: InputMaybe<BooleanOperationFilterInput>;
  priceId?: InputMaybe<IntOperationFilterInput>;
  pricingScheme?: InputMaybe<PricingSchemeFilterInput>;
  primaryAddressId?: InputMaybe<IntOperationFilterInput>;
  primaryBillingContactId?: InputMaybe<IntOperationFilterInput>;
  primaryContactId?: InputMaybe<IntOperationFilterInput>;
  primaryEmail?: InputMaybe<StringOperationFilterInput>;
  primaryEmailId?: InputMaybe<IntOperationFilterInput>;
  primaryFaxId?: InputMaybe<IntOperationFilterInput>;
  primaryPhone?: InputMaybe<StringOperationFilterInput>;
  primaryPhoneId?: InputMaybe<IntOperationFilterInput>;
  primaryWebsiteId?: InputMaybe<IntOperationFilterInput>;
  salesAgent?: InputMaybe<EmployeeFilterInput>;
  salesManId1?: InputMaybe<IntOperationFilterInput>;
  salesRegion?: InputMaybe<SalesRegionFilterInput>;
  salesRegionId?: InputMaybe<IntOperationFilterInput>;
  statusCustomer?: InputMaybe<IntOperationFilterInput>;
  subAcct?: InputMaybe<StringOperationFilterInput>;
  system?: InputMaybe<BooleanOperationFilterInput>;
  taxId?: InputMaybe<StringOperationFilterInput>;
  term?: InputMaybe<TermFilterInput>;
  termId1?: InputMaybe<IntOperationFilterInput>;
  typId?: InputMaybe<IntOperationFilterInput>;
  ud1?: InputMaybe<StringOperationFilterInput>;
  ud2?: InputMaybe<StringOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type RaptorCustomerWithContactsSortInput = {
  accountType?: InputMaybe<BizObjectSortInput>;
  accountTypeId?: InputMaybe<SortEnumType>;
  address?: InputMaybe<AddressSortInput>;
  allowMobileAppAccess?: InputMaybe<SortEnumType>;
  allowWebPortalAccess?: InputMaybe<SortEnumType>;
  billAddressId?: InputMaybe<SortEnumType>;
  cboGuid?: InputMaybe<SortEnumType>;
  checkListId?: InputMaybe<SortEnumType>;
  companyName?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  custDiscount?: InputMaybe<SortEnumType>;
  customTaxRate?: InputMaybe<SortEnumType>;
  customerCommissionRate?: InputMaybe<SortEnumType>;
  customerSince?: InputMaybe<SortEnumType>;
  customerType?: InputMaybe<ContentTypeSortInput>;
  defaultJobPo?: InputMaybe<SortEnumType>;
  defaultRetentionPercentage?: InputMaybe<SortEnumType>;
  deletable?: InputMaybe<RaptorDeletableCustomerVwSortInput>;
  emailInvoice?: InputMaybe<SortEnumType>;
  emailStatement?: InputMaybe<SortEnumType>;
  guid?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  invMinOverride?: InputMaybe<SortEnumType>;
  isExemptFromFc?: InputMaybe<SortEnumType>;
  isGeofenceEnabled?: InputMaybe<SortEnumType>;
  isJobNumReq?: InputMaybe<SortEnumType>;
  isLotBldgReq?: InputMaybe<SortEnumType>;
  isNonTaxable?: InputMaybe<SortEnumType>;
  isPorequired?: InputMaybe<SortEnumType>;
  lastJobDate?: InputMaybe<SortEnumType>;
  lastJobDateComputed?: InputMaybe<SortEnumType>;
  mailAddress?: InputMaybe<AddressSortInput>;
  mailAddressId?: InputMaybe<SortEnumType>;
  maxCredit?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  poursCount?: InputMaybe<SortEnumType>;
  prelimed?: InputMaybe<SortEnumType>;
  preventAutoPricingVersionChangeOnJobsite?: InputMaybe<SortEnumType>;
  priceId?: InputMaybe<SortEnumType>;
  pricingScheme?: InputMaybe<PricingSchemeSortInput>;
  primaryAddressId?: InputMaybe<SortEnumType>;
  primaryBillingContactId?: InputMaybe<SortEnumType>;
  primaryContactId?: InputMaybe<SortEnumType>;
  primaryEmail?: InputMaybe<SortEnumType>;
  primaryEmailId?: InputMaybe<SortEnumType>;
  primaryFaxId?: InputMaybe<SortEnumType>;
  primaryPhone?: InputMaybe<SortEnumType>;
  primaryPhoneId?: InputMaybe<SortEnumType>;
  primaryWebsiteId?: InputMaybe<SortEnumType>;
  salesAgent?: InputMaybe<EmployeeSortInput>;
  salesManId1?: InputMaybe<SortEnumType>;
  salesRegion?: InputMaybe<SalesRegionSortInput>;
  salesRegionId?: InputMaybe<SortEnumType>;
  statusCustomer?: InputMaybe<SortEnumType>;
  subAcct?: InputMaybe<SortEnumType>;
  system?: InputMaybe<SortEnumType>;
  taxId?: InputMaybe<SortEnumType>;
  term?: InputMaybe<TermSortInput>;
  termId1?: InputMaybe<SortEnumType>;
  typId?: InputMaybe<SortEnumType>;
  ud1?: InputMaybe<SortEnumType>;
  ud2?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  updatedOn?: InputMaybe<SortEnumType>;
};

export type RaptorDeletableCustomerVw = {
  __typename?: 'RaptorDeletableCustomerVW';
  cusId: Scalars['Int']['output'];
  customer: RaptorCustomerWithContacts;
  hasDependencies: Scalars['Boolean']['output'];
};

export type RaptorDeletableCustomerVwFilterInput = {
  and?: InputMaybe<Array<RaptorDeletableCustomerVwFilterInput>>;
  cusId?: InputMaybe<IntOperationFilterInput>;
  customer?: InputMaybe<RaptorCustomerWithContactsFilterInput>;
  hasDependencies?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<RaptorDeletableCustomerVwFilterInput>>;
};

export type RaptorDeletableCustomerVwSortInput = {
  cusId?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<RaptorCustomerWithContactsSortInput>;
  hasDependencies?: InputMaybe<SortEnumType>;
};

export type RaptorDeletableEmployeeVw = {
  __typename?: 'RaptorDeletableEmployeeVW';
  empId: Scalars['Int']['output'];
  employee: Employee;
  hasDependencies: Scalars['Boolean']['output'];
};

export type RaptorDeletableEmployeeVwFilterInput = {
  and?: InputMaybe<Array<RaptorDeletableEmployeeVwFilterInput>>;
  empId?: InputMaybe<IntOperationFilterInput>;
  employee?: InputMaybe<EmployeeFilterInput>;
  hasDependencies?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<RaptorDeletableEmployeeVwFilterInput>>;
};

export type RaptorDeletableEmployeeVwSortInput = {
  empId?: InputMaybe<SortEnumType>;
  employee?: InputMaybe<EmployeeSortInput>;
  hasDependencies?: InputMaybe<SortEnumType>;
};

export type RaptorDeletableEquipmentVw = {
  __typename?: 'RaptorDeletableEquipmentVW';
  eqId: Scalars['Int']['output'];
  equipment: Equipment;
  hasDependencies: Scalars['Boolean']['output'];
};

export type RaptorDeletableEquipmentVwFilterInput = {
  and?: InputMaybe<Array<RaptorDeletableEquipmentVwFilterInput>>;
  eqId?: InputMaybe<IntOperationFilterInput>;
  equipment?: InputMaybe<EquipmentFilterInput>;
  hasDependencies?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<RaptorDeletableEquipmentVwFilterInput>>;
};

export type RaptorDeletableEquipmentVwSortInput = {
  eqId?: InputMaybe<SortEnumType>;
  equipment?: InputMaybe<EquipmentSortInput>;
  hasDependencies?: InputMaybe<SortEnumType>;
};

export type RaptorDeletableJobSiteVw = {
  __typename?: 'RaptorDeletableJobSiteVW';
  hasDependencies: Scalars['Boolean']['output'];
  jobId: Scalars['Int']['output'];
  jobSite: JobSite;
};

export type RaptorDeletableJobSiteVwFilterInput = {
  and?: InputMaybe<Array<RaptorDeletableJobSiteVwFilterInput>>;
  hasDependencies?: InputMaybe<BooleanOperationFilterInput>;
  jobId?: InputMaybe<IntOperationFilterInput>;
  jobSite?: InputMaybe<JobSiteFilterInput>;
  or?: InputMaybe<Array<RaptorDeletableJobSiteVwFilterInput>>;
};

export type RaptorDeletableJobSiteVwSortInput = {
  hasDependencies?: InputMaybe<SortEnumType>;
  jobId?: InputMaybe<SortEnumType>;
  jobSite?: InputMaybe<JobSiteSortInput>;
};

export type RaptorErpJobTicketsVw = {
  __typename?: 'RaptorERPJobTicketsVw';
  customerName?: Maybe<Scalars['String']['output']>;
  dispatchEndTime?: Maybe<Scalars['TimeSpan']['output']>;
  dispatchLeaveTime?: Maybe<Scalars['TimeSpan']['output']>;
  dispatchOnJobTime?: Maybe<Scalars['TimeSpan']['output']>;
  dispatchShowUpTime?: Maybe<Scalars['TimeSpan']['output']>;
  dispatchStartTime?: Maybe<Scalars['TimeSpan']['output']>;
  equipmentTicketResources: Array<RaptorTicketResourcesVw>;
  flag1Id?: Maybe<Scalars['Int']['output']>;
  flag1Name?: Maybe<Scalars['String']['output']>;
  flag2Id?: Maybe<Scalars['Int']['output']>;
  flag2Name?: Maybe<Scalars['String']['output']>;
  flag3Id?: Maybe<Scalars['Int']['output']>;
  flag3Name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  jobId?: Maybe<Scalars['Int']['output']>;
  jobType?: Maybe<Scalars['String']['output']>;
  legacy: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  postJobSignatureSignatureFileUrl?: Maybe<Scalars['String']['output']>;
  postJobSignatureSigned?: Maybe<Scalars['Boolean']['output']>;
  postJobSignatureSignedOn?: Maybe<Scalars['LocalDateTime']['output']>;
  postJobSignatureSignee?: Maybe<Scalars['String']['output']>;
  preJobSignatureSignatureFileUrl?: Maybe<Scalars['String']['output']>;
  preJobSignatureSigned?: Maybe<Scalars['Boolean']['output']>;
  preJobSignatureSignedOn?: Maybe<Scalars['LocalDateTime']['output']>;
  preJobSignatureSignee?: Maybe<Scalars['String']['output']>;
};

export type RaptorErpJobTicketsVwFilterInput = {
  and?: InputMaybe<Array<RaptorErpJobTicketsVwFilterInput>>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  dispatchEndTime?: InputMaybe<TimeSpanOperationFilterInput>;
  dispatchLeaveTime?: InputMaybe<TimeSpanOperationFilterInput>;
  dispatchOnJobTime?: InputMaybe<TimeSpanOperationFilterInput>;
  dispatchShowUpTime?: InputMaybe<TimeSpanOperationFilterInput>;
  dispatchStartTime?: InputMaybe<TimeSpanOperationFilterInput>;
  equipmentTicketResources?: InputMaybe<ListFilterInputTypeOfRaptorTicketResourcesVwFilterInput>;
  flag1Id?: InputMaybe<IntOperationFilterInput>;
  flag1Name?: InputMaybe<StringOperationFilterInput>;
  flag2Id?: InputMaybe<IntOperationFilterInput>;
  flag2Name?: InputMaybe<StringOperationFilterInput>;
  flag3Id?: InputMaybe<IntOperationFilterInput>;
  flag3Name?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  jobId?: InputMaybe<IntOperationFilterInput>;
  jobType?: InputMaybe<StringOperationFilterInput>;
  legacy?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RaptorErpJobTicketsVwFilterInput>>;
  postJobSignatureSignatureFileUrl?: InputMaybe<StringOperationFilterInput>;
  postJobSignatureSigned?: InputMaybe<BooleanOperationFilterInput>;
  postJobSignatureSignedOn?: InputMaybe<DateTimeOperationFilterInput>;
  postJobSignatureSignee?: InputMaybe<StringOperationFilterInput>;
  preJobSignatureSignatureFileUrl?: InputMaybe<StringOperationFilterInput>;
  preJobSignatureSigned?: InputMaybe<BooleanOperationFilterInput>;
  preJobSignatureSignedOn?: InputMaybe<DateTimeOperationFilterInput>;
  preJobSignatureSignee?: InputMaybe<StringOperationFilterInput>;
};

export type RaptorEmployee = {
  __typename?: 'RaptorEmployee';
  employee: Employee;
  employeeId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type RaptorEmployeeFilterInput = {
  and?: InputMaybe<Array<RaptorEmployeeFilterInput>>;
  employee?: InputMaybe<EmployeeFilterInput>;
  employeeId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<RaptorEmployeeFilterInput>>;
};

export type RaptorJob = {
  __typename?: 'RaptorJob';
  calledAt?: Maybe<Scalars['LocalDateTime']['output']>;
  callerId?: Maybe<Scalars['Int']['output']>;
  cod?: Maybe<Scalars['Boolean']['output']>;
  comments: Array<RaptorComment>;
  confirmedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  confirmedBy?: Maybe<Scalars['String']['output']>;
  contacts: Array<RaptorJobContact>;
  crewNotes?: Maybe<Scalars['String']['output']>;
  customer: Customer;
  customerId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  fieldValues: Array<RaptorJobFieldValue>;
  flag1?: Maybe<Scalars['Int']['output']>;
  flag2?: Maybe<Scalars['Int']['output']>;
  flag3?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  internalNotes?: Maybe<Scalars['String']['output']>;
  jobSite: JobSite;
  jobSiteId: Scalars['Int']['output'];
  jobType: RaptorJobType;
  jobTypeId: Scalars['Int']['output'];
  metricEstimates: Array<RaptorJobMetricEstimate>;
  name?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  salesAgent?: Maybe<Employee>;
  salesAgentId?: Maybe<Scalars['Int']['output']>;
  salesRegion?: Maybe<SalesRegion>;
  salesRegionId?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  ticketRecurrences: Array<RaptorJobTicketRecurrence>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type RaptorJobClass = {
  __typename?: 'RaptorJobClass';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  jobTypes: Array<RaptorJobType>;
  name: Scalars['String']['output'];
};

export type RaptorJobClassFilterInput = {
  and?: InputMaybe<Array<RaptorJobClassFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  jobTypes?: InputMaybe<ListFilterInputTypeOfRaptorJobTypeFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RaptorJobClassFilterInput>>;
};

export type RaptorJobClassSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type RaptorJobContact = {
  __typename?: 'RaptorJobContact';
  callerId?: Maybe<Scalars['Int']['output']>;
  confirmedById?: Maybe<Scalars['Int']['output']>;
  contact: ContactPerson;
  contactId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  job?: Maybe<RaptorJob>;
  jobId?: Maybe<Scalars['Int']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
};

export type RaptorJobContactFilterInput = {
  and?: InputMaybe<Array<RaptorJobContactFilterInput>>;
  callerId?: InputMaybe<IntOperationFilterInput>;
  confirmedById?: InputMaybe<IntOperationFilterInput>;
  contact?: InputMaybe<ContactPersonFilterInput>;
  contactId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  job?: InputMaybe<RaptorJobFilterInput>;
  jobId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<RaptorJobContactFilterInput>>;
  primary?: InputMaybe<BooleanOperationFilterInput>;
};

export type RaptorJobEquipmentRequirements = {
  __typename?: 'RaptorJobEquipmentRequirements';
  classId?: Maybe<Scalars['Int']['output']>;
  equipmentClass?: Maybe<Entities_V1_EquipmentClass>;
  equipmentType?: Maybe<EquipmentType>;
  id: Scalars['Int']['output'];
  legacyJob?: Maybe<PourForAdding>;
  legacyJobId: Scalars['Int']['output'];
  typeId?: Maybe<Scalars['Int']['output']>;
};

export type RaptorJobEquipmentRequirementsFilterInput = {
  and?: InputMaybe<Array<RaptorJobEquipmentRequirementsFilterInput>>;
  classId?: InputMaybe<IntOperationFilterInput>;
  equipmentClass?: InputMaybe<Entities_V1_EquipmentClassFilterInput>;
  equipmentType?: InputMaybe<EquipmentTypeFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  legacyJob?: InputMaybe<PourForAddingFilterInput>;
  legacyJobId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<RaptorJobEquipmentRequirementsFilterInput>>;
  typeId?: InputMaybe<IntOperationFilterInput>;
};

export type RaptorJobEquipmentRequirementsSortInput = {
  classId?: InputMaybe<SortEnumType>;
  equipmentClass?: InputMaybe<Entities_V1_EquipmentClassSortInput>;
  equipmentType?: InputMaybe<EquipmentTypeSortInput>;
  id?: InputMaybe<SortEnumType>;
  legacyJob?: InputMaybe<PourForAddingSortInput>;
  legacyJobId?: InputMaybe<SortEnumType>;
  typeId?: InputMaybe<SortEnumType>;
};

export type RaptorJobFieldValue = {
  __typename?: 'RaptorJobFieldValue';
  field: RaptorCustomField;
  fieldId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  job: RaptorJob;
  jobId: Scalars['Int']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type RaptorJobFieldValueFilterInput = {
  and?: InputMaybe<Array<RaptorJobFieldValueFilterInput>>;
  field?: InputMaybe<RaptorCustomFieldFilterInput>;
  fieldId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  job?: InputMaybe<RaptorJobFilterInput>;
  jobId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<RaptorJobFieldValueFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type RaptorJobFilterInput = {
  and?: InputMaybe<Array<RaptorJobFilterInput>>;
  calledAt?: InputMaybe<DateTimeOperationFilterInput>;
  callerId?: InputMaybe<IntOperationFilterInput>;
  cod?: InputMaybe<BooleanOperationFilterInput>;
  comments?: InputMaybe<ListFilterInputTypeOfRaptorCommentFilterInput>;
  confirmedAt?: InputMaybe<DateTimeOperationFilterInput>;
  confirmedBy?: InputMaybe<StringOperationFilterInput>;
  contacts?: InputMaybe<ListFilterInputTypeOfRaptorJobContactFilterInput>;
  crewNotes?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  endDate?: InputMaybe<DateOperationFilterInput>;
  fieldValues?: InputMaybe<ListFilterInputTypeOfRaptorJobFieldValueFilterInput>;
  flag1?: InputMaybe<IntOperationFilterInput>;
  flag2?: InputMaybe<IntOperationFilterInput>;
  flag3?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  internalNotes?: InputMaybe<StringOperationFilterInput>;
  jobSite?: InputMaybe<JobSiteFilterInput>;
  jobSiteId?: InputMaybe<IntOperationFilterInput>;
  jobType?: InputMaybe<RaptorJobTypeFilterInput>;
  jobTypeId?: InputMaybe<IntOperationFilterInput>;
  metricEstimates?: InputMaybe<ListFilterInputTypeOfRaptorJobMetricEstimateFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RaptorJobFilterInput>>;
  poNumber?: InputMaybe<StringOperationFilterInput>;
  salesAgent?: InputMaybe<EmployeeFilterInput>;
  salesAgentId?: InputMaybe<IntOperationFilterInput>;
  salesRegion?: InputMaybe<SalesRegionFilterInput>;
  salesRegionId?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<DateOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  ticketRecurrences?: InputMaybe<ListFilterInputTypeOfRaptorJobTicketRecurrenceFilterInput>;
  timeZone?: InputMaybe<StringOperationFilterInput>;
};

export type RaptorJobInformation = {
  __typename?: 'RaptorJobInformation';
  id: Scalars['Int']['output'];
  information?: Maybe<Scalars['String']['output']>;
  job?: Maybe<PourForAdding>;
};

export type RaptorJobInformationFilterInput = {
  and?: InputMaybe<Array<RaptorJobInformationFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  information?: InputMaybe<StringOperationFilterInput>;
  job?: InputMaybe<PourForAddingFilterInput>;
  or?: InputMaybe<Array<RaptorJobInformationFilterInput>>;
};

export type RaptorJobInformationSortInput = {
  id?: InputMaybe<SortEnumType>;
  information?: InputMaybe<SortEnumType>;
  job?: InputMaybe<PourForAddingSortInput>;
};

export type RaptorJobMetricEstimate = {
  __typename?: 'RaptorJobMetricEstimate';
  id: Scalars['Int']['output'];
  job: RaptorJob;
  jobId: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  type: Scalars['Byte']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type RaptorJobMetricEstimateFilterInput = {
  and?: InputMaybe<Array<RaptorJobMetricEstimateFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  job?: InputMaybe<RaptorJobFilterInput>;
  jobId?: InputMaybe<IntOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RaptorJobMetricEstimateFilterInput>>;
  type?: InputMaybe<ByteOperationFilterInput>;
  unit?: InputMaybe<StringOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type RaptorJobName = {
  __typename?: 'RaptorJobName';
  id: Scalars['Int']['output'];
  jobName?: Maybe<Scalars['String']['output']>;
  legacyJob?: Maybe<PourForAdding>;
  legacyJobId: Scalars['Int']['output'];
};

export type RaptorJobNameFilterInput = {
  and?: InputMaybe<Array<RaptorJobNameFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  jobName?: InputMaybe<StringOperationFilterInput>;
  legacyJob?: InputMaybe<PourForAddingFilterInput>;
  legacyJobId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<RaptorJobNameFilterInput>>;
};

export type RaptorJobNameSortInput = {
  id?: InputMaybe<SortEnumType>;
  jobName?: InputMaybe<SortEnumType>;
  legacyJob?: InputMaybe<PourForAddingSortInput>;
  legacyJobId?: InputMaybe<SortEnumType>;
};

export type RaptorJobResourceGroup = {
  __typename?: 'RaptorJobResourceGroup';
  addToTicket: Scalars['Boolean']['output'];
  billable: Scalars['Boolean']['output'];
  equipmentClass: Entities_V1_EquipmentClass;
  equipmentClassId: Scalars['Int']['output'];
  equipmentSize: EquipmentSize;
  equipmentSizeId: Scalars['Int']['output'];
  equipmentType: EquipmentType;
  equipmentTypeId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  jobResourceGroupEquipments: Array<RaptorJobResourceGroupEquipment>;
  parentId: Scalars['Int']['output'];
  parentType: Scalars['Short']['output'];
  raptorJobGroupItems: Array<RaptorJobResourceGroupItem>;
  raptorJobResourceGroupRoles: Array<RaptorJobResourceGroupRole>;
  raptorTicket: RaptorTicket;
  raptorTicketResourceGroups: Array<RaptorTicketResourceGroup>;
};

export type RaptorJobResourceGroupEquipment = {
  __typename?: 'RaptorJobResourceGroupEquipment';
  activityTracker: Scalars['String']['output'];
  equipmentClass?: Maybe<Entities_V1_EquipmentClass>;
  equipmentClassId?: Maybe<Scalars['Int']['output']>;
  equipmentSize?: Maybe<EquipmentSize>;
  equipmentSizeId?: Maybe<Scalars['Int']['output']>;
  equipmentType?: Maybe<EquipmentType>;
  equipmentTypeId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  jobResourceGroup: RaptorJobResourceGroup;
  jobResourceGroupId: Scalars['Int']['output'];
};

export type RaptorJobResourceGroupEquipmentFilterInput = {
  activityTracker?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<RaptorJobResourceGroupEquipmentFilterInput>>;
  equipmentClass?: InputMaybe<Entities_V1_EquipmentClassFilterInput>;
  equipmentClassId?: InputMaybe<IntOperationFilterInput>;
  equipmentSize?: InputMaybe<EquipmentSizeFilterInput>;
  equipmentSizeId?: InputMaybe<IntOperationFilterInput>;
  equipmentType?: InputMaybe<EquipmentTypeFilterInput>;
  equipmentTypeId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  jobResourceGroup?: InputMaybe<RaptorJobResourceGroupFilterInput>;
  jobResourceGroupId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<RaptorJobResourceGroupEquipmentFilterInput>>;
};

export type RaptorJobResourceGroupFilterInput = {
  addToTicket?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<RaptorJobResourceGroupFilterInput>>;
  billable?: InputMaybe<BooleanOperationFilterInput>;
  equipmentClass?: InputMaybe<Entities_V1_EquipmentClassFilterInput>;
  equipmentClassId?: InputMaybe<IntOperationFilterInput>;
  equipmentSize?: InputMaybe<EquipmentSizeFilterInput>;
  equipmentSizeId?: InputMaybe<IntOperationFilterInput>;
  equipmentType?: InputMaybe<EquipmentTypeFilterInput>;
  equipmentTypeId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  jobResourceGroupEquipments?: InputMaybe<ListFilterInputTypeOfRaptorJobResourceGroupEquipmentFilterInput>;
  or?: InputMaybe<Array<RaptorJobResourceGroupFilterInput>>;
  parentId?: InputMaybe<IntOperationFilterInput>;
  parentType?: InputMaybe<ShortOperationFilterInput>;
  raptorJobGroupItems?: InputMaybe<ListFilterInputTypeOfRaptorJobResourceGroupItemFilterInput>;
  raptorJobResourceGroupRoles?: InputMaybe<ListFilterInputTypeOfRaptorJobResourceGroupRoleFilterInput>;
  raptorTicket?: InputMaybe<RaptorTicketFilterInput>;
  raptorTicketResourceGroups?: InputMaybe<ListFilterInputTypeOfRaptorTicketResourceGroupFilterInput>;
};

export type RaptorJobResourceGroupItem = {
  __typename?: 'RaptorJobResourceGroupItem';
  id: Scalars['Int']['output'];
  item: Entities_V1_Item;
  itemId: Scalars['Int']['output'];
  raptorJobResourceGroup: RaptorJobResourceGroup;
  resourceGroupId: Scalars['Int']['output'];
};

export type RaptorJobResourceGroupItemFilterInput = {
  and?: InputMaybe<Array<RaptorJobResourceGroupItemFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  item?: InputMaybe<Entities_V1_ItemFilterInput>;
  itemId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<RaptorJobResourceGroupItemFilterInput>>;
  raptorJobResourceGroup?: InputMaybe<RaptorJobResourceGroupFilterInput>;
  resourceGroupId?: InputMaybe<IntOperationFilterInput>;
};

export type RaptorJobResourceGroupItemSortInput = {
  id?: InputMaybe<SortEnumType>;
  item?: InputMaybe<Entities_V1_ItemSortInput>;
  itemId?: InputMaybe<SortEnumType>;
  raptorJobResourceGroup?: InputMaybe<RaptorJobResourceGroupSortInput>;
  resourceGroupId?: InputMaybe<SortEnumType>;
};

export type RaptorJobResourceGroupRole = {
  __typename?: 'RaptorJobResourceGroupRole';
  crewRoleId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  raptorCrewRole: RaptorCrewRole;
  raptorJobResourceGroup: RaptorJobResourceGroup;
  resourceGroupId: Scalars['Int']['output'];
};

export type RaptorJobResourceGroupRoleFilterInput = {
  and?: InputMaybe<Array<RaptorJobResourceGroupRoleFilterInput>>;
  crewRoleId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<RaptorJobResourceGroupRoleFilterInput>>;
  raptorCrewRole?: InputMaybe<RaptorCrewRoleFilterInput>;
  raptorJobResourceGroup?: InputMaybe<RaptorJobResourceGroupFilterInput>;
  resourceGroupId?: InputMaybe<IntOperationFilterInput>;
};

export type RaptorJobResourceGroupSortInput = {
  addToTicket?: InputMaybe<SortEnumType>;
  billable?: InputMaybe<SortEnumType>;
  equipmentClass?: InputMaybe<Entities_V1_EquipmentClassSortInput>;
  equipmentClassId?: InputMaybe<SortEnumType>;
  equipmentSize?: InputMaybe<EquipmentSizeSortInput>;
  equipmentSizeId?: InputMaybe<SortEnumType>;
  equipmentType?: InputMaybe<EquipmentTypeSortInput>;
  equipmentTypeId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  parentId?: InputMaybe<SortEnumType>;
  parentType?: InputMaybe<SortEnumType>;
  raptorTicket?: InputMaybe<RaptorTicketSortInput>;
};

export type RaptorJobTicketRecurrence = {
  __typename?: 'RaptorJobTicketRecurrence';
  endDate: Scalars['Date']['output'];
  endTime?: Maybe<Scalars['TimeSpan']['output']>;
  executionDays: Scalars['Byte']['output'];
  id: Scalars['Int']['output'];
  job: RaptorJob;
  jobId: Scalars['Int']['output'];
  leaveTime?: Maybe<Scalars['TimeSpan']['output']>;
  onJobTime?: Maybe<Scalars['TimeSpan']['output']>;
  showUpTime?: Maybe<Scalars['TimeSpan']['output']>;
  startDate: Scalars['Date']['output'];
  startTime?: Maybe<Scalars['TimeSpan']['output']>;
};

export type RaptorJobTicketRecurrenceFilterInput = {
  and?: InputMaybe<Array<RaptorJobTicketRecurrenceFilterInput>>;
  endDate?: InputMaybe<DateOperationFilterInput>;
  endTime?: InputMaybe<TimeSpanOperationFilterInput>;
  executionDays?: InputMaybe<ByteOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  job?: InputMaybe<RaptorJobFilterInput>;
  jobId?: InputMaybe<IntOperationFilterInput>;
  leaveTime?: InputMaybe<TimeSpanOperationFilterInput>;
  onJobTime?: InputMaybe<TimeSpanOperationFilterInput>;
  or?: InputMaybe<Array<RaptorJobTicketRecurrenceFilterInput>>;
  showUpTime?: InputMaybe<TimeSpanOperationFilterInput>;
  startDate?: InputMaybe<DateOperationFilterInput>;
  startTime?: InputMaybe<TimeSpanOperationFilterInput>;
};

export type RaptorJobType = {
  __typename?: 'RaptorJobType';
  allJobs: Array<RaptorAllJobsVw>;
  class: RaptorJobClass;
  classId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  jobs: Array<RaptorJob>;
  name: Scalars['String']['output'];
  typeFields: Array<RaptorJobTypeField>;
};

export type RaptorJobTypeField = {
  __typename?: 'RaptorJobTypeField';
  fieldId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  jobField: RaptorCustomField;
  jobType: RaptorJobType;
  required: Scalars['Boolean']['output'];
  typeId: Scalars['Int']['output'];
};

export type RaptorJobTypeFieldFilterInput = {
  and?: InputMaybe<Array<RaptorJobTypeFieldFilterInput>>;
  fieldId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  jobField?: InputMaybe<RaptorCustomFieldFilterInput>;
  jobType?: InputMaybe<RaptorJobTypeFilterInput>;
  or?: InputMaybe<Array<RaptorJobTypeFieldFilterInput>>;
  required?: InputMaybe<BooleanOperationFilterInput>;
  typeId?: InputMaybe<IntOperationFilterInput>;
};

export type RaptorJobTypeFilterInput = {
  allJobs?: InputMaybe<ListFilterInputTypeOfRaptorAllJobsVwFilterInput>;
  and?: InputMaybe<Array<RaptorJobTypeFilterInput>>;
  class?: InputMaybe<RaptorJobClassFilterInput>;
  classId?: InputMaybe<IntOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  jobs?: InputMaybe<ListFilterInputTypeOfRaptorJobFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RaptorJobTypeFilterInput>>;
  typeFields?: InputMaybe<ListFilterInputTypeOfRaptorJobTypeFieldFilterInput>;
};

export type RaptorJobTypeSortInput = {
  class?: InputMaybe<RaptorJobClassSortInput>;
  classId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type RaptorJobsCollectionSegment = {
  __typename?: 'RaptorJobsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V2_RaptorJob_RaptorJobDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type RaptorPermitAssignmentVw = {
  __typename?: 'RaptorPermitAssignmentVw';
  attachments: Array<AppBlobRemote>;
  comments?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['LocalDateTime']['output'];
  customerId?: Maybe<Scalars['Int']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<Employee>;
  equipment?: Maybe<Equipment>;
  expiresOn?: Maybe<Scalars['LocalDateTime']['output']>;
  id: Scalars['Int']['output'];
  isReminderDisabled: Scalars['Boolean']['output'];
  jobSite?: Maybe<JobSite>;
  jobSiteAddress?: Maybe<Scalars['String']['output']>;
  jobSiteName?: Maybe<Scalars['String']['output']>;
  legacyRecordId?: Maybe<Scalars['Int']['output']>;
  mapParentType: MapParentType;
  parentId: Scalars['Int']['output'];
  permitId: Scalars['Int']['output'];
  permitName: Scalars['String']['output'];
  permitNumber: Scalars['String']['output'];
  permits: RaptorPermitVw;
  remindOn?: Maybe<Scalars['LocalDateTime']['output']>;
  reminderDisabledBy?: Maybe<Scalars['Int']['output']>;
  reminderDisabledOn?: Maybe<Scalars['LocalDateTime']['output']>;
  resourceId?: Maybe<Scalars['Int']['output']>;
  resourceName?: Maybe<Scalars['String']['output']>;
  statusId: Scalars['Int']['output'];
  updatedBy: Scalars['Int']['output'];
  updatedOn: Scalars['LocalDateTime']['output'];
  validity: Scalars['String']['output'];
};

export type RaptorPermitAssignmentVwFilterInput = {
  and?: InputMaybe<Array<RaptorPermitAssignmentVwFilterInput>>;
  attachments?: InputMaybe<ListFilterInputTypeOfAppBlobRemoteFilterInput>;
  comments?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  employee?: InputMaybe<EmployeeFilterInput>;
  equipment?: InputMaybe<EquipmentFilterInput>;
  expiresOn?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isReminderDisabled?: InputMaybe<BooleanOperationFilterInput>;
  jobSite?: InputMaybe<JobSiteFilterInput>;
  jobSiteAddress?: InputMaybe<StringOperationFilterInput>;
  jobSiteName?: InputMaybe<StringOperationFilterInput>;
  legacyRecordId?: InputMaybe<IntOperationFilterInput>;
  mapParentType?: InputMaybe<MapParentTypeOperationFilterInput>;
  or?: InputMaybe<Array<RaptorPermitAssignmentVwFilterInput>>;
  parentId?: InputMaybe<IntOperationFilterInput>;
  permitId?: InputMaybe<IntOperationFilterInput>;
  permitName?: InputMaybe<StringOperationFilterInput>;
  permitNumber?: InputMaybe<StringOperationFilterInput>;
  permits?: InputMaybe<RaptorPermitVwFilterInput>;
  remindOn?: InputMaybe<DateTimeOperationFilterInput>;
  reminderDisabledBy?: InputMaybe<IntOperationFilterInput>;
  reminderDisabledOn?: InputMaybe<DateTimeOperationFilterInput>;
  resourceId?: InputMaybe<IntOperationFilterInput>;
  resourceName?: InputMaybe<StringOperationFilterInput>;
  statusId?: InputMaybe<IntOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
  validity?: InputMaybe<StringOperationFilterInput>;
};

export type RaptorPermitAssignmentVwSortInput = {
  comments?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  customerName?: InputMaybe<SortEnumType>;
  employee?: InputMaybe<EmployeeSortInput>;
  equipment?: InputMaybe<EquipmentSortInput>;
  expiresOn?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isReminderDisabled?: InputMaybe<SortEnumType>;
  jobSite?: InputMaybe<JobSiteSortInput>;
  jobSiteAddress?: InputMaybe<SortEnumType>;
  jobSiteName?: InputMaybe<SortEnumType>;
  legacyRecordId?: InputMaybe<SortEnumType>;
  mapParentType?: InputMaybe<SortEnumType>;
  parentId?: InputMaybe<SortEnumType>;
  permitId?: InputMaybe<SortEnumType>;
  permitName?: InputMaybe<SortEnumType>;
  permitNumber?: InputMaybe<SortEnumType>;
  permits?: InputMaybe<RaptorPermitVwSortInput>;
  remindOn?: InputMaybe<SortEnumType>;
  reminderDisabledBy?: InputMaybe<SortEnumType>;
  reminderDisabledOn?: InputMaybe<SortEnumType>;
  resourceId?: InputMaybe<SortEnumType>;
  resourceName?: InputMaybe<SortEnumType>;
  statusId?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  updatedOn?: InputMaybe<SortEnumType>;
  validity?: InputMaybe<SortEnumType>;
};

export type RaptorPermitVw = {
  __typename?: 'RaptorPermitVw';
  active: Scalars['Boolean']['output'];
  categoryDescription?: Maybe<Scalars['String']['output']>;
  categoryId: Scalars['Int']['output'];
  categoryName: Scalars['String']['output'];
  deletable: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  permitsAssignments: Array<RaptorPermitAssignmentVw>;
  regionDescription?: Maybe<Scalars['String']['output']>;
  regionId?: Maybe<Scalars['Int']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  renewCycleInDays?: Maybe<Scalars['Short']['output']>;
  renewable: Scalars['Boolean']['output'];
};

export type RaptorPermitVwFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<RaptorPermitVwFilterInput>>;
  categoryDescription?: InputMaybe<StringOperationFilterInput>;
  categoryId?: InputMaybe<IntOperationFilterInput>;
  categoryName?: InputMaybe<StringOperationFilterInput>;
  deletable?: InputMaybe<BooleanOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RaptorPermitVwFilterInput>>;
  permitsAssignments?: InputMaybe<ListFilterInputTypeOfRaptorPermitAssignmentVwFilterInput>;
  regionDescription?: InputMaybe<StringOperationFilterInput>;
  regionId?: InputMaybe<IntOperationFilterInput>;
  regionName?: InputMaybe<StringOperationFilterInput>;
  renewCycleInDays?: InputMaybe<ShortOperationFilterInput>;
  renewable?: InputMaybe<BooleanOperationFilterInput>;
};

export type RaptorPermitVwSortInput = {
  active?: InputMaybe<SortEnumType>;
  categoryDescription?: InputMaybe<SortEnumType>;
  categoryId?: InputMaybe<SortEnumType>;
  categoryName?: InputMaybe<SortEnumType>;
  deletable?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  regionDescription?: InputMaybe<SortEnumType>;
  regionId?: InputMaybe<SortEnumType>;
  regionName?: InputMaybe<SortEnumType>;
  renewCycleInDays?: InputMaybe<SortEnumType>;
  renewable?: InputMaybe<SortEnumType>;
};

export type RaptorTicket = {
  __typename?: 'RaptorTicket';
  dailyNotes?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  endTime?: Maybe<Scalars['TimeSpan']['output']>;
  flag1Id?: Maybe<Scalars['Int']['output']>;
  flag2Id?: Maybe<Scalars['Int']['output']>;
  flag3Id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  items: Array<RaptorJobResourceGroup>;
  job: RaptorAllJobsVw;
  jobId: Scalars['Int']['output'];
  leaveTime?: Maybe<Scalars['TimeSpan']['output']>;
  onJobTime?: Maybe<Scalars['TimeSpan']['output']>;
  raptorTicketActivities: Array<RaptorTicketActivity>;
  resourceGroupCrew: Array<RaptorTicketResourceGroupCrew>;
  resourceGroupEquipments: Array<RaptorTicketResourceGroupEquipment>;
  showUpTime?: Maybe<Scalars['TimeSpan']['output']>;
  signatureRequired?: Maybe<Scalars['Boolean']['output']>;
  startTime?: Maybe<Scalars['TimeSpan']['output']>;
  status: RaptorTicketStatus;
  ticketName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RaptorTicketActivity = {
  __typename?: 'RaptorTicketActivity';
  activity: Scalars['Byte']['output'];
  addToTotal: Scalars['Boolean']['output'];
  endTime?: Maybe<Scalars['TimeSpan']['output']>;
  id: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  resourceGroup: RaptorTicketResourceGroup;
  resourceGroupId: Scalars['Int']['output'];
  startTime?: Maybe<Scalars['TimeSpan']['output']>;
  ticket: RaptorTicket;
  ticketId: Scalars['Int']['output'];
};

export type RaptorTicketActivityFilterInput = {
  activity?: InputMaybe<ByteOperationFilterInput>;
  addToTotal?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<RaptorTicketActivityFilterInput>>;
  endTime?: InputMaybe<TimeSpanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RaptorTicketActivityFilterInput>>;
  resourceGroup?: InputMaybe<RaptorTicketResourceGroupFilterInput>;
  resourceGroupId?: InputMaybe<IntOperationFilterInput>;
  startTime?: InputMaybe<TimeSpanOperationFilterInput>;
  ticket?: InputMaybe<RaptorTicketFilterInput>;
  ticketId?: InputMaybe<IntOperationFilterInput>;
};

export type RaptorTicketFilterInput = {
  and?: InputMaybe<Array<RaptorTicketFilterInput>>;
  dailyNotes?: InputMaybe<StringOperationFilterInput>;
  date?: InputMaybe<DateOperationFilterInput>;
  endTime?: InputMaybe<TimeSpanOperationFilterInput>;
  flag1Id?: InputMaybe<IntOperationFilterInput>;
  flag2Id?: InputMaybe<IntOperationFilterInput>;
  flag3Id?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  items?: InputMaybe<ListFilterInputTypeOfRaptorJobResourceGroupFilterInput>;
  job?: InputMaybe<RaptorAllJobsVwFilterInput>;
  jobId?: InputMaybe<IntOperationFilterInput>;
  leaveTime?: InputMaybe<TimeSpanOperationFilterInput>;
  onJobTime?: InputMaybe<TimeSpanOperationFilterInput>;
  or?: InputMaybe<Array<RaptorTicketFilterInput>>;
  raptorTicketActivities?: InputMaybe<ListFilterInputTypeOfRaptorTicketActivityFilterInput>;
  resourceGroupCrew?: InputMaybe<ListFilterInputTypeOfRaptorTicketResourceGroupCrewFilterInput>;
  resourceGroupEquipments?: InputMaybe<ListFilterInputTypeOfRaptorTicketResourceGroupEquipmentFilterInput>;
  showUpTime?: InputMaybe<TimeSpanOperationFilterInput>;
  signatureRequired?: InputMaybe<BooleanOperationFilterInput>;
  startTime?: InputMaybe<TimeSpanOperationFilterInput>;
  status?: InputMaybe<RaptorTicketStatusOperationFilterInput>;
  ticketName?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type RaptorTicketResourceGroup = {
  __typename?: 'RaptorTicketResourceGroup';
  addToTicket: Scalars['Boolean']['output'];
  billable: Scalars['Boolean']['output'];
  endTime?: Maybe<Scalars['TimeSpan']['output']>;
  id: Scalars['Int']['output'];
  jobResourceGroup: RaptorJobResourceGroup;
  jobResourceGroupId: Scalars['Int']['output'];
  leaveTime?: Maybe<Scalars['TimeSpan']['output']>;
  onJobTime?: Maybe<Scalars['TimeSpan']['output']>;
  raptorTicketActivities: Array<RaptorTicketActivity>;
  raptorTicketResourceGroupCrews: Array<RaptorTicketResourceGroupCrew>;
  raptorTicketResourceGroupEquipments: Array<RaptorTicketResourceGroupEquipment>;
  raptorTicketResourceGroupItems: Array<RaptorTicketResourceGroupItem>;
  showUpTime?: Maybe<Scalars['TimeSpan']['output']>;
  startTime?: Maybe<Scalars['TimeSpan']['output']>;
};

export type RaptorTicketResourceGroupCrew = {
  __typename?: 'RaptorTicketResourceGroupCrew';
  crew: Crew;
  crewId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  resourcesTicket: RaptorTicketResourcesVw;
  ticketResourceGroup: RaptorTicketResourceGroup;
  ticketResourceGroupId: Scalars['Int']['output'];
};

export type RaptorTicketResourceGroupCrewFilterInput = {
  and?: InputMaybe<Array<RaptorTicketResourceGroupCrewFilterInput>>;
  crew?: InputMaybe<CrewFilterInput>;
  crewId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<RaptorTicketResourceGroupCrewFilterInput>>;
  resourcesTicket?: InputMaybe<RaptorTicketResourcesVwFilterInput>;
  ticketResourceGroup?: InputMaybe<RaptorTicketResourceGroupFilterInput>;
  ticketResourceGroupId?: InputMaybe<IntOperationFilterInput>;
};

export type RaptorTicketResourceGroupEquipment = {
  __typename?: 'RaptorTicketResourceGroupEquipment';
  activityTracker: Scalars['String']['output'];
  equipment: Equipment;
  equipmentId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  resourcesTicket: RaptorTicketResourcesVw;
  ticketResourceGroup: RaptorTicketResourceGroup;
  ticketResourceGroupId: Scalars['Int']['output'];
};

export type RaptorTicketResourceGroupEquipmentFilterInput = {
  activityTracker?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<RaptorTicketResourceGroupEquipmentFilterInput>>;
  equipment?: InputMaybe<EquipmentFilterInput>;
  equipmentId?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<RaptorTicketResourceGroupEquipmentFilterInput>>;
  resourcesTicket?: InputMaybe<RaptorTicketResourcesVwFilterInput>;
  ticketResourceGroup?: InputMaybe<RaptorTicketResourceGroupFilterInput>;
  ticketResourceGroupId?: InputMaybe<IntOperationFilterInput>;
};

export type RaptorTicketResourceGroupFilterInput = {
  addToTicket?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<RaptorTicketResourceGroupFilterInput>>;
  billable?: InputMaybe<BooleanOperationFilterInput>;
  endTime?: InputMaybe<TimeSpanOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  jobResourceGroup?: InputMaybe<RaptorJobResourceGroupFilterInput>;
  jobResourceGroupId?: InputMaybe<IntOperationFilterInput>;
  leaveTime?: InputMaybe<TimeSpanOperationFilterInput>;
  onJobTime?: InputMaybe<TimeSpanOperationFilterInput>;
  or?: InputMaybe<Array<RaptorTicketResourceGroupFilterInput>>;
  raptorTicketActivities?: InputMaybe<ListFilterInputTypeOfRaptorTicketActivityFilterInput>;
  raptorTicketResourceGroupCrews?: InputMaybe<ListFilterInputTypeOfRaptorTicketResourceGroupCrewFilterInput>;
  raptorTicketResourceGroupEquipments?: InputMaybe<ListFilterInputTypeOfRaptorTicketResourceGroupEquipmentFilterInput>;
  raptorTicketResourceGroupItems?: InputMaybe<ListFilterInputTypeOfRaptorTicketResourceGroupItemFilterInput>;
  showUpTime?: InputMaybe<TimeSpanOperationFilterInput>;
  startTime?: InputMaybe<TimeSpanOperationFilterInput>;
};

export type RaptorTicketResourceGroupItem = {
  __typename?: 'RaptorTicketResourceGroupItem';
  id: Scalars['Int']['output'];
  itemId: Scalars['Int']['output'];
  ticketResourceGroup: RaptorTicketResourceGroup;
  ticketResourceGroupId: Scalars['Int']['output'];
};

export type RaptorTicketResourceGroupItemFilterInput = {
  and?: InputMaybe<Array<RaptorTicketResourceGroupItemFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  itemId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<RaptorTicketResourceGroupItemFilterInput>>;
  ticketResourceGroup?: InputMaybe<RaptorTicketResourceGroupFilterInput>;
  ticketResourceGroupId?: InputMaybe<IntOperationFilterInput>;
};

export type RaptorTicketResourcesVw = {
  __typename?: 'RaptorTicketResourcesVw';
  crews?: Maybe<Array<RaptorTicketResourceGroupCrew>>;
  equipments?: Maybe<Array<RaptorTicketResourceGroupEquipment>>;
  id: Scalars['Int']['output'];
  jobId?: Maybe<Scalars['Int']['output']>;
  parentId?: Maybe<Scalars['Int']['output']>;
  raptorERPJobTicket?: Maybe<RaptorErpJobTicketsVw>;
};

export type RaptorTicketResourcesVwFilterInput = {
  and?: InputMaybe<Array<RaptorTicketResourcesVwFilterInput>>;
  crews?: InputMaybe<ListFilterInputTypeOfRaptorTicketResourceGroupCrewFilterInput>;
  equipments?: InputMaybe<ListFilterInputTypeOfRaptorTicketResourceGroupEquipmentFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  jobId?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<RaptorTicketResourcesVwFilterInput>>;
  parentId?: InputMaybe<IntOperationFilterInput>;
  raptorERPJobTicket?: InputMaybe<RaptorErpJobTicketsVwFilterInput>;
};

export type RaptorTicketSortInput = {
  dailyNotes?: InputMaybe<SortEnumType>;
  date?: InputMaybe<SortEnumType>;
  endTime?: InputMaybe<SortEnumType>;
  flag1Id?: InputMaybe<SortEnumType>;
  flag2Id?: InputMaybe<SortEnumType>;
  flag3Id?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  job?: InputMaybe<RaptorAllJobsVwSortInput>;
  jobId?: InputMaybe<SortEnumType>;
  leaveTime?: InputMaybe<SortEnumType>;
  onJobTime?: InputMaybe<SortEnumType>;
  showUpTime?: InputMaybe<SortEnumType>;
  signatureRequired?: InputMaybe<SortEnumType>;
  startTime?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  ticketName?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export enum RaptorTicketStatus {
  Cancelled = 'CANCELLED',
  Dispatched = 'DISPATCHED',
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  NotApplicable = 'NOT_APPLICABLE',
  Pending = 'PENDING'
}

export type RaptorTicketStatusOperationFilterInput = {
  eq?: InputMaybe<RaptorTicketStatus>;
  in?: InputMaybe<Array<RaptorTicketStatus>>;
  neq?: InputMaybe<RaptorTicketStatus>;
  nin?: InputMaybe<Array<RaptorTicketStatus>>;
};

export type Result = {
  __typename?: 'Result';
  checkedError: IError;
  error?: Maybe<IError>;
  isSuccess: Scalars['Boolean']['output'];
};

export type ResultOfAppUser = {
  __typename?: 'ResultOfAppUser';
  checkedError: IError;
  error?: Maybe<IError>;
  isSuccess: Scalars['Boolean']['output'];
  value: AppUser;
  valueIfSuccess?: Maybe<AppUser>;
};

export type ResultOfCreateCustomerDto = {
  __typename?: 'ResultOfCreateCustomerDto';
  checkedError: IError;
  error?: Maybe<IError>;
  isSuccess: Scalars['Boolean']['output'];
  value: CreateCustomerDto;
  valueIfSuccess?: Maybe<CreateCustomerDto>;
};

export type ResultOfCreateJobsiteDto = {
  __typename?: 'ResultOfCreateJobsiteDto';
  checkedError: IError;
  error?: Maybe<IError>;
  isSuccess: Scalars['Boolean']['output'];
  value: CreateJobsiteDto;
  valueIfSuccess?: Maybe<CreateJobsiteDto>;
};

export type ResultOfCustomersContactsResultDto = {
  __typename?: 'ResultOfCustomersContactsResultDto';
  checkedError: IError;
  error?: Maybe<IError>;
  isSuccess: Scalars['Boolean']['output'];
  value: CustomersContactsResultDto;
  valueIfSuccess?: Maybe<CustomersContactsResultDto>;
};

export type ResultOfDtos_V1_EmployeeDto = {
  __typename?: 'ResultOfDtos_V1_EmployeeDto';
  checkedError: IError;
  error?: Maybe<IError>;
  isSuccess: Scalars['Boolean']['output'];
  value: Dtos_V1_EmployeeDto;
  valueIfSuccess?: Maybe<Dtos_V1_EmployeeDto>;
};

export type ResultOfDtos_V1_Employee_EmployeeSupportingDataDto = {
  __typename?: 'ResultOfDtos_V1_Employee_EmployeeSupportingDataDto';
  checkedError: IError;
  error?: Maybe<IError>;
  isSuccess: Scalars['Boolean']['output'];
  value: Dtos_V1_Employee_EmployeeSupportingDataDto;
  valueIfSuccess?: Maybe<Dtos_V1_Employee_EmployeeSupportingDataDto>;
};

export type ResultOfDtos_V2_Employee_EmployeeDto = {
  __typename?: 'ResultOfDtos_V2_Employee_EmployeeDto';
  checkedError: IError;
  error?: Maybe<IError>;
  isSuccess: Scalars['Boolean']['output'];
  value: Dtos_V2_Employee_EmployeeDto;
  valueIfSuccess?: Maybe<Dtos_V2_Employee_EmployeeDto>;
};

export type ResultOfDtos_V2_Equipment_EquipmentDto = {
  __typename?: 'ResultOfDtos_V2_Equipment_EquipmentDto';
  checkedError: IError;
  error?: Maybe<IError>;
  isSuccess: Scalars['Boolean']['output'];
  value: Dtos_V2_Equipment_EquipmentDto;
  valueIfSuccess?: Maybe<Dtos_V2_Equipment_EquipmentDto>;
};

export type ResultOfDtos_V2_RaptorJob_RaptorJobDto = {
  __typename?: 'ResultOfDtos_V2_RaptorJob_RaptorJobDto';
  checkedError: IError;
  error?: Maybe<IError>;
  isSuccess: Scalars['Boolean']['output'];
  value: Dtos_V2_RaptorJob_RaptorJobDto;
  valueIfSuccess?: Maybe<Dtos_V2_RaptorJob_RaptorJobDto>;
};

export type ResultOfDtos_V2_RaptorJob_RaptorJobSupportingDataDto = {
  __typename?: 'ResultOfDtos_V2_RaptorJob_RaptorJobSupportingDataDto';
  checkedError: IError;
  error?: Maybe<IError>;
  isSuccess: Scalars['Boolean']['output'];
  value: Dtos_V2_RaptorJob_RaptorJobSupportingDataDto;
  valueIfSuccess?: Maybe<Dtos_V2_RaptorJob_RaptorJobSupportingDataDto>;
};

export type ResultOfEmployee = {
  __typename?: 'ResultOfEmployee';
  checkedError: IError;
  error?: Maybe<IError>;
  isSuccess: Scalars['Boolean']['output'];
  value: Employee;
  valueIfSuccess?: Maybe<Employee>;
};

export type ResultOfPourForAdding = {
  __typename?: 'ResultOfPourForAdding';
  checkedError: IError;
  error?: Maybe<IError>;
  isSuccess: Scalars['Boolean']['output'];
  value: PourForAdding;
  valueIfSuccess?: Maybe<PourForAdding>;
};

export type SalesAgentInput = {
  empId?: InputMaybe<Scalars['Int']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
};

/** A segment of a collection. */
export type SalesAgentsCollectionSegment = {
  __typename?: 'SalesAgentsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V1_EmployeeDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type SalesRegion = {
  __typename?: 'SalesRegion';
  allJobs: Array<RaptorAllJobsVw>;
  child: Scalars['Int']['output'];
  createdOn?: Maybe<Scalars['LocalDateTime']['output']>;
  customer: Customer;
  customerWithContacts: RaptorCustomerWithContacts;
  description?: Maybe<Scalars['String']['output']>;
  gridColor?: Maybe<Scalars['Int']['output']>;
  isInactive?: Maybe<Scalars['Boolean']['output']>;
  isUsable?: Maybe<Scalars['Boolean']['output']>;
  jobSites: JobSite;
  jobs: Array<RaptorJob>;
  parentObjectID?: Maybe<Scalars['Int']['output']>;
  salesRegionId: Scalars['Int']['output'];
  salesRegionName?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  updatedOn?: Maybe<Scalars['LocalDateTime']['output']>;
};

export type SalesRegionDto = {
  __typename?: 'SalesRegionDto';
  id?: Maybe<Scalars['Int']['output']>;
  salesRegionName?: Maybe<Scalars['String']['output']>;
};

export type SalesRegionDtoFilterInput = {
  and?: InputMaybe<Array<SalesRegionDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<SalesRegionDtoFilterInput>>;
  salesRegionName?: InputMaybe<StringOperationFilterInput>;
};

export type SalesRegionDtoInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  salesRegionName?: InputMaybe<Scalars['String']['input']>;
};

export type SalesRegionDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  salesRegionName?: InputMaybe<SortEnumType>;
};

export type SalesRegionFilterInput = {
  allJobs?: InputMaybe<ListFilterInputTypeOfRaptorAllJobsVwFilterInput>;
  and?: InputMaybe<Array<SalesRegionFilterInput>>;
  child?: InputMaybe<IntOperationFilterInput>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerWithContacts?: InputMaybe<RaptorCustomerWithContactsFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  gridColor?: InputMaybe<IntOperationFilterInput>;
  isInactive?: InputMaybe<BooleanOperationFilterInput>;
  isUsable?: InputMaybe<BooleanOperationFilterInput>;
  jobSites?: InputMaybe<JobSiteFilterInput>;
  jobs?: InputMaybe<ListFilterInputTypeOfRaptorJobFilterInput>;
  or?: InputMaybe<Array<SalesRegionFilterInput>>;
  parentObjectID?: InputMaybe<IntOperationFilterInput>;
  salesRegionId?: InputMaybe<IntOperationFilterInput>;
  salesRegionName?: InputMaybe<StringOperationFilterInput>;
  sort?: InputMaybe<StringOperationFilterInput>;
  updatedBy?: InputMaybe<IntOperationFilterInput>;
  updatedOn?: InputMaybe<DateTimeOperationFilterInput>;
};

export type SalesRegionInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  salesRegionName?: InputMaybe<Scalars['String']['input']>;
};

export type SalesRegionSortInput = {
  child?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerWithContacts?: InputMaybe<RaptorCustomerWithContactsSortInput>;
  description?: InputMaybe<SortEnumType>;
  gridColor?: InputMaybe<SortEnumType>;
  isInactive?: InputMaybe<SortEnumType>;
  isUsable?: InputMaybe<SortEnumType>;
  jobSites?: InputMaybe<JobSiteSortInput>;
  parentObjectID?: InputMaybe<SortEnumType>;
  salesRegionId?: InputMaybe<SortEnumType>;
  salesRegionName?: InputMaybe<SortEnumType>;
  sort?: InputMaybe<SortEnumType>;
  updatedBy?: InputMaybe<SortEnumType>;
  updatedOn?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type SalesRegionsCollectionSegment = {
  __typename?: 'SalesRegionsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V1_SalesRegionDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type ShortOperationFilterInput = {
  eq?: InputMaybe<Scalars['Short']['input']>;
  gt?: InputMaybe<Scalars['Short']['input']>;
  gte?: InputMaybe<Scalars['Short']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Short']['input']>>>;
  lt?: InputMaybe<Scalars['Short']['input']>;
  lte?: InputMaybe<Scalars['Short']['input']>;
  neq?: InputMaybe<Scalars['Short']['input']>;
  ngt?: InputMaybe<Scalars['Short']['input']>;
  ngte?: InputMaybe<Scalars['Short']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Short']['input']>>>;
  nlt?: InputMaybe<Scalars['Short']['input']>;
  nlte?: InputMaybe<Scalars['Short']['input']>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StateDto = {
  __typename?: 'StateDto';
  abbreviation?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type StateDtoFilterInput = {
  abbreviation?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<StateDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StateDtoFilterInput>>;
};

export type StateDtoInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type StateDtoSortInput = {
  abbreviation?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type StatesCollectionSegment = {
  __typename?: 'StatesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<StateDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Supplier = {
  __typename?: 'Supplier';
  billingAddressId?: Maybe<Scalars['Int']['output']>;
  contentTypeId?: Maybe<Scalars['Int']['output']>;
  contractorJobSite: JobSite;
  id: Scalars['Int']['output'];
  isPartsSupplier: Scalars['Boolean']['output'];
  jobs?: Maybe<Array<RaptorAllJobsVw>>;
  mailAddress?: Maybe<Address>;
  mailAddressId?: Maybe<Scalars['Int']['output']>;
  mpSupplierId?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  partnerLevelId: Scalars['Int']['output'];
  primaryAddressId?: Maybe<Scalars['Int']['output']>;
  primaryBillingContactId?: Maybe<Scalars['Int']['output']>;
  primaryContactId?: Maybe<Scalars['Int']['output']>;
  primaryEmailContactSource?: Maybe<ContactSource>;
  primaryEmailId?: Maybe<Scalars['Int']['output']>;
  primaryFaxId?: Maybe<Scalars['Int']['output']>;
  primaryPhoneContactSource?: Maybe<ContactSource>;
  primaryPhoneId?: Maybe<Scalars['Int']['output']>;
  primaryWebsiteId?: Maybe<Scalars['Int']['output']>;
  readMixJobs: Array<PourForAdding>;
  readyMixJobSite: JobSite;
  rowId: Scalars['UUID']['output'];
  statusSupplier?: Maybe<Scalars['Int']['output']>;
  supplierName?: Maybe<Scalars['String']['output']>;
  system?: Maybe<Scalars['Boolean']['output']>;
  ud1?: Maybe<Scalars['String']['output']>;
  ud2?: Maybe<Scalars['String']['output']>;
};

export type SupplierDto = {
  __typename?: 'SupplierDto';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  typId?: Maybe<Scalars['Int']['output']>;
};

export type SupplierDtoFilterInput = {
  and?: InputMaybe<Array<SupplierDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SupplierDtoFilterInput>>;
  typId?: InputMaybe<IntOperationFilterInput>;
};

export type SupplierDtoInput = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  typId?: InputMaybe<Scalars['Int']['input']>;
};

export type SupplierDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  typId?: InputMaybe<SortEnumType>;
};

export type SupplierFilterInput = {
  and?: InputMaybe<Array<SupplierFilterInput>>;
  billingAddressId?: InputMaybe<IntOperationFilterInput>;
  contentTypeId?: InputMaybe<IntOperationFilterInput>;
  contractorJobSite?: InputMaybe<JobSiteFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isPartsSupplier?: InputMaybe<BooleanOperationFilterInput>;
  jobs?: InputMaybe<ListFilterInputTypeOfRaptorAllJobsVwFilterInput>;
  mailAddress?: InputMaybe<AddressFilterInput>;
  mailAddressId?: InputMaybe<IntOperationFilterInput>;
  mpSupplierId?: InputMaybe<IntOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SupplierFilterInput>>;
  partnerLevelId?: InputMaybe<IntOperationFilterInput>;
  primaryAddressId?: InputMaybe<IntOperationFilterInput>;
  primaryBillingContactId?: InputMaybe<IntOperationFilterInput>;
  primaryContactId?: InputMaybe<IntOperationFilterInput>;
  primaryEmailContactSource?: InputMaybe<ContactSourceFilterInput>;
  primaryEmailId?: InputMaybe<IntOperationFilterInput>;
  primaryFaxId?: InputMaybe<IntOperationFilterInput>;
  primaryPhoneContactSource?: InputMaybe<ContactSourceFilterInput>;
  primaryPhoneId?: InputMaybe<IntOperationFilterInput>;
  primaryWebsiteId?: InputMaybe<IntOperationFilterInput>;
  readMixJobs?: InputMaybe<ListFilterInputTypeOfPourForAddingFilterInput>;
  readyMixJobSite?: InputMaybe<JobSiteFilterInput>;
  rowId?: InputMaybe<UuidOperationFilterInput>;
  statusSupplier?: InputMaybe<IntOperationFilterInput>;
  supplierName?: InputMaybe<StringOperationFilterInput>;
  system?: InputMaybe<BooleanOperationFilterInput>;
  ud1?: InputMaybe<StringOperationFilterInput>;
  ud2?: InputMaybe<StringOperationFilterInput>;
};

export type SupplierSortInput = {
  billingAddressId?: InputMaybe<SortEnumType>;
  contentTypeId?: InputMaybe<SortEnumType>;
  contractorJobSite?: InputMaybe<JobSiteSortInput>;
  id?: InputMaybe<SortEnumType>;
  isPartsSupplier?: InputMaybe<SortEnumType>;
  mailAddress?: InputMaybe<AddressSortInput>;
  mailAddressId?: InputMaybe<SortEnumType>;
  mpSupplierId?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  partnerLevelId?: InputMaybe<SortEnumType>;
  primaryAddressId?: InputMaybe<SortEnumType>;
  primaryBillingContactId?: InputMaybe<SortEnumType>;
  primaryContactId?: InputMaybe<SortEnumType>;
  primaryEmailContactSource?: InputMaybe<ContactSourceSortInput>;
  primaryEmailId?: InputMaybe<SortEnumType>;
  primaryFaxId?: InputMaybe<SortEnumType>;
  primaryPhoneContactSource?: InputMaybe<ContactSourceSortInput>;
  primaryPhoneId?: InputMaybe<SortEnumType>;
  primaryWebsiteId?: InputMaybe<SortEnumType>;
  readyMixJobSite?: InputMaybe<JobSiteSortInput>;
  rowId?: InputMaybe<SortEnumType>;
  statusSupplier?: InputMaybe<SortEnumType>;
  supplierName?: InputMaybe<SortEnumType>;
  system?: InputMaybe<SortEnumType>;
  ud1?: InputMaybe<SortEnumType>;
  ud2?: InputMaybe<SortEnumType>;
};

export type Term = {
  __typename?: 'Term';
  customer: Customer;
  customerWithContacts: RaptorCustomerWithContacts;
  id?: Maybe<Scalars['Int']['output']>;
  isInactive?: Maybe<Scalars['Short']['output']>;
  makeTheJobCOD: Scalars['Int']['output'];
  termName?: Maybe<Scalars['String']['output']>;
};

export type TermDto = {
  __typename?: 'TermDto';
  id?: Maybe<Scalars['Int']['output']>;
  termName?: Maybe<Scalars['String']['output']>;
};

export type TermDtoFilterInput = {
  and?: InputMaybe<Array<TermDtoFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<TermDtoFilterInput>>;
  termName?: InputMaybe<StringOperationFilterInput>;
};

export type TermDtoInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  termName?: InputMaybe<Scalars['String']['input']>;
};

export type TermDtoSortInput = {
  id?: InputMaybe<SortEnumType>;
  termName?: InputMaybe<SortEnumType>;
};

export type TermFilterInput = {
  and?: InputMaybe<Array<TermFilterInput>>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerWithContacts?: InputMaybe<RaptorCustomerWithContactsFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  isInactive?: InputMaybe<ShortOperationFilterInput>;
  makeTheJobCOD?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<TermFilterInput>>;
  termName?: InputMaybe<StringOperationFilterInput>;
};

export type TermInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  termName?: InputMaybe<Scalars['String']['input']>;
};

export type TermSortInput = {
  customer?: InputMaybe<CustomerSortInput>;
  customerWithContacts?: InputMaybe<RaptorCustomerWithContactsSortInput>;
  id?: InputMaybe<SortEnumType>;
  isInactive?: InputMaybe<SortEnumType>;
  makeTheJobCOD?: InputMaybe<SortEnumType>;
  termName?: InputMaybe<SortEnumType>;
};

/** A segment of a collection. */
export type TermsCollectionSegment = {
  __typename?: 'TermsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V1_TermDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimeSpanOperationFilterInput = {
  eq?: InputMaybe<Scalars['TimeSpan']['input']>;
  gt?: InputMaybe<Scalars['TimeSpan']['input']>;
  gte?: InputMaybe<Scalars['TimeSpan']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['TimeSpan']['input']>>>;
  lt?: InputMaybe<Scalars['TimeSpan']['input']>;
  lte?: InputMaybe<Scalars['TimeSpan']['input']>;
  neq?: InputMaybe<Scalars['TimeSpan']['input']>;
  ngt?: InputMaybe<Scalars['TimeSpan']['input']>;
  ngte?: InputMaybe<Scalars['TimeSpan']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['TimeSpan']['input']>>>;
  nlt?: InputMaybe<Scalars['TimeSpan']['input']>;
  nlte?: InputMaybe<Scalars['TimeSpan']['input']>;
};

/** A segment of a collection. */
export type TimeZonesCollectionSegment = {
  __typename?: 'TimeZonesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V2_TimeZone_TimeZoneDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export enum UnavailableOperation {
  Historical = 'HISTORICAL',
  Upcoming = 'UPCOMING'
}

export type UpdateCustomerContactsMutationInput = {
  contactsToUpdate: Array<ContactDtoInput>;
  customerId: Scalars['Int']['input'];
};

export type UpdateCustomerMutationInput = {
  accountType?: InputMaybe<AccountTypeInput>;
  address?: InputMaybe<AddressDtoInput>;
  addressId?: InputMaybe<Scalars['Int']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactsToCreate?: InputMaybe<Array<ContactDtoInput>>;
  contactsToDelete?: InputMaybe<Array<Scalars['Int']['input']>>;
  contactsToUpdate?: InputMaybe<Array<ContactDtoInput>>;
  customerDiscount?: InputMaybe<Scalars['Float']['input']>;
  customerType?: InputMaybe<CustomerTypeInput>;
  id: Scalars['Int']['input'];
  maxCredit?: InputMaybe<Scalars['Decimal']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  pricingScheme?: InputMaybe<PricingSchemeInput>;
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
  salesAgent?: InputMaybe<SalesAgentInput>;
  salesRegion?: InputMaybe<SalesRegionInput>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<TermInput>;
};

export type UpdateJobSiteMutationInput = {
  address?: Scalars['String']['input'];
  city?: Scalars['String']['input'];
  customerId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  jobSiteName?: InputMaybe<Scalars['String']['input']>;
  jobSiteType?: InputMaybe<JobSiteTypeInput>;
  latitude?: Scalars['Decimal']['input'];
  longitude?: Scalars['Decimal']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  powerlinePresent?: Scalars['Boolean']['input'];
  pricingScheme?: InputMaybe<PricingSchemeInput>;
  salesAgent?: InputMaybe<SalesAgentInput>;
  salesRegion?: InputMaybe<SalesRegionInput>;
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  state?: Scalars['String']['input'];
  term?: InputMaybe<TermInput>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

export type ValidationException = {
  __typename?: 'ValidationException';
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type VendorDto = {
  __typename?: 'VendorDto';
  companyName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type VendorDtoFilterInput = {
  and?: InputMaybe<Array<VendorDtoFilterInput>>;
  companyName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<VendorDtoFilterInput>>;
};

export type VendorDtoInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type VendorDtoSortInput = {
  companyName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

export type VolumetricPlannedAllocationInput = {
  clearTime?: InputMaybe<Scalars['TimeSpan']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  estimatedArea?: InputMaybe<Scalars['Float']['input']>;
  estimatedHours?: InputMaybe<Scalars['Float']['input']>;
  estimatedVolume?: InputMaybe<Scalars['Float']['input']>;
  leaveTime?: InputMaybe<Scalars['TimeSpan']['input']>;
  onJobTime?: InputMaybe<Scalars['TimeSpan']['input']>;
  showUpTime?: InputMaybe<Scalars['TimeSpan']['input']>;
  startTime?: InputMaybe<Scalars['TimeSpan']['input']>;
};

/** A segment of a collection. */
export type WorkLocationsCollectionSegment = {
  __typename?: 'WorkLocationsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Dtos_V1_LocationDto>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type Yard = {
  __typename?: 'Yard';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  descriptor?: Maybe<Scalars['String']['output']>;
  employee: Employee;
  fax?: Maybe<Scalars['String']['output']>;
  gridColor?: Maybe<Scalars['Int']['output']>;
  isGeofenceEnabled: Scalars['Boolean']['output'];
  isInactive?: Maybe<Scalars['Int']['output']>;
  isVerifiedOnSite: Scalars['Boolean']['output'];
  isYard: Scalars['Boolean']['output'];
  latitude: Scalars['Decimal']['output'];
  longitude: Scalars['Decimal']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  pours: Array<PourForAdding>;
  rowId: Scalars['UUID']['output'];
  salesRegionId: Scalars['Int']['output'];
  state?: Maybe<Scalars['String']['output']>;
  system?: Maybe<Scalars['Boolean']['output']>;
  yardId: Scalars['Int']['output'];
  yardUserId?: Maybe<Scalars['String']['output']>;
};

export type YardFilterInput = {
  address?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<YardFilterInput>>;
  city?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  descriptor?: InputMaybe<StringOperationFilterInput>;
  employee?: InputMaybe<EmployeeFilterInput>;
  fax?: InputMaybe<StringOperationFilterInput>;
  gridColor?: InputMaybe<IntOperationFilterInput>;
  isGeofenceEnabled?: InputMaybe<BooleanOperationFilterInput>;
  isInactive?: InputMaybe<IntOperationFilterInput>;
  isVerifiedOnSite?: InputMaybe<BooleanOperationFilterInput>;
  isYard?: InputMaybe<BooleanOperationFilterInput>;
  latitude?: InputMaybe<DecimalOperationFilterInput>;
  longitude?: InputMaybe<DecimalOperationFilterInput>;
  or?: InputMaybe<Array<YardFilterInput>>;
  phone?: InputMaybe<StringOperationFilterInput>;
  postalCode?: InputMaybe<StringOperationFilterInput>;
  pours?: InputMaybe<ListFilterInputTypeOfPourForAddingFilterInput>;
  rowId?: InputMaybe<UuidOperationFilterInput>;
  salesRegionId?: InputMaybe<IntOperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  system?: InputMaybe<BooleanOperationFilterInput>;
  yardId?: InputMaybe<IntOperationFilterInput>;
  yardUserId?: InputMaybe<StringOperationFilterInput>;
};

export type YardSortInput = {
  address?: InputMaybe<SortEnumType>;
  city?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  descriptor?: InputMaybe<SortEnumType>;
  employee?: InputMaybe<EmployeeSortInput>;
  fax?: InputMaybe<SortEnumType>;
  gridColor?: InputMaybe<SortEnumType>;
  isGeofenceEnabled?: InputMaybe<SortEnumType>;
  isInactive?: InputMaybe<SortEnumType>;
  isVerifiedOnSite?: InputMaybe<SortEnumType>;
  isYard?: InputMaybe<SortEnumType>;
  latitude?: InputMaybe<SortEnumType>;
  longitude?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  postalCode?: InputMaybe<SortEnumType>;
  rowId?: InputMaybe<SortEnumType>;
  salesRegionId?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  system?: InputMaybe<SortEnumType>;
  yardId?: InputMaybe<SortEnumType>;
  yardUserId?: InputMaybe<SortEnumType>;
};

export type CreateCustomerMutationVariables = Exact<{
  customer: CreateCustomerMutationInput;
}>;

export type CreateCustomerMutation = {
  __typename?: 'Mutation';
  createCustomer: {
    __typename?: 'ResultOfCreateCustomerDto';
    isSuccess: boolean;
    value: { __typename?: 'CreateCustomerDto'; id?: number | null; companyName?: string | null };
    error?: {
      __typename?: 'Error';
      errorMessage: string;
      errorType: ErrorType;
      statusCode: number;
      validationErrors: Array<{ __typename?: 'ValidationException'; field: string; message: string }>;
    } | null;
  };
};

export type DeleteCustomerMutationVariables = Exact<{
  customerId: Scalars['Int']['input'];
}>;

export type DeleteCustomerMutation = {
  __typename?: 'Mutation';
  deleteCustomer: {
    __typename?: 'Result';
    isSuccess: boolean;
    error?: {
      __typename?: 'Error';
      errorMessage: string;
      errorType: ErrorType;
      statusCode: number;
      validationErrors: Array<{ __typename?: 'ValidationException'; field: string; message: string }>;
    } | null;
  };
};

export type UpdateCustomerMutationVariables = Exact<{
  customer: UpdateCustomerMutationInput;
}>;

export type UpdateCustomerMutation = {
  __typename?: 'Mutation';
  updateCustomer: {
    __typename?: 'Result';
    isSuccess: boolean;
    error?: {
      __typename?: 'Error';
      errorMessage: string;
      errorType: ErrorType;
      statusCode: number;
      validationErrors: Array<{ __typename?: 'ValidationException'; field: string; message: string }>;
    } | null;
  };
};

export type GetAccountTypesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAccountTypesQuery = {
  __typename?: 'Query';
  accountTypes?: {
    __typename?: 'AccountTypesCollectionSegment';
    items?: Array<{ __typename?: 'AccountTypeDto'; id: number; accountType?: string | null }> | null;
  } | null;
};

export type GetAccountTypesAutocompleteQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetAccountTypesAutocompleteQuery = {
  __typename?: 'Query';
  accountTypes?: {
    __typename?: 'AccountTypesCollectionSegment';
    totalCount: number;
    items?: Array<{ __typename?: 'AccountTypeDto'; id: number; accountType?: string | null }> | null;
  } | null;
};

export type GetCustomerQueryVariables = Exact<{
  customerId: Scalars['Int']['input'];
}>;

export type GetCustomerQuery = {
  __typename?: 'Query';
  customerDetails?: {
    __typename?: 'Dtos_V2_Customer_CustomerDto';
    id?: number | null;
    companyName?: string | null;
    primaryEmail?: string | null;
    primaryPhone?: string | null;
    deletable: boolean;
    customerStatus: CustomerStatus;
    notes?: string | null;
    taxNumber?: string | null;
    maxCredit: any;
    customerDiscount?: number | null;
    createdOn: any;
    updatedOn?: any | null;
    availableCustomerTypes?: Array<{ __typename?: 'CustomerTypeDto'; id: number; typeName: string }> | null;
    availableSalesAgents?: Array<{ __typename?: 'EmployeeDto'; empId: number; fullName: string }> | null;
    availableTerms?: Array<{ __typename?: 'Dtos_V1_TermDto'; id?: number | null; termName?: string | null }> | null;
    availablePricingSchemes?: Array<{ __typename?: 'Dtos_V1_PricingSchemeDto'; id: number; schemeName: string }> | null;
    availableSalesRegions?: Array<{ __typename?: 'Dtos_V1_SalesRegionDto'; id?: number | null; salesRegionName?: string | null }> | null;
    availableAccountTypes?: Array<{ __typename?: 'AccountTypeDto'; id: number; accountType?: string | null }> | null;
    financialSummary?: { __typename?: 'FinancialSummaryDto'; revenue?: any | null } | null;
    address?: {
      __typename?: 'AddressDto';
      address?: string | null;
      city?: string | null;
      state?: string | null;
      zipCode?: string | null;
      country?: string | null;
    } | null;
    contacts?: Array<{
      __typename?: 'ContactDto';
      id?: number | null;
      firstName?: string | null;
      lastName?: string | null;
      title?: string | null;
      contactInformation: Array<{
        __typename?: 'ContactInformationDto';
        id?: number | null;
        contact?: string | null;
        type?: string | null;
      }>;
    }> | null;
    customerType?: { __typename?: 'CustomerTypeDto'; id: number; typeName: string } | null;
    salesAgent?: { __typename?: 'EmployeeDto'; empId: number; fullName: string } | null;
    term?: { __typename?: 'TermDto'; id?: number | null; termName?: string | null } | null;
    pricingScheme?: { __typename?: 'PricingSchemeDto'; id: number; schemeName: string } | null;
    salesRegion?: { __typename?: 'SalesRegionDto'; id?: number | null; salesRegionName?: string | null } | null;
    accountType?: { __typename?: 'AccountTypeDto'; id: number; accountType?: string | null } | null;
  } | null;
};

export type CustomerContactInfoFragment = {
  __typename?: 'ContactInformationDto';
  id?: number | null;
  contact?: string | null;
  type?: string | null;
};

export type AddressInfoFragment = {
  __typename?: 'AddressDto';
  address?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  country?: string | null;
};

export type CustomerFormFieldsFragment = {
  __typename?: 'Dtos_V2_Customer_CustomerDto';
  id?: number | null;
  companyName?: string | null;
  primaryEmail?: string | null;
  primaryPhone?: string | null;
  deletable: boolean;
  customerStatus: CustomerStatus;
  notes?: string | null;
  taxNumber?: string | null;
  maxCredit: any;
  customerDiscount?: number | null;
  createdOn: any;
  updatedOn?: any | null;
  financialSummary?: { __typename?: 'FinancialSummaryDto'; revenue?: any | null } | null;
  address?: {
    __typename?: 'AddressDto';
    address?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    country?: string | null;
  } | null;
  contacts?: Array<{
    __typename?: 'ContactDto';
    id?: number | null;
    firstName?: string | null;
    lastName?: string | null;
    title?: string | null;
    contactInformation: Array<{ __typename?: 'ContactInformationDto'; id?: number | null; contact?: string | null; type?: string | null }>;
  }> | null;
  customerType?: { __typename?: 'CustomerTypeDto'; id: number; typeName: string } | null;
  salesAgent?: { __typename?: 'EmployeeDto'; empId: number; fullName: string } | null;
  term?: { __typename?: 'TermDto'; id?: number | null; termName?: string | null } | null;
  pricingScheme?: { __typename?: 'PricingSchemeDto'; id: number; schemeName: string } | null;
  salesRegion?: { __typename?: 'SalesRegionDto'; id?: number | null; salesRegionName?: string | null } | null;
  accountType?: { __typename?: 'AccountTypeDto'; id: number; accountType?: string | null } | null;
};

export type GetCustomerCallerIdQueryVariables = Exact<{
  customerId: Scalars['Int']['input'];
}>;

export type GetCustomerCallerIdQuery = {
  __typename?: 'Query';
  customerDetails?: {
    __typename?: 'Dtos_V2_Customer_CustomerDto';
    id?: number | null;
    companyName?: string | null;
    contacts?: Array<{
      __typename?: 'ContactDto';
      id?: number | null;
      firstName?: string | null;
      lastName?: string | null;
      contactInformation: Array<{
        __typename?: 'ContactInformationDto';
        id?: number | null;
        type?: string | null;
        contact?: string | null;
      }>;
    }> | null;
  } | null;
};

export type GetCustomerTypesQueryVariables = Exact<{ [key: string]: never }>;

export type GetCustomerTypesQuery = {
  __typename?: 'Query';
  customerTypes?: {
    __typename?: 'CustomerTypesCollectionSegment';
    items?: Array<{ __typename?: 'CustomerTypeDto'; id: number; typeName: string }> | null;
  } | null;
};

export type GetCustomerTypesAutocompleteQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetCustomerTypesAutocompleteQuery = {
  __typename?: 'Query';
  customerTypes?: {
    __typename?: 'CustomerTypesCollectionSegment';
    totalCount: number;
    items?: Array<{ __typename?: 'CustomerTypeDto'; id: number; typeName: string }> | null;
  } | null;
};

export type GetPricingSchemesQueryVariables = Exact<{ [key: string]: never }>;

export type GetPricingSchemesQuery = {
  __typename?: 'Query';
  pricingSchemes?: {
    __typename?: 'PricingSchemesCollectionSegment';
    items?: Array<{ __typename?: 'Dtos_V1_PricingSchemeDto'; id: number; schemeName: string }> | null;
  } | null;
};

export type GetPricingSchemesAutocompleteQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetPricingSchemesAutocompleteQuery = {
  __typename?: 'Query';
  pricingSchemes?: {
    __typename?: 'PricingSchemesCollectionSegment';
    totalCount: number;
    items?: Array<{ __typename?: 'Dtos_V1_PricingSchemeDto'; id: number; schemeName: string }> | null;
  } | null;
};

export type GetSalesAgentsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSalesAgentsQuery = {
  __typename?: 'Query';
  salesAgents?: {
    __typename?: 'SalesAgentsCollectionSegment';
    items?: Array<{ __typename?: 'Dtos_V1_EmployeeDto'; fullName?: string | null; default?: boolean | null; empId: number }> | null;
  } | null;
};

export type GetSalesAgentsAutocompleteQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetSalesAgentsAutocompleteQuery = {
  __typename?: 'Query';
  salesAgents?: {
    __typename?: 'SalesAgentsCollectionSegment';
    totalCount: number;
    items?: Array<{ __typename?: 'Dtos_V1_EmployeeDto'; id: number; fullName?: string | null; default?: boolean | null }> | null;
  } | null;
};

export type GetSalesRegionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSalesRegionsQuery = {
  __typename?: 'Query';
  salesRegions?: {
    __typename?: 'SalesRegionsCollectionSegment';
    items?: Array<{ __typename?: 'Dtos_V1_SalesRegionDto'; id?: number | null; salesRegionName?: string | null }> | null;
  } | null;
};

export type GetSalesRegionsAutocompleteQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetSalesRegionsAutocompleteQuery = {
  __typename?: 'Query';
  salesRegions?: {
    __typename?: 'SalesRegionsCollectionSegment';
    totalCount: number;
    items?: Array<{ __typename?: 'Dtos_V1_SalesRegionDto'; id?: number | null; salesRegionName?: string | null }> | null;
  } | null;
};

export type GetTermsQueryVariables = Exact<{ [key: string]: never }>;

export type GetTermsQuery = {
  __typename?: 'Query';
  terms?: {
    __typename?: 'TermsCollectionSegment';
    items?: Array<{ __typename?: 'Dtos_V1_TermDto'; id?: number | null; termName?: string | null }> | null;
  } | null;
};

export type GetTermsAutocompleteQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetTermsAutocompleteQuery = {
  __typename?: 'Query';
  terms?: {
    __typename?: 'TermsCollectionSegment';
    totalCount: number;
    items?: Array<{ __typename?: 'Dtos_V1_TermDto'; id?: number | null; termName?: string | null }> | null;
  } | null;
};

export type ListCustomersQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V2_Customer_CustomerDtoFilterInput>;
  order?: InputMaybe<Array<Dtos_V2_Customer_CustomerDtoSortInput> | Dtos_V2_Customer_CustomerDtoSortInput>;
}>;

export type ListCustomersQuery = {
  __typename?: 'Query';
  customers?: {
    __typename?: 'CustomersCollectionSegment';
    totalCount: number;
    pageInfo: { __typename?: 'CollectionSegmentInfo'; hasNextPage: boolean; hasPreviousPage: boolean };
    items?: Array<{
      __typename?: 'Dtos_V2_Customer_CustomerDto';
      id?: number | null;
      companyName?: string | null;
      primaryEmail?: string | null;
      primaryPhone?: string | null;
      deletable: boolean;
      maxCredit: any;
      customerStatus: CustomerStatus;
      createdOn: any;
      updatedOn?: any | null;
      address?: { __typename?: 'AddressDto'; address?: string | null } | null;
      financialSummary?: { __typename?: 'FinancialSummaryDto'; revenue?: any | null } | null;
      customerType?: { __typename?: 'CustomerTypeDto'; id: number; typeName: string } | null;
      salesRegion?: { __typename?: 'SalesRegionDto'; id?: number | null; salesRegionName?: string | null } | null;
      salesAgent?: { __typename?: 'EmployeeDto'; empId: number; fullName: string } | null;
    }> | null;
  } | null;
};

export type BanEmployeeMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  banType: Scalars['String']['input'];
  bannedFromId: Scalars['Int']['input'];
}>;

export type BanEmployeeMutation = {
  __typename?: 'Mutation';
  banEmployee: {
    __typename?: 'Result';
    isSuccess: boolean;
    error?: {
      __typename?: 'Error';
      errorMessage: string;
      validationErrors: Array<{ __typename?: 'ValidationException'; field: string; message: string }>;
    } | null;
  };
};

export type CreateEmployeeMutationVariables = Exact<{
  employee: Input_V1_Mutations_Employee_CreateEmployeeMutationInput;
}>;

export type CreateEmployeeMutation = {
  __typename?: 'Mutation';
  createEmployee: {
    __typename?: 'ResultOfDtos_V1_EmployeeDto';
    isSuccess: boolean;
    value: { __typename?: 'Dtos_V1_EmployeeDto'; id: number };
    error?: {
      __typename?: 'Error';
      errorMessage: string;
      errorType: ErrorType;
      statusCode: number;
      validationErrors: Array<{ __typename?: 'ValidationException'; field: string; message: string }>;
    } | null;
  };
};

export type DeleteEmployeeMutationVariables = Exact<{
  employeeId: Scalars['Int']['input'];
}>;

export type DeleteEmployeeMutation = {
  __typename?: 'Mutation';
  deleteEmployee: {
    __typename?: 'Result';
    isSuccess: boolean;
    error?: {
      __typename?: 'Error';
      errorMessage: string;
      errorType: ErrorType;
      statusCode: number;
      validationErrors: Array<{ __typename?: 'ValidationException'; field: string; message: string }>;
    } | null;
  };
};

export type CancelBanAssignmentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;

export type CancelBanAssignmentMutation = {
  __typename?: 'Mutation';
  cancelBanAssignment: {
    __typename?: 'Result';
    isSuccess: boolean;
    error?: {
      __typename?: 'Error';
      errorMessage: string;
      validationErrors: Array<{ __typename?: 'ValidationException'; field: string; message: string }>;
    } | null;
  };
};

export type UpdateEmployeeMutationVariables = Exact<{
  employee: Input_V1_Mutations_Employee_UpdateEmployeeMutationInput;
}>;

export type UpdateEmployeeMutation = {
  __typename?: 'Mutation';
  updateEmployee: {
    __typename?: 'ResultOfDtos_V1_EmployeeDto';
    isSuccess: boolean;
    value: { __typename?: 'Dtos_V1_EmployeeDto'; id: number };
    error?: {
      __typename?: 'Error';
      errorMessage: string;
      errorType: ErrorType;
      statusCode: number;
      validationErrors: Array<{ __typename?: 'ValidationException'; field: string; message: string }>;
    } | null;
  };
};

export type GetEmployeeQueryVariables = Exact<{
  employeeId: Scalars['Int']['input'];
}>;

export type GetEmployeeQuery = {
  __typename?: 'Query';
  employeeDetails: {
    __typename?: 'ResultOfDtos_V2_Employee_EmployeeDto';
    value: {
      __typename?: 'Dtos_V2_Employee_EmployeeDto';
      id: number;
      deletable?: boolean | null;
      firstName?: string | null;
      lastName?: string | null;
      employmentType?: EmploymentType | null;
      startDate?: any | null;
      endDate?: any | null;
      notes?: string | null;
      availableJobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
      availableEmploymentStatuses?: Array<{ __typename?: 'Dtos_V1_EmploymentStatusDto'; id: number; name?: string | null }> | null;
      availableDispatchLocations?: Array<{ __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null }> | null;
      availableWorkLocations?: Array<{ __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null }> | null;
      banEntries: Array<{
        __typename?: 'Dtos_V2_Employee_EmployeeBanDto';
        banType: string;
        id: number;
        createdOn: any;
        updatedOn: any;
        bannedFrom: { __typename?: 'Dtos_V2_Employee_EmployeeBannedFrom'; id: number; name: string };
        createdBy?: { __typename?: 'Dtos_V2_Employee_EmployeeDto'; id: number; name?: string | null } | null;
        updatedBy?: { __typename?: 'Dtos_V2_Employee_EmployeeDto'; id: number; name?: string | null } | null;
      }>;
      phoneNumber?: { __typename?: 'ContactInformationDto'; contact?: string | null; id?: number | null; type?: string | null } | null;
      email?: { __typename?: 'ContactInformationDto'; contact?: string | null; id?: number | null; type?: string | null } | null;
      driversLicense?: { __typename?: 'Dtos_V1_DriversLicenseDto'; number?: string | null; state?: string | null } | null;
      jobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
      employmentStatus?: { __typename?: 'Dtos_V1_EmploymentStatusDto'; id: number; name?: string | null } | null;
      dispatchLocation?: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null } | null;
      workLocation?: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null } | null;
    };
  };
};

export type EmployeeContactInfoFragment = {
  __typename?: 'ContactInformationDto';
  contact?: string | null;
  id?: number | null;
  type?: string | null;
};

export type EmployeeLocationInfoFragment = { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null };

export type EmployeeJobRoleInfoFragment = { __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null };

export type EmploymentStatusInfoFragment = { __typename?: 'Dtos_V1_EmploymentStatusDto'; id: number; name?: string | null };

export type EmployeeFormFieldsFragment = {
  __typename?: 'Dtos_V2_Employee_EmployeeDto';
  id: number;
  deletable?: boolean | null;
  firstName?: string | null;
  lastName?: string | null;
  employmentType?: EmploymentType | null;
  startDate?: any | null;
  endDate?: any | null;
  notes?: string | null;
  phoneNumber?: { __typename?: 'ContactInformationDto'; contact?: string | null; id?: number | null; type?: string | null } | null;
  email?: { __typename?: 'ContactInformationDto'; contact?: string | null; id?: number | null; type?: string | null } | null;
  driversLicense?: { __typename?: 'Dtos_V1_DriversLicenseDto'; number?: string | null; state?: string | null } | null;
  jobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
  employmentStatus?: { __typename?: 'Dtos_V1_EmploymentStatusDto'; id: number; name?: string | null } | null;
  dispatchLocation?: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null } | null;
  workLocation?: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null } | null;
};

export type GetEmployeeDetailsByIdQueryVariables = Exact<{
  input: Input_V1_Queries_Employee_GetEmployeeDetailsInput;
}>;

export type GetEmployeeDetailsByIdQuery = {
  __typename?: 'Query';
  employeeDetails: {
    __typename?: 'ResultOfDtos_V2_Employee_EmployeeDto';
    value: {
      __typename?: 'Dtos_V2_Employee_EmployeeDto';
      id: number;
      deletable?: boolean | null;
      firstName?: string | null;
      lastName?: string | null;
      employmentType?: EmploymentType | null;
      startDate?: any | null;
      endDate?: any | null;
      notes?: string | null;
      upcomingOutOfOffice?: Array<{
        __typename?: 'Dtos_V1_Employee_EmployeeOutOfOfficeDto';
        id?: number | null;
        startDate: any;
        endDate: any;
        notes?: string | null;
        employee: {
          __typename?: 'Dtos_V1_EmployeeDto';
          id: number;
          firstName?: string | null;
          lastName?: string | null;
          fullName?: string | null;
          employmentStatus?: { __typename?: 'Dtos_V1_EmploymentStatusDto'; id: number; name?: string | null } | null;
          systemRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
        };
        reason: { __typename?: 'Dtos_V1_Employee_ReasonDto'; id: number; name?: string | null };
      }> | null;
      phoneNumber?: { __typename?: 'ContactInformationDto'; contact?: string | null; id?: number | null; type?: string | null } | null;
      email?: { __typename?: 'ContactInformationDto'; contact?: string | null; id?: number | null; type?: string | null } | null;
      driversLicense?: { __typename?: 'Dtos_V1_DriversLicenseDto'; number?: string | null; state?: string | null } | null;
      jobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
      employmentStatus?: { __typename?: 'Dtos_V1_EmploymentStatusDto'; id: number; name?: string | null } | null;
      dispatchLocation?: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null } | null;
      workLocation?: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null } | null;
    };
  };
};

export type EmployeeFormFieldsDetailsFragment = {
  __typename?: 'Dtos_V2_Employee_EmployeeDto';
  id: number;
  deletable?: boolean | null;
  firstName?: string | null;
  lastName?: string | null;
  employmentType?: EmploymentType | null;
  startDate?: any | null;
  endDate?: any | null;
  notes?: string | null;
  phoneNumber?: { __typename?: 'ContactInformationDto'; contact?: string | null; id?: number | null; type?: string | null } | null;
  email?: { __typename?: 'ContactInformationDto'; contact?: string | null; id?: number | null; type?: string | null } | null;
  driversLicense?: { __typename?: 'Dtos_V1_DriversLicenseDto'; number?: string | null; state?: string | null } | null;
  jobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
  employmentStatus?: { __typename?: 'Dtos_V1_EmploymentStatusDto'; id: number; name?: string | null } | null;
  dispatchLocation?: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null } | null;
  workLocation?: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null } | null;
};

export type GetEmployeeFormOptionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetEmployeeFormOptionsQuery = {
  __typename?: 'Query';
  supportingEmployeeDataQuery: {
    __typename?: 'ResultOfDtos_V1_Employee_EmployeeSupportingDataDto';
    value: {
      __typename?: 'Dtos_V1_Employee_EmployeeSupportingDataDto';
      availableJobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
      availableEmploymentStatuses?: Array<{ __typename?: 'Dtos_V1_EmploymentStatusDto'; id: number; name?: string | null }> | null;
      availableDispatchLocations?: Array<{ __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null }> | null;
      availableWorkLocations?: Array<{ __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null }> | null;
      availableOutOfOfficeReasons?: Array<{ __typename?: 'Dtos_V1_Employee_OutOfOfficeReasonDto'; id: number; name: string }> | null;
    };
  };
};

export type ListCrewMembersQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V1_EmployeeDtoFilterInput>;
  order?: InputMaybe<Array<Dtos_V1_EmployeeDtoSortInput> | Dtos_V1_EmployeeDtoSortInput>;
  employeesInput?: InputMaybe<Input_V1_Queries_Employee_GetEmployeesInput>;
}>;

export type ListCrewMembersQuery = {
  __typename?: 'Query';
  employees?: {
    __typename?: 'EmployeesCollectionSegment';
    totalCount: number;
    pageInfo: { __typename?: 'CollectionSegmentInfo'; hasNextPage: boolean; hasPreviousPage: boolean };
    items?: Array<{
      __typename?: 'Dtos_V1_EmployeeDto';
      id: number;
      name?: string | null;
      fullName?: string | null;
      employmentType?: EmploymentType | null;
      jobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
      employmentStatus?: { __typename?: 'Dtos_V1_EmploymentStatusDto'; id: number; name?: string | null } | null;
    }> | null;
  } | null;
};

export type PageInfoFieldsFragment = { __typename?: 'CollectionSegmentInfo'; hasNextPage: boolean; hasPreviousPage: boolean };

export type EmployeeCrewMemberTableViewFieldsFragment = {
  __typename?: 'Dtos_V1_EmployeeDto';
  id: number;
  name?: string | null;
  fullName?: string | null;
  employmentType?: EmploymentType | null;
  jobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
  employmentStatus?: { __typename?: 'Dtos_V1_EmploymentStatusDto'; id: number; name?: string | null } | null;
};

export type ListEmployeesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V1_EmployeeDtoFilterInput>;
  order?: InputMaybe<Array<Dtos_V1_EmployeeDtoSortInput> | Dtos_V1_EmployeeDtoSortInput>;
}>;

export type ListEmployeesQuery = {
  __typename?: 'Query';
  employees?: {
    __typename?: 'EmployeesCollectionSegment';
    totalCount: number;
    pageInfo: { __typename?: 'CollectionSegmentInfo'; hasNextPage: boolean; hasPreviousPage: boolean };
    items?: Array<{
      __typename?: 'Dtos_V1_EmployeeDto';
      id: number;
      eid?: string | null;
      name?: string | null;
      fullName?: string | null;
      startDate?: any | null;
      endDate?: any | null;
      seniorityCode?: string | null;
      updatedOn?: any | null;
      deletable?: boolean | null;
      usable?: boolean | null;
      inactive?: boolean | null;
      dotHours8Day?: any | null;
      dotHours7Day?: any | null;
      dotHours6Day?: any | null;
      dotHours5Day?: any | null;
      clockStatus?: string | null;
      clockTime?: any | null;
      assignedEquipment?: string | null;
      daysOut?: number | null;
      jobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
      availableJobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
      employmentStatus?: { __typename?: 'Dtos_V1_EmploymentStatusDto'; id: number; name?: string | null } | null;
      phoneNumber?: { __typename?: 'ContactInformationDto'; contact?: string | null; id?: number | null; type?: string | null } | null;
      email?: { __typename?: 'ContactInformationDto'; contact?: string | null; id?: number | null; type?: string | null } | null;
      dispatchLocation?: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null } | null;
      workLocation?: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null } | null;
      updatedBy?: { __typename?: 'Dtos_V1_Employee_EmployeeReferenceDto'; id?: number | null; name?: string | null } | null;
    }> | null;
  } | null;
};

export type EmployeeTableViewFieldsFragment = {
  __typename?: 'Dtos_V1_EmployeeDto';
  id: number;
  eid?: string | null;
  name?: string | null;
  fullName?: string | null;
  startDate?: any | null;
  endDate?: any | null;
  seniorityCode?: string | null;
  updatedOn?: any | null;
  deletable?: boolean | null;
  usable?: boolean | null;
  inactive?: boolean | null;
  dotHours8Day?: any | null;
  dotHours7Day?: any | null;
  dotHours6Day?: any | null;
  dotHours5Day?: any | null;
  clockStatus?: string | null;
  clockTime?: any | null;
  assignedEquipment?: string | null;
  daysOut?: number | null;
  jobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
  availableJobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
  employmentStatus?: { __typename?: 'Dtos_V1_EmploymentStatusDto'; id: number; name?: string | null } | null;
  phoneNumber?: { __typename?: 'ContactInformationDto'; contact?: string | null; id?: number | null; type?: string | null } | null;
  email?: { __typename?: 'ContactInformationDto'; contact?: string | null; id?: number | null; type?: string | null } | null;
  dispatchLocation?: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null } | null;
  workLocation?: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null } | null;
  updatedBy?: { __typename?: 'Dtos_V1_Employee_EmployeeReferenceDto'; id?: number | null; name?: string | null } | null;
};

export type CreateEquipmentMutationVariables = Exact<{
  equipment: Input_V2_Mutations_Equipment_CreateEquipmentMutationInput;
}>;

export type CreateEquipmentMutation = {
  __typename?: 'Mutation';
  createEquipment: {
    __typename?: 'ResultOfDtos_V2_Equipment_EquipmentDto';
    isSuccess: boolean;
    value: { __typename?: 'Dtos_V2_Equipment_EquipmentDto'; id: number };
    error?: {
      __typename?: 'Error';
      errorMessage: string;
      errorType: ErrorType;
      statusCode: number;
      validationErrors: Array<{ __typename?: 'ValidationException'; field: string; message: string }>;
    } | null;
  };
};

export type DeleteEquipmentMutationVariables = Exact<{
  equipmentId: Scalars['Int']['input'];
}>;

export type DeleteEquipmentMutation = {
  __typename?: 'Mutation';
  deleteEquipment: {
    __typename?: 'Result';
    isSuccess: boolean;
    error?: {
      __typename?: 'Error';
      errorMessage: string;
      errorType: ErrorType;
      statusCode: number;
      validationErrors: Array<{ __typename?: 'ValidationException'; field: string; message: string }>;
    } | null;
  };
};

export type UpdateEquipmentMutationVariables = Exact<{
  equipment: Input_V2_Mutations_Equipment_UpdateEquipmentMutationInput;
}>;

export type UpdateEquipmentMutation = {
  __typename?: 'Mutation';
  updateEquipment: {
    __typename?: 'ResultOfDtos_V2_Equipment_EquipmentDto';
    isSuccess: boolean;
    value: { __typename?: 'Dtos_V2_Equipment_EquipmentDto'; id: number };
    error?: {
      __typename?: 'Error';
      errorMessage: string;
      errorType: ErrorType;
      statusCode: number;
      validationErrors: Array<{ __typename?: 'ValidationException'; field: string; message: string }>;
    } | null;
  };
};

export type GetEquipmentQueryVariables = Exact<{
  equipmentId: Scalars['Int']['input'];
}>;

export type GetEquipmentQuery = {
  __typename?: 'Query';
  equipmentDetails: {
    __typename?: 'Dtos_V1_Equipment_EquipmentDto';
    id: number;
    name?: string | null;
    year?: number | null;
    notes?: string | null;
    gpsTrackerSerialNumber?: string | null;
    geoFencingEnabled?: boolean | null;
    vinNumber?: string | null;
    grossWeight?: number | null;
    acquiredOn?: any | null;
    beganServiceOn?: any | null;
    purchasedMileage?: number | null;
    beganServiceMileage?: number | null;
    mpEquipmentId?: number | null;
    availableMakes?: Array<{ __typename?: 'Dtos_V1_EquipmentMakeDto'; id: number; name?: string | null }> | null;
    availableModels?: Array<{ __typename?: 'Dtos_V1_EquipmentModelDto'; id?: number | null; name?: string | null }> | null;
    availableClasses?: Array<{ __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null }> | null;
    availableTypes?: Array<{
      __typename?: 'Dtos_V1_EquipmentTypeDto';
      id: number;
      name?: string | null;
      class: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null };
    }> | null;
    availableSizes?: Array<{
      __typename?: 'Dtos_V1_EquipmentSizeDto';
      id: number;
      name?: string | null;
      class: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null };
    }> | null;
    availableEmployees?: Array<{ __typename?: 'Dtos_V1_EmployeeDto'; id: number; name?: string | null }> | null;
    availableDefaultEmployees?: Array<{
      __typename?: 'Dtos_V1_CrewDto';
      id: number;
      name?: string | null;
      supportedRoleIds: Array<number>;
      defaultEmployeeCrewRoleId?: number | null;
      jobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
    }> | null;
    availableJobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
    availableStatuses?: Array<{ __typename?: 'Dtos_V1_JobStatusDto'; id: number; name?: string | null }> | null;
    availableDispatchLocations?: Array<{ __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null }> | null;
    availableLocations?: Array<{ __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null }> | null;
    make?: { __typename?: 'Dtos_V1_EquipmentMakeDto'; id: number; name?: string | null } | null;
    class?: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null } | null;
    type?: {
      __typename?: 'Dtos_V1_EquipmentTypeDto';
      id: number;
      name?: string | null;
      class: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null };
    } | null;
    size?: {
      __typename?: 'Dtos_V1_EquipmentSizeDto';
      id: number;
      name?: string | null;
      class: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null };
    } | null;
    defaultEmployee?: {
      __typename?: 'Dtos_V1_EmployeeDto';
      defaultEmployeeCrewRoleId?: number | null;
      id: number;
      name?: string | null;
      jobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
    } | null;
    requiredJobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
    status?: { __typename?: 'Dtos_V1_JobStatusDto'; id: number; name?: string | null } | null;
    dispatchLocation?: { __typename?: 'Dtos_V1_DispatchLocationDto'; id: number; name?: string | null } | null;
    licensePlate?: { __typename?: 'Dtos_V1_LicensePlateDto'; number: string; state: string } | null;
    defaultLocation?: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null } | null;
    location?: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null } | null;
    model?: { __typename?: 'Dtos_V1_EquipmentModelDto'; id?: number | null; name?: string | null } | null;
  };
};

export type MakeInfoFragment = { __typename?: 'Dtos_V1_EquipmentMakeDto'; id: number; name?: string | null };

export type ModelInfoFragment = { __typename?: 'Dtos_V1_EquipmentModelDto'; id?: number | null; name?: string | null };

export type EquipmentClassInfoFragment = { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null };

export type EquipmentTypeInfoFragment = {
  __typename?: 'Dtos_V1_EquipmentTypeDto';
  id: number;
  name?: string | null;
  class: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null };
};

export type EquipmentSizeInfoFragment = {
  __typename?: 'Dtos_V1_EquipmentSizeDto';
  id: number;
  name?: string | null;
  class: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null };
};

export type EmployeeInfoFragment = { __typename?: 'Dtos_V1_EmployeeDto'; id: number; name?: string | null };

export type CrewInfoFragment = {
  __typename?: 'Dtos_V1_CrewDto';
  id: number;
  name?: string | null;
  supportedRoleIds: Array<number>;
  defaultEmployeeCrewRoleId?: number | null;
  jobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
};

export type JobRoleInfoFragment = { __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null };

export type JobStatusInfoFragment = { __typename?: 'Dtos_V1_JobStatusDto'; id: number; name?: string | null };

export type DispatchLocationInfoFragment = { __typename?: 'Dtos_V1_DispatchLocationDto'; id: number; name?: string | null };

export type LocationInfoFragment = { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null };

export type EquipmentFormFieldsFragment = {
  __typename?: 'Dtos_V1_Equipment_EquipmentDto';
  id: number;
  name?: string | null;
  year?: number | null;
  notes?: string | null;
  gpsTrackerSerialNumber?: string | null;
  geoFencingEnabled?: boolean | null;
  vinNumber?: string | null;
  grossWeight?: number | null;
  acquiredOn?: any | null;
  beganServiceOn?: any | null;
  purchasedMileage?: number | null;
  beganServiceMileage?: number | null;
  mpEquipmentId?: number | null;
  make?: { __typename?: 'Dtos_V1_EquipmentMakeDto'; id: number; name?: string | null } | null;
  class?: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null } | null;
  type?: {
    __typename?: 'Dtos_V1_EquipmentTypeDto';
    id: number;
    name?: string | null;
    class: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null };
  } | null;
  size?: {
    __typename?: 'Dtos_V1_EquipmentSizeDto';
    id: number;
    name?: string | null;
    class: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null };
  } | null;
  defaultEmployee?: {
    __typename?: 'Dtos_V1_EmployeeDto';
    defaultEmployeeCrewRoleId?: number | null;
    id: number;
    name?: string | null;
    jobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
  } | null;
  requiredJobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
  status?: { __typename?: 'Dtos_V1_JobStatusDto'; id: number; name?: string | null } | null;
  dispatchLocation?: { __typename?: 'Dtos_V1_DispatchLocationDto'; id: number; name?: string | null } | null;
  licensePlate?: { __typename?: 'Dtos_V1_LicensePlateDto'; number: string; state: string } | null;
  defaultLocation?: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null } | null;
  location?: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null } | null;
  model?: { __typename?: 'Dtos_V1_EquipmentModelDto'; id?: number | null; name?: string | null } | null;
};

export type GetEquipmentDetailsByIdQueryVariables = Exact<{
  input: Input_V1_Queries_Equipment_GetEquipmentDetailsInput;
}>;

export type GetEquipmentDetailsByIdQuery = {
  __typename?: 'Query';
  equipmentDetails: {
    __typename?: 'Dtos_V1_Equipment_EquipmentDto';
    id: number;
    name?: string | null;
    year?: number | null;
    make?: { __typename?: 'Dtos_V1_EquipmentMakeDto'; id: number; name?: string | null } | null;
    model?: {
      __typename?: 'Dtos_V1_EquipmentModelDto';
      id?: number | null;
      name?: string | null;
      make: { __typename?: 'Dtos_V1_EquipmentMakeDto'; id: number; name?: string | null };
    } | null;
    status?: { __typename?: 'Dtos_V1_JobStatusDto'; id: number; name?: string | null } | null;
    class?: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null } | null;
    type?: {
      __typename?: 'Dtos_V1_EquipmentTypeDto';
      id: number;
      name?: string | null;
      class: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null };
    } | null;
    size?: {
      __typename?: 'Dtos_V1_EquipmentSizeDto';
      id: number;
      name?: string | null;
      class: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null };
    } | null;
    upcomingOutOfService?: Array<{
      __typename?: 'Dtos_V1_Equipment_EquipmentOutOfServiceDto';
      id?: number | null;
      start: any;
      end: any;
      notes?: string | null;
      equipment: { __typename?: 'Dtos_V1_Equipment_EquipmentDto'; id: number; name?: string | null };
      reason?: { __typename?: 'Dtos_V1_Equipment_OutOfServiceReasonDto'; id: number; name: string } | null;
    }> | null;
    outOfServiceHistory?: Array<{
      __typename?: 'Dtos_V1_Equipment_EquipmentOutOfServiceDto';
      id?: number | null;
      start: any;
      end: any;
      notes?: string | null;
      equipment: { __typename?: 'Dtos_V1_Equipment_EquipmentDto'; id: number; name?: string | null };
      reason?: { __typename?: 'Dtos_V1_Equipment_OutOfServiceReasonDto'; id: number; name: string } | null;
    }> | null;
  };
};

export type GetEquipmentFormOptionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetEquipmentFormOptionsQuery = {
  __typename?: 'Query';
  supportingEquipmentData: {
    __typename?: 'Dtos_V1_Equipment_EquipmentSupportingDataDto';
    availableMakes?: Array<{ __typename?: 'Dtos_V1_EquipmentMakeDto'; id: number; name?: string | null }> | null;
    availableModels?: Array<{ __typename?: 'Dtos_V1_EquipmentModelDto'; id?: number | null; name?: string | null }> | null;
    availableClasses?: Array<{ __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null }> | null;
    availableTypes?: Array<{
      __typename?: 'Dtos_V1_EquipmentTypeDto';
      id: number;
      name?: string | null;
      class: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null };
    }> | null;
    availableSizes?: Array<{
      __typename?: 'Dtos_V1_EquipmentSizeDto';
      id: number;
      name?: string | null;
      class: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null };
    }> | null;
    availableEmployees?: Array<{ __typename?: 'Dtos_V1_EmployeeDto'; id: number; name?: string | null }> | null;
    availableDefaultEmployees?: Array<{
      __typename?: 'Dtos_V1_CrewDto';
      id: number;
      name?: string | null;
      supportedRoleIds: Array<number>;
      defaultEmployeeCrewRoleId?: number | null;
    }> | null;
    availableJobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
    availableStatuses?: Array<{ __typename?: 'Dtos_V1_JobStatusDto'; id: number; name?: string | null }> | null;
    availableDispatchLocations?: Array<{ __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null }> | null;
    availableLocations?: Array<{ __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null }> | null;
    availableOutOfServiceReasons?: Array<{ __typename?: 'Dtos_V1_Equipment_OutOfServiceReasonDto'; id: number; name: string }> | null;
  };
};

export type ListEquipmentsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V1_Equipment_EquipmentDtoFilterInput>;
  order?: InputMaybe<Array<Dtos_V1_Equipment_EquipmentDtoSortInput> | Dtos_V1_Equipment_EquipmentDtoSortInput>;
  equipmentsInput?: InputMaybe<Input_V1_Queries_Equipment_GetEquipmentsInput>;
}>;

export type ListEquipmentsQuery = {
  __typename?: 'Query';
  equipments?: {
    __typename?: 'EquipmentsCollectionSegment';
    totalCount: number;
    pageInfo: { __typename?: 'CollectionSegmentInfo'; hasNextPage: boolean; hasPreviousPage: boolean };
    items?: Array<{
      __typename?: 'Dtos_V1_Equipment_EquipmentDto';
      id: number;
      name?: string | null;
      notes?: string | null;
      deletable?: boolean | null;
      year?: number | null;
      vinNumber?: string | null;
      gpsTrackerSerialNumber?: string | null;
      geoFencingEnabled?: boolean | null;
      grossWeight?: number | null;
      acquiredOn?: any | null;
      beganServiceOn?: any | null;
      purchasedMileage?: number | null;
      beganServiceMileage?: number | null;
      mpEquipmentId?: number | null;
      truckYear?: number | null;
      truckModelNumber?: string | null;
      machineSerialNumber?: string | null;
      boomSerialNumber?: string | null;
      boomModelNum?: string | null;
      defaultInsideSystemDiameter?: number | null;
      defaultEndStyle?: number | null;
      maxGroundBearingPressure?: number | null;
      daysDown?: number | null;
      unworkable?: boolean | null;
      make?: { __typename?: 'Dtos_V1_EquipmentMakeDto'; id: number; name?: string | null } | null;
      model?: {
        __typename?: 'Dtos_V1_EquipmentModelDto';
        id?: number | null;
        name?: string | null;
        make: { __typename?: 'Dtos_V1_EquipmentMakeDto'; id: number; name?: string | null };
      } | null;
      class?: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null } | null;
      type?: { __typename?: 'Dtos_V1_EquipmentTypeDto'; id: number; name?: string | null } | null;
      size?: { __typename?: 'Dtos_V1_EquipmentSizeDto'; id: number; name?: string | null } | null;
      status?: { __typename?: 'Dtos_V1_JobStatusDto'; id: number; name?: string | null } | null;
      licensePlate?: { __typename?: 'Dtos_V1_LicensePlateDto'; number: string; state: string } | null;
      defaultLocation?: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null } | null;
      location?: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null } | null;
      dispatchLocation?: { __typename?: 'Dtos_V1_DispatchLocationDto'; id: number; name?: string | null } | null;
    }> | null;
  } | null;
};

export type EquipmentTableViewFieldsFragment = {
  __typename?: 'Dtos_V1_Equipment_EquipmentDto';
  id: number;
  name?: string | null;
  notes?: string | null;
  deletable?: boolean | null;
  year?: number | null;
  vinNumber?: string | null;
  gpsTrackerSerialNumber?: string | null;
  geoFencingEnabled?: boolean | null;
  grossWeight?: number | null;
  acquiredOn?: any | null;
  beganServiceOn?: any | null;
  purchasedMileage?: number | null;
  beganServiceMileage?: number | null;
  mpEquipmentId?: number | null;
  truckYear?: number | null;
  truckModelNumber?: string | null;
  machineSerialNumber?: string | null;
  boomSerialNumber?: string | null;
  boomModelNum?: string | null;
  defaultInsideSystemDiameter?: number | null;
  defaultEndStyle?: number | null;
  maxGroundBearingPressure?: number | null;
  daysDown?: number | null;
  unworkable?: boolean | null;
  make?: { __typename?: 'Dtos_V1_EquipmentMakeDto'; id: number; name?: string | null } | null;
  model?: {
    __typename?: 'Dtos_V1_EquipmentModelDto';
    id?: number | null;
    name?: string | null;
    make: { __typename?: 'Dtos_V1_EquipmentMakeDto'; id: number; name?: string | null };
  } | null;
  class?: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null } | null;
  type?: { __typename?: 'Dtos_V1_EquipmentTypeDto'; id: number; name?: string | null } | null;
  size?: { __typename?: 'Dtos_V1_EquipmentSizeDto'; id: number; name?: string | null } | null;
  status?: { __typename?: 'Dtos_V1_JobStatusDto'; id: number; name?: string | null } | null;
  licensePlate?: { __typename?: 'Dtos_V1_LicensePlateDto'; number: string; state: string } | null;
  defaultLocation?: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null } | null;
  location?: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null } | null;
  dispatchLocation?: { __typename?: 'Dtos_V1_DispatchLocationDto'; id: number; name?: string | null } | null;
};

export type CreateJobSiteMutationVariables = Exact<{
  input: CreateJobsiteMutationInput;
}>;

export type CreateJobSiteMutation = {
  __typename?: 'Mutation';
  createJobSite: {
    __typename?: 'ResultOfCreateJobsiteDto';
    isSuccess: boolean;
    value: {
      __typename?: 'CreateJobsiteDto';
      id?: number | null;
      jobSiteName?: string | null;
      address: string;
      latitude: any;
      longitude: any;
    };
    error?: {
      __typename?: 'Error';
      errorMessage: string;
      errorType: ErrorType;
      statusCode: number;
      validationErrors: Array<{ __typename?: 'ValidationException'; field: string; message: string }>;
    } | null;
  };
};

export type DeleteJobSiteMutationVariables = Exact<{
  input: DeleteJobSiteMutationInput;
}>;

export type DeleteJobSiteMutation = {
  __typename?: 'Mutation';
  deleteJobSite: {
    __typename?: 'Result';
    isSuccess: boolean;
    error?: {
      __typename?: 'Error';
      errorMessage: string;
      errorType: ErrorType;
      statusCode: number;
      validationErrors: Array<{ __typename?: 'ValidationException'; field: string; message: string }>;
    } | null;
  };
};

export type UpdateJobSiteMutationVariables = Exact<{
  input: UpdateJobSiteMutationInput;
}>;

export type UpdateJobSiteMutation = {
  __typename?: 'Mutation';
  updateJobSite: {
    __typename?: 'Result';
    isSuccess: boolean;
    error?: {
      __typename?: 'Error';
      errorMessage: string;
      errorType: ErrorType;
      statusCode: number;
      validationErrors: Array<{ __typename?: 'ValidationException'; field: string; message: string }>;
    } | null;
  };
};

export type GetJobSiteQueryVariables = Exact<{
  jobSiteId: Scalars['Int']['input'];
}>;

export type GetJobSiteQuery = {
  __typename?: 'Query';
  jobsiteDetails?: {
    __typename?: 'Dtos_V2_JobSite_JobSiteDto';
    permitPresent: boolean;
    jobsiteId: string;
    deletable?: boolean | null;
    jobName: string;
    location: string;
    cityTown: string;
    state: string;
    zip: string;
    latitude?: any | null;
    longitude?: any | null;
    parcelNumber: string;
    crossStreet: string;
    defaultBidLot: string;
    mapPage: string;
    jobPhone: string;
    jobNumber: string;
    specialInstruction: string;
    contractNumber: string;
    defaultPoNumber: string;
    billableTravelHours: any;
    createdOn: string;
    notes: string;
    customId: string;
    billingAddress: string;
    jobsiteType: string;
    projectType: string;
    pricingScheme: string;
    salesAgent: string;
    salesRegion: string;
    disposal: string;
    availableJobSiteTypes?: Array<{ __typename?: 'JobSiteTypeDto'; id: number; objectName: string }> | null;
    availableStates?: Array<{ __typename?: 'StateDto'; id?: number | null; name?: string | null; abbreviation?: string | null }> | null;
    customer?: { __typename?: 'Dtos_V2_JobSite_CustomerInfoDto'; id?: string | null; name?: string | null } | null;
    contractor?: { __typename?: 'Dtos_V2_JobSite_ContractorInfoDto'; id?: string | null; name?: string | null } | null;
    settings?: {
      __typename?: 'Dtos_V2_JobSite_SettingsDto';
      inactive: boolean;
      ocip: boolean;
      cprPrevailing: boolean;
      publicProject: boolean;
      released: boolean;
      safetyRequired: boolean;
      nonTaxable: boolean;
      geofencing: boolean;
      poRequired: boolean;
      emailInvoices: boolean;
    } | null;
    flags?: { __typename?: 'Dtos_V2_JobSite_FlagsDto'; powerline: boolean; noSubs: boolean } | null;
  } | null;
};

export type JobSiteContactInfoFragment = {
  __typename?: 'ContactInformationDto';
  contact?: string | null;
  id?: number | null;
  type?: string | null;
};

export type JobSiteLocationInfoFragment = { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null };

export type JobSiteJobRoleInfoFragment = { __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null };

export type JobSiteFormFieldsFragment = {
  __typename?: 'Dtos_V2_JobSite_JobSiteDto';
  jobsiteId: string;
  deletable?: boolean | null;
  jobName: string;
  location: string;
  cityTown: string;
  state: string;
  zip: string;
  latitude?: any | null;
  longitude?: any | null;
  parcelNumber: string;
  crossStreet: string;
  defaultBidLot: string;
  mapPage: string;
  jobPhone: string;
  jobNumber: string;
  specialInstruction: string;
  contractNumber: string;
  defaultPoNumber: string;
  billableTravelHours: any;
  createdOn: string;
  notes: string;
  customId: string;
  billingAddress: string;
  jobsiteType: string;
  projectType: string;
  pricingScheme: string;
  salesAgent: string;
  salesRegion: string;
  disposal: string;
  customer?: { __typename?: 'Dtos_V2_JobSite_CustomerInfoDto'; id?: string | null; name?: string | null } | null;
  contractor?: { __typename?: 'Dtos_V2_JobSite_ContractorInfoDto'; id?: string | null; name?: string | null } | null;
  settings?: {
    __typename?: 'Dtos_V2_JobSite_SettingsDto';
    inactive: boolean;
    ocip: boolean;
    cprPrevailing: boolean;
    publicProject: boolean;
    released: boolean;
    safetyRequired: boolean;
    nonTaxable: boolean;
    geofencing: boolean;
    poRequired: boolean;
    emailInvoices: boolean;
  } | null;
  flags?: { __typename?: 'Dtos_V2_JobSite_FlagsDto'; powerline: boolean; noSubs: boolean } | null;
};

export type GetJobSiteFormOptionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetJobSiteFormOptionsQuery = {
  __typename?: 'Query';
  jobsiteTypes?: {
    __typename?: 'JobsiteTypesCollectionSegment';
    totalCount: number;
    items?: Array<{ __typename?: 'JobSiteTypeDto'; id: number; objectName: string; default: boolean }> | null;
  } | null;
};

export type ListJobSitesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V2_JobSite_JobSiteDtoFilterInput>;
  order?: InputMaybe<Array<Dtos_V2_JobSite_JobSiteDtoSortInput> | Dtos_V2_JobSite_JobSiteDtoSortInput>;
}>;

export type ListJobSitesQuery = {
  __typename?: 'Query';
  jobSites?: {
    __typename?: 'JobSitesCollectionSegment';
    totalCount: number;
    pageInfo: { __typename?: 'CollectionSegmentInfo'; hasNextPage: boolean; hasPreviousPage: boolean };
    items?: Array<{
      __typename?: 'Dtos_V2_JobSite_JobSiteDto';
      jobsiteId: string;
      jobName: string;
      location: string;
      cityTown: string;
      state: string;
      zip: string;
      latitude?: any | null;
      longitude?: any | null;
      parcelNumber: string;
      crossStreet: string;
      defaultBidLot: string;
      mapPage: string;
      jobPhone: string;
      jobNumber: string;
      specialInstruction: string;
      contractNumber: string;
      defaultPoNumber: string;
      billableTravelHours: any;
      createdOn: string;
      prelimed: string;
      notes: string;
      customId: string;
      jobsiteType: string;
      projectType: string;
      pricingScheme: string;
      salesAgent: string;
      salesRegion: string;
      billingAddress: string;
      verified: boolean;
      verifiedBy: string;
      deletable?: boolean | null;
      customer?: { __typename?: 'Dtos_V2_JobSite_CustomerInfoDto'; id?: string | null; name?: string | null } | null;
      contractor?: { __typename?: 'Dtos_V2_JobSite_ContractorInfoDto'; id?: string | null; name?: string | null } | null;
      settings?: {
        __typename?: 'Dtos_V2_JobSite_SettingsDto';
        ocip: boolean;
        cprPrevailing: boolean;
        publicProject: boolean;
        released: boolean;
        safetyRequired: boolean;
        nonTaxable: boolean;
        geofencing: boolean;
        poRequired: boolean;
        emailInvoices: boolean;
        inactive: boolean;
      } | null;
      flags?: { __typename?: 'Dtos_V2_JobSite_FlagsDto'; powerline: boolean } | null;
    }> | null;
  } | null;
};

export type JobSiteTableViewFieldsFragment = {
  __typename?: 'Dtos_V2_JobSite_JobSiteDto';
  jobsiteId: string;
  jobName: string;
  location: string;
  cityTown: string;
  state: string;
  zip: string;
  latitude?: any | null;
  longitude?: any | null;
  parcelNumber: string;
  crossStreet: string;
  defaultBidLot: string;
  mapPage: string;
  jobPhone: string;
  jobNumber: string;
  specialInstruction: string;
  contractNumber: string;
  defaultPoNumber: string;
  billableTravelHours: any;
  createdOn: string;
  prelimed: string;
  notes: string;
  customId: string;
  jobsiteType: string;
  projectType: string;
  pricingScheme: string;
  salesAgent: string;
  salesRegion: string;
  billingAddress: string;
  verified: boolean;
  verifiedBy: string;
  deletable?: boolean | null;
  customer?: { __typename?: 'Dtos_V2_JobSite_CustomerInfoDto'; id?: string | null; name?: string | null } | null;
  contractor?: { __typename?: 'Dtos_V2_JobSite_ContractorInfoDto'; id?: string | null; name?: string | null } | null;
  settings?: {
    __typename?: 'Dtos_V2_JobSite_SettingsDto';
    ocip: boolean;
    cprPrevailing: boolean;
    publicProject: boolean;
    released: boolean;
    safetyRequired: boolean;
    nonTaxable: boolean;
    geofencing: boolean;
    poRequired: boolean;
    emailInvoices: boolean;
    inactive: boolean;
  } | null;
  flags?: { __typename?: 'Dtos_V2_JobSite_FlagsDto'; powerline: boolean } | null;
};

export type GetOutOfServiceEquipmentsQueryVariables = Exact<{
  input?: InputMaybe<Input_V2_Queries_Equipment_GetOutOfServiceEquipmentsInput>;
}>;

export type GetOutOfServiceEquipmentsQuery = {
  __typename?: 'Query';
  outOfServiceEquipment?: {
    __typename?: 'OutOfServiceEquipmentCollectionSegment';
    totalCount: number;
    items?: Array<{
      __typename?: 'Dtos_V2_Equipment_EquipmentOutOfServiceDto';
      id?: number | null;
      start: any;
      end?: any | null;
      notes?: string | null;
      createdOn?: any | null;
      updatedOn?: any | null;
      equipment: {
        __typename?: 'Dtos_V2_Equipment_EquipmentDto';
        id: number;
        name?: string | null;
        model?: { __typename?: 'Dtos_V1_EquipmentModelDto'; id?: number | null; name?: string | null } | null;
        make?: { __typename?: 'Dtos_V1_EquipmentMakeDto'; id: number; name?: string | null } | null;
      };
      reason?: { __typename?: 'Dtos_V2_Equipment_OutOfServiceReasonDto'; id: number; name: string } | null;
    }> | null;
  } | null;
};

export type CancelJobMutationVariables = Exact<{
  jobId: Scalars['Int']['input'];
}>;

export type CancelJobMutation = {
  __typename?: 'Mutation';
  cancelRaptorJob: {
    __typename?: 'Result';
    isSuccess: boolean;
    error?: {
      __typename?: 'Error';
      errorMessage: string;
      errorType: ErrorType;
      statusCode: number;
      validationErrors: Array<{ __typename?: 'ValidationException'; field: string; message: string }>;
    } | null;
  };
};

export type CreateJobMutationVariables = Exact<{
  job: Input_V2_Mutations_RaptorJob_CreateRaptorJobMutationInput;
}>;

export type CreateJobMutation = {
  __typename?: 'Mutation';
  createRaptorJob: {
    __typename?: 'ResultOfDtos_V2_RaptorJob_RaptorJobDto';
    isSuccess: boolean;
    value: { __typename?: 'Dtos_V2_RaptorJob_RaptorJobDto'; id: number };
    error?: {
      __typename?: 'Error';
      errorMessage: string;
      errorType: ErrorType;
      statusCode: number;
      validationErrors: Array<{ __typename?: 'ValidationException'; field: string; message: string }>;
    } | null;
  };
};

export type DeleteJobMutationVariables = Exact<{
  raptorJobId: Scalars['Int']['input'];
}>;

export type DeleteJobMutation = {
  __typename?: 'Mutation';
  cancelRaptorJob: {
    __typename?: 'Result';
    isSuccess: boolean;
    error?: {
      __typename?: 'Error';
      errorMessage: string;
      errorType: ErrorType;
      statusCode: number;
      validationErrors: Array<{ __typename?: 'ValidationException'; field: string; message: string }>;
    } | null;
  };
};

export type NotifyCrewMembersMutationVariables = Exact<{
  input: NotifyCrewMembersInput;
}>;

export type NotifyCrewMembersMutation = {
  __typename?: 'Mutation';
  notifyCrewMembers: {
    __typename?: 'Result';
    isSuccess: boolean;
    error?: {
      __typename?: 'Error';
      statusCode: number;
      errorType: ErrorType;
      errorMessage: string;
      validationErrors: Array<{ __typename?: 'ValidationException'; field: string; message: string }>;
    } | null;
  };
};

export type UpdateJobMutationVariables = Exact<{
  job: Input_V2_Mutations_RaptorJob_UpdateRaptorJobMutationInput;
}>;

export type UpdateJobMutation = {
  __typename?: 'Mutation';
  updateRaptorJob: {
    __typename?: 'ResultOfDtos_V2_RaptorJob_RaptorJobDto';
    isSuccess: boolean;
    error?: {
      __typename?: 'Error';
      errorMessage: string;
      errorType: ErrorType;
      statusCode: number;
      validationErrors: Array<{ __typename?: 'ValidationException'; field: string; message: string }>;
    } | null;
  };
};

export type GetDispatcherByUserIdQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;

export type GetDispatcherByUserIdQuery = {
  __typename?: 'Query';
  dispatchers?: {
    __typename?: 'DispatchersCollectionSegment';
    totalCount: number;
    items?: Array<{
      __typename?: 'Dtos_V2_Employee_EmployeeDto';
      id: number;
      name?: string | null;
      user?: { __typename?: 'Dtos_V2_User_UserSummaryDto'; userId: number } | null;
    }> | null;
  } | null;
};

export type GetJobQueryVariables = Exact<{
  jobId: Scalars['Int']['input'];
}>;

export type GetJobQuery = {
  __typename?: 'Query';
  raptorJobDetails: {
    __typename?: 'ResultOfDtos_V2_RaptorJob_RaptorJobDto';
    value: {
      __typename?: 'Dtos_V2_RaptorJob_RaptorJobDto';
      id: number;
      jobNumber: string;
      jobName: string;
      poNumber: string;
      startDate: any;
      endDate?: any | null;
      calledInTime: any;
      timeZone?: string | null;
      caller?: string | null;
      createdOn: any;
      updatedOn: any;
      confirmedTime: any;
      dispatchNotes: string;
      specialInstructions?: string | null;
      notesForCrew?: string | null;
      cod: boolean;
      strictSizeRequested: boolean;
      priorityCode?: string | null;
      cancelable: boolean;
      availableCrewMembers: Array<{
        __typename?: 'Dtos_V2_CrewDto';
        id: number;
        name?: string | null;
        supportedRoleIds: Array<number>;
        role?: { __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null } | null;
      }>;
      availableCrewRoles: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }>;
      availableCustomers: Array<{
        __typename?: 'CustomerDto';
        id?: number | null;
        companyName?: string | null;
        primaryEmail?: string | null;
        primaryPhone?: string | null;
      }>;
      availableDispatchers: Array<{ __typename?: 'Dtos_V1_EmployeeDto'; id: number; name?: string | null }>;
      availableDispatchLocations: Array<{ __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null }>;
      availableEquipment: Array<{ __typename?: 'Dtos_V2_Equipment_EquipmentDto'; id: number; name?: string | null }>;
      availableEquipmentLocations: Array<{ __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null }>;
      availableEquipmentSizes: Array<{ __typename?: 'Dtos_V1_EquipmentSizeDto'; id: number; name?: string | null }>;
      availableEquipmentTypes: Array<{ __typename?: 'Dtos_V1_EquipmentTypeDto'; id: number; name?: string | null }>;
      availableExtraSystems: Array<{ __typename?: 'Dtos_V2_ExtraSystemDto'; id: number; name?: string | null }>;
      availableJobInformation: Array<{ __typename?: 'Dtos_V1_JobInformationDto'; id: number; name?: string | null }>;
      availableJobStatuses: Array<{ __typename?: 'Dtos_V1_JobStatusDto'; id: number; name?: string | null }>;
      availableJobTypes: Array<{ __typename?: 'Dtos_V1_JobTypeDto'; id: number; name?: string | null }>;
      availableSpecialFlags: Array<{ __typename?: 'Dtos_V1_SpecialFlagDto'; id: number; name?: string | null }>;
      availableVendors: Array<{
        __typename?: 'Dtos_V1_VendorDto';
        id: number;
        name?: string | null;
        mailAddress?: string | null;
        phoneNumber?: string | null;
        emailAddress?: string | null;
      }>;
      createdBy?: { __typename?: 'Dtos_V1_EmployeeDto'; id: number; name?: string | null } | null;
      updatedBy: { __typename?: 'Dtos_V1_EmployeeDto'; id: number; name?: string | null };
      confirmedBy: { __typename?: 'Dtos_V1_EmployeeDto'; id: number; name?: string | null };
      jobInformation: { __typename?: 'Dtos_V1_JobInformationDto'; id: number; name?: string | null };
      dispatcher: { __typename?: 'Dtos_V1_EmployeeDto'; id: number; name?: string | null };
      sizeRequested: { __typename?: 'Dtos_V1_EquipmentSizeDto'; id: number; name?: string | null };
      specialFlag1?: { __typename?: 'Dtos_V1_SpecialFlagDto'; id: number; name?: string | null } | null;
      specialFlag2?: { __typename?: 'Dtos_V1_SpecialFlagDto'; id: number; name?: string | null } | null;
      specialFlag3?: { __typename?: 'Dtos_V1_SpecialFlagDto'; id: number; name?: string | null } | null;
      vendor?: {
        __typename?: 'Dtos_V1_VendorDto';
        id: number;
        name?: string | null;
        mailAddress?: string | null;
        phoneNumber?: string | null;
        emailAddress?: string | null;
      } | null;
      crew: Array<{
        __typename?: 'Dtos_V2_CrewDto';
        id: number;
        name?: string | null;
        employmentType?: EmploymentType | null;
        supportedRoleIds: Array<number>;
        notified: boolean;
        acknowledged: boolean;
        role?: { __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null } | null;
        employmentStatus?: { __typename?: 'Dtos_V1_EmploymentStatusDto'; id: number; name?: string | null } | null;
        plannedAllocation: {
          __typename?: 'Dtos_V2_PlannedAllocationDto';
          date?: any | null;
          showUpTime?: any | null;
          leaveTime?: any | null;
          onJobTime?: any | null;
          startTime?: any | null;
          clearTime?: any | null;
          estimatedHours?: number | null;
        };
      }>;
      equipment: Array<{
        __typename?: 'Dtos_V2_Equipment_EquipmentDto';
        id: number;
        name?: string | null;
        year?: number | null;
        notes?: string | null;
        gpsTrackerSerialNumber?: string | null;
        geoFencingEnabled?: boolean | null;
        plannedAllocation: {
          __typename?: 'Dtos_V2_Equipment_EquipmentPlannedAllocationDto';
          date?: any | null;
          showUpTime?: any | null;
          leaveTime?: any | null;
          onJobTime?: any | null;
          startTime?: any | null;
          clearTime?: any | null;
          estimatedHours?: number | null;
          estimatedVolume?: number | null;
          estimatedArea?: number | null;
        };
        make?: { __typename?: 'Dtos_V1_EquipmentMakeDto'; id: number; name?: string | null } | null;
        model?: { __typename?: 'Dtos_V1_EquipmentModelDto'; id?: number | null; name?: string | null } | null;
        class?: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null } | null;
        type?: { __typename?: 'Dtos_V1_EquipmentTypeDto'; id: number; name?: string | null } | null;
        size?: { __typename?: 'Dtos_V1_EquipmentSizeDto'; id: number; name?: string | null } | null;
        defaultEmployee?: {
          __typename?: 'Dtos_V2_CrewDto';
          id: number;
          fullName?: string | null;
          employmentType?: EmploymentType | null;
          status: Array<CrewAssignmentStatus>;
          statusNotes: string;
          jobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
          employmentStatus?: { __typename?: 'Dtos_V1_EmploymentStatusDto'; id: number; name?: string | null } | null;
        } | null;
        requiredJobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
        status?: { __typename?: 'Dtos_V1_JobStatusDto'; id: number; name?: string | null; colorCode?: string | null } | null;
        dispatchLocation?: { __typename?: 'Dtos_V1_DispatchLocationDto'; id: number; name?: string | null } | null;
        licensePlate?: { __typename?: 'Dtos_V1_LicensePlateDto'; number: string; state: string } | null;
        location?: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null } | null;
        availableClasses?: Array<{ __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null }> | null;
      }>;
      extraSystems: Array<{
        __typename?: 'Dtos_V2_ExtraSystemDto';
        id: number;
        name?: string | null;
        description?: string | null;
        price: any;
        quantity: any;
        billable?: boolean | null;
        taxable?: boolean | null;
        defaultItem?: boolean | null;
        showAsExtraSystemOnJob?: boolean | null;
        class: { __typename?: 'Dtos_V1_ClassDto'; id: number; name?: string | null };
        plannedAllocation?: {
          __typename?: 'Dtos_V2_PlannedAllocationDto';
          date?: any | null;
          showUpTime?: any | null;
          leaveTime?: any | null;
          onJobTime?: any | null;
          startTime?: any | null;
          clearTime?: any | null;
          estimatedHours?: number | null;
        } | null;
      }>;
      customer: {
        __typename?: 'CustomerDto';
        id?: number | null;
        companyName?: string | null;
        primaryPhone?: string | null;
        primaryEmail?: string | null;
      };
      salesAgent: { __typename?: 'Dtos_V1_EmployeeDto'; id: number; name?: string | null };
      jobSite: {
        __typename?: 'Dtos_V1_JobSiteDto';
        id: number;
        jobNumber?: string | null;
        jobSiteName?: string | null;
        address?: string | null;
        latitude?: any | null;
        longitude?: any | null;
      };
      type: { __typename?: 'Dtos_V2_JobTypeDto'; id: number; name?: string | null };
      status: { __typename?: 'Dtos_V1_JobStatusDto'; id: number; name?: string | null };
      equipmentLocation: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null };
      dispatchLocation: { __typename?: 'Dtos_V1_DispatchLocationDto'; id: number; name?: string | null };
    };
  };
};

export type JobFormFieldsFragment = {
  __typename?: 'Dtos_V2_RaptorJob_RaptorJobDto';
  id: number;
  jobNumber: string;
  jobName: string;
  poNumber: string;
  startDate: any;
  endDate?: any | null;
  calledInTime: any;
  timeZone?: string | null;
  caller?: string | null;
  createdOn: any;
  updatedOn: any;
  confirmedTime: any;
  dispatchNotes: string;
  specialInstructions?: string | null;
  notesForCrew?: string | null;
  cod: boolean;
  strictSizeRequested: boolean;
  priorityCode?: string | null;
  cancelable: boolean;
  createdBy?: { __typename?: 'Dtos_V1_EmployeeDto'; id: number; name?: string | null } | null;
  updatedBy: { __typename?: 'Dtos_V1_EmployeeDto'; id: number; name?: string | null };
  confirmedBy: { __typename?: 'Dtos_V1_EmployeeDto'; id: number; name?: string | null };
  jobInformation: { __typename?: 'Dtos_V1_JobInformationDto'; id: number; name?: string | null };
  dispatcher: { __typename?: 'Dtos_V1_EmployeeDto'; id: number; name?: string | null };
  sizeRequested: { __typename?: 'Dtos_V1_EquipmentSizeDto'; id: number; name?: string | null };
  specialFlag1?: { __typename?: 'Dtos_V1_SpecialFlagDto'; id: number; name?: string | null } | null;
  specialFlag2?: { __typename?: 'Dtos_V1_SpecialFlagDto'; id: number; name?: string | null } | null;
  specialFlag3?: { __typename?: 'Dtos_V1_SpecialFlagDto'; id: number; name?: string | null } | null;
  vendor?: {
    __typename?: 'Dtos_V1_VendorDto';
    id: number;
    name?: string | null;
    mailAddress?: string | null;
    phoneNumber?: string | null;
    emailAddress?: string | null;
  } | null;
  crew: Array<{
    __typename?: 'Dtos_V2_CrewDto';
    id: number;
    name?: string | null;
    employmentType?: EmploymentType | null;
    supportedRoleIds: Array<number>;
    notified: boolean;
    acknowledged: boolean;
    role?: { __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null } | null;
    employmentStatus?: { __typename?: 'Dtos_V1_EmploymentStatusDto'; id: number; name?: string | null } | null;
    plannedAllocation: {
      __typename?: 'Dtos_V2_PlannedAllocationDto';
      date?: any | null;
      showUpTime?: any | null;
      leaveTime?: any | null;
      onJobTime?: any | null;
      startTime?: any | null;
      clearTime?: any | null;
      estimatedHours?: number | null;
    };
  }>;
  equipment: Array<{
    __typename?: 'Dtos_V2_Equipment_EquipmentDto';
    id: number;
    name?: string | null;
    year?: number | null;
    notes?: string | null;
    gpsTrackerSerialNumber?: string | null;
    geoFencingEnabled?: boolean | null;
    plannedAllocation: {
      __typename?: 'Dtos_V2_Equipment_EquipmentPlannedAllocationDto';
      date?: any | null;
      showUpTime?: any | null;
      leaveTime?: any | null;
      onJobTime?: any | null;
      startTime?: any | null;
      clearTime?: any | null;
      estimatedHours?: number | null;
      estimatedVolume?: number | null;
      estimatedArea?: number | null;
    };
    make?: { __typename?: 'Dtos_V1_EquipmentMakeDto'; id: number; name?: string | null } | null;
    model?: { __typename?: 'Dtos_V1_EquipmentModelDto'; id?: number | null; name?: string | null } | null;
    class?: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null } | null;
    type?: { __typename?: 'Dtos_V1_EquipmentTypeDto'; id: number; name?: string | null } | null;
    size?: { __typename?: 'Dtos_V1_EquipmentSizeDto'; id: number; name?: string | null } | null;
    defaultEmployee?: {
      __typename?: 'Dtos_V2_CrewDto';
      id: number;
      fullName?: string | null;
      employmentType?: EmploymentType | null;
      status: Array<CrewAssignmentStatus>;
      statusNotes: string;
      jobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
      employmentStatus?: { __typename?: 'Dtos_V1_EmploymentStatusDto'; id: number; name?: string | null } | null;
    } | null;
    requiredJobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
    status?: { __typename?: 'Dtos_V1_JobStatusDto'; id: number; name?: string | null; colorCode?: string | null } | null;
    dispatchLocation?: { __typename?: 'Dtos_V1_DispatchLocationDto'; id: number; name?: string | null } | null;
    licensePlate?: { __typename?: 'Dtos_V1_LicensePlateDto'; number: string; state: string } | null;
    location?: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null } | null;
    availableClasses?: Array<{ __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null }> | null;
  }>;
  extraSystems: Array<{
    __typename?: 'Dtos_V2_ExtraSystemDto';
    id: number;
    name?: string | null;
    description?: string | null;
    price: any;
    quantity: any;
    billable?: boolean | null;
    taxable?: boolean | null;
    defaultItem?: boolean | null;
    showAsExtraSystemOnJob?: boolean | null;
    class: { __typename?: 'Dtos_V1_ClassDto'; id: number; name?: string | null };
    plannedAllocation?: {
      __typename?: 'Dtos_V2_PlannedAllocationDto';
      date?: any | null;
      showUpTime?: any | null;
      leaveTime?: any | null;
      onJobTime?: any | null;
      startTime?: any | null;
      clearTime?: any | null;
      estimatedHours?: number | null;
    } | null;
  }>;
  customer: {
    __typename?: 'CustomerDto';
    id?: number | null;
    companyName?: string | null;
    primaryPhone?: string | null;
    primaryEmail?: string | null;
  };
  salesAgent: { __typename?: 'Dtos_V1_EmployeeDto'; id: number; name?: string | null };
  jobSite: {
    __typename?: 'Dtos_V1_JobSiteDto';
    id: number;
    jobNumber?: string | null;
    jobSiteName?: string | null;
    address?: string | null;
    latitude?: any | null;
    longitude?: any | null;
  };
  type: { __typename?: 'Dtos_V2_JobTypeDto'; id: number; name?: string | null };
  status: { __typename?: 'Dtos_V1_JobStatusDto'; id: number; name?: string | null };
  equipmentLocation: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null };
  dispatchLocation: { __typename?: 'Dtos_V1_DispatchLocationDto'; id: number; name?: string | null };
};

export type GetJobFormOptionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetJobFormOptionsQuery = {
  __typename?: 'Query';
  raptorJobSupportingDataQuery: {
    __typename?: 'ResultOfDtos_V2_RaptorJob_RaptorJobSupportingDataDto';
    value: {
      __typename?: 'Dtos_V2_RaptorJob_RaptorJobSupportingDataDto';
      availableCrewMembers: Array<{
        __typename?: 'Dtos_V1_CrewDto';
        id: number;
        name?: string | null;
        supportedRoleIds: Array<number>;
        role: { __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null };
      }>;
      availableCrewRoles: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }>;
      availableCustomers: Array<{
        __typename?: 'CustomerDto';
        id?: number | null;
        companyName?: string | null;
        primaryEmail?: string | null;
        primaryPhone?: string | null;
      }>;
      availableDispatchers: Array<{ __typename?: 'Dtos_V1_EmployeeDto'; id: number; name?: string | null }>;
      availableDispatchLocations: Array<{ __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null; default?: boolean | null }>;
      availableEquipment: Array<{
        __typename?: 'Dtos_V1_Equipment_EquipmentDto';
        id: number;
        name?: string | null;
        type?: { __typename?: 'Dtos_V1_EquipmentTypeDto'; id: number; name?: string | null } | null;
        class?: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null } | null;
        size?: { __typename?: 'Dtos_V1_EquipmentSizeDto'; id: number; name?: string | null } | null;
        status?: { __typename?: 'Dtos_V1_JobStatusDto'; id: number; name?: string | null } | null;
      }>;
      availableEquipmentLocations: Array<{ __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null }>;
      availableEquipmentSizes: Array<{
        __typename?: 'Dtos_V1_EquipmentSizeDto';
        id: number;
        name?: string | null;
        class?: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null } | null;
      }>;
      availableEquipmentTypes: Array<{
        __typename?: 'Dtos_V1_EquipmentTypeDto';
        id: number;
        name?: string | null;
        class?: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null } | null;
      }>;
      availableExtraSystems: Array<{
        __typename?: 'Dtos_V1_ExtraSystemDto';
        id: number;
        name?: string | null;
        description?: string | null;
        price: any;
        quantity: any;
        billable?: boolean | null;
        taxable?: boolean | null;
        defaultItem?: boolean | null;
        showAsExtraSystemOnJob?: boolean | null;
        class: { __typename?: 'Dtos_V1_ClassDto'; id: number; name?: string | null };
      }>;
      availableJobInformation: Array<{ __typename?: 'Dtos_V1_JobInformationDto'; id: number; name?: string | null }>;
      availableJobStatuses: Array<{
        __typename?: 'Dtos_V1_JobStatusDto';
        id: number;
        name?: string | null;
        default?: boolean | null;
        colorCode?: string | null;
      }>;
      availableJobTypes: Array<{ __typename?: 'Dtos_V1_JobTypeDto'; id: number; name?: string | null; default?: boolean | null }>;
      availableSpecialFlags: Array<{ __typename?: 'Dtos_V1_SpecialFlagDto'; id: number; name?: string | null }>;
      availableVendors: Array<{
        __typename?: 'Dtos_V1_VendorDto';
        id: number;
        name?: string | null;
        mailAddress?: string | null;
        phoneNumber?: string | null;
        emailAddress?: string | null;
        default?: boolean | null;
      }>;
      requiredFields: Array<{ __typename?: 'Dtos_V2_RaptorJob_JobFieldDto'; name: string; required: boolean }>;
      uiBehaviorRules: Array<{ __typename?: 'Dtos_V2_RaptorJob_JobFieldUiBehaviorRuleDto'; name: string; enabled: boolean }>;
    };
  };
};

export type GetJobSitesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V2_JobSite_JobSiteDtoFilterInput>;
  order?: InputMaybe<Array<Dtos_V2_JobSite_JobSiteDtoSortInput> | Dtos_V2_JobSite_JobSiteDtoSortInput>;
}>;

export type GetJobSitesQuery = {
  __typename?: 'Query';
  jobSites?: {
    __typename?: 'JobSitesCollectionSegment';
    totalCount: number;
    pageInfo: { __typename?: 'CollectionSegmentInfo'; hasNextPage: boolean; hasPreviousPage: boolean };
    items?: Array<{
      __typename?: 'Dtos_V2_JobSite_JobSiteDto';
      jobsiteId: string;
      jobName: string;
      customId: string;
      location: string;
      cityTown: string;
      state: string;
      zip: string;
      latitude?: any | null;
      longitude?: any | null;
      parcelNumber: string;
      crossStreet: string;
      defaultBidLot: string;
      mapPage: string;
      jobPhone: string;
      jobNumber: string;
      specialInstruction: string;
      contractNumber: string;
      defaultPoNumber: string;
      billableTravelHours: any;
      createdOn: string;
      prelimed: string;
      notes: string;
      jobsiteType: string;
      projectType: string;
      pricingScheme: string;
      salesAgent: string;
      salesRegion: string;
      billingAddress: string;
      customer?: { __typename?: 'Dtos_V2_JobSite_CustomerInfoDto'; id?: string | null; name?: string | null } | null;
      contractor?: { __typename?: 'Dtos_V2_JobSite_ContractorInfoDto'; id?: string | null; name?: string | null } | null;
      settings?: {
        __typename?: 'Dtos_V2_JobSite_SettingsDto';
        ocip: boolean;
        cprPrevailing: boolean;
        publicProject: boolean;
        released: boolean;
        safetyRequired: boolean;
        nonTaxable: boolean;
        geofencing: boolean;
        poRequired: boolean;
        emailInvoices: boolean;
        inactive: boolean;
      } | null;
    }> | null;
  } | null;
};

export type JobSiteFieldsFragment = {
  __typename?: 'Dtos_V2_JobSite_JobSiteDto';
  jobsiteId: string;
  jobName: string;
  customId: string;
  location: string;
  cityTown: string;
  state: string;
  zip: string;
  latitude?: any | null;
  longitude?: any | null;
  parcelNumber: string;
  crossStreet: string;
  defaultBidLot: string;
  mapPage: string;
  jobPhone: string;
  jobNumber: string;
  specialInstruction: string;
  contractNumber: string;
  defaultPoNumber: string;
  billableTravelHours: any;
  createdOn: string;
  prelimed: string;
  notes: string;
  jobsiteType: string;
  projectType: string;
  pricingScheme: string;
  salesAgent: string;
  salesRegion: string;
  billingAddress: string;
  customer?: { __typename?: 'Dtos_V2_JobSite_CustomerInfoDto'; id?: string | null; name?: string | null } | null;
  contractor?: { __typename?: 'Dtos_V2_JobSite_ContractorInfoDto'; id?: string | null; name?: string | null } | null;
  settings?: {
    __typename?: 'Dtos_V2_JobSite_SettingsDto';
    ocip: boolean;
    cprPrevailing: boolean;
    publicProject: boolean;
    released: boolean;
    safetyRequired: boolean;
    nonTaxable: boolean;
    geofencing: boolean;
    poRequired: boolean;
    emailInvoices: boolean;
    inactive: boolean;
  } | null;
};

export type GetTimeZonesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V2_TimeZone_TimeZoneDtoFilterInput>;
  order?: InputMaybe<Array<Dtos_V2_TimeZone_TimeZoneDtoSortInput> | Dtos_V2_TimeZone_TimeZoneDtoSortInput>;
}>;

export type GetTimeZonesQuery = {
  __typename?: 'Query';
  timeZones?: {
    __typename?: 'TimeZonesCollectionSegment';
    totalCount: number;
    pageInfo: { __typename?: 'CollectionSegmentInfo'; hasNextPage: boolean; hasPreviousPage: boolean };
    items?: Array<{
      __typename?: 'Dtos_V2_TimeZone_TimeZoneDto';
      id: string;
      timeZone?: string | null;
      shortName?: string | null;
      default: boolean;
    }> | null;
  } | null;
};

export type TimeZoneFieldsFragment = {
  __typename?: 'Dtos_V2_TimeZone_TimeZoneDto';
  id: string;
  timeZone?: string | null;
  shortName?: string | null;
  default: boolean;
};

export type ListAvailableCrewMembersQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  availableCrewMembersInput?: InputMaybe<Input_V2_Queries_CrewMembersInput>;
  where?: InputMaybe<Dtos_V2_CrewDtoFilterInput>;
  order?: InputMaybe<Array<Dtos_V2_CrewDtoSortInput> | Dtos_V2_CrewDtoSortInput>;
}>;

export type ListAvailableCrewMembersQuery = {
  __typename?: 'Query';
  availableCrewMembers?: {
    __typename?: 'AvailableCrewMembersCollectionSegment';
    totalCount: number;
    items?: Array<{
      __typename?: 'Dtos_V2_CrewDto';
      id: number;
      name?: string | null;
      employmentType?: EmploymentType | null;
      status: Array<CrewAssignmentStatus>;
      statusNotes: string;
      jobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
      employmentStatus?: { __typename?: 'Dtos_V1_EmploymentStatusDto'; id: number; name?: string | null } | null;
    }> | null;
  } | null;
};

export type ListAvailableEquipmentsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  availableEquipmentsInput?: InputMaybe<Input_V2_Queries_Equipment_AvailableEquipmentsInput>;
  where?: InputMaybe<Dtos_V2_Equipment_EquipmentDtoFilterInput>;
  order?: InputMaybe<Array<Dtos_V2_Equipment_EquipmentDtoSortInput> | Dtos_V2_Equipment_EquipmentDtoSortInput>;
}>;

export type ListAvailableEquipmentsQuery = {
  __typename?: 'Query';
  availableEquipments?: {
    __typename?: 'AvailableEquipmentsCollectionSegment';
    totalCount: number;
    items?: Array<{
      __typename?: 'Dtos_V2_Equipment_EquipmentDto';
      id: number;
      name?: string | null;
      equipmentStatus?: EquipmentStatusType | null;
      statusNotes?: string | null;
      type?: { __typename?: 'Dtos_V1_EquipmentTypeDto'; id: number; name?: string | null } | null;
      class?: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null } | null;
      size?: { __typename?: 'Dtos_V1_EquipmentSizeDto'; id: number; name?: string | null } | null;
      status?: { __typename?: 'Dtos_V1_JobStatusDto'; id: number; name?: string | null } | null;
      defaultEmployee?: {
        __typename?: 'Dtos_V2_CrewDto';
        id: number;
        fullName?: string | null;
        employmentType?: EmploymentType | null;
        status: Array<CrewAssignmentStatus>;
        statusNotes: string;
        jobRoles?: Array<{ __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null }> | null;
        employmentStatus?: { __typename?: 'Dtos_V1_EmploymentStatusDto'; id: number; name?: string | null } | null;
      } | null;
    }> | null;
  } | null;
};

export type ListAvailableExtraSystemsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V1_ExtraSystemDtoFilterInput>;
  order?: InputMaybe<Array<Dtos_V1_ExtraSystemDtoSortInput> | Dtos_V1_ExtraSystemDtoSortInput>;
}>;

export type ListAvailableExtraSystemsQuery = {
  __typename?: 'Query';
  extraSystems?: {
    __typename?: 'ExtraSystemsCollectionSegment';
    totalCount: number;
    items?: Array<{
      __typename?: 'Dtos_V1_ExtraSystemDto';
      id: number;
      name?: string | null;
      description?: string | null;
      quantity: any;
      price: any;
    }> | null;
  } | null;
};

export type ListCustomersAutocompleteQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V2_Customer_CustomerDtoFilterInput>;
}>;

export type ListCustomersAutocompleteQuery = {
  __typename?: 'Query';
  customers?: {
    __typename?: 'CustomersCollectionSegment';
    totalCount: number;
    items?: Array<{
      __typename?: 'Dtos_V2_Customer_CustomerDto';
      id?: number | null;
      companyName?: string | null;
      primaryEmail?: string | null;
      primaryPhone?: string | null;
      contacts?: Array<{
        __typename?: 'ContactDto';
        id?: number | null;
        firstName?: string | null;
        lastName?: string | null;
        contactInformation: Array<{
          __typename?: 'ContactInformationDto';
          id?: number | null;
          type?: string | null;
          contact?: string | null;
        }>;
      }> | null;
    }> | null;
  } | null;
};

export type ListDispatchLocationsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V1_DispatchLocationDtoFilterInput>;
  order?: InputMaybe<Array<Dtos_V1_DispatchLocationDtoSortInput> | Dtos_V1_DispatchLocationDtoSortInput>;
}>;

export type ListDispatchLocationsQuery = {
  __typename?: 'Query';
  dispatchLocations?: {
    __typename?: 'DispatchLocationsCollectionSegment';
    totalCount: number;
    items?: Array<{ __typename?: 'Dtos_V1_DispatchLocationDto'; id: number; name?: string | null }> | null;
  } | null;
};

export type ListDispatchersAutocompleteQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListDispatchersAutocompleteQuery = {
  __typename?: 'Query';
  dispatchers?: {
    __typename?: 'DispatchersCollectionSegment';
    totalCount: number;
    items?: Array<{
      __typename?: 'Dtos_V2_Employee_EmployeeDto';
      id: number;
      name?: string | null;
      user?: { __typename?: 'Dtos_V2_User_UserSummaryDto'; userId: number } | null;
    }> | null;
  } | null;
};

export type ListEquipmentSizesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V1_EquipmentSizeDtoFilterInput>;
  order?: InputMaybe<Array<Dtos_V1_EquipmentSizeDtoSortInput> | Dtos_V1_EquipmentSizeDtoSortInput>;
}>;

export type ListEquipmentSizesQuery = {
  __typename?: 'Query';
  equipmentSizes?: {
    __typename?: 'EquipmentSizesCollectionSegment';
    totalCount: number;
    items?: Array<{ __typename?: 'Dtos_V1_EquipmentSizeDto'; id: number; name?: string | null }> | null;
  } | null;
};

export type ListJobSitesAutocompleteQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListJobSitesAutocompleteQuery = {
  __typename?: 'Query';
  jobSites?: {
    __typename?: 'JobSitesCollectionSegment';
    totalCount: number;
    items?: Array<{
      __typename?: 'Dtos_V2_JobSite_JobSiteDto';
      jobsiteId: string;
      jobName: string;
      location: string;
      latitude?: any | null;
      longitude?: any | null;
    }> | null;
  } | null;
};

export type ListJobSitesAutocompleteWithoutCustomerQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListJobSitesAutocompleteWithoutCustomerQuery = {
  __typename?: 'Query';
  jobSites?: {
    __typename?: 'JobSitesCollectionSegment';
    totalCount: number;
    items?: Array<{
      __typename?: 'Dtos_V2_JobSite_JobSiteDto';
      jobsiteId: string;
      jobName: string;
      location: string;
      latitude?: any | null;
      longitude?: any | null;
    }> | null;
  } | null;
};

export type ListJobTypesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V2_JobTypeDtoFilterInput>;
  order?: InputMaybe<Array<Dtos_V2_JobTypeDtoSortInput> | Dtos_V2_JobTypeDtoSortInput>;
}>;

export type ListJobTypesQuery = {
  __typename?: 'Query';
  jobTypes?: {
    __typename?: 'JobTypesCollectionSegment';
    totalCount: number;
    items?: Array<{ __typename?: 'Dtos_V2_JobTypeDto'; id: number; name?: string | null }> | null;
  } | null;
};

export type ListJobsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V2_RaptorJob_RaptorJobDtoFilterInput>;
  order?: InputMaybe<Array<Dtos_V2_RaptorJob_RaptorJobDtoSortInput> | Dtos_V2_RaptorJob_RaptorJobDtoSortInput>;
  startDate: Scalars['LocalDate']['input'];
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
}>;

export type ListJobsQuery = {
  __typename?: 'Query';
  raptorJobs?: {
    __typename?: 'RaptorJobsCollectionSegment';
    totalCount: number;
    pageInfo: { __typename?: 'CollectionSegmentInfo'; hasNextPage: boolean; hasPreviousPage: boolean };
    items?: Array<{
      __typename?: 'Dtos_V2_RaptorJob_RaptorJobDto';
      id: number;
      jobNumber: string;
      jobName: string;
      startDate: any;
      endDate?: any | null;
      calledInTime: any;
      timeZone?: string | null;
      cancelable: boolean;
      cod: boolean;
      crew: Array<{
        __typename?: 'Dtos_V2_CrewDto';
        fullName?: string | null;
        role?: { __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null } | null;
      }>;
      customer: {
        __typename?: 'CustomerDto';
        id?: number | null;
        companyName?: string | null;
        primaryPhone?: string | null;
        primaryEmail?: string | null;
      };
      jobSite: {
        __typename?: 'Dtos_V1_JobSiteDto';
        id: number;
        address?: string | null;
        jobSiteName?: string | null;
        powerlinePresent?: boolean | null;
        cpr?: boolean | null;
        ocip?: boolean | null;
        publicProject?: boolean | null;
        jobSiteType?: { __typename?: 'JobSiteTypeDto'; id: number; objectName: string } | null;
      };
      type: { __typename?: 'Dtos_V2_JobTypeDto'; id: number; name?: string | null };
      equipmentLocation: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null };
      dispatchLocation: { __typename?: 'Dtos_V1_DispatchLocationDto'; id: number; name?: string | null };
      status: { __typename?: 'Dtos_V1_JobStatusDto'; id: number; name?: string | null };
      sizeRequested: { __typename?: 'Dtos_V1_EquipmentSizeDto'; id: number; name?: string | null };
      equipment: Array<{
        __typename?: 'Dtos_V2_Equipment_EquipmentDto';
        id: number;
        name?: string | null;
        size?: { __typename?: 'Dtos_V1_EquipmentSizeDto'; id: number; name?: string | null } | null;
        plannedAllocation: {
          __typename?: 'Dtos_V2_Equipment_EquipmentPlannedAllocationDto';
          date?: any | null;
          estimatedHours?: number | null;
          startTime?: any | null;
          onJobTime?: any | null;
          leaveTime?: any | null;
          showUpTime?: any | null;
        };
      }>;
      specialFlag1?: { __typename?: 'Dtos_V1_SpecialFlagDto'; id: number; name?: string | null } | null;
      specialFlag2?: { __typename?: 'Dtos_V1_SpecialFlagDto'; id: number; name?: string | null } | null;
      specialFlag3?: { __typename?: 'Dtos_V1_SpecialFlagDto'; id: number; name?: string | null } | null;
    }> | null;
  } | null;
};

export type JobTableViewFieldsFragment = {
  __typename?: 'Dtos_V2_RaptorJob_RaptorJobDto';
  id: number;
  jobNumber: string;
  jobName: string;
  startDate: any;
  endDate?: any | null;
  calledInTime: any;
  timeZone?: string | null;
  cancelable: boolean;
  cod: boolean;
  crew: Array<{
    __typename?: 'Dtos_V2_CrewDto';
    fullName?: string | null;
    role?: { __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null } | null;
  }>;
  customer: {
    __typename?: 'CustomerDto';
    id?: number | null;
    companyName?: string | null;
    primaryPhone?: string | null;
    primaryEmail?: string | null;
  };
  jobSite: {
    __typename?: 'Dtos_V1_JobSiteDto';
    id: number;
    address?: string | null;
    jobSiteName?: string | null;
    powerlinePresent?: boolean | null;
    cpr?: boolean | null;
    ocip?: boolean | null;
    publicProject?: boolean | null;
    jobSiteType?: { __typename?: 'JobSiteTypeDto'; id: number; objectName: string } | null;
  };
  type: { __typename?: 'Dtos_V2_JobTypeDto'; id: number; name?: string | null };
  equipmentLocation: { __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null };
  dispatchLocation: { __typename?: 'Dtos_V1_DispatchLocationDto'; id: number; name?: string | null };
  status: { __typename?: 'Dtos_V1_JobStatusDto'; id: number; name?: string | null };
  sizeRequested: { __typename?: 'Dtos_V1_EquipmentSizeDto'; id: number; name?: string | null };
  equipment: Array<{
    __typename?: 'Dtos_V2_Equipment_EquipmentDto';
    id: number;
    name?: string | null;
    size?: { __typename?: 'Dtos_V1_EquipmentSizeDto'; id: number; name?: string | null } | null;
    plannedAllocation: {
      __typename?: 'Dtos_V2_Equipment_EquipmentPlannedAllocationDto';
      date?: any | null;
      estimatedHours?: number | null;
      startTime?: any | null;
      onJobTime?: any | null;
      leaveTime?: any | null;
      showUpTime?: any | null;
    };
  }>;
  specialFlag1?: { __typename?: 'Dtos_V1_SpecialFlagDto'; id: number; name?: string | null } | null;
  specialFlag2?: { __typename?: 'Dtos_V1_SpecialFlagDto'; id: number; name?: string | null } | null;
  specialFlag3?: { __typename?: 'Dtos_V1_SpecialFlagDto'; id: number; name?: string | null } | null;
};

export type ListSalesAgentsAutocompleteQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListSalesAgentsAutocompleteQuery = {
  __typename?: 'Query';
  salesAgents?: {
    __typename?: 'SalesAgentsCollectionSegment';
    totalCount: number;
    items?: Array<{
      __typename?: 'Dtos_V1_EmployeeDto';
      id: number;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      default?: boolean | null;
    }> | null;
  } | null;
};

export type ListWorkLocationsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Dtos_V1_LocationDtoFilterInput>;
  order?: InputMaybe<Array<Dtos_V1_LocationDtoSortInput> | Dtos_V1_LocationDtoSortInput>;
}>;

export type ListWorkLocationsQuery = {
  __typename?: 'Query';
  workLocations?: {
    __typename?: 'WorkLocationsCollectionSegment';
    totalCount: number;
    items?: Array<{ __typename?: 'Dtos_V1_LocationDto'; id: number; name?: string | null }> | null;
  } | null;
};

export type GetRaptorJobsQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['LocalDate']['input']>;
  endDate?: InputMaybe<Scalars['LocalDate']['input']>;
  referenceStartDate?: InputMaybe<Scalars['LocalDate']['input']>;
  referenceEndDate?: InputMaybe<Scalars['LocalDate']['input']>;
  where?: InputMaybe<Dtos_V2_RaptorJob_RaptorJobDtoFilterInput>;
  order?: InputMaybe<Array<Dtos_V2_RaptorJob_RaptorJobDtoSortInput> | Dtos_V2_RaptorJob_RaptorJobDtoSortInput>;
}>;

export type GetRaptorJobsQuery = {
  __typename?: 'Query';
  raptorJobs?: {
    __typename?: 'RaptorJobsCollectionSegment';
    totalCount: number;
    pageInfo: { __typename?: 'CollectionSegmentInfo'; hasNextPage: boolean; hasPreviousPage: boolean };
    items?: Array<{
      __typename?: 'Dtos_V2_RaptorJob_RaptorJobDto';
      id: number;
      jobName: string;
      startDate: any;
      finishedAt?: any | null;
      estimatedClearedTime?: any | null;
      isMultiDay: boolean;
      endDate?: any | null;
      timeZone?: string | null;
      plannedAllocation: { __typename?: 'Dtos_V2_Equipment_EquipmentPlannedAllocationDto'; startTime?: any | null; date?: any | null };
      status: { __typename?: 'Dtos_V1_JobStatusDto'; id: number; name?: string | null };
      crew: Array<{
        __typename?: 'Dtos_V2_CrewDto';
        deletable?: boolean | null;
        employmentType?: EmploymentType | null;
        endDate?: any | null;
        firstName?: string | null;
        fullName?: string | null;
        id: number;
        lastName?: string | null;
        name?: string | null;
        startDate?: any | null;
        status: Array<CrewAssignmentStatus>;
        role?: { __typename?: 'Dtos_V1_CrewRoleDto'; id: number; name?: string | null } | null;
      }>;
      jobSite: { __typename?: 'Dtos_V1_JobSiteDto'; id: number; address?: string | null; state?: string | null; zipCode?: string | null };
      customer: { __typename?: 'CustomerDto'; id?: number | null; companyName?: string | null };
      sizeRequested: { __typename?: 'Dtos_V1_EquipmentSizeDto'; id: number; name?: string | null };
      specialFlag1?: { __typename?: 'Dtos_V1_SpecialFlagDto'; id: number; name?: string | null } | null;
      specialFlag2?: { __typename?: 'Dtos_V1_SpecialFlagDto'; id: number; name?: string | null } | null;
      specialFlag3?: { __typename?: 'Dtos_V1_SpecialFlagDto'; id: number; name?: string | null } | null;
      equipment: Array<{
        __typename?: 'Dtos_V2_Equipment_EquipmentDto';
        id: number;
        name?: string | null;
        plannedAllocation: {
          __typename?: 'Dtos_V2_Equipment_EquipmentPlannedAllocationDto';
          estimatedHours?: number | null;
          startTime?: any | null;
          onJobTime?: any | null;
          leaveTime?: any | null;
          showUpTime?: any | null;
          endTime?: any | null;
        };
        class?: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null } | null;
        type?: { __typename?: 'Dtos_V1_EquipmentTypeDto'; id: number; name?: string | null } | null;
        size?: { __typename?: 'Dtos_V1_EquipmentSizeDto'; id: number; name?: string | null } | null;
      }>;
    }> | null;
  } | null;
};

export type ListAvailableEquipmentsForTimelineQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  availableEquipmentsInput?: InputMaybe<Input_V2_Queries_Equipment_AvailableEquipmentsInput>;
  where?: InputMaybe<Dtos_V2_Equipment_EquipmentDtoFilterInput>;
  order?: InputMaybe<Array<Dtos_V2_Equipment_EquipmentDtoSortInput> | Dtos_V2_Equipment_EquipmentDtoSortInput>;
}>;

export type ListAvailableEquipmentsForTimelineQuery = {
  __typename?: 'Query';
  availableEquipments?: {
    __typename?: 'AvailableEquipmentsCollectionSegment';
    totalCount: number;
    items?: Array<{
      __typename?: 'Dtos_V2_Equipment_EquipmentDto';
      id: number;
      name?: string | null;
      class?: { __typename?: 'Dtos_V1_EquipmentClassDto'; id?: number | null; name?: string | null } | null;
      type?: { __typename?: 'Dtos_V1_EquipmentTypeDto'; id: number; name?: string | null } | null;
      size?: { __typename?: 'Dtos_V1_EquipmentSizeDto'; id: number; name?: string | null } | null;
      status?: { __typename?: 'Dtos_V1_JobStatusDto'; id: number; name?: string | null } | null;
    }> | null;
  } | null;
};

export type UpdateRaptorJobTimelineMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  startDate: Scalars['Date']['input'];
  startTime?: InputMaybe<Scalars['TimeSpan']['input']>;
  onJobTime?: InputMaybe<Scalars['TimeSpan']['input']>;
  leaveTime?: InputMaybe<Scalars['TimeSpan']['input']>;
  showUpTime?: InputMaybe<Scalars['TimeSpan']['input']>;
  estimatedHours: Scalars['Decimal']['input'];
  timeZone?: InputMaybe<Scalars['String']['input']>;
  equipmentToAdd?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  equipmentToDelete?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  crewMembersToDelete?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  jobInformationId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type UpdateRaptorJobTimelineMutation = {
  __typename?: 'Mutation';
  updateRaptorJob: {
    __typename?: 'ResultOfDtos_V2_RaptorJob_RaptorJobDto';
    isSuccess: boolean;
    error?: {
      __typename?: 'Error';
      statusCode: number;
      errorType: ErrorType;
      errorMessage: string;
      validationErrors: Array<{ __typename?: 'ValidationException'; field: string; message: string }>;
    } | null;
  };
};

export type UnassignRaptorJobFromTimelineMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  startDate: Scalars['Date']['input'];
  estimatedHours: Scalars['Decimal']['input'];
  equipmentToDelete?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  jobInformationId?: InputMaybe<Scalars['Int']['input']>;
}>;

export type UnassignRaptorJobFromTimelineMutation = {
  __typename?: 'Mutation';
  updateRaptorJob: {
    __typename?: 'ResultOfDtos_V2_RaptorJob_RaptorJobDto';
    isSuccess: boolean;
    error?: {
      __typename?: 'Error';
      statusCode: number;
      errorType: ErrorType;
      errorMessage: string;
      validationErrors: Array<{ __typename?: 'ValidationException'; field: string; message: string }>;
    } | null;
  };
};

export type GetAvailableExtraSystemsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAvailableExtraSystemsQuery = {
  __typename?: 'Query';
  raptorJobSupportingDataQuery: {
    __typename?: 'ResultOfDtos_V2_RaptorJob_RaptorJobSupportingDataDto';
    value: {
      __typename?: 'Dtos_V2_RaptorJob_RaptorJobSupportingDataDto';
      availableExtraSystems: Array<{ __typename?: 'Dtos_V1_ExtraSystemDto'; id: number; name?: string | null }>;
    };
  };
};

export type GetAvailableSpecialFlagsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAvailableSpecialFlagsQuery = {
  __typename?: 'Query';
  raptorJobSupportingDataQuery: {
    __typename?: 'ResultOfDtos_V2_RaptorJob_RaptorJobSupportingDataDto';
    value: {
      __typename?: 'Dtos_V2_RaptorJob_RaptorJobSupportingDataDto';
      availableSpecialFlags: Array<{ __typename?: 'Dtos_V1_SpecialFlagDto'; id: number; name?: string | null }>;
    };
  };
};

export type GetAvailableVendorsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAvailableVendorsQuery = {
  __typename?: 'Query';
  raptorJobSupportingDataQuery: {
    __typename?: 'ResultOfDtos_V2_RaptorJob_RaptorJobSupportingDataDto';
    value: {
      __typename?: 'Dtos_V2_RaptorJob_RaptorJobSupportingDataDto';
      availableVendors: Array<{ __typename?: 'Dtos_V1_VendorDto'; id: number; name?: string | null; default?: boolean | null }>;
    };
  };
};

export type GetCustomerUiBehaviorRulesQueryVariables = Exact<{ [key: string]: never }>;

export type GetCustomerUiBehaviorRulesQuery = {
  __typename?: 'Query';
  raptorJobSupportingDataQuery: {
    __typename?: 'ResultOfDtos_V2_RaptorJob_RaptorJobSupportingDataDto';
    value: {
      __typename?: 'Dtos_V2_RaptorJob_RaptorJobSupportingDataDto';
      uiBehaviorRules: Array<{ __typename?: 'Dtos_V2_RaptorJob_JobFieldUiBehaviorRuleDto'; name: string; enabled: boolean }>;
    };
  };
};

export type GetSalesAgentsAutocompleteWithTakeQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetSalesAgentsAutocompleteWithTakeQuery = {
  __typename?: 'Query';
  salesAgents?: {
    __typename?: 'SalesAgentsCollectionSegment';
    totalCount: number;
    items?: Array<{
      __typename?: 'Dtos_V1_EmployeeDto';
      id: number;
      name?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      default?: boolean | null;
    }> | null;
  } | null;
};

export type GetSalesRegionsAutocompleteWithTakeQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetSalesRegionsAutocompleteWithTakeQuery = {
  __typename?: 'Query';
  salesRegions?: {
    __typename?: 'SalesRegionsCollectionSegment';
    totalCount: number;
    items?: Array<{ __typename?: 'Dtos_V1_SalesRegionDto'; id?: number | null; salesRegionName?: string | null }> | null;
  } | null;
};

export const AddressInfoFragmentDoc = gql`
  fragment AddressInfo on AddressDto {
    address
    city
    state
    zipCode
    country
  }
`;
export const CustomerContactInfoFragmentDoc = gql`
  fragment CustomerContactInfo on ContactInformationDto {
    id
    contact
    type
  }
`;
export const CustomerFormFieldsFragmentDoc = gql`
  fragment CustomerFormFields on Dtos_V2_Customer_CustomerDto {
    id
    companyName
    primaryEmail
    primaryPhone
    deletable
    customerStatus
    financialSummary {
      revenue
    }
    address {
      ...AddressInfo
    }
    contacts {
      id
      firstName
      lastName
      title
      contactInformation {
        ...CustomerContactInfo
      }
    }
    customerType {
      id
      typeName
    }
    salesAgent {
      empId
      fullName
    }
    term {
      id
      termName
    }
    pricingScheme {
      id
      schemeName
    }
    salesRegion {
      id
      salesRegionName
    }
    accountType {
      id
      accountType
    }
    notes
    taxNumber
    maxCredit
    customerDiscount
    createdOn
    updatedOn
  }
  ${AddressInfoFragmentDoc}
  ${CustomerContactInfoFragmentDoc}
`;
export const EmployeeContactInfoFragmentDoc = gql`
  fragment EmployeeContactInfo on ContactInformationDto {
    contact
    id
    type
  }
`;
export const EmployeeJobRoleInfoFragmentDoc = gql`
  fragment EmployeeJobRoleInfo on Dtos_V1_CrewRoleDto {
    id
    name
  }
`;
export const EmploymentStatusInfoFragmentDoc = gql`
  fragment EmploymentStatusInfo on Dtos_V1_EmploymentStatusDto {
    id
    name
  }
`;
export const EmployeeLocationInfoFragmentDoc = gql`
  fragment EmployeeLocationInfo on Dtos_V1_LocationDto {
    id
    name
  }
`;
export const EmployeeFormFieldsFragmentDoc = gql`
  fragment EmployeeFormFields on Dtos_V2_Employee_EmployeeDto {
    id
    deletable
    firstName
    lastName
    phoneNumber {
      ...EmployeeContactInfo
    }
    email {
      ...EmployeeContactInfo
    }
    driversLicense {
      number
      state
    }
    jobRoles {
      ...EmployeeJobRoleInfo
    }
    employmentType
    employmentStatus {
      ...EmploymentStatusInfo
    }
    dispatchLocation {
      ...EmployeeLocationInfo
    }
    workLocation {
      ...EmployeeLocationInfo
    }
    startDate
    endDate
    notes
  }
  ${EmployeeContactInfoFragmentDoc}
  ${EmployeeJobRoleInfoFragmentDoc}
  ${EmploymentStatusInfoFragmentDoc}
  ${EmployeeLocationInfoFragmentDoc}
`;
export const JobRoleInfoFragmentDoc = gql`
  fragment JobRoleInfo on Dtos_V1_CrewRoleDto {
    id
    name
  }
`;
export const LocationInfoFragmentDoc = gql`
  fragment LocationInfo on Dtos_V1_LocationDto {
    id
    name
  }
`;
export const EmployeeFormFieldsDetailsFragmentDoc = gql`
  fragment EmployeeFormFieldsDetails on Dtos_V2_Employee_EmployeeDto {
    id
    deletable
    firstName
    lastName
    phoneNumber {
      ...EmployeeContactInfo
    }
    email {
      ...EmployeeContactInfo
    }
    driversLicense {
      number
      state
    }
    jobRoles {
      ...JobRoleInfo
    }
    employmentType
    employmentStatus {
      ...EmploymentStatusInfo
    }
    dispatchLocation {
      ...LocationInfo
    }
    workLocation {
      ...LocationInfo
    }
    startDate
    endDate
    notes
  }
  ${EmployeeContactInfoFragmentDoc}
  ${JobRoleInfoFragmentDoc}
  ${EmploymentStatusInfoFragmentDoc}
  ${LocationInfoFragmentDoc}
`;
export const PageInfoFieldsFragmentDoc = gql`
  fragment PageInfoFields on CollectionSegmentInfo {
    hasNextPage
    hasPreviousPage
  }
`;
export const EmployeeCrewMemberTableViewFieldsFragmentDoc = gql`
  fragment EmployeeCrewMemberTableViewFields on Dtos_V1_EmployeeDto {
    id
    name
    fullName
    jobRoles {
      id
      name
    }
    employmentType
    employmentStatus {
      id
      name
    }
  }
`;
export const EmployeeTableViewFieldsFragmentDoc = gql`
  fragment EmployeeTableViewFields on Dtos_V1_EmployeeDto {
    id
    eid
    name
    fullName
    startDate
    endDate
    jobRoles {
      id
      name
    }
    availableJobRoles {
      id
      name
    }
    employmentStatus {
      id
      name
    }
    phoneNumber {
      contact
      id
      type
    }
    email {
      contact
      id
      type
    }
    dispatchLocation {
      id
      name
    }
    workLocation {
      id
      name
    }
    seniorityCode
    updatedOn
    deletable
    usable
    inactive
    dotHours8Day
    dotHours7Day
    dotHours6Day
    dotHours5Day
    clockStatus
    clockTime
    assignedEquipment
    daysOut
    updatedBy {
      id
      name
    }
  }
`;
export const CrewInfoFragmentDoc = gql`
  fragment CrewInfo on Dtos_V1_CrewDto {
    id
    name
    jobRoles {
      id
      name
    }
    supportedRoleIds
    defaultEmployeeCrewRoleId
  }
`;
export const MakeInfoFragmentDoc = gql`
  fragment MakeInfo on Dtos_V1_EquipmentMakeDto {
    id
    name
  }
`;
export const EquipmentClassInfoFragmentDoc = gql`
  fragment EquipmentClassInfo on Dtos_V1_EquipmentClassDto {
    id
    name
  }
`;
export const EquipmentTypeInfoFragmentDoc = gql`
  fragment EquipmentTypeInfo on Dtos_V1_EquipmentTypeDto {
    id
    name
    class {
      id
      name
    }
  }
`;
export const EquipmentSizeInfoFragmentDoc = gql`
  fragment EquipmentSizeInfo on Dtos_V1_EquipmentSizeDto {
    id
    name
    class {
      id
      name
    }
  }
`;
export const EmployeeInfoFragmentDoc = gql`
  fragment EmployeeInfo on Dtos_V1_EmployeeDto {
    id
    name
  }
`;
export const JobStatusInfoFragmentDoc = gql`
  fragment JobStatusInfo on Dtos_V1_JobStatusDto {
    id
    name
  }
`;
export const DispatchLocationInfoFragmentDoc = gql`
  fragment DispatchLocationInfo on Dtos_V1_DispatchLocationDto {
    id
    name
  }
`;
export const ModelInfoFragmentDoc = gql`
  fragment ModelInfo on Dtos_V1_EquipmentModelDto {
    id
    name
  }
`;
export const EquipmentFormFieldsFragmentDoc = gql`
  fragment EquipmentFormFields on Dtos_V1_Equipment_EquipmentDto {
    id
    name
    make {
      ...MakeInfo
    }
    year
    class {
      ...EquipmentClassInfo
    }
    type {
      ...EquipmentTypeInfo
    }
    size {
      ...EquipmentSizeInfo
    }
    defaultEmployee {
      ...EmployeeInfo
      jobRoles {
        id
        name
      }
      defaultEmployeeCrewRoleId
    }
    requiredJobRoles {
      ...JobRoleInfo
    }
    status {
      ...JobStatusInfo
    }
    notes
    dispatchLocation {
      ...DispatchLocationInfo
    }
    licensePlate {
      number
      state
    }
    defaultLocation {
      ...LocationInfo
    }
    location {
      ...LocationInfo
    }
    model {
      ...ModelInfo
    }
    gpsTrackerSerialNumber
    geoFencingEnabled
    vinNumber
    grossWeight
    acquiredOn
    beganServiceOn
    purchasedMileage
    beganServiceMileage
    mpEquipmentId
  }
  ${MakeInfoFragmentDoc}
  ${EquipmentClassInfoFragmentDoc}
  ${EquipmentTypeInfoFragmentDoc}
  ${EquipmentSizeInfoFragmentDoc}
  ${EmployeeInfoFragmentDoc}
  ${JobRoleInfoFragmentDoc}
  ${JobStatusInfoFragmentDoc}
  ${DispatchLocationInfoFragmentDoc}
  ${LocationInfoFragmentDoc}
  ${ModelInfoFragmentDoc}
`;
export const EquipmentTableViewFieldsFragmentDoc = gql`
  fragment EquipmentTableViewFields on Dtos_V1_Equipment_EquipmentDto {
    id
    name
    notes
    deletable
    make {
      id
      name
    }
    model {
      id
      name
      make {
        id
        name
      }
    }
    year
    class {
      id
      name
    }
    type {
      id
      name
    }
    size {
      id
      name
    }
    status {
      id
      name
    }
    vinNumber
    gpsTrackerSerialNumber
    geoFencingEnabled
    licensePlate {
      number
      state
    }
    grossWeight
    acquiredOn
    beganServiceOn
    purchasedMileage
    beganServiceMileage
    defaultLocation {
      id
      name
    }
    location {
      id
      name
    }
    dispatchLocation {
      id
      name
    }
    mpEquipmentId
    truckYear
    truckModelNumber
    machineSerialNumber
    boomSerialNumber
    boomModelNum
    defaultInsideSystemDiameter
    defaultEndStyle
    maxGroundBearingPressure
    daysDown
    unworkable
  }
`;
export const JobSiteContactInfoFragmentDoc = gql`
  fragment JobSiteContactInfo on ContactInformationDto {
    contact
    id
    type
  }
`;
export const JobSiteLocationInfoFragmentDoc = gql`
  fragment JobSiteLocationInfo on Dtos_V1_LocationDto {
    id
    name
  }
`;
export const JobSiteJobRoleInfoFragmentDoc = gql`
  fragment JobSiteJobRoleInfo on Dtos_V1_CrewRoleDto {
    id
    name
  }
`;
export const JobSiteFormFieldsFragmentDoc = gql`
  fragment JobSiteFormFields on Dtos_V2_JobSite_JobSiteDto {
    jobsiteId
    deletable
    jobName
    location
    cityTown
    state
    zip
    latitude
    longitude
    parcelNumber
    crossStreet
    defaultBidLot
    mapPage
    jobPhone
    jobNumber
    specialInstruction
    contractNumber
    defaultPoNumber
    billableTravelHours
    createdOn
    notes
    customId
    billingAddress
    jobsiteType
    projectType
    pricingScheme
    salesAgent
    salesRegion
    disposal
    customer {
      id
      name
    }
    contractor {
      id
      name
    }
    settings {
      inactive
      ocip
      cprPrevailing
      publicProject
      released
      safetyRequired
      nonTaxable
      geofencing
      poRequired
      emailInvoices
    }
    flags {
      powerline
      noSubs
    }
  }
`;
export const JobSiteTableViewFieldsFragmentDoc = gql`
  fragment JobSiteTableViewFields on Dtos_V2_JobSite_JobSiteDto {
    jobsiteId
    jobName
    location
    cityTown
    state
    zip
    latitude
    longitude
    parcelNumber
    crossStreet
    defaultBidLot
    mapPage
    jobPhone
    jobNumber
    specialInstruction
    contractNumber
    defaultPoNumber
    billableTravelHours
    createdOn
    prelimed
    notes
    customId
    customer {
      id
      name
    }
    contractor {
      id
      name
    }
    jobsiteType
    projectType
    pricingScheme
    salesAgent
    salesRegion
    billingAddress
    settings {
      ocip
      cprPrevailing
      publicProject
      released
      safetyRequired
      nonTaxable
      geofencing
      poRequired
      emailInvoices
      inactive
    }
    flags {
      powerline
    }
    verified
    verifiedBy
    deletable
  }
`;
export const JobFormFieldsFragmentDoc = gql`
  fragment JobFormFields on Dtos_V2_RaptorJob_RaptorJobDto {
    id
    jobNumber
    jobName
    poNumber
    startDate
    endDate
    calledInTime
    timeZone
    caller
    createdBy {
      id
      name
    }
    createdOn
    updatedBy {
      id
      name
    }
    updatedOn
    confirmedBy {
      id
      name
    }
    confirmedTime
    dispatchNotes
    specialInstructions
    notesForCrew
    jobInformation {
      id
      name
    }
    dispatcher {
      id
      name
    }
    cod
    strictSizeRequested
    sizeRequested {
      id
      name
    }
    specialFlag1 {
      id
      name
    }
    specialFlag2 {
      id
      name
    }
    specialFlag3 {
      id
      name
    }
    priorityCode
    vendor {
      id
      name
      mailAddress
      phoneNumber
      emailAddress
    }
    crew {
      id
      name
      role {
        id
        name
      }
      employmentType
      employmentStatus {
        id
        name
      }
      supportedRoleIds
      plannedAllocation {
        date
        showUpTime
        leaveTime
        onJobTime
        startTime
        clearTime
        estimatedHours
      }
      notified
      acknowledged
    }
    equipment {
      id
      name
      plannedAllocation {
        date
        showUpTime
        leaveTime
        onJobTime
        startTime
        clearTime
        estimatedHours
        estimatedVolume
        estimatedArea
      }
      make {
        id
        name
      }
      model {
        id
        name
      }
      year
      class {
        id
        name
      }
      type {
        id
        name
      }
      size {
        id
        name
      }
      defaultEmployee {
        id
        fullName
        jobRoles {
          id
          name
        }
        employmentType
        employmentStatus {
          id
          name
        }
        status
        statusNotes
      }
      requiredJobRoles {
        id
        name
      }
      status {
        id
        name
        colorCode
      }
      notes
      dispatchLocation {
        id
        name
      }
      licensePlate {
        number
        state
      }
      location {
        id
        name
      }
      gpsTrackerSerialNumber
      geoFencingEnabled
      availableClasses {
        id
        name
      }
    }
    extraSystems {
      id
      name
      description
      price
      quantity
      class {
        id
        name
      }
      billable
      taxable
      defaultItem
      showAsExtraSystemOnJob
      plannedAllocation {
        date
        showUpTime
        leaveTime
        onJobTime
        startTime
        clearTime
        estimatedHours
      }
    }
    customer {
      id
      companyName
      primaryPhone
      primaryEmail
    }
    salesAgent {
      id
      name
    }
    jobSite {
      id
      jobNumber
      jobSiteName
      address
      latitude
      longitude
    }
    type {
      id
      name
    }
    status {
      id
      name
    }
    equipmentLocation {
      id
      name
    }
    dispatchLocation {
      id
      name
    }
    jobInformation {
      id
      name
    }
    cancelable
  }
`;
export const JobSiteFieldsFragmentDoc = gql`
  fragment JobSiteFields on Dtos_V2_JobSite_JobSiteDto {
    jobsiteId
    jobName
    customId
    location
    cityTown
    state
    zip
    latitude
    longitude
    parcelNumber
    crossStreet
    defaultBidLot
    mapPage
    jobPhone
    jobNumber
    specialInstruction
    contractNumber
    defaultPoNumber
    billableTravelHours
    createdOn
    prelimed
    notes
    customer {
      id
      name
    }
    contractor {
      id
      name
    }
    jobsiteType
    projectType
    pricingScheme
    salesAgent
    salesRegion
    billingAddress
    settings {
      ocip
      cprPrevailing
      publicProject
      released
      safetyRequired
      nonTaxable
      geofencing
      poRequired
      emailInvoices
      inactive
    }
  }
`;
export const TimeZoneFieldsFragmentDoc = gql`
  fragment TimeZoneFields on Dtos_V2_TimeZone_TimeZoneDto {
    id
    timeZone
    shortName
    default
  }
`;
export const JobTableViewFieldsFragmentDoc = gql`
  fragment JobTableViewFields on Dtos_V2_RaptorJob_RaptorJobDto {
    id
    jobNumber
    jobName
    crew {
      fullName
      role {
        id
        name
      }
    }
    startDate
    endDate
    customer {
      id
      companyName
      primaryPhone
      primaryEmail
    }
    jobSite {
      id
      address
      jobSiteName
      powerlinePresent
      cpr
      ocip
      publicProject
      jobSiteType {
        id
        objectName
      }
    }
    type {
      id
      name
    }
    calledInTime
    timeZone
    equipmentLocation {
      id
      name
    }
    dispatchLocation {
      id
      name
    }
    status {
      id
      name
    }
    sizeRequested {
      id
      name
    }
    equipment {
      id
      name
      size {
        id
        name
      }
      plannedAllocation {
        date
        estimatedHours
        startTime
        onJobTime
        leaveTime
        showUpTime
      }
    }
    cancelable
    cod
    timeZone
    specialFlag1 {
      id
      name
    }
    specialFlag2 {
      id
      name
    }
    specialFlag3 {
      id
      name
    }
  }
`;
export const CreateCustomerDocument = gql`
  mutation createCustomer($customer: CreateCustomerMutationInput!) {
    createCustomer(input: $customer) {
      isSuccess
      value {
        id
        companyName
      }
      error {
        errorMessage
        errorType
        statusCode
        validationErrors {
          field
          message
        }
      }
    }
  }
`;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function useCreateCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
}
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const DeleteCustomerDocument = gql`
  mutation deleteCustomer($customerId: Int!) {
    deleteCustomer(input: { id: $customerId }) {
      isSuccess
      error {
        errorMessage
        errorType
        statusCode
        validationErrors {
          field
          message
        }
      }
    }
  }
`;
export type DeleteCustomerMutationFn = Apollo.MutationFunction<DeleteCustomerMutation, DeleteCustomerMutationVariables>;

/**
 * __useDeleteCustomerMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerMutation, { data, loading, error }] = useDeleteCustomerMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useDeleteCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteCustomerMutation, DeleteCustomerMutationVariables>(DeleteCustomerDocument, options);
}
export type DeleteCustomerMutationHookResult = ReturnType<typeof useDeleteCustomerMutation>;
export type DeleteCustomerMutationResult = Apollo.MutationResult<DeleteCustomerMutation>;
export type DeleteCustomerMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>;
export const UpdateCustomerDocument = gql`
  mutation updateCustomer($customer: UpdateCustomerMutationInput!) {
    updateCustomer(input: $customer) {
      isSuccess
      error {
        errorMessage
        errorType
        statusCode
        validationErrors {
          field
          message
        }
      }
    }
  }
`;
export type UpdateCustomerMutationFn = Apollo.MutationFunction<UpdateCustomerMutation, UpdateCustomerMutationVariables>;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function useUpdateCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(UpdateCustomerDocument, options);
}
export type UpdateCustomerMutationHookResult = ReturnType<typeof useUpdateCustomerMutation>;
export type UpdateCustomerMutationResult = Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const GetAccountTypesDocument = gql`
  query getAccountTypes {
    accountTypes {
      items {
        id
        accountType
      }
    }
  }
`;

/**
 * __useGetAccountTypesQuery__
 *
 * To run a query within a React component, call `useGetAccountTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountTypesQuery, GetAccountTypesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAccountTypesQuery, GetAccountTypesQueryVariables>(GetAccountTypesDocument, options);
}
export function useGetAccountTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAccountTypesQuery, GetAccountTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAccountTypesQuery, GetAccountTypesQueryVariables>(GetAccountTypesDocument, options);
}
export type GetAccountTypesQueryHookResult = ReturnType<typeof useGetAccountTypesQuery>;
export type GetAccountTypesLazyQueryHookResult = ReturnType<typeof useGetAccountTypesLazyQuery>;
export type GetAccountTypesQueryResult = Apollo.QueryResult<GetAccountTypesQuery, GetAccountTypesQueryVariables>;
export const GetAccountTypesAutocompleteDocument = gql`
  query getAccountTypesAutocomplete($skip: Int, $search: String) {
    accountTypes(skip: $skip, take: 100, where: { or: [{ accountType: { contains: $search } }] }) {
      totalCount
      items {
        id
        accountType
      }
    }
  }
`;

/**
 * __useGetAccountTypesAutocompleteQuery__
 *
 * To run a query within a React component, call `useGetAccountTypesAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountTypesAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountTypesAutocompleteQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAccountTypesAutocompleteQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAccountTypesAutocompleteQuery, GetAccountTypesAutocompleteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAccountTypesAutocompleteQuery, GetAccountTypesAutocompleteQueryVariables>(
    GetAccountTypesAutocompleteDocument,
    options
  );
}
export function useGetAccountTypesAutocompleteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAccountTypesAutocompleteQuery, GetAccountTypesAutocompleteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAccountTypesAutocompleteQuery, GetAccountTypesAutocompleteQueryVariables>(
    GetAccountTypesAutocompleteDocument,
    options
  );
}
export type GetAccountTypesAutocompleteQueryHookResult = ReturnType<typeof useGetAccountTypesAutocompleteQuery>;
export type GetAccountTypesAutocompleteLazyQueryHookResult = ReturnType<typeof useGetAccountTypesAutocompleteLazyQuery>;
export type GetAccountTypesAutocompleteQueryResult = Apollo.QueryResult<
  GetAccountTypesAutocompleteQuery,
  GetAccountTypesAutocompleteQueryVariables
>;
export const GetCustomerDocument = gql`
  query getCustomer($customerId: Int!) {
    customerDetails(input: { customerId: $customerId }) {
      ...CustomerFormFields
      availableCustomerTypes {
        id
        typeName
      }
      availableSalesAgents {
        empId
        fullName
      }
      availableTerms {
        id
        termName
      }
      availablePricingSchemes {
        id
        schemeName
      }
      availableSalesRegions {
        id
        salesRegionName
      }
      availableAccountTypes {
        id
        accountType
      }
    }
  }
  ${CustomerFormFieldsFragmentDoc}
`;

/**
 * __useGetCustomerQuery__
 *
 * To run a query within a React component, call `useGetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
}
export function useGetCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
}
export type GetCustomerQueryHookResult = ReturnType<typeof useGetCustomerQuery>;
export type GetCustomerLazyQueryHookResult = ReturnType<typeof useGetCustomerLazyQuery>;
export type GetCustomerQueryResult = Apollo.QueryResult<GetCustomerQuery, GetCustomerQueryVariables>;
export const GetCustomerCallerIdDocument = gql`
  query getCustomerCallerId($customerId: Int!) {
    customerDetails(input: { customerId: $customerId }) {
      id
      companyName
      contacts {
        id
        firstName
        lastName
        contactInformation {
          id
          type
          contact
        }
      }
    }
  }
`;

/**
 * __useGetCustomerCallerIdQuery__
 *
 * To run a query within a React component, call `useGetCustomerCallerIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerCallerIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerCallerIdQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerCallerIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetCustomerCallerIdQuery, GetCustomerCallerIdQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCustomerCallerIdQuery, GetCustomerCallerIdQueryVariables>(GetCustomerCallerIdDocument, options);
}
export function useGetCustomerCallerIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerCallerIdQuery, GetCustomerCallerIdQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCustomerCallerIdQuery, GetCustomerCallerIdQueryVariables>(GetCustomerCallerIdDocument, options);
}
export type GetCustomerCallerIdQueryHookResult = ReturnType<typeof useGetCustomerCallerIdQuery>;
export type GetCustomerCallerIdLazyQueryHookResult = ReturnType<typeof useGetCustomerCallerIdLazyQuery>;
export type GetCustomerCallerIdQueryResult = Apollo.QueryResult<GetCustomerCallerIdQuery, GetCustomerCallerIdQueryVariables>;
export const GetCustomerTypesDocument = gql`
  query getCustomerTypes {
    customerTypes {
      items {
        id
        typeName
      }
    }
  }
`;

/**
 * __useGetCustomerTypesQuery__
 *
 * To run a query within a React component, call `useGetCustomerTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomerTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerTypesQuery, GetCustomerTypesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCustomerTypesQuery, GetCustomerTypesQueryVariables>(GetCustomerTypesDocument, options);
}
export function useGetCustomerTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerTypesQuery, GetCustomerTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCustomerTypesQuery, GetCustomerTypesQueryVariables>(GetCustomerTypesDocument, options);
}
export type GetCustomerTypesQueryHookResult = ReturnType<typeof useGetCustomerTypesQuery>;
export type GetCustomerTypesLazyQueryHookResult = ReturnType<typeof useGetCustomerTypesLazyQuery>;
export type GetCustomerTypesQueryResult = Apollo.QueryResult<GetCustomerTypesQuery, GetCustomerTypesQueryVariables>;
export const GetCustomerTypesAutocompleteDocument = gql`
  query getCustomerTypesAutocomplete($skip: Int, $search: String) {
    customerTypes(skip: $skip, take: 100, where: { or: [{ typeName: { contains: $search } }] }) {
      totalCount
      items {
        id
        typeName
      }
    }
  }
`;

/**
 * __useGetCustomerTypesAutocompleteQuery__
 *
 * To run a query within a React component, call `useGetCustomerTypesAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerTypesAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerTypesAutocompleteQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetCustomerTypesAutocompleteQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCustomerTypesAutocompleteQuery, GetCustomerTypesAutocompleteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCustomerTypesAutocompleteQuery, GetCustomerTypesAutocompleteQueryVariables>(
    GetCustomerTypesAutocompleteDocument,
    options
  );
}
export function useGetCustomerTypesAutocompleteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerTypesAutocompleteQuery, GetCustomerTypesAutocompleteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCustomerTypesAutocompleteQuery, GetCustomerTypesAutocompleteQueryVariables>(
    GetCustomerTypesAutocompleteDocument,
    options
  );
}
export type GetCustomerTypesAutocompleteQueryHookResult = ReturnType<typeof useGetCustomerTypesAutocompleteQuery>;
export type GetCustomerTypesAutocompleteLazyQueryHookResult = ReturnType<typeof useGetCustomerTypesAutocompleteLazyQuery>;
export type GetCustomerTypesAutocompleteQueryResult = Apollo.QueryResult<
  GetCustomerTypesAutocompleteQuery,
  GetCustomerTypesAutocompleteQueryVariables
>;
export const GetPricingSchemesDocument = gql`
  query getPricingSchemes {
    pricingSchemes {
      items {
        id
        schemeName
      }
    }
  }
`;

/**
 * __useGetPricingSchemesQuery__
 *
 * To run a query within a React component, call `useGetPricingSchemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingSchemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricingSchemesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPricingSchemesQuery(baseOptions?: Apollo.QueryHookOptions<GetPricingSchemesQuery, GetPricingSchemesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPricingSchemesQuery, GetPricingSchemesQueryVariables>(GetPricingSchemesDocument, options);
}
export function useGetPricingSchemesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPricingSchemesQuery, GetPricingSchemesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPricingSchemesQuery, GetPricingSchemesQueryVariables>(GetPricingSchemesDocument, options);
}
export type GetPricingSchemesQueryHookResult = ReturnType<typeof useGetPricingSchemesQuery>;
export type GetPricingSchemesLazyQueryHookResult = ReturnType<typeof useGetPricingSchemesLazyQuery>;
export type GetPricingSchemesQueryResult = Apollo.QueryResult<GetPricingSchemesQuery, GetPricingSchemesQueryVariables>;
export const GetPricingSchemesAutocompleteDocument = gql`
  query getPricingSchemesAutocomplete($skip: Int, $search: String) {
    pricingSchemes(skip: $skip, take: 100, where: { or: [{ schemeName: { contains: $search } }] }) {
      totalCount
      items {
        id
        schemeName
      }
    }
  }
`;

/**
 * __useGetPricingSchemesAutocompleteQuery__
 *
 * To run a query within a React component, call `useGetPricingSchemesAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingSchemesAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricingSchemesAutocompleteQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPricingSchemesAutocompleteQuery(
  baseOptions?: Apollo.QueryHookOptions<GetPricingSchemesAutocompleteQuery, GetPricingSchemesAutocompleteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPricingSchemesAutocompleteQuery, GetPricingSchemesAutocompleteQueryVariables>(
    GetPricingSchemesAutocompleteDocument,
    options
  );
}
export function useGetPricingSchemesAutocompleteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPricingSchemesAutocompleteQuery, GetPricingSchemesAutocompleteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPricingSchemesAutocompleteQuery, GetPricingSchemesAutocompleteQueryVariables>(
    GetPricingSchemesAutocompleteDocument,
    options
  );
}
export type GetPricingSchemesAutocompleteQueryHookResult = ReturnType<typeof useGetPricingSchemesAutocompleteQuery>;
export type GetPricingSchemesAutocompleteLazyQueryHookResult = ReturnType<typeof useGetPricingSchemesAutocompleteLazyQuery>;
export type GetPricingSchemesAutocompleteQueryResult = Apollo.QueryResult<
  GetPricingSchemesAutocompleteQuery,
  GetPricingSchemesAutocompleteQueryVariables
>;
export const GetSalesAgentsDocument = gql`
  query getSalesAgents {
    salesAgents {
      items {
        fullName
        empId: id
        default
      }
    }
  }
`;

/**
 * __useGetSalesAgentsQuery__
 *
 * To run a query within a React component, call `useGetSalesAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesAgentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalesAgentsQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesAgentsQuery, GetSalesAgentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSalesAgentsQuery, GetSalesAgentsQueryVariables>(GetSalesAgentsDocument, options);
}
export function useGetSalesAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesAgentsQuery, GetSalesAgentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSalesAgentsQuery, GetSalesAgentsQueryVariables>(GetSalesAgentsDocument, options);
}
export type GetSalesAgentsQueryHookResult = ReturnType<typeof useGetSalesAgentsQuery>;
export type GetSalesAgentsLazyQueryHookResult = ReturnType<typeof useGetSalesAgentsLazyQuery>;
export type GetSalesAgentsQueryResult = Apollo.QueryResult<GetSalesAgentsQuery, GetSalesAgentsQueryVariables>;
export const GetSalesAgentsAutocompleteDocument = gql`
  query getSalesAgentsAutocomplete($skip: Int, $search: String) {
    salesAgents(skip: $skip, take: 100, where: { or: [{ fullName: { contains: $search } }] }) {
      totalCount
      items {
        id
        fullName
        default
      }
    }
  }
`;

/**
 * __useGetSalesAgentsAutocompleteQuery__
 *
 * To run a query within a React component, call `useGetSalesAgentsAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesAgentsAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesAgentsAutocompleteQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetSalesAgentsAutocompleteQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSalesAgentsAutocompleteQuery, GetSalesAgentsAutocompleteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSalesAgentsAutocompleteQuery, GetSalesAgentsAutocompleteQueryVariables>(
    GetSalesAgentsAutocompleteDocument,
    options
  );
}
export function useGetSalesAgentsAutocompleteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSalesAgentsAutocompleteQuery, GetSalesAgentsAutocompleteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSalesAgentsAutocompleteQuery, GetSalesAgentsAutocompleteQueryVariables>(
    GetSalesAgentsAutocompleteDocument,
    options
  );
}
export type GetSalesAgentsAutocompleteQueryHookResult = ReturnType<typeof useGetSalesAgentsAutocompleteQuery>;
export type GetSalesAgentsAutocompleteLazyQueryHookResult = ReturnType<typeof useGetSalesAgentsAutocompleteLazyQuery>;
export type GetSalesAgentsAutocompleteQueryResult = Apollo.QueryResult<
  GetSalesAgentsAutocompleteQuery,
  GetSalesAgentsAutocompleteQueryVariables
>;
export const GetSalesRegionsDocument = gql`
  query getSalesRegions {
    salesRegions {
      items {
        id
        salesRegionName
      }
    }
  }
`;

/**
 * __useGetSalesRegionsQuery__
 *
 * To run a query within a React component, call `useGetSalesRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSalesRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSalesRegionsQuery, GetSalesRegionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSalesRegionsQuery, GetSalesRegionsQueryVariables>(GetSalesRegionsDocument, options);
}
export function useGetSalesRegionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSalesRegionsQuery, GetSalesRegionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSalesRegionsQuery, GetSalesRegionsQueryVariables>(GetSalesRegionsDocument, options);
}
export type GetSalesRegionsQueryHookResult = ReturnType<typeof useGetSalesRegionsQuery>;
export type GetSalesRegionsLazyQueryHookResult = ReturnType<typeof useGetSalesRegionsLazyQuery>;
export type GetSalesRegionsQueryResult = Apollo.QueryResult<GetSalesRegionsQuery, GetSalesRegionsQueryVariables>;
export const GetSalesRegionsAutocompleteDocument = gql`
  query getSalesRegionsAutocomplete($skip: Int, $search: String) {
    salesRegions(skip: $skip, take: 100, where: { or: [{ salesRegionName: { contains: $search } }] }) {
      totalCount
      items {
        id
        salesRegionName
      }
    }
  }
`;

/**
 * __useGetSalesRegionsAutocompleteQuery__
 *
 * To run a query within a React component, call `useGetSalesRegionsAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesRegionsAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesRegionsAutocompleteQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetSalesRegionsAutocompleteQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSalesRegionsAutocompleteQuery, GetSalesRegionsAutocompleteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSalesRegionsAutocompleteQuery, GetSalesRegionsAutocompleteQueryVariables>(
    GetSalesRegionsAutocompleteDocument,
    options
  );
}
export function useGetSalesRegionsAutocompleteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSalesRegionsAutocompleteQuery, GetSalesRegionsAutocompleteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSalesRegionsAutocompleteQuery, GetSalesRegionsAutocompleteQueryVariables>(
    GetSalesRegionsAutocompleteDocument,
    options
  );
}
export type GetSalesRegionsAutocompleteQueryHookResult = ReturnType<typeof useGetSalesRegionsAutocompleteQuery>;
export type GetSalesRegionsAutocompleteLazyQueryHookResult = ReturnType<typeof useGetSalesRegionsAutocompleteLazyQuery>;
export type GetSalesRegionsAutocompleteQueryResult = Apollo.QueryResult<
  GetSalesRegionsAutocompleteQuery,
  GetSalesRegionsAutocompleteQueryVariables
>;
export const GetTermsDocument = gql`
  query getTerms {
    terms {
      items {
        id
        termName
      }
    }
  }
`;

/**
 * __useGetTermsQuery__
 *
 * To run a query within a React component, call `useGetTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTermsQuery(baseOptions?: Apollo.QueryHookOptions<GetTermsQuery, GetTermsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTermsQuery, GetTermsQueryVariables>(GetTermsDocument, options);
}
export function useGetTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTermsQuery, GetTermsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTermsQuery, GetTermsQueryVariables>(GetTermsDocument, options);
}
export type GetTermsQueryHookResult = ReturnType<typeof useGetTermsQuery>;
export type GetTermsLazyQueryHookResult = ReturnType<typeof useGetTermsLazyQuery>;
export type GetTermsQueryResult = Apollo.QueryResult<GetTermsQuery, GetTermsQueryVariables>;
export const GetTermsAutocompleteDocument = gql`
  query getTermsAutocomplete($skip: Int, $search: String) {
    terms(skip: $skip, take: 100, where: { or: [{ termName: { contains: $search } }] }) {
      totalCount
      items {
        id
        termName
      }
    }
  }
`;

/**
 * __useGetTermsAutocompleteQuery__
 *
 * To run a query within a React component, call `useGetTermsAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsAutocompleteQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetTermsAutocompleteQuery(
  baseOptions?: Apollo.QueryHookOptions<GetTermsAutocompleteQuery, GetTermsAutocompleteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTermsAutocompleteQuery, GetTermsAutocompleteQueryVariables>(GetTermsAutocompleteDocument, options);
}
export function useGetTermsAutocompleteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTermsAutocompleteQuery, GetTermsAutocompleteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTermsAutocompleteQuery, GetTermsAutocompleteQueryVariables>(GetTermsAutocompleteDocument, options);
}
export type GetTermsAutocompleteQueryHookResult = ReturnType<typeof useGetTermsAutocompleteQuery>;
export type GetTermsAutocompleteLazyQueryHookResult = ReturnType<typeof useGetTermsAutocompleteLazyQuery>;
export type GetTermsAutocompleteQueryResult = Apollo.QueryResult<GetTermsAutocompleteQuery, GetTermsAutocompleteQueryVariables>;
export const ListCustomersDocument = gql`
  query listCustomers(
    $skip: Int
    $take: Int
    $where: Dtos_V2_Customer_CustomerDtoFilterInput
    $order: [Dtos_V2_Customer_CustomerDtoSortInput!]
  ) {
    customers(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      items {
        id
        companyName
        primaryEmail
        primaryPhone
        address {
          address
        }
        deletable
        financialSummary {
          revenue
        }
        customerType {
          id
          typeName
        }
        salesRegion {
          id
          salesRegionName
        }
        salesAgent {
          empId
          fullName
        }
        maxCredit
        customerStatus
        createdOn
        updatedOn
      }
    }
  }
`;

/**
 * __useListCustomersQuery__
 *
 * To run a query within a React component, call `useListCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCustomersQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListCustomersQuery(baseOptions?: Apollo.QueryHookOptions<ListCustomersQuery, ListCustomersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListCustomersQuery, ListCustomersQueryVariables>(ListCustomersDocument, options);
}
export function useListCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCustomersQuery, ListCustomersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListCustomersQuery, ListCustomersQueryVariables>(ListCustomersDocument, options);
}
export type ListCustomersQueryHookResult = ReturnType<typeof useListCustomersQuery>;
export type ListCustomersLazyQueryHookResult = ReturnType<typeof useListCustomersLazyQuery>;
export type ListCustomersQueryResult = Apollo.QueryResult<ListCustomersQuery, ListCustomersQueryVariables>;
export const BanEmployeeDocument = gql`
  mutation BanEmployee($id: Int!, $banType: String!, $bannedFromId: Int!) {
    banEmployee(id: $id, banType: $banType, bannedFromId: $bannedFromId) {
      isSuccess
      error {
        errorMessage
        validationErrors {
          field
          message
        }
      }
    }
  }
`;
export type BanEmployeeMutationFn = Apollo.MutationFunction<BanEmployeeMutation, BanEmployeeMutationVariables>;

/**
 * __useBanEmployeeMutation__
 *
 * To run a mutation, you first call `useBanEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBanEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [banEmployeeMutation, { data, loading, error }] = useBanEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      banType: // value for 'banType'
 *      bannedFromId: // value for 'bannedFromId'
 *   },
 * });
 */
export function useBanEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<BanEmployeeMutation, BanEmployeeMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BanEmployeeMutation, BanEmployeeMutationVariables>(BanEmployeeDocument, options);
}
export type BanEmployeeMutationHookResult = ReturnType<typeof useBanEmployeeMutation>;
export type BanEmployeeMutationResult = Apollo.MutationResult<BanEmployeeMutation>;
export type BanEmployeeMutationOptions = Apollo.BaseMutationOptions<BanEmployeeMutation, BanEmployeeMutationVariables>;
export const CreateEmployeeDocument = gql`
  mutation createEmployee($employee: Input_V1_Mutations_Employee_CreateEmployeeMutationInput!) {
    createEmployee(input: $employee) {
      value {
        id
      }
      isSuccess
      error {
        errorMessage
        errorType
        statusCode
        validationErrors {
          field
          message
        }
      }
    }
  }
`;
export type CreateEmployeeMutationFn = Apollo.MutationFunction<CreateEmployeeMutation, CreateEmployeeMutationVariables>;

/**
 * __useCreateEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeMutation, { data, loading, error }] = useCreateEmployeeMutation({
 *   variables: {
 *      employee: // value for 'employee'
 *   },
 * });
 */
export function useCreateEmployeeMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateEmployeeMutation, CreateEmployeeMutationVariables>(CreateEmployeeDocument, options);
}
export type CreateEmployeeMutationHookResult = ReturnType<typeof useCreateEmployeeMutation>;
export type CreateEmployeeMutationResult = Apollo.MutationResult<CreateEmployeeMutation>;
export type CreateEmployeeMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>;
export const DeleteEmployeeDocument = gql`
  mutation deleteEmployee($employeeId: Int!) {
    deleteEmployee(id: $employeeId) {
      isSuccess
      error {
        errorMessage
        errorType
        statusCode
        validationErrors {
          field
          message
        }
      }
    }
  }
`;
export type DeleteEmployeeMutationFn = Apollo.MutationFunction<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;

/**
 * __useDeleteEmployeeMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeMutation, { data, loading, error }] = useDeleteEmployeeMutation({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useDeleteEmployeeMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>(DeleteEmployeeDocument, options);
}
export type DeleteEmployeeMutationHookResult = ReturnType<typeof useDeleteEmployeeMutation>;
export type DeleteEmployeeMutationResult = Apollo.MutationResult<DeleteEmployeeMutation>;
export type DeleteEmployeeMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;
export const CancelBanAssignmentDocument = gql`
  mutation CancelBanAssignment($id: Int!) {
    cancelBanAssignment(id: $id) {
      isSuccess
      error {
        errorMessage
        validationErrors {
          field
          message
        }
      }
    }
  }
`;
export type CancelBanAssignmentMutationFn = Apollo.MutationFunction<CancelBanAssignmentMutation, CancelBanAssignmentMutationVariables>;

/**
 * __useCancelBanAssignmentMutation__
 *
 * To run a mutation, you first call `useCancelBanAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelBanAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelBanAssignmentMutation, { data, loading, error }] = useCancelBanAssignmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelBanAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<CancelBanAssignmentMutation, CancelBanAssignmentMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CancelBanAssignmentMutation, CancelBanAssignmentMutationVariables>(CancelBanAssignmentDocument, options);
}
export type CancelBanAssignmentMutationHookResult = ReturnType<typeof useCancelBanAssignmentMutation>;
export type CancelBanAssignmentMutationResult = Apollo.MutationResult<CancelBanAssignmentMutation>;
export type CancelBanAssignmentMutationOptions = Apollo.BaseMutationOptions<
  CancelBanAssignmentMutation,
  CancelBanAssignmentMutationVariables
>;
export const UpdateEmployeeDocument = gql`
  mutation updateEmployee($employee: Input_V1_Mutations_Employee_UpdateEmployeeMutationInput!) {
    updateEmployee(input: $employee) {
      value {
        id
      }
      isSuccess
      error {
        errorMessage
        errorType
        statusCode
        validationErrors {
          field
          message
        }
      }
    }
  }
`;
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      employee: // value for 'employee'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>(UpdateEmployeeDocument, options);
}
export type UpdateEmployeeMutationHookResult = ReturnType<typeof useUpdateEmployeeMutation>;
export type UpdateEmployeeMutationResult = Apollo.MutationResult<UpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const GetEmployeeDocument = gql`
  query getEmployee($employeeId: Int!) {
    employeeDetails(input: { id: $employeeId }) {
      value {
        ...EmployeeFormFields
        availableJobRoles {
          ...EmployeeJobRoleInfo
        }
        availableEmploymentStatuses {
          ...EmploymentStatusInfo
        }
        availableDispatchLocations {
          ...EmployeeLocationInfo
        }
        availableWorkLocations {
          ...EmployeeLocationInfo
        }
        banEntries {
          banType
          id
          bannedFrom {
            id
            name
          }
          createdBy {
            id
            name
          }
          createdOn
          updatedBy {
            id
            name
          }
          updatedOn
        }
      }
    }
  }
  ${EmployeeFormFieldsFragmentDoc}
  ${EmployeeJobRoleInfoFragmentDoc}
  ${EmploymentStatusInfoFragmentDoc}
  ${EmployeeLocationInfoFragmentDoc}
`;

/**
 * __useGetEmployeeQuery__
 *
 * To run a query within a React component, call `useGetEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useGetEmployeeQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
}
export function useGetEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
}
export type GetEmployeeQueryHookResult = ReturnType<typeof useGetEmployeeQuery>;
export type GetEmployeeLazyQueryHookResult = ReturnType<typeof useGetEmployeeLazyQuery>;
export type GetEmployeeQueryResult = Apollo.QueryResult<GetEmployeeQuery, GetEmployeeQueryVariables>;
export const GetEmployeeDetailsByIdDocument = gql`
  query getEmployeeDetailsById($input: Input_V1_Queries_Employee_GetEmployeeDetailsInput!) {
    employeeDetails(input: $input) {
      value {
        ...EmployeeFormFieldsDetails
        upcomingOutOfOffice {
          id
          employee {
            id
            firstName
            lastName
            fullName
            employmentStatus {
              id
              name
            }
            systemRoles {
              id
              name
            }
          }
          startDate
          endDate
          reason {
            id
            name
          }
          notes
        }
      }
    }
  }
  ${EmployeeFormFieldsDetailsFragmentDoc}
`;

/**
 * __useGetEmployeeDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetEmployeeDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeDetailsByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEmployeeDetailsByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetEmployeeDetailsByIdQuery, GetEmployeeDetailsByIdQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployeeDetailsByIdQuery, GetEmployeeDetailsByIdQueryVariables>(GetEmployeeDetailsByIdDocument, options);
}
export function useGetEmployeeDetailsByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeDetailsByIdQuery, GetEmployeeDetailsByIdQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmployeeDetailsByIdQuery, GetEmployeeDetailsByIdQueryVariables>(GetEmployeeDetailsByIdDocument, options);
}
export type GetEmployeeDetailsByIdQueryHookResult = ReturnType<typeof useGetEmployeeDetailsByIdQuery>;
export type GetEmployeeDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetEmployeeDetailsByIdLazyQuery>;
export type GetEmployeeDetailsByIdQueryResult = Apollo.QueryResult<GetEmployeeDetailsByIdQuery, GetEmployeeDetailsByIdQueryVariables>;
export const GetEmployeeFormOptionsDocument = gql`
  query getEmployeeFormOptions {
    supportingEmployeeDataQuery {
      value {
        availableJobRoles {
          id
          name
        }
        availableEmploymentStatuses {
          id
          name
        }
        availableDispatchLocations {
          id
          name
        }
        availableWorkLocations {
          id
          name
        }
        availableOutOfOfficeReasons {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useGetEmployeeFormOptionsQuery__
 *
 * To run a query within a React component, call `useGetEmployeeFormOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeFormOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeFormOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmployeeFormOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetEmployeeFormOptionsQuery, GetEmployeeFormOptionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEmployeeFormOptionsQuery, GetEmployeeFormOptionsQueryVariables>(GetEmployeeFormOptionsDocument, options);
}
export function useGetEmployeeFormOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeFormOptionsQuery, GetEmployeeFormOptionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEmployeeFormOptionsQuery, GetEmployeeFormOptionsQueryVariables>(GetEmployeeFormOptionsDocument, options);
}
export type GetEmployeeFormOptionsQueryHookResult = ReturnType<typeof useGetEmployeeFormOptionsQuery>;
export type GetEmployeeFormOptionsLazyQueryHookResult = ReturnType<typeof useGetEmployeeFormOptionsLazyQuery>;
export type GetEmployeeFormOptionsQueryResult = Apollo.QueryResult<GetEmployeeFormOptionsQuery, GetEmployeeFormOptionsQueryVariables>;
export const ListCrewMembersDocument = gql`
  query listCrewMembers(
    $skip: Int
    $take: Int
    $where: Dtos_V1_EmployeeDtoFilterInput
    $order: [Dtos_V1_EmployeeDtoSortInput!]
    $employeesInput: Input_V1_Queries_Employee_GetEmployeesInput
  ) {
    employees(skip: $skip, take: $take, where: $where, order: $order, employeesInput: $employeesInput) {
      totalCount
      pageInfo {
        ...PageInfoFields
      }
      items {
        ...EmployeeCrewMemberTableViewFields
      }
    }
  }
  ${PageInfoFieldsFragmentDoc}
  ${EmployeeCrewMemberTableViewFieldsFragmentDoc}
`;

/**
 * __useListCrewMembersQuery__
 *
 * To run a query within a React component, call `useListCrewMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCrewMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCrewMembersQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      employeesInput: // value for 'employeesInput'
 *   },
 * });
 */
export function useListCrewMembersQuery(baseOptions?: Apollo.QueryHookOptions<ListCrewMembersQuery, ListCrewMembersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListCrewMembersQuery, ListCrewMembersQueryVariables>(ListCrewMembersDocument, options);
}
export function useListCrewMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListCrewMembersQuery, ListCrewMembersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListCrewMembersQuery, ListCrewMembersQueryVariables>(ListCrewMembersDocument, options);
}
export type ListCrewMembersQueryHookResult = ReturnType<typeof useListCrewMembersQuery>;
export type ListCrewMembersLazyQueryHookResult = ReturnType<typeof useListCrewMembersLazyQuery>;
export type ListCrewMembersQueryResult = Apollo.QueryResult<ListCrewMembersQuery, ListCrewMembersQueryVariables>;
export const ListEmployeesDocument = gql`
  query listEmployees($skip: Int, $take: Int, $where: Dtos_V1_EmployeeDtoFilterInput, $order: [Dtos_V1_EmployeeDtoSortInput!]) {
    employees(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      pageInfo {
        ...PageInfoFields
      }
      items {
        ...EmployeeTableViewFields
      }
    }
  }
  ${PageInfoFieldsFragmentDoc}
  ${EmployeeTableViewFieldsFragmentDoc}
`;

/**
 * __useListEmployeesQuery__
 *
 * To run a query within a React component, call `useListEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEmployeesQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<ListEmployeesQuery, ListEmployeesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListEmployeesQuery, ListEmployeesQueryVariables>(ListEmployeesDocument, options);
}
export function useListEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEmployeesQuery, ListEmployeesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListEmployeesQuery, ListEmployeesQueryVariables>(ListEmployeesDocument, options);
}
export type ListEmployeesQueryHookResult = ReturnType<typeof useListEmployeesQuery>;
export type ListEmployeesLazyQueryHookResult = ReturnType<typeof useListEmployeesLazyQuery>;
export type ListEmployeesQueryResult = Apollo.QueryResult<ListEmployeesQuery, ListEmployeesQueryVariables>;
export const CreateEquipmentDocument = gql`
  mutation createEquipment($equipment: Input_V2_Mutations_Equipment_CreateEquipmentMutationInput!) {
    createEquipment(input: $equipment) {
      value {
        id
      }
      isSuccess
      error {
        errorMessage
        errorType
        statusCode
        validationErrors {
          field
          message
        }
      }
    }
  }
`;
export type CreateEquipmentMutationFn = Apollo.MutationFunction<CreateEquipmentMutation, CreateEquipmentMutationVariables>;

/**
 * __useCreateEquipmentMutation__
 *
 * To run a mutation, you first call `useCreateEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEquipmentMutation, { data, loading, error }] = useCreateEquipmentMutation({
 *   variables: {
 *      equipment: // value for 'equipment'
 *   },
 * });
 */
export function useCreateEquipmentMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateEquipmentMutation, CreateEquipmentMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateEquipmentMutation, CreateEquipmentMutationVariables>(CreateEquipmentDocument, options);
}
export type CreateEquipmentMutationHookResult = ReturnType<typeof useCreateEquipmentMutation>;
export type CreateEquipmentMutationResult = Apollo.MutationResult<CreateEquipmentMutation>;
export type CreateEquipmentMutationOptions = Apollo.BaseMutationOptions<CreateEquipmentMutation, CreateEquipmentMutationVariables>;
export const DeleteEquipmentDocument = gql`
  mutation deleteEquipment($equipmentId: Int!) {
    deleteEquipment(input: { id: $equipmentId }) {
      isSuccess
      error {
        errorMessage
        errorType
        statusCode
        validationErrors {
          field
          message
        }
      }
    }
  }
`;
export type DeleteEquipmentMutationFn = Apollo.MutationFunction<DeleteEquipmentMutation, DeleteEquipmentMutationVariables>;

/**
 * __useDeleteEquipmentMutation__
 *
 * To run a mutation, you first call `useDeleteEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEquipmentMutation, { data, loading, error }] = useDeleteEquipmentMutation({
 *   variables: {
 *      equipmentId: // value for 'equipmentId'
 *   },
 * });
 */
export function useDeleteEquipmentMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteEquipmentMutation, DeleteEquipmentMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteEquipmentMutation, DeleteEquipmentMutationVariables>(DeleteEquipmentDocument, options);
}
export type DeleteEquipmentMutationHookResult = ReturnType<typeof useDeleteEquipmentMutation>;
export type DeleteEquipmentMutationResult = Apollo.MutationResult<DeleteEquipmentMutation>;
export type DeleteEquipmentMutationOptions = Apollo.BaseMutationOptions<DeleteEquipmentMutation, DeleteEquipmentMutationVariables>;
export const UpdateEquipmentDocument = gql`
  mutation updateEquipment($equipment: Input_V2_Mutations_Equipment_UpdateEquipmentMutationInput!) {
    updateEquipment(input: $equipment) {
      value {
        id
      }
      isSuccess
      error {
        errorMessage
        errorType
        statusCode
        validationErrors {
          field
          message
        }
      }
    }
  }
`;
export type UpdateEquipmentMutationFn = Apollo.MutationFunction<UpdateEquipmentMutation, UpdateEquipmentMutationVariables>;

/**
 * __useUpdateEquipmentMutation__
 *
 * To run a mutation, you first call `useUpdateEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEquipmentMutation, { data, loading, error }] = useUpdateEquipmentMutation({
 *   variables: {
 *      equipment: // value for 'equipment'
 *   },
 * });
 */
export function useUpdateEquipmentMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateEquipmentMutation, UpdateEquipmentMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateEquipmentMutation, UpdateEquipmentMutationVariables>(UpdateEquipmentDocument, options);
}
export type UpdateEquipmentMutationHookResult = ReturnType<typeof useUpdateEquipmentMutation>;
export type UpdateEquipmentMutationResult = Apollo.MutationResult<UpdateEquipmentMutation>;
export type UpdateEquipmentMutationOptions = Apollo.BaseMutationOptions<UpdateEquipmentMutation, UpdateEquipmentMutationVariables>;
export const GetEquipmentDocument = gql`
  query getEquipment($equipmentId: Int!) {
    equipmentDetails(equipmentInput: { id: $equipmentId }) {
      ...EquipmentFormFields
      availableMakes {
        ...MakeInfo
      }
      availableModels {
        ...ModelInfo
      }
      availableClasses {
        ...EquipmentClassInfo
      }
      availableTypes {
        ...EquipmentTypeInfo
      }
      availableSizes {
        ...EquipmentSizeInfo
      }
      availableEmployees {
        ...EmployeeInfo
      }
      availableDefaultEmployees {
        ...CrewInfo
      }
      availableJobRoles {
        ...JobRoleInfo
      }
      availableStatuses {
        ...JobStatusInfo
      }
      availableDispatchLocations {
        ...LocationInfo
      }
      availableLocations {
        ...LocationInfo
      }
    }
  }
  ${EquipmentFormFieldsFragmentDoc}
  ${MakeInfoFragmentDoc}
  ${ModelInfoFragmentDoc}
  ${EquipmentClassInfoFragmentDoc}
  ${EquipmentTypeInfoFragmentDoc}
  ${EquipmentSizeInfoFragmentDoc}
  ${EmployeeInfoFragmentDoc}
  ${CrewInfoFragmentDoc}
  ${JobRoleInfoFragmentDoc}
  ${JobStatusInfoFragmentDoc}
  ${LocationInfoFragmentDoc}
`;

/**
 * __useGetEquipmentQuery__
 *
 * To run a query within a React component, call `useGetEquipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentQuery({
 *   variables: {
 *      equipmentId: // value for 'equipmentId'
 *   },
 * });
 */
export function useGetEquipmentQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentQuery, GetEquipmentQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEquipmentQuery, GetEquipmentQueryVariables>(GetEquipmentDocument, options);
}
export function useGetEquipmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentQuery, GetEquipmentQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEquipmentQuery, GetEquipmentQueryVariables>(GetEquipmentDocument, options);
}
export type GetEquipmentQueryHookResult = ReturnType<typeof useGetEquipmentQuery>;
export type GetEquipmentLazyQueryHookResult = ReturnType<typeof useGetEquipmentLazyQuery>;
export type GetEquipmentQueryResult = Apollo.QueryResult<GetEquipmentQuery, GetEquipmentQueryVariables>;
export const GetEquipmentDetailsByIdDocument = gql`
  query getEquipmentDetailsById($input: Input_V1_Queries_Equipment_GetEquipmentDetailsInput!) {
    equipmentDetails(equipmentInput: $input) {
      id
      name
      make {
        id
        name
      }
      model {
        id
        name
        make {
          id
          name
        }
      }
      year
      status {
        id
        name
      }
      class {
        id
        name
      }
      type {
        id
        name
        class {
          id
          name
        }
      }
      size {
        id
        name
        class {
          id
          name
        }
      }
      upcomingOutOfService {
        id
        equipment {
          id
          name
        }
        start
        end
        reason {
          id
          name
        }
        notes
      }
      outOfServiceHistory {
        id
        equipment {
          id
          name
        }
        start
        end
        reason {
          id
          name
        }
        notes
      }
    }
  }
`;

/**
 * __useGetEquipmentDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetEquipmentDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentDetailsByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEquipmentDetailsByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetEquipmentDetailsByIdQuery, GetEquipmentDetailsByIdQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEquipmentDetailsByIdQuery, GetEquipmentDetailsByIdQueryVariables>(GetEquipmentDetailsByIdDocument, options);
}
export function useGetEquipmentDetailsByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentDetailsByIdQuery, GetEquipmentDetailsByIdQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEquipmentDetailsByIdQuery, GetEquipmentDetailsByIdQueryVariables>(GetEquipmentDetailsByIdDocument, options);
}
export type GetEquipmentDetailsByIdQueryHookResult = ReturnType<typeof useGetEquipmentDetailsByIdQuery>;
export type GetEquipmentDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetEquipmentDetailsByIdLazyQuery>;
export type GetEquipmentDetailsByIdQueryResult = Apollo.QueryResult<GetEquipmentDetailsByIdQuery, GetEquipmentDetailsByIdQueryVariables>;
export const GetEquipmentFormOptionsDocument = gql`
  query getEquipmentFormOptions {
    supportingEquipmentData {
      availableMakes {
        id
        name
      }
      availableModels {
        id
        name
      }
      availableClasses {
        id
        name
      }
      availableTypes {
        id
        name
        class {
          id
          name
        }
      }
      availableSizes {
        id
        name
        class {
          id
          name
        }
      }
      availableEmployees {
        id
        name
      }
      availableDefaultEmployees {
        id
        name
        supportedRoleIds
        defaultEmployeeCrewRoleId
      }
      availableJobRoles {
        id
        name
      }
      availableStatuses {
        id
        name
      }
      availableDispatchLocations {
        id
        name
      }
      availableLocations {
        id
        name
      }
      availableOutOfServiceReasons {
        id
        name
      }
    }
  }
`;

/**
 * __useGetEquipmentFormOptionsQuery__
 *
 * To run a query within a React component, call `useGetEquipmentFormOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentFormOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentFormOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEquipmentFormOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetEquipmentFormOptionsQuery, GetEquipmentFormOptionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEquipmentFormOptionsQuery, GetEquipmentFormOptionsQueryVariables>(GetEquipmentFormOptionsDocument, options);
}
export function useGetEquipmentFormOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentFormOptionsQuery, GetEquipmentFormOptionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEquipmentFormOptionsQuery, GetEquipmentFormOptionsQueryVariables>(GetEquipmentFormOptionsDocument, options);
}
export type GetEquipmentFormOptionsQueryHookResult = ReturnType<typeof useGetEquipmentFormOptionsQuery>;
export type GetEquipmentFormOptionsLazyQueryHookResult = ReturnType<typeof useGetEquipmentFormOptionsLazyQuery>;
export type GetEquipmentFormOptionsQueryResult = Apollo.QueryResult<GetEquipmentFormOptionsQuery, GetEquipmentFormOptionsQueryVariables>;
export const ListEquipmentsDocument = gql`
  query listEquipments(
    $skip: Int
    $take: Int
    $where: Dtos_V1_Equipment_EquipmentDtoFilterInput
    $order: [Dtos_V1_Equipment_EquipmentDtoSortInput!]
    $equipmentsInput: Input_V1_Queries_Equipment_GetEquipmentsInput
  ) {
    equipments(skip: $skip, take: $take, where: $where, order: $order, equipmentsInput: $equipmentsInput) {
      totalCount
      pageInfo {
        ...PageInfoFields
      }
      items {
        ...EquipmentTableViewFields
      }
    }
  }
  ${PageInfoFieldsFragmentDoc}
  ${EquipmentTableViewFieldsFragmentDoc}
`;

/**
 * __useListEquipmentsQuery__
 *
 * To run a query within a React component, call `useListEquipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEquipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEquipmentsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      equipmentsInput: // value for 'equipmentsInput'
 *   },
 * });
 */
export function useListEquipmentsQuery(baseOptions?: Apollo.QueryHookOptions<ListEquipmentsQuery, ListEquipmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListEquipmentsQuery, ListEquipmentsQueryVariables>(ListEquipmentsDocument, options);
}
export function useListEquipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEquipmentsQuery, ListEquipmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListEquipmentsQuery, ListEquipmentsQueryVariables>(ListEquipmentsDocument, options);
}
export type ListEquipmentsQueryHookResult = ReturnType<typeof useListEquipmentsQuery>;
export type ListEquipmentsLazyQueryHookResult = ReturnType<typeof useListEquipmentsLazyQuery>;
export type ListEquipmentsQueryResult = Apollo.QueryResult<ListEquipmentsQuery, ListEquipmentsQueryVariables>;
export const CreateJobSiteDocument = gql`
  mutation createJobSite($input: CreateJobsiteMutationInput!) {
    createJobSite(input: $input) {
      value {
        id
        jobSiteName
        address
        latitude
        longitude
      }
      isSuccess
      error {
        errorMessage
        errorType
        statusCode
        validationErrors {
          field
          message
        }
      }
    }
  }
`;
export type CreateJobSiteMutationFn = Apollo.MutationFunction<CreateJobSiteMutation, CreateJobSiteMutationVariables>;

/**
 * __useCreateJobSiteMutation__
 *
 * To run a mutation, you first call `useCreateJobSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobSiteMutation, { data, loading, error }] = useCreateJobSiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateJobSiteMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobSiteMutation, CreateJobSiteMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateJobSiteMutation, CreateJobSiteMutationVariables>(CreateJobSiteDocument, options);
}
export type CreateJobSiteMutationHookResult = ReturnType<typeof useCreateJobSiteMutation>;
export type CreateJobSiteMutationResult = Apollo.MutationResult<CreateJobSiteMutation>;
export type CreateJobSiteMutationOptions = Apollo.BaseMutationOptions<CreateJobSiteMutation, CreateJobSiteMutationVariables>;
export const DeleteJobSiteDocument = gql`
  mutation deleteJobSite($input: DeleteJobSiteMutationInput!) {
    deleteJobSite(input: $input) {
      isSuccess
      error {
        errorMessage
        errorType
        statusCode
        validationErrors {
          field
          message
        }
      }
    }
  }
`;
export type DeleteJobSiteMutationFn = Apollo.MutationFunction<DeleteJobSiteMutation, DeleteJobSiteMutationVariables>;

/**
 * __useDeleteJobSiteMutation__
 *
 * To run a mutation, you first call `useDeleteJobSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobSiteMutation, { data, loading, error }] = useDeleteJobSiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteJobSiteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobSiteMutation, DeleteJobSiteMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteJobSiteMutation, DeleteJobSiteMutationVariables>(DeleteJobSiteDocument, options);
}
export type DeleteJobSiteMutationHookResult = ReturnType<typeof useDeleteJobSiteMutation>;
export type DeleteJobSiteMutationResult = Apollo.MutationResult<DeleteJobSiteMutation>;
export type DeleteJobSiteMutationOptions = Apollo.BaseMutationOptions<DeleteJobSiteMutation, DeleteJobSiteMutationVariables>;
export const UpdateJobSiteDocument = gql`
  mutation updateJobSite($input: UpdateJobSiteMutationInput!) {
    updateJobSite(input: $input) {
      isSuccess
      error {
        errorMessage
        errorType
        statusCode
        validationErrors {
          field
          message
        }
      }
    }
  }
`;
export type UpdateJobSiteMutationFn = Apollo.MutationFunction<UpdateJobSiteMutation, UpdateJobSiteMutationVariables>;

/**
 * __useUpdateJobSiteMutation__
 *
 * To run a mutation, you first call `useUpdateJobSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobSiteMutation, { data, loading, error }] = useUpdateJobSiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobSiteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobSiteMutation, UpdateJobSiteMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateJobSiteMutation, UpdateJobSiteMutationVariables>(UpdateJobSiteDocument, options);
}
export type UpdateJobSiteMutationHookResult = ReturnType<typeof useUpdateJobSiteMutation>;
export type UpdateJobSiteMutationResult = Apollo.MutationResult<UpdateJobSiteMutation>;
export type UpdateJobSiteMutationOptions = Apollo.BaseMutationOptions<UpdateJobSiteMutation, UpdateJobSiteMutationVariables>;
export const GetJobSiteDocument = gql`
  query getJobSite($jobSiteId: Int!) {
    jobsiteDetails(input: { jobsiteId: $jobSiteId }) {
      ...JobSiteFormFields
      permitPresent
      availableJobSiteTypes {
        id
        objectName
      }
      availableStates {
        id
        name
        abbreviation
      }
    }
  }
  ${JobSiteFormFieldsFragmentDoc}
`;

/**
 * __useGetJobSiteQuery__
 *
 * To run a query within a React component, call `useGetJobSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobSiteQuery({
 *   variables: {
 *      jobSiteId: // value for 'jobSiteId'
 *   },
 * });
 */
export function useGetJobSiteQuery(baseOptions: Apollo.QueryHookOptions<GetJobSiteQuery, GetJobSiteQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobSiteQuery, GetJobSiteQueryVariables>(GetJobSiteDocument, options);
}
export function useGetJobSiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobSiteQuery, GetJobSiteQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobSiteQuery, GetJobSiteQueryVariables>(GetJobSiteDocument, options);
}
export type GetJobSiteQueryHookResult = ReturnType<typeof useGetJobSiteQuery>;
export type GetJobSiteLazyQueryHookResult = ReturnType<typeof useGetJobSiteLazyQuery>;
export type GetJobSiteQueryResult = Apollo.QueryResult<GetJobSiteQuery, GetJobSiteQueryVariables>;
export const GetJobSiteFormOptionsDocument = gql`
  query getJobSiteFormOptions {
    jobsiteTypes(skip: 0, take: 100) {
      totalCount
      items {
        id
        objectName
        default
      }
    }
  }
`;

/**
 * __useGetJobSiteFormOptionsQuery__
 *
 * To run a query within a React component, call `useGetJobSiteFormOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobSiteFormOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobSiteFormOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJobSiteFormOptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetJobSiteFormOptionsQuery, GetJobSiteFormOptionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobSiteFormOptionsQuery, GetJobSiteFormOptionsQueryVariables>(GetJobSiteFormOptionsDocument, options);
}
export function useGetJobSiteFormOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobSiteFormOptionsQuery, GetJobSiteFormOptionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobSiteFormOptionsQuery, GetJobSiteFormOptionsQueryVariables>(GetJobSiteFormOptionsDocument, options);
}
export type GetJobSiteFormOptionsQueryHookResult = ReturnType<typeof useGetJobSiteFormOptionsQuery>;
export type GetJobSiteFormOptionsLazyQueryHookResult = ReturnType<typeof useGetJobSiteFormOptionsLazyQuery>;
export type GetJobSiteFormOptionsQueryResult = Apollo.QueryResult<GetJobSiteFormOptionsQuery, GetJobSiteFormOptionsQueryVariables>;
export const ListJobSitesDocument = gql`
  query listJobSites(
    $skip: Int
    $take: Int
    $where: Dtos_V2_JobSite_JobSiteDtoFilterInput
    $order: [Dtos_V2_JobSite_JobSiteDtoSortInput!]
  ) {
    jobSites(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      pageInfo {
        ...PageInfoFields
      }
      items {
        ...JobSiteTableViewFields
      }
    }
  }
  ${PageInfoFieldsFragmentDoc}
  ${JobSiteTableViewFieldsFragmentDoc}
`;

/**
 * __useListJobSitesQuery__
 *
 * To run a query within a React component, call `useListJobSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListJobSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListJobSitesQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListJobSitesQuery(baseOptions?: Apollo.QueryHookOptions<ListJobSitesQuery, ListJobSitesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListJobSitesQuery, ListJobSitesQueryVariables>(ListJobSitesDocument, options);
}
export function useListJobSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListJobSitesQuery, ListJobSitesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListJobSitesQuery, ListJobSitesQueryVariables>(ListJobSitesDocument, options);
}
export type ListJobSitesQueryHookResult = ReturnType<typeof useListJobSitesQuery>;
export type ListJobSitesLazyQueryHookResult = ReturnType<typeof useListJobSitesLazyQuery>;
export type ListJobSitesQueryResult = Apollo.QueryResult<ListJobSitesQuery, ListJobSitesQueryVariables>;
export const GetOutOfServiceEquipmentsDocument = gql`
  query GetOutOfServiceEquipments($input: Input_V2_Queries_Equipment_GetOutOfServiceEquipmentsInput) {
    outOfServiceEquipment(input: $input) {
      items {
        id
        start
        end
        notes
        equipment {
          id
          name
          model {
            id
            name
          }
          make {
            id
            name
          }
        }
        reason {
          id
          name
        }
        createdOn
        updatedOn
      }
      totalCount
    }
  }
`;

/**
 * __useGetOutOfServiceEquipmentsQuery__
 *
 * To run a query within a React component, call `useGetOutOfServiceEquipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutOfServiceEquipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutOfServiceEquipmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOutOfServiceEquipmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetOutOfServiceEquipmentsQuery, GetOutOfServiceEquipmentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOutOfServiceEquipmentsQuery, GetOutOfServiceEquipmentsQueryVariables>(
    GetOutOfServiceEquipmentsDocument,
    options
  );
}
export function useGetOutOfServiceEquipmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetOutOfServiceEquipmentsQuery, GetOutOfServiceEquipmentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOutOfServiceEquipmentsQuery, GetOutOfServiceEquipmentsQueryVariables>(
    GetOutOfServiceEquipmentsDocument,
    options
  );
}
export type GetOutOfServiceEquipmentsQueryHookResult = ReturnType<typeof useGetOutOfServiceEquipmentsQuery>;
export type GetOutOfServiceEquipmentsLazyQueryHookResult = ReturnType<typeof useGetOutOfServiceEquipmentsLazyQuery>;
export type GetOutOfServiceEquipmentsQueryResult = Apollo.QueryResult<
  GetOutOfServiceEquipmentsQuery,
  GetOutOfServiceEquipmentsQueryVariables
>;
export const CancelJobDocument = gql`
  mutation cancelJob($jobId: Int!) {
    cancelRaptorJob(raptorJobId: $jobId) {
      isSuccess
      error {
        errorMessage
        errorType
        statusCode
        validationErrors {
          field
          message
        }
      }
    }
  }
`;
export type CancelJobMutationFn = Apollo.MutationFunction<CancelJobMutation, CancelJobMutationVariables>;

/**
 * __useCancelJobMutation__
 *
 * To run a mutation, you first call `useCancelJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelJobMutation, { data, loading, error }] = useCancelJobMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCancelJobMutation(baseOptions?: Apollo.MutationHookOptions<CancelJobMutation, CancelJobMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CancelJobMutation, CancelJobMutationVariables>(CancelJobDocument, options);
}
export type CancelJobMutationHookResult = ReturnType<typeof useCancelJobMutation>;
export type CancelJobMutationResult = Apollo.MutationResult<CancelJobMutation>;
export type CancelJobMutationOptions = Apollo.BaseMutationOptions<CancelJobMutation, CancelJobMutationVariables>;
export const CreateJobDocument = gql`
  mutation createJob($job: Input_V2_Mutations_RaptorJob_CreateRaptorJobMutationInput!) {
    createRaptorJob(input: $job) {
      value {
        id
      }
      isSuccess
      error {
        errorMessage
        errorType
        statusCode
        validationErrors {
          field
          message
        }
      }
    }
  }
`;
export type CreateJobMutationFn = Apollo.MutationFunction<CreateJobMutation, CreateJobMutationVariables>;

/**
 * __useCreateJobMutation__
 *
 * To run a mutation, you first call `useCreateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobMutation, { data, loading, error }] = useCreateJobMutation({
 *   variables: {
 *      job: // value for 'job'
 *   },
 * });
 */
export function useCreateJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobMutation, CreateJobMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateJobMutation, CreateJobMutationVariables>(CreateJobDocument, options);
}
export type CreateJobMutationHookResult = ReturnType<typeof useCreateJobMutation>;
export type CreateJobMutationResult = Apollo.MutationResult<CreateJobMutation>;
export type CreateJobMutationOptions = Apollo.BaseMutationOptions<CreateJobMutation, CreateJobMutationVariables>;
export const DeleteJobDocument = gql`
  mutation DeleteJob($raptorJobId: Int!) {
    cancelRaptorJob(raptorJobId: $raptorJobId) {
      isSuccess
      error {
        errorMessage
        errorType
        statusCode
        validationErrors {
          field
          message
        }
      }
    }
  }
`;
export type DeleteJobMutationFn = Apollo.MutationFunction<DeleteJobMutation, DeleteJobMutationVariables>;

/**
 * __useDeleteJobMutation__
 *
 * To run a mutation, you first call `useDeleteJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobMutation, { data, loading, error }] = useDeleteJobMutation({
 *   variables: {
 *      raptorJobId: // value for 'raptorJobId'
 *   },
 * });
 */
export function useDeleteJobMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobMutation, DeleteJobMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteJobMutation, DeleteJobMutationVariables>(DeleteJobDocument, options);
}
export type DeleteJobMutationHookResult = ReturnType<typeof useDeleteJobMutation>;
export type DeleteJobMutationResult = Apollo.MutationResult<DeleteJobMutation>;
export type DeleteJobMutationOptions = Apollo.BaseMutationOptions<DeleteJobMutation, DeleteJobMutationVariables>;
export const NotifyCrewMembersDocument = gql`
  mutation NotifyCrewMembers($input: NotifyCrewMembersInput!) {
    notifyCrewMembers(input: $input) {
      isSuccess
      error {
        statusCode
        errorType
        errorMessage
        validationErrors {
          field
          message
        }
      }
    }
  }
`;
export type NotifyCrewMembersMutationFn = Apollo.MutationFunction<NotifyCrewMembersMutation, NotifyCrewMembersMutationVariables>;

/**
 * __useNotifyCrewMembersMutation__
 *
 * To run a mutation, you first call `useNotifyCrewMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyCrewMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyCrewMembersMutation, { data, loading, error }] = useNotifyCrewMembersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotifyCrewMembersMutation(
  baseOptions?: Apollo.MutationHookOptions<NotifyCrewMembersMutation, NotifyCrewMembersMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<NotifyCrewMembersMutation, NotifyCrewMembersMutationVariables>(NotifyCrewMembersDocument, options);
}
export type NotifyCrewMembersMutationHookResult = ReturnType<typeof useNotifyCrewMembersMutation>;
export type NotifyCrewMembersMutationResult = Apollo.MutationResult<NotifyCrewMembersMutation>;
export type NotifyCrewMembersMutationOptions = Apollo.BaseMutationOptions<NotifyCrewMembersMutation, NotifyCrewMembersMutationVariables>;
export const UpdateJobDocument = gql`
  mutation updateJob($job: Input_V2_Mutations_RaptorJob_UpdateRaptorJobMutationInput!) {
    updateRaptorJob(input: $job) {
      isSuccess
      error {
        errorMessage
        errorType
        statusCode
        validationErrors {
          field
          message
        }
      }
    }
  }
`;
export type UpdateJobMutationFn = Apollo.MutationFunction<UpdateJobMutation, UpdateJobMutationVariables>;

/**
 * __useUpdateJobMutation__
 *
 * To run a mutation, you first call `useUpdateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobMutation, { data, loading, error }] = useUpdateJobMutation({
 *   variables: {
 *      job: // value for 'job'
 *   },
 * });
 */
export function useUpdateJobMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobMutation, UpdateJobMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateJobMutation, UpdateJobMutationVariables>(UpdateJobDocument, options);
}
export type UpdateJobMutationHookResult = ReturnType<typeof useUpdateJobMutation>;
export type UpdateJobMutationResult = Apollo.MutationResult<UpdateJobMutation>;
export type UpdateJobMutationOptions = Apollo.BaseMutationOptions<UpdateJobMutation, UpdateJobMutationVariables>;
export const GetDispatcherByUserIdDocument = gql`
  query getDispatcherByUserId($userId: Int!) {
    dispatchers(skip: 0, take: 1, where: { user: { userId: { eq: $userId } } }) {
      totalCount
      items {
        id
        name
        user {
          userId
        }
      }
    }
  }
`;

/**
 * __useGetDispatcherByUserIdQuery__
 *
 * To run a query within a React component, call `useGetDispatcherByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDispatcherByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDispatcherByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetDispatcherByUserIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetDispatcherByUserIdQuery, GetDispatcherByUserIdQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDispatcherByUserIdQuery, GetDispatcherByUserIdQueryVariables>(GetDispatcherByUserIdDocument, options);
}
export function useGetDispatcherByUserIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDispatcherByUserIdQuery, GetDispatcherByUserIdQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDispatcherByUserIdQuery, GetDispatcherByUserIdQueryVariables>(GetDispatcherByUserIdDocument, options);
}
export type GetDispatcherByUserIdQueryHookResult = ReturnType<typeof useGetDispatcherByUserIdQuery>;
export type GetDispatcherByUserIdLazyQueryHookResult = ReturnType<typeof useGetDispatcherByUserIdLazyQuery>;
export type GetDispatcherByUserIdQueryResult = Apollo.QueryResult<GetDispatcherByUserIdQuery, GetDispatcherByUserIdQueryVariables>;
export const GetJobDocument = gql`
  query getJob($jobId: Int!) {
    raptorJobDetails(id: $jobId) {
      value {
        ...JobFormFields
        availableCrewMembers {
          id
          name
          role {
            id
            name
          }
          supportedRoleIds
        }
        availableCrewRoles {
          id
          name
        }
        availableCustomers {
          id
          companyName
          primaryEmail
          primaryPhone
        }
        availableDispatchers {
          id
          name
        }
        availableDispatchLocations {
          id
          name
        }
        availableEquipment {
          id
          name
        }
        availableEquipmentLocations {
          id
          name
        }
        availableEquipmentSizes {
          id
          name
        }
        availableEquipmentTypes {
          id
          name
        }
        availableExtraSystems {
          id
          name
        }
        availableJobInformation {
          id
          name
        }
        availableJobStatuses {
          id
          name
        }
        availableJobTypes {
          id
          name
        }
        availableSpecialFlags {
          id
          name
        }
        availableVendors {
          id
          name
          mailAddress
          phoneNumber
          emailAddress
        }
      }
    }
  }
  ${JobFormFieldsFragmentDoc}
`;

/**
 * __useGetJobQuery__
 *
 * To run a query within a React component, call `useGetJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetJobQuery(baseOptions: Apollo.QueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
}
export function useGetJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
}
export type GetJobQueryHookResult = ReturnType<typeof useGetJobQuery>;
export type GetJobLazyQueryHookResult = ReturnType<typeof useGetJobLazyQuery>;
export type GetJobQueryResult = Apollo.QueryResult<GetJobQuery, GetJobQueryVariables>;
export const GetJobFormOptionsDocument = gql`
  query getJobFormOptions {
    raptorJobSupportingDataQuery {
      value {
        availableCrewMembers {
          id
          name
          role {
            id
            name
          }
          supportedRoleIds
        }
        availableCrewRoles {
          id
          name
        }
        availableCustomers {
          id
          companyName
          primaryEmail
          primaryPhone
        }
        availableDispatchers {
          id
          name
        }
        availableDispatchLocations {
          id
          name
          default
        }
        availableEquipment {
          id
          name
          type {
            id
            name
          }
          class {
            id
            name
          }
          size {
            id
            name
          }
          status {
            id
            name
          }
        }
        availableEquipmentLocations {
          id
          name
        }
        availableEquipmentSizes {
          id
          name
          class {
            id
          }
        }
        availableEquipmentTypes {
          id
          name
          class {
            id
          }
        }
        availableExtraSystems {
          id
          name
          description
          price
          quantity
          class {
            id
            name
          }
          billable
          taxable
          defaultItem
          showAsExtraSystemOnJob
        }
        availableJobInformation {
          id
          name
        }
        availableJobStatuses {
          id
          name
          default
          colorCode
        }
        availableJobTypes {
          id
          name
          default
        }
        availableSpecialFlags {
          id
          name
        }
        availableVendors {
          id
          name
          mailAddress
          phoneNumber
          emailAddress
          default
        }
        requiredFields {
          name
          required
        }
        uiBehaviorRules {
          name
          enabled
        }
      }
    }
  }
`;

/**
 * __useGetJobFormOptionsQuery__
 *
 * To run a query within a React component, call `useGetJobFormOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobFormOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobFormOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJobFormOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetJobFormOptionsQuery, GetJobFormOptionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobFormOptionsQuery, GetJobFormOptionsQueryVariables>(GetJobFormOptionsDocument, options);
}
export function useGetJobFormOptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetJobFormOptionsQuery, GetJobFormOptionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobFormOptionsQuery, GetJobFormOptionsQueryVariables>(GetJobFormOptionsDocument, options);
}
export type GetJobFormOptionsQueryHookResult = ReturnType<typeof useGetJobFormOptionsQuery>;
export type GetJobFormOptionsLazyQueryHookResult = ReturnType<typeof useGetJobFormOptionsLazyQuery>;
export type GetJobFormOptionsQueryResult = Apollo.QueryResult<GetJobFormOptionsQuery, GetJobFormOptionsQueryVariables>;
export const GetJobSitesDocument = gql`
  query getJobSites($skip: Int, $take: Int, $where: Dtos_V2_JobSite_JobSiteDtoFilterInput, $order: [Dtos_V2_JobSite_JobSiteDtoSortInput!]) {
    jobSites(skip: $skip, take: $skip, where: $where, order: $order) {
      totalCount
      pageInfo {
        ...PageInfoFields
      }
      items {
        ...JobSiteFields
      }
    }
  }
  ${PageInfoFieldsFragmentDoc}
  ${JobSiteFieldsFragmentDoc}
`;

/**
 * __useGetJobSitesQuery__
 *
 * To run a query within a React component, call `useGetJobSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobSitesQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetJobSitesQuery(baseOptions?: Apollo.QueryHookOptions<GetJobSitesQuery, GetJobSitesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetJobSitesQuery, GetJobSitesQueryVariables>(GetJobSitesDocument, options);
}
export function useGetJobSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobSitesQuery, GetJobSitesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetJobSitesQuery, GetJobSitesQueryVariables>(GetJobSitesDocument, options);
}
export type GetJobSitesQueryHookResult = ReturnType<typeof useGetJobSitesQuery>;
export type GetJobSitesLazyQueryHookResult = ReturnType<typeof useGetJobSitesLazyQuery>;
export type GetJobSitesQueryResult = Apollo.QueryResult<GetJobSitesQuery, GetJobSitesQueryVariables>;
export const GetTimeZonesDocument = gql`
  query getTimeZones(
    $skip: Int
    $take: Int
    $where: Dtos_V2_TimeZone_TimeZoneDtoFilterInput
    $order: [Dtos_V2_TimeZone_TimeZoneDtoSortInput!]
  ) {
    timeZones(skip: $skip, take: $take, where: $where, order: $order) {
      totalCount
      pageInfo {
        ...PageInfoFields
      }
      items {
        ...TimeZoneFields
      }
    }
  }
  ${PageInfoFieldsFragmentDoc}
  ${TimeZoneFieldsFragmentDoc}
`;

/**
 * __useGetTimeZonesQuery__
 *
 * To run a query within a React component, call `useGetTimeZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeZonesQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetTimeZonesQuery(baseOptions?: Apollo.QueryHookOptions<GetTimeZonesQuery, GetTimeZonesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTimeZonesQuery, GetTimeZonesQueryVariables>(GetTimeZonesDocument, options);
}
export function useGetTimeZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeZonesQuery, GetTimeZonesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTimeZonesQuery, GetTimeZonesQueryVariables>(GetTimeZonesDocument, options);
}
export type GetTimeZonesQueryHookResult = ReturnType<typeof useGetTimeZonesQuery>;
export type GetTimeZonesLazyQueryHookResult = ReturnType<typeof useGetTimeZonesLazyQuery>;
export type GetTimeZonesQueryResult = Apollo.QueryResult<GetTimeZonesQuery, GetTimeZonesQueryVariables>;
export const ListAvailableCrewMembersDocument = gql`
  query listAvailableCrewMembers(
    $skip: Int
    $take: Int
    $availableCrewMembersInput: Input_V2_Queries_CrewMembersInput
    $where: Dtos_V2_CrewDtoFilterInput
    $order: [Dtos_V2_CrewDtoSortInput!]
  ) {
    availableCrewMembers(skip: $skip, take: $take, availableCrewMembersInput: $availableCrewMembersInput, where: $where, order: $order) {
      items {
        id
        name
        jobRoles {
          id
          name
        }
        employmentType
        employmentStatus {
          id
          name
        }
        status
        statusNotes
      }
      totalCount
    }
  }
`;

/**
 * __useListAvailableCrewMembersQuery__
 *
 * To run a query within a React component, call `useListAvailableCrewMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAvailableCrewMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAvailableCrewMembersQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      availableCrewMembersInput: // value for 'availableCrewMembersInput'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListAvailableCrewMembersQuery(
  baseOptions?: Apollo.QueryHookOptions<ListAvailableCrewMembersQuery, ListAvailableCrewMembersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListAvailableCrewMembersQuery, ListAvailableCrewMembersQueryVariables>(ListAvailableCrewMembersDocument, options);
}
export function useListAvailableCrewMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListAvailableCrewMembersQuery, ListAvailableCrewMembersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListAvailableCrewMembersQuery, ListAvailableCrewMembersQueryVariables>(
    ListAvailableCrewMembersDocument,
    options
  );
}
export type ListAvailableCrewMembersQueryHookResult = ReturnType<typeof useListAvailableCrewMembersQuery>;
export type ListAvailableCrewMembersLazyQueryHookResult = ReturnType<typeof useListAvailableCrewMembersLazyQuery>;
export type ListAvailableCrewMembersQueryResult = Apollo.QueryResult<ListAvailableCrewMembersQuery, ListAvailableCrewMembersQueryVariables>;
export const ListAvailableEquipmentsDocument = gql`
  query listAvailableEquipments(
    $skip: Int
    $take: Int
    $availableEquipmentsInput: Input_V2_Queries_Equipment_AvailableEquipmentsInput
    $where: Dtos_V2_Equipment_EquipmentDtoFilterInput
    $order: [Dtos_V2_Equipment_EquipmentDtoSortInput!]
  ) {
    availableEquipments(skip: $skip, take: $take, availableEquipmentsInput: $availableEquipmentsInput, where: $where, order: $order) {
      items {
        id
        name
        type {
          id
          name
        }
        class {
          id
          name
        }
        size {
          id
          name
        }
        status {
          id
          name
        }
        equipmentStatus
        statusNotes
        defaultEmployee {
          id
          fullName
          jobRoles {
            id
            name
          }
          employmentType
          employmentStatus {
            id
            name
          }
          status
          statusNotes
        }
      }
      totalCount
    }
  }
`;

/**
 * __useListAvailableEquipmentsQuery__
 *
 * To run a query within a React component, call `useListAvailableEquipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAvailableEquipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAvailableEquipmentsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      availableEquipmentsInput: // value for 'availableEquipmentsInput'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListAvailableEquipmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListAvailableEquipmentsQuery, ListAvailableEquipmentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListAvailableEquipmentsQuery, ListAvailableEquipmentsQueryVariables>(ListAvailableEquipmentsDocument, options);
}
export function useListAvailableEquipmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListAvailableEquipmentsQuery, ListAvailableEquipmentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListAvailableEquipmentsQuery, ListAvailableEquipmentsQueryVariables>(ListAvailableEquipmentsDocument, options);
}
export type ListAvailableEquipmentsQueryHookResult = ReturnType<typeof useListAvailableEquipmentsQuery>;
export type ListAvailableEquipmentsLazyQueryHookResult = ReturnType<typeof useListAvailableEquipmentsLazyQuery>;
export type ListAvailableEquipmentsQueryResult = Apollo.QueryResult<ListAvailableEquipmentsQuery, ListAvailableEquipmentsQueryVariables>;
export const ListAvailableExtraSystemsDocument = gql`
  query listAvailableExtraSystems(
    $skip: Int
    $take: Int
    $where: Dtos_V1_ExtraSystemDtoFilterInput
    $order: [Dtos_V1_ExtraSystemDtoSortInput!]
  ) {
    extraSystems(skip: $skip, take: $take, where: $where, order: $order) {
      items {
        id
        name
        description
        quantity
        price
      }
      totalCount
    }
  }
`;

/**
 * __useListAvailableExtraSystemsQuery__
 *
 * To run a query within a React component, call `useListAvailableExtraSystemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAvailableExtraSystemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAvailableExtraSystemsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListAvailableExtraSystemsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListAvailableExtraSystemsQuery, ListAvailableExtraSystemsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListAvailableExtraSystemsQuery, ListAvailableExtraSystemsQueryVariables>(
    ListAvailableExtraSystemsDocument,
    options
  );
}
export function useListAvailableExtraSystemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListAvailableExtraSystemsQuery, ListAvailableExtraSystemsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListAvailableExtraSystemsQuery, ListAvailableExtraSystemsQueryVariables>(
    ListAvailableExtraSystemsDocument,
    options
  );
}
export type ListAvailableExtraSystemsQueryHookResult = ReturnType<typeof useListAvailableExtraSystemsQuery>;
export type ListAvailableExtraSystemsLazyQueryHookResult = ReturnType<typeof useListAvailableExtraSystemsLazyQuery>;
export type ListAvailableExtraSystemsQueryResult = Apollo.QueryResult<
  ListAvailableExtraSystemsQuery,
  ListAvailableExtraSystemsQueryVariables
>;
export const ListCustomersAutocompleteDocument = gql`
  query listCustomersAutocomplete($skip: Int, $where: Dtos_V2_Customer_CustomerDtoFilterInput) {
    customers(skip: $skip, take: 100, where: $where) {
      totalCount
      items {
        id
        companyName
        primaryEmail
        primaryPhone
        contacts {
          id
          firstName
          lastName
          contactInformation {
            id
            type
            contact
          }
        }
      }
    }
  }
`;

/**
 * __useListCustomersAutocompleteQuery__
 *
 * To run a query within a React component, call `useListCustomersAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCustomersAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCustomersAutocompleteQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useListCustomersAutocompleteQuery(
  baseOptions?: Apollo.QueryHookOptions<ListCustomersAutocompleteQuery, ListCustomersAutocompleteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListCustomersAutocompleteQuery, ListCustomersAutocompleteQueryVariables>(
    ListCustomersAutocompleteDocument,
    options
  );
}
export function useListCustomersAutocompleteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListCustomersAutocompleteQuery, ListCustomersAutocompleteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListCustomersAutocompleteQuery, ListCustomersAutocompleteQueryVariables>(
    ListCustomersAutocompleteDocument,
    options
  );
}
export type ListCustomersAutocompleteQueryHookResult = ReturnType<typeof useListCustomersAutocompleteQuery>;
export type ListCustomersAutocompleteLazyQueryHookResult = ReturnType<typeof useListCustomersAutocompleteLazyQuery>;
export type ListCustomersAutocompleteQueryResult = Apollo.QueryResult<
  ListCustomersAutocompleteQuery,
  ListCustomersAutocompleteQueryVariables
>;
export const ListDispatchLocationsDocument = gql`
  query listDispatchLocations(
    $skip: Int
    $take: Int
    $where: Dtos_V1_DispatchLocationDtoFilterInput
    $order: [Dtos_V1_DispatchLocationDtoSortInput!]
  ) {
    dispatchLocations(skip: $skip, take: $take, where: $where, order: $order) {
      items {
        id
        name
      }
      totalCount
    }
  }
`;

/**
 * __useListDispatchLocationsQuery__
 *
 * To run a query within a React component, call `useListDispatchLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDispatchLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDispatchLocationsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListDispatchLocationsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListDispatchLocationsQuery, ListDispatchLocationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListDispatchLocationsQuery, ListDispatchLocationsQueryVariables>(ListDispatchLocationsDocument, options);
}
export function useListDispatchLocationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListDispatchLocationsQuery, ListDispatchLocationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListDispatchLocationsQuery, ListDispatchLocationsQueryVariables>(ListDispatchLocationsDocument, options);
}
export type ListDispatchLocationsQueryHookResult = ReturnType<typeof useListDispatchLocationsQuery>;
export type ListDispatchLocationsLazyQueryHookResult = ReturnType<typeof useListDispatchLocationsLazyQuery>;
export type ListDispatchLocationsQueryResult = Apollo.QueryResult<ListDispatchLocationsQuery, ListDispatchLocationsQueryVariables>;
export const ListDispatchersAutocompleteDocument = gql`
  query listDispatchersAutocomplete($skip: Int, $search: String) {
    dispatchers(
      skip: $skip
      take: 100
      where: {
        or: [
          { name: { contains: $search } }
          { firstName: { contains: $search } }
          { lastName: { contains: $search } }
          { email: { contact: { contains: $search } } }
          { phoneNumber: { contact: { contains: $search } } }
        ]
      }
    ) {
      totalCount
      items {
        id
        name
        user {
          userId
        }
      }
    }
  }
`;

/**
 * __useListDispatchersAutocompleteQuery__
 *
 * To run a query within a React component, call `useListDispatchersAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDispatchersAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDispatchersAutocompleteQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useListDispatchersAutocompleteQuery(
  baseOptions?: Apollo.QueryHookOptions<ListDispatchersAutocompleteQuery, ListDispatchersAutocompleteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListDispatchersAutocompleteQuery, ListDispatchersAutocompleteQueryVariables>(
    ListDispatchersAutocompleteDocument,
    options
  );
}
export function useListDispatchersAutocompleteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListDispatchersAutocompleteQuery, ListDispatchersAutocompleteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListDispatchersAutocompleteQuery, ListDispatchersAutocompleteQueryVariables>(
    ListDispatchersAutocompleteDocument,
    options
  );
}
export type ListDispatchersAutocompleteQueryHookResult = ReturnType<typeof useListDispatchersAutocompleteQuery>;
export type ListDispatchersAutocompleteLazyQueryHookResult = ReturnType<typeof useListDispatchersAutocompleteLazyQuery>;
export type ListDispatchersAutocompleteQueryResult = Apollo.QueryResult<
  ListDispatchersAutocompleteQuery,
  ListDispatchersAutocompleteQueryVariables
>;
export const ListEquipmentSizesDocument = gql`
  query listEquipmentSizes(
    $skip: Int
    $take: Int
    $where: Dtos_V1_EquipmentSizeDtoFilterInput
    $order: [Dtos_V1_EquipmentSizeDtoSortInput!]
  ) {
    equipmentSizes(skip: $skip, take: $take, where: $where, order: $order) {
      items {
        id
        name
      }
      totalCount
    }
  }
`;

/**
 * __useListEquipmentSizesQuery__
 *
 * To run a query within a React component, call `useListEquipmentSizesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEquipmentSizesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEquipmentSizesQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListEquipmentSizesQuery(
  baseOptions?: Apollo.QueryHookOptions<ListEquipmentSizesQuery, ListEquipmentSizesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListEquipmentSizesQuery, ListEquipmentSizesQueryVariables>(ListEquipmentSizesDocument, options);
}
export function useListEquipmentSizesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListEquipmentSizesQuery, ListEquipmentSizesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListEquipmentSizesQuery, ListEquipmentSizesQueryVariables>(ListEquipmentSizesDocument, options);
}
export type ListEquipmentSizesQueryHookResult = ReturnType<typeof useListEquipmentSizesQuery>;
export type ListEquipmentSizesLazyQueryHookResult = ReturnType<typeof useListEquipmentSizesLazyQuery>;
export type ListEquipmentSizesQueryResult = Apollo.QueryResult<ListEquipmentSizesQuery, ListEquipmentSizesQueryVariables>;
export const ListJobSitesAutocompleteDocument = gql`
  query listJobSitesAutocomplete($skip: Int, $search: String, $customerId: String) {
    jobSites(
      skip: $skip
      take: 100
      where: {
        or: [
          { jobName: { contains: $search } }
          { location: { contains: $search } }
          { cityTown: { contains: $search } }
          { state: { contains: $search } }
        ]
        and: [{ customer: { id: { eq: $customerId } } }]
      }
    ) {
      totalCount
      items {
        jobsiteId
        jobName
        location
        latitude
        longitude
      }
    }
  }
`;

/**
 * __useListJobSitesAutocompleteQuery__
 *
 * To run a query within a React component, call `useListJobSitesAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useListJobSitesAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListJobSitesAutocompleteQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      search: // value for 'search'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useListJobSitesAutocompleteQuery(
  baseOptions?: Apollo.QueryHookOptions<ListJobSitesAutocompleteQuery, ListJobSitesAutocompleteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListJobSitesAutocompleteQuery, ListJobSitesAutocompleteQueryVariables>(ListJobSitesAutocompleteDocument, options);
}
export function useListJobSitesAutocompleteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListJobSitesAutocompleteQuery, ListJobSitesAutocompleteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListJobSitesAutocompleteQuery, ListJobSitesAutocompleteQueryVariables>(
    ListJobSitesAutocompleteDocument,
    options
  );
}
export type ListJobSitesAutocompleteQueryHookResult = ReturnType<typeof useListJobSitesAutocompleteQuery>;
export type ListJobSitesAutocompleteLazyQueryHookResult = ReturnType<typeof useListJobSitesAutocompleteLazyQuery>;
export type ListJobSitesAutocompleteQueryResult = Apollo.QueryResult<ListJobSitesAutocompleteQuery, ListJobSitesAutocompleteQueryVariables>;
export const ListJobSitesAutocompleteWithoutCustomerDocument = gql`
  query listJobSitesAutocompleteWithoutCustomer($skip: Int, $search: String) {
    jobSites(
      skip: $skip
      take: 100
      where: {
        or: [
          { jobName: { contains: $search } }
          { location: { contains: $search } }
          { cityTown: { contains: $search } }
          { state: { contains: $search } }
        ]
      }
    ) {
      totalCount
      items {
        jobsiteId
        jobName
        location
        latitude
        longitude
      }
    }
  }
`;

/**
 * __useListJobSitesAutocompleteWithoutCustomerQuery__
 *
 * To run a query within a React component, call `useListJobSitesAutocompleteWithoutCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useListJobSitesAutocompleteWithoutCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListJobSitesAutocompleteWithoutCustomerQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useListJobSitesAutocompleteWithoutCustomerQuery(
  baseOptions?: Apollo.QueryHookOptions<ListJobSitesAutocompleteWithoutCustomerQuery, ListJobSitesAutocompleteWithoutCustomerQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListJobSitesAutocompleteWithoutCustomerQuery, ListJobSitesAutocompleteWithoutCustomerQueryVariables>(
    ListJobSitesAutocompleteWithoutCustomerDocument,
    options
  );
}
export function useListJobSitesAutocompleteWithoutCustomerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListJobSitesAutocompleteWithoutCustomerQuery,
    ListJobSitesAutocompleteWithoutCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListJobSitesAutocompleteWithoutCustomerQuery, ListJobSitesAutocompleteWithoutCustomerQueryVariables>(
    ListJobSitesAutocompleteWithoutCustomerDocument,
    options
  );
}
export type ListJobSitesAutocompleteWithoutCustomerQueryHookResult = ReturnType<typeof useListJobSitesAutocompleteWithoutCustomerQuery>;
export type ListJobSitesAutocompleteWithoutCustomerLazyQueryHookResult = ReturnType<
  typeof useListJobSitesAutocompleteWithoutCustomerLazyQuery
>;
export type ListJobSitesAutocompleteWithoutCustomerQueryResult = Apollo.QueryResult<
  ListJobSitesAutocompleteWithoutCustomerQuery,
  ListJobSitesAutocompleteWithoutCustomerQueryVariables
>;
export const ListJobTypesDocument = gql`
  query listJobTypes($skip: Int, $take: Int, $where: Dtos_V2_JobTypeDtoFilterInput, $order: [Dtos_V2_JobTypeDtoSortInput!]) {
    jobTypes(skip: $skip, take: $take, where: $where, order: $order) {
      items {
        id
        name
      }
      totalCount
    }
  }
`;

/**
 * __useListJobTypesQuery__
 *
 * To run a query within a React component, call `useListJobTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListJobTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListJobTypesQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListJobTypesQuery(baseOptions?: Apollo.QueryHookOptions<ListJobTypesQuery, ListJobTypesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListJobTypesQuery, ListJobTypesQueryVariables>(ListJobTypesDocument, options);
}
export function useListJobTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListJobTypesQuery, ListJobTypesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListJobTypesQuery, ListJobTypesQueryVariables>(ListJobTypesDocument, options);
}
export type ListJobTypesQueryHookResult = ReturnType<typeof useListJobTypesQuery>;
export type ListJobTypesLazyQueryHookResult = ReturnType<typeof useListJobTypesLazyQuery>;
export type ListJobTypesQueryResult = Apollo.QueryResult<ListJobTypesQuery, ListJobTypesQueryVariables>;
export const ListJobsDocument = gql`
  query listJobs(
    $skip: Int
    $take: Int
    $where: Dtos_V2_RaptorJob_RaptorJobDtoFilterInput
    $order: [Dtos_V2_RaptorJob_RaptorJobDtoSortInput!]
    $startDate: LocalDate!
    $endDate: LocalDate
  ) {
    raptorJobs(skip: $skip, take: $take, where: $where, order: $order, startDate: $startDate, endDate: $endDate) {
      totalCount
      pageInfo {
        ...PageInfoFields
      }
      items {
        ...JobTableViewFields
      }
    }
  }
  ${PageInfoFieldsFragmentDoc}
  ${JobTableViewFieldsFragmentDoc}
`;

/**
 * __useListJobsQuery__
 *
 * To run a query within a React component, call `useListJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListJobsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useListJobsQuery(baseOptions: Apollo.QueryHookOptions<ListJobsQuery, ListJobsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListJobsQuery, ListJobsQueryVariables>(ListJobsDocument, options);
}
export function useListJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListJobsQuery, ListJobsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListJobsQuery, ListJobsQueryVariables>(ListJobsDocument, options);
}
export type ListJobsQueryHookResult = ReturnType<typeof useListJobsQuery>;
export type ListJobsLazyQueryHookResult = ReturnType<typeof useListJobsLazyQuery>;
export type ListJobsQueryResult = Apollo.QueryResult<ListJobsQuery, ListJobsQueryVariables>;
export const ListSalesAgentsAutocompleteDocument = gql`
  query listSalesAgentsAutocomplete($skip: Int, $search: String) {
    salesAgents(
      skip: $skip
      take: 100
      where: {
        or: [
          { name: { contains: $search } }
          { firstName: { contains: $search } }
          { lastName: { contains: $search } }
          { email: { contact: { contains: $search } } }
          { phoneNumber: { contact: { contains: $search } } }
        ]
      }
    ) {
      totalCount
      items {
        id
        name
        firstName
        lastName
        default
      }
    }
  }
`;

/**
 * __useListSalesAgentsAutocompleteQuery__
 *
 * To run a query within a React component, call `useListSalesAgentsAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSalesAgentsAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSalesAgentsAutocompleteQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useListSalesAgentsAutocompleteQuery(
  baseOptions?: Apollo.QueryHookOptions<ListSalesAgentsAutocompleteQuery, ListSalesAgentsAutocompleteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListSalesAgentsAutocompleteQuery, ListSalesAgentsAutocompleteQueryVariables>(
    ListSalesAgentsAutocompleteDocument,
    options
  );
}
export function useListSalesAgentsAutocompleteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListSalesAgentsAutocompleteQuery, ListSalesAgentsAutocompleteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListSalesAgentsAutocompleteQuery, ListSalesAgentsAutocompleteQueryVariables>(
    ListSalesAgentsAutocompleteDocument,
    options
  );
}
export type ListSalesAgentsAutocompleteQueryHookResult = ReturnType<typeof useListSalesAgentsAutocompleteQuery>;
export type ListSalesAgentsAutocompleteLazyQueryHookResult = ReturnType<typeof useListSalesAgentsAutocompleteLazyQuery>;
export type ListSalesAgentsAutocompleteQueryResult = Apollo.QueryResult<
  ListSalesAgentsAutocompleteQuery,
  ListSalesAgentsAutocompleteQueryVariables
>;
export const ListWorkLocationsDocument = gql`
  query listWorkLocations($skip: Int, $take: Int, $where: Dtos_V1_LocationDtoFilterInput, $order: [Dtos_V1_LocationDtoSortInput!]) {
    workLocations(skip: $skip, take: $take, where: $where, order: $order) {
      items {
        id
        name
      }
      totalCount
    }
  }
`;

/**
 * __useListWorkLocationsQuery__
 *
 * To run a query within a React component, call `useListWorkLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListWorkLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListWorkLocationsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListWorkLocationsQuery(baseOptions?: Apollo.QueryHookOptions<ListWorkLocationsQuery, ListWorkLocationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListWorkLocationsQuery, ListWorkLocationsQueryVariables>(ListWorkLocationsDocument, options);
}
export function useListWorkLocationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListWorkLocationsQuery, ListWorkLocationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListWorkLocationsQuery, ListWorkLocationsQueryVariables>(ListWorkLocationsDocument, options);
}
export type ListWorkLocationsQueryHookResult = ReturnType<typeof useListWorkLocationsQuery>;
export type ListWorkLocationsLazyQueryHookResult = ReturnType<typeof useListWorkLocationsLazyQuery>;
export type ListWorkLocationsQueryResult = Apollo.QueryResult<ListWorkLocationsQuery, ListWorkLocationsQueryVariables>;
export const GetRaptorJobsDocument = gql`
  query GetRaptorJobs(
    $startDate: LocalDate
    $endDate: LocalDate
    $referenceStartDate: LocalDate
    $referenceEndDate: LocalDate
    $where: Dtos_V2_RaptorJob_RaptorJobDtoFilterInput
    $order: [Dtos_V2_RaptorJob_RaptorJobDtoSortInput!]
  ) {
    raptorJobs(
      startDate: $startDate
      endDate: $endDate
      referenceStartDate: $referenceStartDate
      referenceEndDate: $referenceEndDate
      where: $where
      order: $order
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
      items {
        id
        jobName
        startDate
        finishedAt
        estimatedClearedTime
        plannedAllocation {
          startTime
          date
        }
        isMultiDay
        endDate
        status {
          id
          name
        }
        crew {
          deletable
          employmentType
          endDate
          firstName
          fullName
          id
          lastName
          name
          startDate
          status
          role {
            id
            name
          }
        }
        jobSite {
          id
          address
          state
          zipCode
        }
        customer {
          id
          companyName
        }
        sizeRequested {
          id
          name
        }
        specialFlag1 {
          id
          name
        }
        specialFlag2 {
          id
          name
        }
        specialFlag3 {
          id
          name
        }
        equipment {
          id
          name
          plannedAllocation {
            estimatedHours
            startTime
            onJobTime
            leaveTime
            showUpTime
            endTime
          }
          class {
            id
            name
          }
          type {
            id
            name
          }
          size {
            id
            name
          }
        }
        timeZone
      }
    }
  }
`;

/**
 * __useGetRaptorJobsQuery__
 *
 * To run a query within a React component, call `useGetRaptorJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRaptorJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRaptorJobsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      referenceStartDate: // value for 'referenceStartDate'
 *      referenceEndDate: // value for 'referenceEndDate'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetRaptorJobsQuery(baseOptions?: Apollo.QueryHookOptions<GetRaptorJobsQuery, GetRaptorJobsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRaptorJobsQuery, GetRaptorJobsQueryVariables>(GetRaptorJobsDocument, options);
}
export function useGetRaptorJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRaptorJobsQuery, GetRaptorJobsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRaptorJobsQuery, GetRaptorJobsQueryVariables>(GetRaptorJobsDocument, options);
}
export type GetRaptorJobsQueryHookResult = ReturnType<typeof useGetRaptorJobsQuery>;
export type GetRaptorJobsLazyQueryHookResult = ReturnType<typeof useGetRaptorJobsLazyQuery>;
export type GetRaptorJobsQueryResult = Apollo.QueryResult<GetRaptorJobsQuery, GetRaptorJobsQueryVariables>;
export const ListAvailableEquipmentsForTimelineDocument = gql`
  query listAvailableEquipmentsForTimeline(
    $skip: Int
    $take: Int
    $availableEquipmentsInput: Input_V2_Queries_Equipment_AvailableEquipmentsInput
    $where: Dtos_V2_Equipment_EquipmentDtoFilterInput
    $order: [Dtos_V2_Equipment_EquipmentDtoSortInput!]
  ) {
    availableEquipments(skip: $skip, take: $take, availableEquipmentsInput: $availableEquipmentsInput, where: $where, order: $order) {
      totalCount
      items {
        id
        name
        class {
          id
          name
        }
        type {
          id
          name
        }
        size {
          id
          name
        }
        status {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useListAvailableEquipmentsForTimelineQuery__
 *
 * To run a query within a React component, call `useListAvailableEquipmentsForTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAvailableEquipmentsForTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAvailableEquipmentsForTimelineQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      availableEquipmentsInput: // value for 'availableEquipmentsInput'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListAvailableEquipmentsForTimelineQuery(
  baseOptions?: Apollo.QueryHookOptions<ListAvailableEquipmentsForTimelineQuery, ListAvailableEquipmentsForTimelineQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListAvailableEquipmentsForTimelineQuery, ListAvailableEquipmentsForTimelineQueryVariables>(
    ListAvailableEquipmentsForTimelineDocument,
    options
  );
}
export function useListAvailableEquipmentsForTimelineLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListAvailableEquipmentsForTimelineQuery, ListAvailableEquipmentsForTimelineQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListAvailableEquipmentsForTimelineQuery, ListAvailableEquipmentsForTimelineQueryVariables>(
    ListAvailableEquipmentsForTimelineDocument,
    options
  );
}
export type ListAvailableEquipmentsForTimelineQueryHookResult = ReturnType<typeof useListAvailableEquipmentsForTimelineQuery>;
export type ListAvailableEquipmentsForTimelineLazyQueryHookResult = ReturnType<typeof useListAvailableEquipmentsForTimelineLazyQuery>;
export type ListAvailableEquipmentsForTimelineQueryResult = Apollo.QueryResult<
  ListAvailableEquipmentsForTimelineQuery,
  ListAvailableEquipmentsForTimelineQueryVariables
>;
export const UpdateRaptorJobTimelineDocument = gql`
  mutation UpdateRaptorJobTimeline(
    $id: Int!
    $startDate: Date!
    $startTime: TimeSpan
    $onJobTime: TimeSpan
    $leaveTime: TimeSpan
    $showUpTime: TimeSpan
    $estimatedHours: Decimal!
    $timeZone: String
    $equipmentToAdd: [Int!]
    $equipmentToDelete: [Int!]
    $crewMembersToDelete: [Int!]
    $customerId: Int
    $jobInformationId: Int
  ) {
    updateRaptorJob(
      input: {
        id: $id
        startDate: $startDate
        startTime: $startTime
        onJobTime: $onJobTime
        leaveTime: $leaveTime
        showUpTime: $showUpTime
        estimatedHours: $estimatedHours
        timeZone: $timeZone
        equipmentToAdd: $equipmentToAdd
        equipmentToDelete: $equipmentToDelete
        crewMembersToDelete: $crewMembersToDelete
        customerId: $customerId
        jobInformationId: $jobInformationId
      }
    ) {
      isSuccess
      error {
        statusCode
        errorType
        errorMessage
        validationErrors {
          field
          message
        }
      }
    }
  }
`;
export type UpdateRaptorJobTimelineMutationFn = Apollo.MutationFunction<
  UpdateRaptorJobTimelineMutation,
  UpdateRaptorJobTimelineMutationVariables
>;

/**
 * __useUpdateRaptorJobTimelineMutation__
 *
 * To run a mutation, you first call `useUpdateRaptorJobTimelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRaptorJobTimelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRaptorJobTimelineMutation, { data, loading, error }] = useUpdateRaptorJobTimelineMutation({
 *   variables: {
 *      id: // value for 'id'
 *      startDate: // value for 'startDate'
 *      startTime: // value for 'startTime'
 *      onJobTime: // value for 'onJobTime'
 *      leaveTime: // value for 'leaveTime'
 *      showUpTime: // value for 'showUpTime'
 *      estimatedHours: // value for 'estimatedHours'
 *      timeZone: // value for 'timeZone'
 *      equipmentToAdd: // value for 'equipmentToAdd'
 *      equipmentToDelete: // value for 'equipmentToDelete'
 *      crewMembersToDelete: // value for 'crewMembersToDelete'
 *      customerId: // value for 'customerId'
 *      jobInformationId: // value for 'jobInformationId'
 *   },
 * });
 */
export function useUpdateRaptorJobTimelineMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateRaptorJobTimelineMutation, UpdateRaptorJobTimelineMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateRaptorJobTimelineMutation, UpdateRaptorJobTimelineMutationVariables>(
    UpdateRaptorJobTimelineDocument,
    options
  );
}
export type UpdateRaptorJobTimelineMutationHookResult = ReturnType<typeof useUpdateRaptorJobTimelineMutation>;
export type UpdateRaptorJobTimelineMutationResult = Apollo.MutationResult<UpdateRaptorJobTimelineMutation>;
export type UpdateRaptorJobTimelineMutationOptions = Apollo.BaseMutationOptions<
  UpdateRaptorJobTimelineMutation,
  UpdateRaptorJobTimelineMutationVariables
>;
export const UnassignRaptorJobFromTimelineDocument = gql`
  mutation UnassignRaptorJobFromTimeline(
    $id: Int!
    $startDate: Date!
    $estimatedHours: Decimal!
    $equipmentToDelete: [Int!]
    $customerId: Int
    $jobInformationId: Int
  ) {
    updateRaptorJob(
      input: {
        id: $id
        startDate: $startDate
        estimatedHours: $estimatedHours
        equipmentToDelete: $equipmentToDelete
        customerId: $customerId
        jobInformationId: $jobInformationId
      }
    ) {
      isSuccess
      error {
        statusCode
        errorType
        errorMessage
        validationErrors {
          field
          message
        }
      }
    }
  }
`;
export type UnassignRaptorJobFromTimelineMutationFn = Apollo.MutationFunction<
  UnassignRaptorJobFromTimelineMutation,
  UnassignRaptorJobFromTimelineMutationVariables
>;

/**
 * __useUnassignRaptorJobFromTimelineMutation__
 *
 * To run a mutation, you first call `useUnassignRaptorJobFromTimelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignRaptorJobFromTimelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignRaptorJobFromTimelineMutation, { data, loading, error }] = useUnassignRaptorJobFromTimelineMutation({
 *   variables: {
 *      id: // value for 'id'
 *      startDate: // value for 'startDate'
 *      estimatedHours: // value for 'estimatedHours'
 *      equipmentToDelete: // value for 'equipmentToDelete'
 *      customerId: // value for 'customerId'
 *      jobInformationId: // value for 'jobInformationId'
 *   },
 * });
 */
export function useUnassignRaptorJobFromTimelineMutation(
  baseOptions?: Apollo.MutationHookOptions<UnassignRaptorJobFromTimelineMutation, UnassignRaptorJobFromTimelineMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UnassignRaptorJobFromTimelineMutation, UnassignRaptorJobFromTimelineMutationVariables>(
    UnassignRaptorJobFromTimelineDocument,
    options
  );
}
export type UnassignRaptorJobFromTimelineMutationHookResult = ReturnType<typeof useUnassignRaptorJobFromTimelineMutation>;
export type UnassignRaptorJobFromTimelineMutationResult = Apollo.MutationResult<UnassignRaptorJobFromTimelineMutation>;
export type UnassignRaptorJobFromTimelineMutationOptions = Apollo.BaseMutationOptions<
  UnassignRaptorJobFromTimelineMutation,
  UnassignRaptorJobFromTimelineMutationVariables
>;
export const GetAvailableExtraSystemsDocument = gql`
  query getAvailableExtraSystems {
    raptorJobSupportingDataQuery {
      value {
        availableExtraSystems {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useGetAvailableExtraSystemsQuery__
 *
 * To run a query within a React component, call `useGetAvailableExtraSystemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableExtraSystemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableExtraSystemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableExtraSystemsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAvailableExtraSystemsQuery, GetAvailableExtraSystemsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAvailableExtraSystemsQuery, GetAvailableExtraSystemsQueryVariables>(GetAvailableExtraSystemsDocument, options);
}
export function useGetAvailableExtraSystemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableExtraSystemsQuery, GetAvailableExtraSystemsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAvailableExtraSystemsQuery, GetAvailableExtraSystemsQueryVariables>(
    GetAvailableExtraSystemsDocument,
    options
  );
}
export type GetAvailableExtraSystemsQueryHookResult = ReturnType<typeof useGetAvailableExtraSystemsQuery>;
export type GetAvailableExtraSystemsLazyQueryHookResult = ReturnType<typeof useGetAvailableExtraSystemsLazyQuery>;
export type GetAvailableExtraSystemsQueryResult = Apollo.QueryResult<GetAvailableExtraSystemsQuery, GetAvailableExtraSystemsQueryVariables>;
export const GetAvailableSpecialFlagsDocument = gql`
  query getAvailableSpecialFlags {
    raptorJobSupportingDataQuery {
      value {
        availableSpecialFlags {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useGetAvailableSpecialFlagsQuery__
 *
 * To run a query within a React component, call `useGetAvailableSpecialFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableSpecialFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableSpecialFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableSpecialFlagsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAvailableSpecialFlagsQuery, GetAvailableSpecialFlagsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAvailableSpecialFlagsQuery, GetAvailableSpecialFlagsQueryVariables>(GetAvailableSpecialFlagsDocument, options);
}
export function useGetAvailableSpecialFlagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableSpecialFlagsQuery, GetAvailableSpecialFlagsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAvailableSpecialFlagsQuery, GetAvailableSpecialFlagsQueryVariables>(
    GetAvailableSpecialFlagsDocument,
    options
  );
}
export type GetAvailableSpecialFlagsQueryHookResult = ReturnType<typeof useGetAvailableSpecialFlagsQuery>;
export type GetAvailableSpecialFlagsLazyQueryHookResult = ReturnType<typeof useGetAvailableSpecialFlagsLazyQuery>;
export type GetAvailableSpecialFlagsQueryResult = Apollo.QueryResult<GetAvailableSpecialFlagsQuery, GetAvailableSpecialFlagsQueryVariables>;
export const GetAvailableVendorsDocument = gql`
  query getAvailableVendors {
    raptorJobSupportingDataQuery {
      value {
        availableVendors {
          id
          name
          default
        }
      }
    }
  }
`;

/**
 * __useGetAvailableVendorsQuery__
 *
 * To run a query within a React component, call `useGetAvailableVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableVendorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableVendorsQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAvailableVendorsQuery, GetAvailableVendorsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAvailableVendorsQuery, GetAvailableVendorsQueryVariables>(GetAvailableVendorsDocument, options);
}
export function useGetAvailableVendorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableVendorsQuery, GetAvailableVendorsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAvailableVendorsQuery, GetAvailableVendorsQueryVariables>(GetAvailableVendorsDocument, options);
}
export type GetAvailableVendorsQueryHookResult = ReturnType<typeof useGetAvailableVendorsQuery>;
export type GetAvailableVendorsLazyQueryHookResult = ReturnType<typeof useGetAvailableVendorsLazyQuery>;
export type GetAvailableVendorsQueryResult = Apollo.QueryResult<GetAvailableVendorsQuery, GetAvailableVendorsQueryVariables>;
export const GetCustomerUiBehaviorRulesDocument = gql`
  query getCustomerUiBehaviorRules {
    raptorJobSupportingDataQuery {
      value {
        uiBehaviorRules {
          name
          enabled
        }
      }
    }
  }
`;

/**
 * __useGetCustomerUiBehaviorRulesQuery__
 *
 * To run a query within a React component, call `useGetCustomerUiBehaviorRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerUiBehaviorRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerUiBehaviorRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomerUiBehaviorRulesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetCustomerUiBehaviorRulesQuery, GetCustomerUiBehaviorRulesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCustomerUiBehaviorRulesQuery, GetCustomerUiBehaviorRulesQueryVariables>(
    GetCustomerUiBehaviorRulesDocument,
    options
  );
}
export function useGetCustomerUiBehaviorRulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerUiBehaviorRulesQuery, GetCustomerUiBehaviorRulesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCustomerUiBehaviorRulesQuery, GetCustomerUiBehaviorRulesQueryVariables>(
    GetCustomerUiBehaviorRulesDocument,
    options
  );
}
export type GetCustomerUiBehaviorRulesQueryHookResult = ReturnType<typeof useGetCustomerUiBehaviorRulesQuery>;
export type GetCustomerUiBehaviorRulesLazyQueryHookResult = ReturnType<typeof useGetCustomerUiBehaviorRulesLazyQuery>;
export type GetCustomerUiBehaviorRulesQueryResult = Apollo.QueryResult<
  GetCustomerUiBehaviorRulesQuery,
  GetCustomerUiBehaviorRulesQueryVariables
>;
export const GetSalesAgentsAutocompleteWithTakeDocument = gql`
  query getSalesAgentsAutocompleteWithTake($skip: Int, $search: String, $take: Int) {
    salesAgents(
      skip: $skip
      take: $take
      where: {
        or: [
          { name: { contains: $search } }
          { firstName: { contains: $search } }
          { lastName: { contains: $search } }
          { email: { contact: { contains: $search } } }
          { phoneNumber: { contact: { contains: $search } } }
        ]
      }
    ) {
      totalCount
      items {
        id
        name
        firstName
        lastName
        default
      }
    }
  }
`;

/**
 * __useGetSalesAgentsAutocompleteWithTakeQuery__
 *
 * To run a query within a React component, call `useGetSalesAgentsAutocompleteWithTakeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesAgentsAutocompleteWithTakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesAgentsAutocompleteWithTakeQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      search: // value for 'search'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetSalesAgentsAutocompleteWithTakeQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSalesAgentsAutocompleteWithTakeQuery, GetSalesAgentsAutocompleteWithTakeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSalesAgentsAutocompleteWithTakeQuery, GetSalesAgentsAutocompleteWithTakeQueryVariables>(
    GetSalesAgentsAutocompleteWithTakeDocument,
    options
  );
}
export function useGetSalesAgentsAutocompleteWithTakeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSalesAgentsAutocompleteWithTakeQuery, GetSalesAgentsAutocompleteWithTakeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSalesAgentsAutocompleteWithTakeQuery, GetSalesAgentsAutocompleteWithTakeQueryVariables>(
    GetSalesAgentsAutocompleteWithTakeDocument,
    options
  );
}
export type GetSalesAgentsAutocompleteWithTakeQueryHookResult = ReturnType<typeof useGetSalesAgentsAutocompleteWithTakeQuery>;
export type GetSalesAgentsAutocompleteWithTakeLazyQueryHookResult = ReturnType<typeof useGetSalesAgentsAutocompleteWithTakeLazyQuery>;
export type GetSalesAgentsAutocompleteWithTakeQueryResult = Apollo.QueryResult<
  GetSalesAgentsAutocompleteWithTakeQuery,
  GetSalesAgentsAutocompleteWithTakeQueryVariables
>;
export const GetSalesRegionsAutocompleteWithTakeDocument = gql`
  query getSalesRegionsAutocompleteWithTake($skip: Int, $search: String, $take: Int) {
    salesRegions(skip: $skip, take: $take, where: { or: [{ salesRegionName: { contains: $search } }] }) {
      totalCount
      items {
        id
        salesRegionName
      }
    }
  }
`;

/**
 * __useGetSalesRegionsAutocompleteWithTakeQuery__
 *
 * To run a query within a React component, call `useGetSalesRegionsAutocompleteWithTakeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesRegionsAutocompleteWithTakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesRegionsAutocompleteWithTakeQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      search: // value for 'search'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetSalesRegionsAutocompleteWithTakeQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSalesRegionsAutocompleteWithTakeQuery, GetSalesRegionsAutocompleteWithTakeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSalesRegionsAutocompleteWithTakeQuery, GetSalesRegionsAutocompleteWithTakeQueryVariables>(
    GetSalesRegionsAutocompleteWithTakeDocument,
    options
  );
}
export function useGetSalesRegionsAutocompleteWithTakeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSalesRegionsAutocompleteWithTakeQuery, GetSalesRegionsAutocompleteWithTakeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSalesRegionsAutocompleteWithTakeQuery, GetSalesRegionsAutocompleteWithTakeQueryVariables>(
    GetSalesRegionsAutocompleteWithTakeDocument,
    options
  );
}
export type GetSalesRegionsAutocompleteWithTakeQueryHookResult = ReturnType<typeof useGetSalesRegionsAutocompleteWithTakeQuery>;
export type GetSalesRegionsAutocompleteWithTakeLazyQueryHookResult = ReturnType<typeof useGetSalesRegionsAutocompleteWithTakeLazyQuery>;
export type GetSalesRegionsAutocompleteWithTakeQueryResult = Apollo.QueryResult<
  GetSalesRegionsAutocompleteWithTakeQuery,
  GetSalesRegionsAutocompleteWithTakeQueryVariables
>;
